import React__default, { Fragment, Component, forwardRef, createElement, memo, Children, isValidElement, cloneElement, useMemo, useRef, useCallback, useLayoutEffect, useEffect, useState, useImperativeHandle, createContext, useContext, useDebugValue } from 'react';
import Paper from '@material-ui/core/Paper';
import IconButton$2 from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles as withStyles$1, makeStyles, useTheme as useTheme$1, jssPreset, createGenerateClassName, StylesProvider, ThemeProvider } from '@material-ui/styles';
import cx$1 from 'classnames';
import PropTypes__default, { objectOf, any, func, shape as shape$1, arrayOf, string, bool, number, element, oneOf, node, oneOfType, object, instanceOf } from 'prop-types';
import Menu from '@material-ui/core/Menu';
import AppsIcon from '@material-ui/icons/Apps';
import Tooltip from '@material-ui/core/Tooltip';
import _sortBy from 'lodash/sortBy';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText$2 from '@material-ui/core/ListItemText';
import Button$2 from '@material-ui/core/Button';
import _get from 'lodash/get';
import Avatar$1 from '@material-ui/core/Avatar';
import _findIndex from 'lodash/findIndex';
import ListSubheader from '@material-ui/core/ListSubheader';
import Divider from '@material-ui/core/Divider';
import Badge from '@material-ui/core/Badge';
import NotificationIcon from '@material-ui/icons/Notifications';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Popover from '@material-ui/core/Popover';
import _includes from 'lodash/includes';
import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import RefreshIcon from '@material-ui/icons/Refresh';
import HelpIcon from '@material-ui/icons/Help';
import MessageIcon from '@material-ui/icons/Message';
import DescriptionIcon from '@material-ui/icons/Description';
import List$2 from '@material-ui/core/List';
import ListItem$2 from '@material-ui/core/ListItem';
import ButtonBase$2 from '@material-ui/core/ButtonBase';
import LibChip from '@material-ui/core/Chip';
import indigo$1 from '@material-ui/core/colors/indigo';
export { default as Truncate } from 'react-dotdotdot';
import Fade from '@material-ui/core/Fade';
import CircularProgress$2 from '@material-ui/core/CircularProgress';
import _kebabCase from 'lodash/kebabCase';
import _map from 'lodash/map';
import _initial from 'lodash/initial';
import _noop from 'lodash/noop';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import _slice from 'lodash/fp/slice';
import _flatten from 'lodash/flatten';
import _zip from 'lodash/zip';
import _flow from 'lodash/flow';
import _constant from 'lodash/constant';
import _spread from 'lodash/spread';
import _isFunction from 'lodash/isFunction';
import _tail from 'lodash/tail';
import ClearFiltersIconFixme from '@material-ui/icons/FormatClear';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ArrowRightIcon$1 from '@material-ui/icons/KeyboardArrowRight';
import EditIcon from '@material-ui/icons/Edit';
import MenuIcon from '@material-ui/icons/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import _isArray from 'lodash/isArray';
import _isString from 'lodash/isString';
import HTML, { NativeTypes, getEmptyImage } from 'react-dnd-html5-backend';
import { DropTarget, DndProvider, useDrag, useDrop, useDragLayer } from 'react-dnd';
import pluralize from 'pluralize';
import mime from 'mime-types';
import _endsWith from 'lodash/endsWith';
import _startsWith from 'lodash/startsWith';
import _uniq from 'lodash/uniq';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import CropIcon from '@material-ui/icons/Crop';
import _isUndefined from 'lodash/isUndefined';
import FormControl from '@material-ui/core/FormControl';
import Input$1 from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Typography$2 from '@material-ui/core/Typography';
import ReactDOM__default, { findDOMNode } from 'react-dom';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Info from '@material-ui/icons/Info';
import Warning from '@material-ui/icons/Warning';
import green$1 from '@material-ui/core/colors/green';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import AudioIcon from '@material-ui/icons/PlayCircleOutline';
import VideoIcon from '@material-ui/icons/LocalMovies';
import ImageIcon from '@material-ui/icons/Photo';
import TextIcon from '@material-ui/icons/ShortText';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import red$1 from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import Checkbox$3 from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import _isDate from 'lodash/isDate';
import _isMatch from 'lodash/isMatch';
import Select$2 from '@material-ui/core/Select';
import InfiniteCalendar, { withRange, Calendar as Calendar$2, EVENT_TYPE } from 'react-infinite-calendar';
import RadioGroup$1 from '@material-ui/core/RadioGroup';
import TextField$1 from '@material-ui/core/TextField';
import Today from '@material-ui/icons/Today';
import LibSwitch from '@material-ui/core/Switch';
import _isNumber from 'lodash/isNumber';
import _range from 'lodash/range';
import _omit from 'lodash/omit';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import MuiTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import LastPageIcon from '@material-ui/icons/LastPage';
import _difference from 'lodash/difference';
import _intersection from 'lodash/intersection';
import _without from 'lodash/without';
import _camelCase from 'lodash/camelCase';
import _startCase from 'lodash/startCase';
import { createMuiTheme as createMuiTheme$1, makeStyles as makeStyles$1, createStyles, withStyles as withStyles$2, useTheme as useTheme$2, fade as fade$1 } from '@material-ui/core/styles';
import blue$1 from '@material-ui/core/colors/blue';
import merge from 'lodash/merge';
import Icon from '@material-ui/core/Icon';
import Grow from '@material-ui/core/Grow';
import _truncate from 'lodash/truncate';
import { setDisplayName, wrapDisplayName, branch, renderNothing } from 'recompose';
import Slide from '@material-ui/core/Slide';
import ArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey$1 from '@material-ui/core/colors/grey';
import Radio$1 from '@material-ui/core/Radio';
import { Player, ControlBar, ReplayControl, ForwardControl, PlayToggle, CurrentTimeDisplay, TimeDivider, DurationDisplay, ProgressControl, VolumeMenuButton, FullscreenToggle, BigPlayButton } from 'video-react';
import shaka from 'shaka-player';
import Cancel from '@material-ui/icons/Cancel';
import SvgIcon$2 from '@material-ui/core/SvgIcon';
import _debounce from 'lodash/debounce';
import Folder$1 from '@material-ui/icons/Folder';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import KeyboardVoice from '@material-ui/icons/KeyboardVoice';
import Videocam from '@material-ui/icons/Videocam';
import Hidden from '@material-ui/core/Hidden';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import AppBar$1 from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuList from '@material-ui/core/MenuList';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import _identity from 'lodash/identity';
import _pickBy from 'lodash/pickBy';
import _flattenDeep from 'lodash/flattenDeep';
import _isNil from 'lodash/isNil';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Add from '@material-ui/icons/AddCircle';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import Zoom from '@material-ui/core/Zoom';
import FormGroup from '@material-ui/core/FormGroup';
import Box from '@material-ui/core/Box';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import DragHandle from '@material-ui/icons/DragHandle';
import Link from '@material-ui/core/Link';
import Title from '@material-ui/icons/Title';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';
import CalendarToday from '@material-ui/icons/CalendarToday';
import StarBorderOutlined from '@material-ui/icons/StarBorderOutlined';
import Notes from '@material-ui/icons/Notes';
import ExposurePlus1 from '@material-ui/icons/ExposurePlus1';
import EditAttributesIcon from '@material-ui/icons/EditAttributes';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@import url(\"https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500\");\n@import url(\"https://fonts.googleapis.com/css?family=Dosis:300,400,500\");\n@import url(\"https://static.veritone.com/veritone-ui/veritone-icons-26/style.css\");\n@import url(\"https://static.veritone.com/engines/assets/v001/style.css\");\nbody {\n  font-family: Roboto, 'Helvetica Neue', sans-serif; }\n\ninput:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px white inset; }\n\n* {\n  box-sizing: border-box; }\n\na {\n  text-decoration: none;\n  color: #2196f3; }\n  a:hover {\n    text-decoration: underline; }\n";
styleInject(css);

const muiTextStyles = {
    'display4': {
        'font-weight': 300,
        'font-size': '112px',
        'line-height': '112px'
    },
    'display3': {
        'font-weight': 400,
        'font-size': '56px',
        'line-height': '56px'
    },
    'display2': {
        'font-weight': 400,
        'font-size': '45px',
        'line-height': '48px'
    },
    'display1': {
        'font-weight': 400,
        'font-size': '34px',
        'line-height': '40px'
    },
    'headline': {
        'font-weight': 400,
        'font-size': '24px',
        'line-height': '32px'
    },
    'title': {
        'font-weight': 400,
        'font-size': '20px',
        'line-height': '28px'
    },
    'subhead': {
        'font-weight': 400,
        'font-size': '16px',
        'line-height': '24px'
    },
    'body2': {
        'font-weight': 500,
        'font-size': '14px',
        'line-height': '20px'
    },
    'body1': {
        'font-weight': 400,
        'font-size': '14px',
        'line-height': '20px'
    },
    'caption': {
        'font-weight': 400,
        'font-size': '12px',
        'line-height': '16px'
    },
    'menu': {
        'font-weight': 500,
        'font-size': '13px',
        'line-height': '17px'
    },
    'button': {
        'font-weight': 500,
        'font-size': '14px',
        'line-height': '18px'
    }
};

const muiText = muiName => {
    const muiStyles = muiTextStyles[muiName];
    const css = {
        fontWeight: `${muiStyles['font-weight']} !important`,
        fontSize: `${muiStyles['font-size']} !important`,
        lineHeight: `${muiStyles['line-height']} !important`
    };

    if (muiName === 'button') {
        css['textTransform'] = 'uppercase';
    }

    return css;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

const bodyText = muiText('body1');
const captionText = muiText('caption');
const subheadText = muiText('subhead');

var styles = {
  appSwitcherTitle: _extends({}, captionText, {
    color: 'white',
    display: 'inline-block',
    margin: 0,
    opacity: 0.87
  }),
  popover: {
    marginTop: 18
  },
  appListButton: _extends({}, subheadText, {
    minWidth: 220,
    lineHeight: '48px !important'
  }),
  appListButtonIcon: {
    margin: 'auto 2px auto 0',
    verticalAlign: 'middle',
    width: 24,
    marginRight: 10,
    display: 'inline-block',
    fontSize: 20,
    textIndent: 1
  },
  hasSvg: {
    width: 24,
    opacity: 0.54,
    marginRight: 10
  },
  appListButtonNullstate: _extends({}, bodyText, {
    padding: '20px 0 !important',
    margin: '0 auto',
    width: 200,
    textAlign: 'center',
    cursor: 'default !important'
  }),
  appListButtonErrorState: _extends({}, bodyText, {
    padding: '20px 0 !important',
    margin: '0 auto !important',
    whiteSpace: 'normal',
    width: 150,
    lineHeight: 'initial',
    textAlign: 'center',
    cursor: 'default'
  }),
  '& > button': {
    marginTop: 20
  }
};

var _class, _temp2;

let AppSwitcherItem = (_temp2 = _class = class AppSwitcherItem extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleSwitchApp = () => {
      this.props.onSelect(this.props.app.applicationId);
    }, _temp;
  }

  render() {
    const { app, classes } = this.props;

    const appListButtonIconClasses = cx$1(classes['appListButtonIcon'], {
      [`${classes['hasSvg']}`]: app.applicationIconSvg
    });

    return React__default.createElement(
      MenuItem,
      {
        button: true,
        className: classes['appListButton']
        // target={app.applicationId}
        , onClick: this.handleSwitchApp
      },
      React__default.createElement(
        ListItemIcon,
        null,
        app.signedApplicationIconUrl || app.applicationIconUrl || app.applicationIconSvg ? React__default.createElement('img', {
          className: appListButtonIconClasses,
          src: app.signedApplicationIconUrl || app.applicationIconUrl || app.applicationIconSvg
        }) : React__default.createElement('span', {
          className: cx$1(appListButtonIconClasses, 'icon-applications')
        })
      ),
      React__default.createElement(ListItemText$2, { primary: app.applicationName })
    );
  }
}, _class.propTypes = {
  app: objectOf(any).isRequired,
  onSelect: func.isRequired,
  classes: shape$1({ any })
}, _temp2);
AppSwitcherItem.displayName = 'AppSwitcherItem';


var AppSwitcherItem$1 = withStyles$1(styles)(AppSwitcherItem);

var _class$1, _temp;

let AppSwitcherList = (_temp = _class$1 = class AppSwitcherList extends React__default.Component {

  render() {
    const { classes } = this.props;
    const apps = _sortBy(this.props.enabledApps, 'applicationName');
    return apps.length ? React__default.createElement(
      'div',
      null,
      apps.map(app => React__default.createElement(AppSwitcherItem$1, {
        app: app,
        onSelect: this.props.onSwitchApp,
        key: app.applicationId
      }))
    ) : React__default.createElement(
      'div',
      { className: classes['appListButtonNullstate'] },
      'No Applications Found'
    );
  }
}, _class$1.propTypes = {
  enabledApps: arrayOf(shape$1({
    applicationId: string,
    applicationName: string,
    applicationIconSvg: string,
    applicationIconUrl: string
  })),
  onSwitchApp: func.isRequired,
  classes: shape$1({ any })
}, _class$1.defaultProps = {
  enabledApps: []
}, _temp);
AppSwitcherList.displayName = 'AppSwitcherList';


var AppSwitcherList$1 = withStyles$1(styles)(AppSwitcherList);

var _class$2, _temp$1;

let AppSwitcherErrorState = (_temp$1 = _class$2 = class AppSwitcherErrorState extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.appListButtonErrorState },
      'An error occurred loading this content',
      React__default.createElement(
        Button$2,
        { variant: 'contained', onClick: this.props.onRefresh },
        'retry'
      )
    );
  }
}, _class$2.propTypes = {
  onRefresh: func,
  classes: shape$1({ any })
}, _temp$1);
AppSwitcherErrorState.displayName = 'AppSwitcherErrorState';


var AppSwitcherErrorState$1 = withStyles$1(styles)(AppSwitcherErrorState);

var _class$3, _temp2$1;

let AppSwitcher = (_temp2$1 = _class$3 = class AppSwitcher extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      open: false,
      anchorEl: null
    }, this.openMenu = event => {
      this.setState({ open: true, anchorEl: event.currentTarget });
    }, this.closeMenu = () => {
      this.setState({
        open: false
      });
    }, this.handleSwitchApp = id => {
      this.props.onSwitchApp(id);
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    // todo: loading state
    return React__default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center' } },
      React__default.createElement(
        Tooltip,
        { title: this.props.tooltipTitle || '', disableFocusListener: true },
        React__default.createElement(
          IconButton$2,
          {
            onClick: this.openMenu,
            'data-veritone-element': 'app-switcher-button'
          },
          React__default.createElement(AppsIcon, { htmlColor: 'white' })
        )
      ),
      React__default.createElement(
        Menu,
        {
          open: this.state.open,
          onClose: this.closeMenu,
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          anchorEl: this.state.anchorEl,
          getContentAnchorEl: null,
          className: classes.popover
        },
        this.props.enabledAppsFailedLoading ? React__default.createElement(AppSwitcherErrorState$1, { onRefresh: this.props.handleRefresh }) : React__default.createElement(AppSwitcherList$1, {
          onSwitchApp: this.handleSwitchApp,
          enabledApps: this.props.enabledApps
        })
      ),
      React__default.createElement(
        'span',
        { className: classes.appSwitcherTitle },
        this.props.currentAppName
      )
    );
  }
}, _class$3.propTypes = {
  tooltipTitle: string,
  currentAppName: string,
  enabledApps: arrayOf(shape$1({
    applicationId: string,
    applicationName: string,
    applicationIconSvg: string,
    applicationIconUrl: string,
    signedApplicationIconUrl: string
  })),
  enabledAppsFailedLoading: bool,
  handleRefresh: func,
  onSwitchApp: func,
  classes: shape$1({ any })
}, _class$3.defaultProps = {
  tooltipTitle: 'Switch Apps'
}, _temp2$1);
AppSwitcher.displayName = 'AppSwitcher';


var AppSwitcher$1 = withStyles$1(styles)(AppSwitcher);

// colors

const lightRed50 = '#ffebee';

const grey1 = '#fafafa';
const grey2 = '#eee';
const grey4 = '#e0e0e0';
const grey5 = '#727272';
const grey6 = '#666';

const lightBlue50 = '#e1f5fe';

const blue1 = '#2196f3';
const blue2 = 'darken(#2196f3, 15%)';
const blue3 = '#2096f3';
const blue400 = '#42a5f5';

const fullBlack = 'rgba(0, 0, 0, 1)';
const darkBlack = 'rgba(0, 0, 0, 0.87)';
const lightBlack = 'rgba(0, 0, 0, 0.54)';
const semiBlack = 'rgba(0, 0, 0, 0.44)';
const minBlack = 'rgba(0, 0, 0, 0.38)';
const faintBlack = 'rgba(0, 0, 0, 0.12)';
const barelyBlack = 'rgba(0, 0, 0, 0.05)';

const fullWhite = 'rgba(255, 255, 255, 1)';
const darkWhite = 'rgba(255, 255, 255, 0.87)';

// file picker variables
const filePickerMargin = '20px';

const body1Text = muiText('body1');
const captionText$1 = muiText('caption');
const titleText = muiText('title');

var styles$1 = {

  paper: {
    borderRadius: '13px',
    boxShadow: '0 2px 6px 0 rgba(96,107,134,0.5)'
  },
  popover: {
    marginTop: '18px'
  },
  userNullState: _extends({}, body1Text, {
    padding: '20px 0 !important',
    margin: '0 auto',
    width: '200px',
    textAlign: 'center',
    cursor: 'default !important'
  }),
  header: {
    padding: '30px 30px 15px 30px',
    display: 'flex',
    '&:focus': {
      outline: 'none' // prevent outline around profile subheade
    },
    '& $userAvatar': {
      paddingRight: '15px'
    },
    '& $userProfile': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      '& $fullName': _extends({}, titleText, {
        color: darkBlack
      }),
      '& $username': _extends({}, captionText$1),
      '& $editButton': {
        padding: '0px 0 10px',
        '& div': {
          lineHeight: '36px'
        }
      }
    }
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  userAvatar: {},
  avatarProfile: {
    height: '35px',
    width: '35px',
    fontSize: '18px',
    paddingTop: '2px'
  },
  avatar: {
    height: '58px',
    width: '58px',
    marginRight: '20px'
  },
  userProfile: {},
  fullName: {},
  username: {},
  editButton: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'

  },
  settingsButton: {
    height: '41px',
    textTransform: 'capitalize',
    color: '#4284F4',
    borderColor: '#4284F4'

  },
  editProfileButton: {
    height: '41px',
    textTransform: 'capitalize',
    backgroundColor: '#4284F4',
    marginRight: '10px',
    boxShadow: 'none',
    color: '#FFFFFF'
  },
  logoutButton: {
    marginTop: '20px',
    marginBottom: '13px',
    height: '42px',
    textTransform: 'capitalize',
    borderRadius: '21px',
    width: '80%',
    fontColor: '#000'
  }

};

var _class$4, _temp2$2;

let InnerProfileMenu = (_temp2$2 = _class$4 = class InnerProfileMenu extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.sendToAdmin = route => () => {
      window.open(route, 'blank');
    }, _temp;
  }

  render() {
    const { isDiscovery, classes } = this.props;
    let adminRoute;
    const adminAppExists = _findIndex(this.props.enabledApps, ['applicationId', 'ea1d26ab-0d29-4e97-8ae7-d998a243374e']);
    const orgId = _get(this.props.user, 'organization.organizationId');
    const isAdmin = adminAppExists >= 0 ? true : false;
    if (isAdmin) {
      adminRoute = `${this.props.enabledApps[adminAppExists]['applicationUrl']}/organizations/${orgId}/discovery `;
    }

    const userExists = !!Object.keys(this.props.user).length;
    if (!userExists) {
      return React__default.createElement(
        'div',
        { className: classes.userNullState },
        'No user found'
      );
    }
    let userInitials = _get(this.props.user, 'kvp.firstName').slice(0, 1).toUpperCase() + _get(this.props.user, 'kvp.lastName').slice(0, 1).toUpperCase();
    let userProfileImage = this.props.user.signedImageUrl || _get(this.props.user, 'kvp.image');
    if (!userInitials && !userProfileImage) {
      userProfileImage = '//static.veritone.com/veritone-ui/default-avatar-2.png';
    }

    return React__default.createElement(
      Fragment,
      null,
      React__default.createElement(
        ListSubheader,
        { className: classes['header'], key: 'header' },
        React__default.createElement(
          'div',
          { className: classes['userAvatar'] },
          userProfileImage ? React__default.createElement(Avatar$1, {
            'data-test': 'userAvatar',
            className: classes.avatar,
            src: userProfileImage
          }) : React__default.createElement(
            Avatar$1,
            { 'data-test': 'userAvatarInitials', className: classes.avatar },
            userInitials
          )
        ),
        React__default.createElement(
          'div',
          { className: classes['userProfile'] },
          React__default.createElement(
            'div',
            { className: classes['fullName'] },
            _get(this.props.user, 'kvp.firstName'),
            '\xA0',
            _get(this.props.user, 'kvp.lastName')
          ),
          React__default.createElement(
            'div',
            { className: classes['username'] },
            _get(this.props.user, 'userName')
          ),
          React__default.createElement(
            'div',
            { className: classes['editButton'] },
            React__default.createElement(
              Button$2,
              {
                'data-test': 'editProfileButton',
                variant: 'contained',
                color: 'primary',
                onClick: this.props.onEditProfile,
                className: classes.editProfileButton
              },
              'Edit Profile'
            ),
            isDiscovery && isAdmin && React__default.createElement(
              Button$2,
              {
                'data-test': 'discoverySettingsButton',
                variant: 'outlined',
                color: 'primary',
                onClick: this.sendToAdmin(adminRoute),
                className: classes.settingsButton
              },
              'Settings'
            )
          )
        )
      ),
      this.props.additionMenuItems,
      React__default.createElement(Divider, null),
      React__default.createElement(
        'div',
        { className: classes.center },
        React__default.createElement(
          Button$2,
          {
            'data-test': 'logoutButton',
            variant: 'outlined',
            onClick: this.props.onLogout,
            className: classes.logoutButton
          },
          'Sign Out'
        )
      )
    );
  }
}, _class$4.propTypes = {
  onLogout: func.isRequired,
  onEditProfile: func.isRequired,
  user: shape$1({
    userName: string,
    kvp: shape$1({
      firstName: string,
      lastName: string,
      image: string
    }),
    organization: shape$1({
      organizationId: number
    }),
    signedImageUrl: string
  }),
  isDiscovery: bool,
  enabledApps: arrayOf(shape$1({
    name: string,
    permissionId: number,
    iconClass: string,
    displayName: string
  })),
  additionMenuItems: arrayOf(element),
  classes: shape$1({ any })
}, _temp2$2);
InnerProfileMenu.displayName = 'InnerProfileMenu';


var InnerProfileMenu$1 = withStyles$1(styles$1)(InnerProfileMenu);

var _class$5, _temp2$3;

let ProfileMenu = (_temp2$3 = _class$5 = class ProfileMenu extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      open: false,
      anchorEl: null
    }, this.openMenu = event => {
      this.setState({ open: true, anchorEl: event.currentTarget });
    }, this.closeMenu = () => {
      this.setState({
        open: false
      });
    }, this.handleLogout = () => {
      this.props.onLogout();
    }, _temp;
  }

  render() {
    const userExists = !!Object.keys(this.props.user).length;
    let userProfileImage;
    let userInitials;
    if (!userExists) {
      userProfileImage = '//static.veritone.com/veritone-ui/default-avatar-2.png';
    } else {
      userInitials = _get(this.props.user, 'kvp.firstName').slice(0, 1).toUpperCase() + _get(this.props.user, 'kvp.lastName').slice(0, 1).toUpperCase();
      userProfileImage = this.props.user.signedImageUrl || _get(this.props.user, 'kvp.image');
      if (!userInitials && !userProfileImage) {
        userProfileImage = '//static.veritone.com/veritone-ui/default-avatar-2.png';
      }
    }

    const { classes } = this.props;

    return React__default.createElement(
      'div',
      null,
      React__default.createElement(
        Tooltip,
        { title: this.props.tooltipTitle || '', disableFocusListener: true },
        React__default.createElement(
          IconButton$2,
          {
            className: cx$1(this.props.className, classes.center),
            onClick: this.openMenu,
            'data-veritone-element': 'profile-menu-button'
          },
          userProfileImage ? React__default.createElement(Avatar$1, {
            style: { height: 35, width: 35 },
            src: userProfileImage
          }) : React__default.createElement(
            Avatar$1,
            { className: classes.avatarProfile },
            userInitials
          )
        )
      ),
      React__default.createElement(
        Menu,
        {
          disableEnforceFocus: true,
          open: this.state.open,
          onClose: this.closeMenu,
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          transformOrigin: { horizontal: 'right', vertical: 'top' },
          anchorEl: this.state.anchorEl,
          elevation: 0,
          classes: { paper: classes.paper }
          // https://github.com/callemall/material-ui/issues/7961#issuecomment-326215406
          , getContentAnchorEl: null,
          className: classes.popover
        },
        React__default.createElement(InnerProfileMenu$1, {
          user: this.props.user,
          isDiscovery: this.props.isDiscovery,
          enabledApps: this.props.enabledApps,
          onLogout: this.handleLogout,
          onEditProfile: this.props.onEditProfile,
          additionMenuItems: this.props.additionMenuItems
        })
      )
    );
  }
}, _class$5.propTypes = {
  className: string,
  onLogout: func.isRequired,
  onEditProfile: func,
  user: shape$1({
    userName: string,
    kvp: shape$1({
      firstName: string,
      lastName: string,
      image: string
    }),
    organization: shape$1({
      organizationId: number
    })
  }),
  enabledApps: arrayOf(shape$1({
    name: string,
    permissionId: number,
    iconClass: string,
    displayName: string
  })),
  isDiscovery: bool,
  tooltipTitle: string,
  additionMenuItems: arrayOf(element),
  classes: shape$1({ any })
}, _class$5.defaultProps = {
  user: {},
  tooltipTitle: 'Profile'
}, _temp2$3);
ProfileMenu.displayName = 'ProfileMenu';


var ProfileMenu$1 = withStyles$1(styles$1)(ProfileMenu);

const spinnerWidth = 24;
const spinnerColor = '#2196F3';
const spinnerBackground = '#CCEBFF';

const outroTransition = () => ({
  transition: 'opacity 0.6s, margin-left 0.6s,height 0.4s 0.6s, padding 0.4s 0.6s, margin-top 0.4s 0.6s, margin-bottom 0.4s 0.6s'
});

var styles$2 = {
  '@keyframes fadeInAnimation': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  '@keyframes spin': {
    to: {
      transform: 'rotate(360deg)'
    }
  },
  notification: {
    display: 'flex',
    alignItems: 'center',
    '& $toolTipWrapper': {
      display: 'inline-block'
    },
    '& $badge': {
      top: -6,
      right: -6,
      width: 16,
      height: 16,
      fontSize: 10,
      backgroundColor: '#00BCD4'
    }
  },
  popover: {
    marginTop: 18
  },
  notificationWindow: {
    width: 566,
    height: '100%',
    color: 'white',
    backgroundColor: '#323232',
    '& $header': {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '48px',
      padding: '0 16px',
      backgroundColor: '#454545',
      display: 'flex',
      flexDirection: 'row',

      '& $label': {
        minWidth: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      '& $chip': {
        height: 16,
        fontSize: 10,
        lineHeight: '15px',
        padding: '1px 10px 0',
        borderRadius: 8,
        marginTop: 16,
        marginLeft: 20,
        backgroundColor: '#00BCD4'
      },
      '& $controls': {
        marginLeft: 'auto'
      }
    },
    '& $body': {
      height: 'auto',
      maxHeight: 352
    }
  },
  notificationList: {
    overflow: 'auto',
    maxHeight: 'inherit',
    '& $entry': {
      width: '100%',
      height: 64,
      padding: 16,
      display: 'flex',
      flexDirection: 'row',
      justifyItems: 'center',
      '&$fadeIn': {
        animation: '$fadeInAnimation 0.5s'
      },
      '&$slideOut': _extends({
        opacity: 0,
        height: 0,
        padding: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: -600
      }, outroTransition),
      '&$fadeOut': _extends({
        opacity: 0,
        height: 0,
        padding: 0,
        marginTop: 0,
        marginBottom: 0
      }, outroTransition),
      '&$noOutro': {
        display: 'none'
      },
      '& > div:not(:last-child)': {
        marginRight: 16
      },
      '& $visualStatus': {
        width: 30,
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center'
      },
      '& $description': {
        flex: 1,
        minWidth: 0,
        '& div': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        '& $title': {
          fontSize: 14,
          lineHeight: '20px'
        },
        '& $subtitle': {
          fontSize: 12,
          color: 'rgba(255,255,255,0.54)'
        }
      },
      '& $extra': {
        width: 130,
        fontSize: 12,
        lineHeight: '32px',
        color: 'rgba(255,255,255,0.54)',
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        '& $description': {
          flex: 1,
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        '& $actions': {
          '& $iconButton': {
            width: 32,
            height: 32,
            '& $icon': {
              color: 'rgba(255,255,255,0.54)'
            }
          }
        }
      }
    },
    '& $spinner:before': {
      content: '""',
      boxSizing: 'border-box',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: spinnerWidth,
      height: spinnerWidth,
      marginTop: -spinnerWidth / 2,
      marginLeft: -spinnerWidth / 2,
      borderRadius: '50%',
      border: `2px solid ${spinnerColor}`,
      borderTopColor: spinnerBackground,
      animation: '$spin .6s linear infinite'
    }
  },
  toolTipWrapper: {},
  badge: {},
  header: {},
  label: {},
  chip: {},
  controls: {},
  body: {},
  entry: {},
  fadeIn: {},
  slideOut: {},
  fadeOut: {},
  noOutro: {},
  visualStatus: {},
  description: {},
  title: {},
  subtitle: {},
  extra: {},
  actions: {},
  iconButton: {},
  icon: {},
  spinner: {}
};

var ErrorIconSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2225px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2025%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3ED5BA19E1-B078-428E-B890-F55BCA4C4509%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C0%20C5.376%2C0%200%2C5.376%200%2C12%20C0%2C18.624%205.376%2C24%2012%2C24%20C18.624%2C24%2024%2C18.624%2024%2C12%20C24%2C5.376%2018.624%2C0%2012%2C0%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Data-Refresh-Queue-Notification-v3%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%223.0-Data-Refresh-%2F-Expanded-%2F-Fixed-Height-v2%22%20transform%3D%22translate%28-720.000000%2C%20-148.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Data-Refresh-Queue%22%20transform%3D%22translate%28703.000000%2C%2075.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Queue-Dataset-3-%2B-Queue-Dataset-3-Copy-%2B-Queue-Dataset-3-Copy-2-%2B-Queue-Dataset-3-Copy-3-%2B-Queue-Dataset-2-%2B-Queue-Dataset-1-Mask%22%20transform%3D%22translate%280.000000%2C%2016.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Queue-Dataset-1%22%20transform%3D%22translate%2817.866667%2C%2053.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Queue-Dataset%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Spinner%2FSmall-Spinner%22%20transform%3D%22translate%280.000000%2C%204.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Checkmark-Icon%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22material-icon%2Fcontent%2Fclear_24px%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icon%2Falert%2Ferror_24px%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22%E2%86%B3-Color%22%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FF0C3E%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-2.000000%2C%20-2.000000%29%22%20id%3D%22Rectangle%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%2228%22%20height%3D%2228%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%20points%3D%2213%2018%2011%2018%2011%2016%2013%2016%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%20points%3D%2213%2013%2011%2013%2011%206%2013%206%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var CheckIconSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2225px%22%20height%3D%2224px%22%20viewBox%3D%220%200%2025%2024%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3E8F05D0D3-7527-4E09-B857-52076894F35A%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22path-1%22%20points%3D%229.59999999%2016.1376%2018.0752%207.66239998%2019.2%208.78719998%209.59999999%2018.3872%205.13759997%2013.9248%206.26239998%2012.8%22%3E%3C%2Fpolygon%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Data-Refresh-Queue-Notification-v3%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%223.0-Data-Refresh-%2F-Expanded-%2F-Completed-Task%22%20transform%3D%22translate%28-721.000000%2C%20-271.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Data-Refresh-Queue%22%20transform%3D%22translate%28703.000000%2C%2075.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Dataset-3%22%20transform%3D%22translate%2818.866667%2C%20196.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Checkmark-Icon%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%2366BB6A%22%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22check2%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var _class$6, _temp2$4;

const TYPE_CUSTOM = 'custom';
const TYPE_PREPARING = 'preparing';
const TYPE_PROCESSING = 'processing';
const TYPE_FAILED = 'failed';
const TYPE_COMPLETE = 'complete';

const INTRO_NONE = 'none';
const INTRO_FADE_IN = 'fade_in';

const OUTRO_NONE = 'none';
const OUTRO_FADE_OUT = 'fade_out';
const OUTRO_SLIDE_OUT = 'slide_out';

const notificationListPropTypes = arrayOf(shape$1({
  id: string.isRequired,
  type: oneOf([TYPE_CUSTOM, TYPE_PREPARING, TYPE_PROCESSING, TYPE_FAILED, TYPE_COMPLETE]).isRequired,
  customNode: node,
  description1: string,
  description2: string,
  statusDescription: string,
  onActionClick: func,
  onRemoveClick: func,
  introAnimation: oneOf([INTRO_NONE, INTRO_FADE_IN]),
  outroAnimation: oneOf([OUTRO_NONE, OUTRO_FADE_OUT, OUTRO_SLIDE_OUT])
}));

let NotificationList = (_temp2$4 = _class$6 = class NotificationList extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {}, this.handleEntryActionClicked = entry => event => {
      entry.onActionClick && entry.onActionClick(entry);
    }, this.handleEntryRemoveClick = entry => event => {
      entry.onRemoveClick && entry.onRemoveClick(entry);
    }, this.drawCustomItem = entryData => {
      const entryId = entryData.id;
      const isNewEntry = _includes(this.state.newEntryIds, entryId);
      const isRemoved = !isNewEntry && _includes(this.state.removedEntryIds, entryId);
      const { classes } = this.props;

      return React__default.createElement(
        'div',
        { key: entryId, className: cx$1({
            [classes.fadeIn]: isNewEntry && entryData.introAnimation === INTRO_FADE_IN,
            [classes.fadeOut]: isRemoved && entryData.outroAnimation === OUTRO_FADE_OUT,
            [classes.slideOut]: isRemoved && entryData.outroAnimation === OUTRO_SLIDE_OUT,
            [classes.noOutro]: isRemoved && (!entryData.outroAnimation || entryData.outroAnimation === OUTRO_NONE)
          }) },
        entryData.customNode
      );
    }, this.drawGenericItem = (originalData, formatedData) => {
      const entryId = formatedData.id;
      const isNewEntry = _includes(this.state.newEntryIds, entryId);
      const isRemoved = !isNewEntry && _includes(this.state.removedEntryIds, entryId);
      const { classes } = this.props;

      return React__default.createElement(
        'div',
        { key: formatedData.id, className: cx$1(classes.entry, {
            [classes.fadeIn]: isNewEntry && formatedData.introAnimation === INTRO_FADE_IN,
            [classes.fadeOut]: isRemoved && formatedData.outroAnimation === OUTRO_FADE_OUT,
            [classes.slideOut]: isRemoved && formatedData.outroAnimation === OUTRO_SLIDE_OUT,
            [classes.noOutro]: isRemoved && (!formatedData.outroAnimation || formatedData.outroAnimation === OUTRO_NONE)
          }),
          'data-test': 'entry'
        },
        React__default.createElement(
          'div',
          { className: cx$1(classes.visualStatus) },
          formatedData.statusIcon
        ),
        React__default.createElement(
          'div',
          { className: cx$1(classes.description) },
          React__default.createElement(
            'div',
            { className: cx$1(classes.title) },
            formatedData.description1
          ),
          React__default.createElement(
            'div',
            { className: cx$1(classes.subtitle) },
            formatedData.description2
          )
        ),
        React__default.createElement(
          'div',
          { className: cx$1(classes.extra) },
          React__default.createElement(
            'div',
            { className: cx$1(classes.description) },
            formatedData.statusDescription
          ),
          React__default.createElement(
            'div',
            { className: cx$1(classes.actions) },
            formatedData.onActionClick && React__default.createElement(
              IconButton$2,
              {
                color: 'default',
                className: cx$1(classes.iconButton),
                onClick: this.handleEntryActionClicked(originalData),
                'data-veritone-element': formatedData.btnActionTrackName || 'notification-action-button'
              },
              formatedData.actionIcon
            ),
            formatedData.onRemoveClick && React__default.createElement(
              IconButton$2,
              {
                color: 'default',
                className: cx$1(classes.iconButton),
                onClick: this.handleEntryRemoveClick(originalData),
                'data-veritone-element': formatedData.btnRemoveTrackName || 'notification-remove-button'
              },
              formatedData.removeIcon || React__default.createElement(CloseIcon, { className: cx$1(classes.icon), style: { fontSize: "20px" } })
            )
          )
        )
      );
    }, this.drawFailedItem = entryData => {
      const { classes } = this.props;
      const failedEntryData = _extends({
        statusIcon: React__default.createElement('img', { src: ErrorIconSvg }),
        actionIcon: React__default.createElement(RefreshIcon, { className: cx$1(classes.icon), style: { fontSize: "20px" } }),
        statusDescription: 'failed',
        btnActionTrackName: 'failed-notification-retry-botton',
        btnRemoveTrackName: 'failed-notification-remove-button',
        introAnimation: INTRO_FADE_IN,
        outroAnimation: OUTRO_FADE_OUT
      }, entryData);

      return this.drawGenericItem(entryData, failedEntryData);
    }, this.drawCompleteItem = entryData => {
      const completeEntryData = _extends({
        statusIcon: React__default.createElement('img', { src: CheckIconSvg }),
        statusDescription: 'complete',
        btnActionTrackName: 'complete-notification-action-botton',
        btnRemoveTrackName: 'complete-notification-remove-button',
        introAnimation: INTRO_FADE_IN,
        outroAnimation: OUTRO_SLIDE_OUT
      }, entryData);

      return this.drawGenericItem(entryData, completeEntryData);
    }, this.drawPreparingItem = entryData => {
      const preparingEntryData = _extends({
        statusIcon: this.drawSpinner(),
        statusDescription: 'preparing',
        btnActionTrackName: 'preparing-notification-action-botton',
        btnRemoveTrackName: 'preparing-notification-remove-button',
        introAnimation: INTRO_FADE_IN,
        outroAnimation: OUTRO_FADE_OUT
      }, entryData);

      return this.drawGenericItem(entryData, preparingEntryData);
    }, this.drawProcessingItem = entryData => {
      const processingEntryData = _extends({
        statusIcon: this.drawSpinner(),
        statusDescription: 'processing',
        btnActionTrackName: 'processing-notification-action-botton',
        btnRemoveTrackName: 'processing-notification-remove-button',
        introAnimation: INTRO_FADE_IN,
        outroAnimation: OUTRO_FADE_OUT
      }, entryData);

      return this.drawGenericItem(entryData, processingEntryData);
    }, this.drawSpinner = () => {
      const { classes } = this.props;
      return React__default.createElement('div', { className: cx$1(classes.spinner) });
    }, _temp;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const currentEntries = nextProps.notifications || [];

    if (_isEmpty(prevState)) {
      return {
        currentEntries,
        removedEntryIds: [],
        allEntries: currentEntries
      };
    } else if (_isEqual(prevState.currentEntries, currentEntries)) {
      return prevState;
    } else {
      const prevEntries = prevState.currentEntries;

      //Find New Entry
      const newEntryIds = currentEntries.reduce((ids, entry) => {
        const entryId = entry.id;
        const matchedEntry = _find(prevEntries, { id: entryId });
        !matchedEntry && ids.push(entryId);
        return ids;
      }, []);

      //Find Removed Entry
      const removedEntryIds = prevEntries.reduce((ids, entry) => {
        const entryId = entry.id;
        const matchedEntry = _find(currentEntries, { id: entryId });
        !matchedEntry && ids.push(entryId);
        return ids;
      }, []);

      //Merge new entries & prev entries
      let allEntries = currentEntries.reduce((accumulator, entry) => {
        let newAccumulator = accumulator.concat([]);
        const matchedPrevIndex = _findIndex(prevEntries, { id: entry.id });
        if (matchedPrevIndex !== -1) {

          //Append outdated entries for outro animation
          if (matchedPrevIndex > 0) {
            const outDatedEntries = prevEntries.splice(0, matchedPrevIndex);
            newAccumulator = accumulator.concat(outDatedEntries);
          }

          prevEntries.splice(0, 1); //Remove duplicated entry
        }

        newAccumulator.push(entry);

        return newAccumulator;
      }, []);

      allEntries = allEntries.concat(prevEntries); //Append all left over outdated entries for outro animation

      return {
        allEntries,
        currentEntries,
        newEntryIds,
        removedEntryIds
      };
    }
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: cx$1(classes.notificationList) },
      this.state.allEntries.map(entry => {
        switch (entry.type) {
          case TYPE_PREPARING:
            return this.drawPreparingItem(entry);

          case TYPE_PROCESSING:
            return this.drawProcessingItem(entry);

          case TYPE_FAILED:
            return this.drawFailedItem(entry);

          case TYPE_COMPLETE:
            return this.drawCompleteItem(entry);

          case TYPE_CUSTOM:
            return this.drawCustomItem(entry);

          default:
            return null;
        }
      })
    );
  }
}, _class$6.propTypes = {
  notifications: notificationListPropTypes,
  classes: shape$1({ any })
}, _temp2$4);
NotificationList.displayName = 'NotificationList';


var NotificationList$1 = withStyles$1(styles$2)(NotificationList);

var _class$7, _temp2$5;
const notifierPropTypes = {
  tooltipTitle: string,
  headerText: string,
  onOpen: func,
  onClose: func,
  headerBackgroundColor: string,
  bodyBackgroundColor: string,
  notifications: notificationListPropTypes,
  totalNotification: number,
  showNotifications: func,
  hideNotification: func,
  classes: shape$1({ any })
};
let Notifier = (_temp2$5 = _class$7 = class Notifier extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      anchorEl: null
    }, this.showNotifications = event => {
      this.setState({
        anchorEl: event.currentTarget
      });

      this.props.onOpen && this.props.onOpen();
    }, this.hideNotification = event => {
      this.setState({ anchorEl: null });
      this.props.onClose && this.props.onClose();
    }, _temp;
  }

  render() {
    const {
      anchorEl
    } = this.state;

    const {
      tooltipTitle,
      headerText,
      headerBackgroundColor,
      bodyBackgroundColor,
      notifications,
      totalNotification,
      showNotifications,
      hideNotification,
      classes
    } = this.props;

    const displayEntries = notifications.concat([]);
    const numNotifications = totalNotification || totalNotification === 0 ? totalNotification : notifications.length || 0;
    //TODO: remove "numNotifications > 0 ?" condition when material-ui is updated to a later version
    return React__default.createElement(
      'div',
      { className: cx$1(classes.notification) },
      React__default.createElement(
        Tooltip,
        { title: tooltipTitle || '' },
        React__default.createElement(
          'span',
          { className: classes.toolTipWrapper },
          React__default.createElement(
            IconButton$2,
            {
              onClick: showNotifications ? showNotifications : this.showNotifications,
              disabled: notifications.length === 0,
              'data-veritone-element': 'notification-button'
            },
            numNotifications > 0 && !anchorEl ? React__default.createElement(
              Badge,
              {
                color: 'primary',
                badgeContent: numNotifications,
                classes: { badge: classes.badge }
              },
              React__default.createElement(NotificationIcon, { htmlColor: 'white' })
            ) : React__default.createElement(NotificationIcon, { htmlColor: 'white' })
          )
        )
      ),
      React__default.createElement(
        Popover,
        {
          disableRestoreFocus: true,
          open: Boolean(anchorEl),
          anchorEl: anchorEl,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          onClose: hideNotification ? hideNotification : this.hideNotification,
          className: cx$1(classes.popover)
        },
        React__default.createElement(
          'div',
          { className: cx$1(classes.notificationWindow), 'data-test': 'notificationWindow' },
          React__default.createElement(
            'div',
            { className: cx$1(classes.header), style: { backgroundColor: headerBackgroundColor }, 'data-test': 'header' },
            React__default.createElement(
              'div',
              { className: cx$1(classes.label) },
              headerText
            ),
            React__default.createElement(
              'div',
              { className: cx$1(classes.chip) },
              numNotifications
            ),
            React__default.createElement(
              IconButton$2,
              { className: cx$1(classes.controls), onClick: hideNotification ? hideNotification : this.hideNotification },
              React__default.createElement(KeyboardArrowUpIcon, { htmlColor: 'white' })
            )
          ),
          React__default.createElement(
            'div',
            { className: cx$1(classes.body), style: { backgroundColor: bodyBackgroundColor } },
            React__default.createElement(NotificationList$1, { notifications: displayEntries })
          )
        )
      )
    );
  }
}, _class$7.propTypes = notifierPropTypes, _class$7.defaultProps = {
  tooltipTitle: 'Notifications',
  headerText: 'Items in Queue'
}, _temp2$5);
Notifier.displayName = 'Notifier';


var Notifier$1 = withStyles$1(styles$2)(Notifier);

var styles$3 = {
  popover: {
    marginTop: 18,
    '& $helpItemText': {
      padding: 0,
      fontSize: 15
    },
    '& $versionWrapper': {
      paddingTop: 17,
      paddingBottom: 17,
      '& $versionText': {
        fontSize: 12,
        color: '#757575'
      }
    }
  },
  helpItemText: {},
  versionWrapper: {},
  versionText: {}
};

var _class$8, _temp2$6;

const helpPropTypes = {
  tooltipTitle: string,
  helpDocLabel: string,
  helpDocLink: string,
  helpDocCallback: func,
  supportLabel: string,
  supportCallback: func,
  onOpen: func,
  onClose: func,
  classes: shape$1({ any })
};

let Help = (_temp2$6 = _class$8 = class Help extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      anchorEl: null
    }, this.showHelpWindow = event => {
      this.setState({
        anchorEl: event.currentTarget
      });

      this.props.onOpen && this.props.onOpen();
    }, this.hideHelpWindow = event => {
      this.setState({ anchorEl: null });
      this.props.onClose && this.props.onClose();
    }, this.openHelpDoc = event => {
      const {
        helpDocLink,
        helpDocCallback
      } = this.props;

      helpDocCallback && helpDocCallback();
      helpDocLink && window.open(helpDocLink, '_blank');
    }, this.openChatWindow = event => {
      this.setState({ anchorEl: null });
      this.props.supportCallback && this.props.supportCallback();
      window.Intercom && window.Intercom('show');
    }, _temp;
  }

  render() {
    const {
      anchorEl
    } = this.state;

    const {
      tooltipTitle,
      helpDocLabel,
      supportLabel,
      helpDocLink,
      helpDocCallback,
      supportCallback,
      classes
    } = this.props;

    const hasHelpDoc = helpDocLink || helpDocCallback;
    const hasSupportChat = supportCallback || window.Intercom;
    const appVersion = _get(window, 'config.appVersion');

    return React__default.createElement(
      'div',
      { className: classes.help },
      React__default.createElement(
        Tooltip,
        { title: tooltipTitle || '', disableFocusListener: true },
        React__default.createElement(
          IconButton$2,
          { onClick: this.showHelpWindow, 'data-veritone-element': 'help-button' },
          React__default.createElement(HelpIcon, { htmlColor: 'white' })
        )
      ),
      React__default.createElement(
        Popover,
        {
          open: Boolean(anchorEl),
          anchorEl: anchorEl,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          onClose: this.hideHelpWindow,
          className: classes.popover
        },
        React__default.createElement(
          List$2,
          { disablePadding: true },

          //Show Help Doc Link
          hasHelpDoc && React__default.createElement(
            ListItem$2,
            {
              button: true,
              onClick: this.openHelpDoc,
              'data-veritone-element': 'show-help-doc-button'
            },
            React__default.createElement(
              ListItemIcon,
              null,
              React__default.createElement(DescriptionIcon, null)
            ),
            React__default.createElement(ListItemText$2, { primary: helpDocLabel, classes: { root: classes.helpItemText } })
          ),

          //Show Chat With Support
          hasSupportChat && React__default.createElement(
            ListItem$2,
            {
              button: true,
              onClick: this.openChatWindow,
              'data-veritone-element': 'open-support-chat-button'
            },
            React__default.createElement(
              ListItemIcon,
              null,
              React__default.createElement(MessageIcon, null)
            ),
            React__default.createElement(ListItemText$2, { primary: supportLabel, classes: { root: classes.helpItemText } })
          ),

          //Show App Version
          appVersion && React__default.createElement(
            Fragment,
            null,
            React__default.createElement(Divider, null),
            React__default.createElement(
              ListItem$2,
              { className: classes.versionWrapper },
              React__default.createElement(ListItemText$2, { primary: appVersion, classes: { primary: classes.versionText } })
            )
          )
        )
      )
    );
  }
}, _class$8.propTypes = helpPropTypes, _class$8.defaultProps = {
  tooltipTitle: 'Help',
  helpDocLabel: 'View Help Docs',
  supportLabel: 'Chat With Support'
}, _temp2$6);
Help.displayName = 'Help';


var Help$1 = withStyles$1(styles$3)(Help);

var SmallVeritoneLogo = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2226px%22%20height%3D%2223px%22%20viewBox%3D%220%200%2026%2023%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVeritone%20Icon%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22veritone-logo-white%22%20transform%3D%22translate%28-17.000000%2C%20-18.000000%29%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Veritone-Icon%22%20transform%3D%22translate%2817.000000%2C%2018.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-2%22%20opacity%3D%220.36%22%20points%3D%2214.5145782%205.68720379e-05%2017.9676588%205.92820853%2021.430218%205.68720379e-05%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-3%22%20opacity%3D%220.9%22%20points%3D%2221.4300664%205.68720379e-05%208.14267299%2022.748872%2017.0495924%2022.748872%2025.1923412%208.74868246%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-12%22%20opacity%3D%220.36%22%20points%3D%223.76364815%200%20-1.33226763e-13%208.75200138%208.14572082%2022.757346%2012.6032349%2015.1338719%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

var styles$4 = {
  appBar: {
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    position: 'fixed',
    '& $logo': {
      width: 60,
      height: 60,
      padding: 10,
      cursor: 'pointer',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'scale-down',
        userSelect: 'none'
      }
    }
  },
  content: {
    height: '100%',
    flexGrow: '1',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 10px',
    '& > div': {
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'row'
    },
    '& $left': {
      justifyContent: 'flex-start'
    },
    '& $right': {
      justifyContent: 'flex-end'
    },
    '& $searchBarHolder': {
      flexGrow: '1'
    },
    '& $title': {
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: 0.23,
      font: 'Dosis, secondaryLogo, tertiaryLogo, Helvetica, sans-serif'
    },
    '& $appLogo': {
      userSelect: 'none'
    },
    '& $controllers': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  iconGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  iconGroupIcon: {
    paddingLeft: 20
  },
  rightActionLabel: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '16px',
    textDecoration: 'none',
    color: 'white',
    cursor: 'pointer'
  },
  noSelect: {
    userSelect: 'none'
  },
  active: {
    opacity: 1
  },
  passive: {
    opacity: 0.8
  },
  logo: {},
  left: {},
  right: {},
  searchBarHolder: {},
  title: {},
  appLogo: {},
  controllers: {}
};

var _class$9, _temp2$7;

const appBarHeight = 60;
const defaultAppBarZIndex = 1000;

let AppBar = (_temp2$7 = _class$9 = class AppBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleRefresh = () => {
      this.props.fetchEnabledApps();
    }, this.goHome = () => {
      window.location.href = window.location.origin;
    }, _temp;
  }

  render() {
    const {
      elevation,
      zIndex,

      logo,
      logoSrc,
      appLogoSrc,
      backgroundColor,
      logoBackgroundColor,
      title,
      titleColor,
      isDiscovery,
      searchBar,
      searchBarJustification,
      searchBarLeftMargin,
      searchBarAlignSelf,

      rightActions,

      help,
      notification,

      appSwitcher,
      onSwitchApp,
      enabledApps,
      isFetchingApps,
      enabledAppsFailedLoading,

      profileMenu,
      user,
      onLogout,
      onEditProfile,
      additionMenuItems,
      totalNotification,
      showNotifications,
      hideNotification,
      classes
    } = this.props;

    return React__default.createElement(
      Paper,
      {
        'data-test': 'appbar',
        component: 'header',
        square: true,
        elevation: elevation,
        className: classes.appBar,
        style: {
          height: appBarHeight,
          background: backgroundColor,
          zIndex: zIndex
        }
      },
      React__default.createElement(
        'div',
        {
          'data-test': 'appbarLogo',
          className: classes.logo,
          style: { backgroundColor: logoBackgroundColor },
          onClick: this.goHome
        },
        logo && React__default.createElement('img', { src: logoSrc, draggable: 'false' })
      ),
      React__default.createElement(
        'div',
        { className: classes.content, style: { color: titleColor } },
        React__default.createElement(
          'div',
          {
            className: cx$1(classes.left, classes.noSelect),
            onClick: this.goHome
          },
          appLogoSrc ? React__default.createElement('img', {
            className: classes.appLogo,
            src: appLogoSrc,
            draggable: 'false'
          }) : React__default.createElement(
            'div',
            { 'data-test': 'appbarTitle', className: classes.title },
            title
          )
        ),
        React__default.createElement(
          'div',
          {
            'data-test': 'appbarSearch',
            className: classes.searchBarHolder,
            style: {
              justifyContent: searchBarJustification,
              marginLeft: searchBarLeftMargin,
              alignSelf: searchBarAlignSelf
            }
          },
          searchBar || React__default.createElement('div', { id: 'veritone-search-bar' })
        ),
        React__default.createElement(
          'div',
          { className: classes.right },
          React__default.createElement(
            'div',
            { className: classes.controllers },
            //Custom Controllers (Copy over from the previous app bar version)
            rightActions && rightActions.length > 0 && React__default.createElement(
              'div',
              {
                className: cx$1(classes.iconGroup, classes.noSelect)
              },
              rightActions.map(({ label, onClick, isActive }) => React__default.createElement(
                'div',
                { className: classes.iconGroupIcon, key: label },
                React__default.createElement(
                  'span',
                  {
                    onClick: onClick,
                    className: cx$1(classes.rightActionLabel, isActive ? classes.active : classes.passive)
                  },
                  label
                )
              ))
            ),
            //Notifications
            notification && React__default.createElement(Notifier$1, _extends({}, notification, {
              totalNotification: totalNotification,
              showNotifications: showNotifications,
              hideNotification: hideNotification
            })),
            //Help
            help && React__default.createElement(Help$1, help),
            //App Switcher
            appSwitcher && React__default.createElement(
              'div',
              { 'data-test': 'appbarSwitcher' },
              React__default.createElement(AppSwitcher$1, {
                enabledApps: enabledApps,
                isFetchingApps: isFetchingApps,
                onSwitchApp: onSwitchApp,
                handleRefresh: this.handleRefresh,
                enabledAppsFailedLoading: enabledAppsFailedLoading
              })
            ),
            //User Profile
            profileMenu && React__default.createElement(
              'div',
              { 'data-test': 'appbarProfile' },
              React__default.createElement(ProfileMenu$1, {
                enabledApps: enabledApps,
                isDiscovery: isDiscovery,
                onLogout: onLogout,
                onEditProfile: onEditProfile,
                user: user,
                additionMenuItems: additionMenuItems
              })
            ),
            //Close Button
            this.props.closeButton && this.props.onClose && React__default.createElement(
              'div',
              null,
              React__default.createElement(
                'div',
                { style: { marginLeft: 'auto' } },
                React__default.createElement(
                  IconButton$2,
                  { onClick: this.props.onClose },
                  React__default.createElement(CloseIcon, { htmlColor: 'white' })
                )
              )
            )
          )
        )
      )
    );
  }
}, _class$9.propTypes = {
  title: string,
  titleColor: string,
  backgroundColor: string,
  logoBackgroundColor: string,
  enabledApps: arrayOf(shape$1({
    name: string,
    permissionId: number,
    iconClass: string,
    displayName: string
  })),
  currentAppName: string,
  isDiscovery: bool,
  rightActions: arrayOf(shape$1({
    label: string.isRequired,
    onClick: func
  })),
  elevation: number,
  profileMenu: bool,
  appSwitcher: bool,
  closeButton: bool,
  logo: bool,
  logoSrc: string,
  appLogoSrc: string,
  onClose: func,
  enabledAppsFailedLoading: bool,
  isFetchingApps: bool,
  onLogout: func,
  onEditProfile: func,
  fetchEnabledApps: func,
  user: objectOf(any),
  onSwitchApp: func,
  additionMenuItems: arrayOf(element),
  help: shape$1(helpPropTypes),
  notification: shape$1(notifierPropTypes),
  searchBar: oneOfType([bool, element]),
  searchBarJustification: oneOf(['flex-start', 'center', 'flex-end']),
  searchBarLeftMargin: oneOfType([string, number]),
  searchBarAlignSelf: oneOf(['baseline', 'auto', 'inherit', 'center', 'flex-start', 'flex-end']),
  zIndex: number,
  totalNotification: number,
  showNotifications: func,
  hideNotification: func,
  classes: shape$1({ any })
}, _class$9.defaultProps = {
  logo: true,
  logoSrc: SmallVeritoneLogo,
  titleColor: '#FFFFFF',
  backgroundColor: '#325491',
  logoBackgroundColor: 'rgba(0,0,0,0.2)',
  rightActions: [],
  elevation: 2,
  onLogout: () => {},
  onEditProfile: () => {},
  fetchEnabledApps: () => {},
  onSwitchApp: () => {},
  searchBarJustification: 'center',
  searchBarLeftMargin: 0,
  zIndex: defaultAppBarZIndex,
  searchBarAlignSelf: 'center'
}, _temp2$7);
AppBar.displayName = 'AppBar';


var index = withStyles$1(styles$4)(AppBar);

const muiTextStyle = muiText('body1');

var styles$5 = {
  container: _extends({}, muiTextStyle, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fafafa !important',
    color: lightBlack,
    // copied from material-ui
    transition: 'margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
    '& > *': {
      paddingLeft: 30
    },
    '& > a': {
      color: lightBlack
    }
  })
};

const appFooterHeightShort = 40;
const appFooterHeightTall = 65;

const useStyles = makeStyles(styles$5);

const AppFooter = ({
  children,
  elevation = 2,
  leftOffset = 0,
  height = 'short'
}) => {
  const classes = useStyles();
  const footerHeight = {
    short: appFooterHeightShort,
    tall: appFooterHeightTall
  }[height];

  return React__default.createElement(
    Paper,
    {
      component: 'footer',
      square: true,
      elevation: elevation,
      className: classes.container,
      style: { height: footerHeight, marginLeft: leftOffset }
    },
    children
  );
};

AppFooter.displayName = 'AppFooter';
AppFooter.propTypes = {
  children: node,
  elevation: number,
  leftOffset: number,
  height: oneOf(['short', 'tall'])
};

const captionText$2 = muiText('caption');

var styles$6 = {
  container: {
    overflow: 'hidden',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  },
  labelBackgroundContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    height: '100%'
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: lightBlack,
    textAlign: 'center',
    height: '30%',
    width: '100%',
    '& span': _extends({}, captionText$2, {
      fontWeight: '200 !important',
      color: 'white'
    })
  }
};

const useStyles$1 = makeStyles(styles$6);

const Avatar = ({ src, size = 85, label, onClick }) => {
  const classes = useStyles$1();
  return React__default.createElement(
    ButtonBase$2,
    { centerRipple: true, onClick: onClick, disabled: !onClick },
    React__default.createElement(
      'div',
      {
        style: {
          backgroundImage: `url(${src})`,
          height: size,
          width: size,
          cursor: onClick ? 'pointer' : 'initial'
        },
        className: classes.container
      },
      label && React__default.createElement(
        'div',
        { className: classes.labelBackgroundContainer },
        React__default.createElement(
          'div',
          { className: classes.labelContainer },
          React__default.createElement(
            'span',
            null,
            label
          )
        )
      )
    )
  );
};

Avatar.displayName = 'Avatar';
Avatar.propTypes = {
  src: string.isRequired,
  size: number,
  label: string,
  onClick: func
};

const captionText$3 = muiText('caption');

var styles$7 = {
  root: _extends({}, captionText$3, {
    textTransform: 'lowercase',
    backgroundColor: `${grey4} !important`,
    border: `1px solid ${barelyBlack} !important`
  })
};

var _class$a, _temp2$8;

let Chip = (_temp2$8 = _class$a = class Chip extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      hovered: false
    }, this.handleMouseOver = () => {
      if (this.props.hoveredLabel) {
        this.setState({ hovered: true });
      }
    }, this.handleMouseOut = () => {
      if (this.props.hoveredLabel) {
        this.setState({ hovered: false });
      }
    }, _temp;
  }

  render() {
    const _props = this.props,
          { hoveredLabel, label, classes } = _props,
          chipProps = objectWithoutProperties(_props, ['hoveredLabel', 'label', 'classes']);

    return React__default.createElement(
      'div',
      { onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut },
      React__default.createElement(LibChip, _extends({
        classes: { root: classes.root }
      }, chipProps, {
        label: this.state.hovered ? hoveredLabel : label
      }))
    );
  }
}, _class$a.propTypes = {
  label: node,
  hoveredLabel: string,
  classes: shape$1({ any })
}, _temp2$8);
Chip.displayName = 'Chip';


var Chip$1 = withStyles$1(styles$7)(Chip);

var styles$8 = {
  lozenge: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 18,
    borderRadius: 2,
    padding: '0 8px',
    textTransform: 'uppercase',
    fontSize: 10,
    fontWeight: 'bold',
    '& i': {
      fontSize: 11,
      marginRight: 5
    }
  }
};

const useStyles$2 = makeStyles(styles$8);

const Lozenge = (_ref) => {
  let {
    children,
    iconClassName,
    backgroundColor,
    textColor,
    border,
    className
  } = _ref,
      props = objectWithoutProperties(_ref, ['children', 'iconClassName', 'backgroundColor', 'textColor', 'border', 'className']);

  const classes = useStyles$2();
  return React__default.createElement(
    'div',
    _extends({
      className: className || classes.lozenge,
      style: {
        backgroundColor: backgroundColor || indigo$1[500],
        color: textColor || '#fff',
        border: border || 'none'
      }
    }, props),
    iconClassName && React__default.createElement('i', { className: iconClassName }),
    children
  );
};

Lozenge.displayName = 'Lozenge';
Lozenge.propTypes = {
  children: node.isRequired,
  iconClassName: string,
  backgroundColor: string,
  textColor: string,
  border: string,
  className: string
};

var _class$b, _temp$2;

let DelayedProgress = (_temp$2 = _class$b = class DelayedProgress extends React__default.Component {

  render() {
    return React__default.createElement(
      Fade,
      {
        'in': this.props.loading,
        style: {
          transitionDelay: this.props.loading ? `${this.props.delay}ms` : '0ms'
        },
        unmountOnExit: true
      },
      React__default.createElement(CircularProgress$2, this.props.circularProgressProps)
    );
  }
}, _class$b.propTypes = {
  loading: bool,
  delay: number,
  circularProgressProps: objectOf(any)
}, _class$b.defaultProps = {
  delay: 800,
  loading: false
}, _temp$2);
DelayedProgress.displayName = 'DelayedProgress';

var styles$9 = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    color: darkBlack,
    backgroundColor: grey1
  }
};

// https://gist.github.com/jtheisen/f680afab642454fc0747b21ec3b11e02
function intersperse(a, f) {
  const pairs = _zip(_tail(a), _slice(0, -1, a));

  const inner = _map(pairs, _isFunction(f) ? _spread(f) : _constant(f));
  const interposed = _zip(a, inner);

  return _flow(_flatten, _slice(0, -1))(interposed);
}

var styles$a = {
  tabsContainer: {
    width: '100%'
  },
  sectionTreeTab: {
    width: '100%',
    height: 50,
    borderBottom: `1px solid ${grey4} !important`,
    backgroundColor: `${grey1} !important`,
    '&$selected': {
      backgroundColor: `${grey2} !important`
    },
    '& $muiButtonLabelOverride': {
      display: 'inline-flex',
      justifyContent: 'flex-start',

      '& label': {
        flexGrow: 1,
        textAlign: 'left'
      },
      '& $leftIcon': {
        marginRight: 15,
        fontSize: 20,
        display: 'flex'
      },
      '& $rightIcon': {
        justifySelf: 'flex-end',
        display: 'flex'
      }
    }
  },
  selected: {},
  muiButtonLabelOverride: {},
  leftIcon: {},
  rightIcon: {}
};

const nodeShape = {
  label: string,
  icon: element,
  iconClassName: string
};
nodeShape.children = objectOf(shape$1(nodeShape));

const sectionsShape = shape$1(nodeShape);
const useStyles$3 = makeStyles(styles$a);

function SectionTree({
  sections,
  activePath,
  onNavigate,
  selectedItemClasses,
  classes
}) {
  const muiClasses = useStyles$3();
  const getDeepestMatchedPath = () => {
    // find the deepest section we can match in the tree by dropping pieces
    // from the activePath until we find one that works.
    // this can probably be done more cleanly.
    return activePath.reduce(result => {
      const tryPath = intersperse(result, 'children');
      const maybeSection = _get(sections.children, tryPath);
      return maybeSection ? result : _initial(result);
    }, [...activePath]);
  };

  const getNavigationRelativePath = () => {
    const deepestMatchingPath = getDeepestMatchedPath();
    const showingPartialPath = deepestMatchingPath !== activePath;
    return showingPartialPath ? deepestMatchingPath : activePath;
  };

  const handleNavigateForward = path => {
    onNavigate([...getNavigationRelativePath(), path]);
  };

  const handleNavigateBack = () => {
    onNavigate(_initial(getNavigationRelativePath()));
  };

  const handleNavigateSibling = path => {
    onNavigate([..._initial(getNavigationRelativePath()), path]);
  };

  const deepestMatchedPath = getDeepestMatchedPath();
  const deepestMatchedPathParent = _initial(deepestMatchedPath);

  const currentVisibleSection = activePath.length === 0 ? sections // root visible by default
  : _get(sections.children, // skip root when navigating
  intersperse(deepestMatchedPath, 'children'));

  const currentVisibleSectionParent = _get(sections.children, intersperse(deepestMatchedPathParent, 'children'), sections);

  const parentIsRoot = currentVisibleSectionParent === sections;
  const selectedItemHasChildren = !!currentVisibleSection.children;
  const rootItemSelected = parentIsRoot && !selectedItemHasChildren;

  return React__default.createElement(
    'div',
    { className: muiClasses.tabsContainer },
    !rootItemSelected && activePath.length > 0 && React__default.createElement(SectionTreeTab, {
      selectedClasses: selectedItemClasses,
      classes: classes,
      selected: true,
      label: currentVisibleSection.label,
      leftIcon: React__default.createElement(ArrowBackIcon, null)
      // eslint-disable-next-line react/jsx-no-bind
      , onClick: handleNavigateBack,
      'data-testtarget': 'back-button',
      btnActionTrackName: currentVisibleSection.btnActionTrackName
    }),
    _map(
    // render the parent (w/ current section highlighted + its siblings)
    // when we're at a leaf path
    currentVisibleSection.children ? currentVisibleSection.children : currentVisibleSectionParent.children, ({ label, formComponentId, children, icon, iconClassName, btnActionTrackName }, path) => React__default.createElement(SectionTreeTab, {
      selectedClasses: selectedItemClasses,
      classes: classes,
      selected: label === currentVisibleSection.label,
      label: label,
      leftIcon: iconClassName ? React__default.createElement('span', { className: iconClassName }) : icon,
      rightIcon: children && Object.keys(children).length && React__default.createElement(ChevronRightIcon, null),
      key: `${label}-${path}`,
      id: path,
      onClick: currentVisibleSection.children ? handleNavigateForward : handleNavigateSibling,
      btnActionTrackName: btnActionTrackName
    }))
  );
}SectionTree.displayName = 'SectionTree';

SectionTree.propTypes = {
  sections: sectionsShape.isRequired,
  activePath: arrayOf(string).isRequired,
  onNavigate: func.isRequired,
  selectedItemClasses: shape$1({
    leftIcon: string
  }),
  classes: shape$1({
    leftIcon: string
  })
};

const SectionTreeTab = ({
  label = '',
  id,
  leftIcon,
  rightIcon,
  selected,
  selectedClasses = {},
  classes = {},
  onClick = _noop,
  btnActionTrackName
}) => {
  const muiClasses = useStyles$3();
  return (
    /* eslint-disable react/jsx-no-bind */
    React__default.createElement(
      Button$2,
      {
        classes: {
          root: cx$1(muiClasses.sectionTreeTab, { [muiClasses.selected]: selected }),
          label: muiClasses.muiButtonLabelOverride
        },
        onClick: () => onClick(id),
        'data-veritone-element': btnActionTrackName || `sidebar-${_kebabCase(label.toLowerCase())}-button`
      },
      React__default.createElement(
        'span',
        {
          className: cx$1(muiClasses.leftIcon, classes.leftIcon, {
            [selectedClasses.leftIcon]: selected
          })
        },
        leftIcon
      ),
      React__default.createElement(
        'span',
        { className: muiClasses.label },
        label
      ),
      React__default.createElement(
        'span',
        { className: muiClasses.rightIcon },
        rightIcon
      )
    )
  );
};

SectionTreeTab.displayName = 'SectionTreeTab';
SectionTreeTab.propTypes = {
  label: string,
  id: string,
  leftIcon: element,
  rightIcon: element,
  selected: bool,
  onClick: func,
  classes: objectOf(any),
  selectedClasses: objectOf(any),
  btnActionTrackName: string
};

const useStyles$4 = makeStyles(styles$9);

function NavigationSideBarContainer({
  sections,
  activePath,
  onNavigate,
  selectedItemClasses,
  classes
}) {
  const muiClasses = useStyles$4();
  return React__default.createElement(
    'div',
    { className: muiClasses.container },
    React__default.createElement(
      'div',
      { style: { width: '100%' } },
      React__default.createElement(SectionTree, {
        sections: sections,
        activePath: activePath,
        onNavigate: onNavigate,
        classes: classes,
        selectedItemClasses: selectedItemClasses
      })
    )
  );
}

NavigationSideBarContainer.displayName = 'NavigationSideBarContainer';
NavigationSideBarContainer.propTypes = {
  sections: sectionsShape.isRequired,
  classes: objectOf(any),
  selectedItemClasses: objectOf(any),
  activePath: arrayOf(string).isRequired,
  onNavigate: func.isRequired
};

var styles$b = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    color: darkBlack,
    backgroundColor: grey1
  }
};

const body1Text$1 = muiText('body1');

var styles$c = {
  container: {
    width: '100%',
    height: 45,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: grey1,
    borderBottom: `1px solid ${grey4}`
  },
  rightIconButtonContainer: {
    display: 'inline-block',
    width: 50
  },
  multiTabsContainer: {
    flexGrow: 1
  },
  singleTabContainer: {
    flexGrow: 1,
    paddingLeft: 25
  },
  muiTabsFlexContainerOverride: {
    height: 46
  },
  muiTabButtonRootOverride: {
    minWidth: 'initial !important', // hack: 'get rid of material-ui's responsive scaling of tabs
    color: darkBlack,
    fontSize: 14 // hack: 'get rid of material-ui's responsive scaling of tabs
  },
  singleTabLabel: _extends({}, body1Text$1, {
    textTransform: 'uppercase',
    color: darkBlack
  })
};

const useStyles$5 = makeStyles(styles$c);
const MultipleTabHeader = ({ tabs, selectedTab, onSelectTab }) => {
  const classes = useStyles$5();
  return React__default.createElement(
    Tabs,
    {
      value: selectedTab,
      onChange: onSelectTab,
      indicatorColor: 'primary',
      textColor: 'primary',
      classes: {
        flexContainer: classes.muiTabsFlexContainerOverride
      }
    },
    tabs.map(t => React__default.createElement(Tab, {
      classes: {
        root: classes.muiTabButtonRootOverride
      },
      value: t,
      label: t,
      key: t
    }))
  );
};

MultipleTabHeader.displayName = 'MultipleTabHeader';
MultipleTabHeader.propTypes = {
  tabs: arrayOf(string).isRequired,
  selectedTab: string.isRequired,
  onSelectTab: func.isRequired
};

const useStyles$6 = makeStyles(styles$c);
const SingleTabHeader = ({ tab }) => {
  const classes = useStyles$6();
  return React__default.createElement(
    'div',
    { className: classes.singleTabLabel },
    tab
  );
};

SingleTabHeader.displayName = 'SingleTabHeader';
SingleTabHeader.propTypes = {
  tab: string.isRequired
};

var _class$c, _temp$3;

let DiscoverySidebarHeader = (_temp$3 = _class$c = class DiscoverySidebarHeader extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.container },
      this.props.tabs.length > 1 ? React__default.createElement(
        'div',
        { className: classes.multiTabsContainer },
        React__default.createElement(MultipleTabHeader, {
          tabs: this.props.tabs,
          selectedTab: this.props.selectedTab,
          onSelectTab: this.props.onSelectTab
        })
      ) : React__default.createElement(
        'div',
        { className: classes.singleTabContainer },
        React__default.createElement(SingleTabHeader, { tab: this.props.tabs[0] })
      ),
      this.props.rightIconButton && React__default.createElement(
        'div',
        { className: classes.rightIconButtonContainer },
        this.props.rightIconButtonElement
      )
    );
  }
}, _class$c.propTypes = {
  tabs: arrayOf(string).isRequired,
  selectedTab: string.isRequired,
  rightIconButton: bool,
  rightIconButtonElement: element,
  onSelectTab: func.isRequired,
  classes: shape$1({ any })
}, _temp$3);
DiscoverySidebarHeader.displayName = 'DiscoverySidebarHeader';


var Header = withStyles$1(styles$c)(DiscoverySidebarHeader);

var styles$d = {
  tabsContainer: {
    width: '100%'
  },
  sectionTreeTab: {
    width: '100%',
    height: 50,
    borderBottom: `1px solid ${grey4} !important`,
    backgroundColor: `${grey1} !important`,
    '& $dark': {
      backgroundColor: `${grey2} !important`
    },
    '& $muiButtonLabelOverride': {
      display: 'inline-flex',
      justifyContent: 'flex-start',
      '& $label': {
        flexGrow: 1,
        textAlign: 'left'
      },
      '& $leftIcon': {
        marginRight: 15
      },
      '& $rightIcon': {
        justifySelf: 'flex-end'
      }
    }
  },
  dark: {},
  muiButtonLabelOverride: {},
  label: {},
  leftIcon: {},
  rightIcon: {}
};

var _class$d, _temp2$9;

const nodeShape$1 = {
  // formComponentId for a leaf, or label/children for a node
  label: string,
  formComponentId: string
};
nodeShape$1.children = arrayOf(shape$1(nodeShape$1));

const sectionsShape$1 = shape$1(nodeShape$1);
const useStyles$7 = makeStyles(styles$d);

let SectionTree$1 = (_temp2$9 = _class$d = class SectionTree extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleNavigateForward = index => {
      this.props.onNavigate([...this.props.activePath, index]);
    }, this.handleNavigateBack = () => {
      this.props.onNavigate(_initial(this.props.activePath));
    }, _temp;
  }

  render() {
    const currentPath = intersperse(this.props.activePath, 'children');
    const { classes } = this.props;
    const currentVisibleSection = _get(this.props.sections.children, // skip root when navigating
    currentPath, this.props.sections // root visible by default
    );

    const visibleFormComponentIdAtLeaf = currentVisibleSection.children.length === 1 && currentVisibleSection.children[0].formComponentId;

    return React__default.createElement(
      'div',
      { className: classes.tabsContainer },
      currentPath.length > 0 && React__default.createElement(SectionTreeTab$1, {
        dark: true,
        label: currentVisibleSection.label,
        leftIcon: React__default.createElement(ArrowBackIcon, null),
        id: -1,
        onClick: this.handleNavigateBack,
        'data-testtarget': 'back-button'
      }),
      visibleFormComponentIdAtLeaf ? this.props.formComponents[visibleFormComponentIdAtLeaf] : currentVisibleSection.children.map(({ visible, label, formComponentId, children }, i) => visible !== false && React__default.createElement(SectionTreeTab$1, {
        label: label,
        rightIcon: React__default.createElement(ChevronRightIcon, null),
        key: label,
        id: i,
        onClick: this.handleNavigateForward
      }))
    );
  }
}, _class$d.propTypes = {
  sections: sectionsShape$1.isRequired,
  formComponents: objectOf(element).isRequired,
  activePath: arrayOf(number).isRequired,
  onNavigate: func.isRequired,
  classes: shape$1({ any })
}, _temp2$9);
SectionTree$1.displayName = 'SectionTree';


var SectionTree$2 = withStyles$1(styles$d)(SectionTree$1);

const SectionTreeTab$1 = ({
  label,
  id,
  leftIcon,
  rightIcon,
  filterCount,
  dark,
  onClick = _noop
}) => {
  const classes = useStyles$7();
  return (
    /* eslint-disable react/jsx-no-bind */
    React__default.createElement(
      Button$2,
      {
        classes: {
          root: cx$1(classes.sectionTreeTab, { [classes.dark]: dark }),
          label: classes.muiButtonLabelOverride
        },
        onClick: () => onClick(id)
      },
      React__default.createElement(
        'span',
        { className: classes.leftIcon },
        leftIcon
      ),
      React__default.createElement(
        'span',
        { className: classes.label },
        label
      ),
      filterCount > 0 && React__default.createElement(
        'div',
        { onMouseOver: () => console.log('hover') },
        React__default.createElement(Chip$1, {
          label: filterCount,
          hoveredLabel: 'clear',
          style: { height: 18 },
          onClick: e => e.stopPropagation()
        })
      ),
      React__default.createElement(
        'span',
        { className: classes.rightIcon },
        rightIcon
      )
    )
  );
};

SectionTreeTab$1.displayName = 'SectionTreeTab';
SectionTreeTab$1.propTypes = {
  label: string,
  id: number,
  leftIcon: element,
  rightIcon: element,
  filterCount: number,
  dark: bool,
  onClick: func
};

const body1Text$2 = muiText('body1');
const captionText$4 = muiText('caption');

var styles$e = {
  container: {
    width: '100%',
    padding: 15,
    borderBottom: `1px solid ${grey4}`
  },
  headerContainer: _extends({}, body1Text$2, {
    display: 'flex',
    justifyContent: 'space-between'
  }),
  clearLink: _extends({}, captionText$4, {
    textDecoration: 'none'
  }),
  filtersContainer: _extends({}, body1Text$2),
  filterItem: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 5
  },
  clearButton: {
    padding: 4,
    backgroundColor: blue1,
    '& svg': {
      color: 'white',
      height: 10,
      width: 10
    }
  },
  filterItemLink: {
    paddingLeft: 5
  }
};

var _class$e, _temp2$a;

let FiltersListItem = (_temp2$a = _class$e = class FiltersListItem extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleClear = e => {
      e.preventDefault();
      this.props.onClearFilter(this.props.id);
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.filterItem },
      React__default.createElement(
        IconButton$2,
        {
          classes: { root: classes.clearButton },
          onClick: this.handleClear
        },
        React__default.createElement(CloseIcon, null)
      ),
      React__default.createElement(
        'a',
        {
          href: '#',
          className: classes.filterItemLink,
          onClick: this.handleClear
        },
        this.props.label,
        ' ',
        this.props.number && `(${this.props.number})`
      )
    );
  }
}, _class$e.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  number: number,
  onClearFilter: func.isRequired,
  classes: shape$1({ any })
}, _class$e.defaultProps = {}, _temp2$a);
FiltersListItem.displayName = 'FiltersListItem';


var FiltersListItem$1 = withStyles$1(styles$e)(FiltersListItem);

var _class$f, _temp2$b;

let AllFiltersList = (_temp2$b = _class$f = class AllFiltersList extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleClearAllFilters = e => {
      e.preventDefault();
      this.props.onClearAllFilters();
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.container },
      React__default.createElement(
        'div',
        { className: classes.headerContainer },
        React__default.createElement(
          'span',
          { className: classes.header },
          'Your Selections'
        ),
        React__default.createElement(
          'a',
          {
            className: classes.clearLink,
            onClick: this.handleClearAllFilters,
            href: '#'
          },
          'Clear all'
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.filtersContainer },
        this.props.filters.map(filter => React__default.createElement(FiltersListItem$1, _extends({
          key: filter.id,
          onClearFilter: this.props.onClearFilter
        }, filter)))
      )
    );
  }
}, _class$f.propTypes = {
  onClearAllFilters: func.isRequired,
  onClearFilter: func.isRequired,
  filters: arrayOf(shape$1({
    label: string.isRequired,
    number: number,
    id: string.isRequired
  })),
  classes: shape$1({ any })
}, _class$f.defaultProps = {
  filters: []
}, _temp2$b);
AllFiltersList.displayName = 'AllFiltersList';


var AllFiltersList$1 = withStyles$1(styles$e)(AllFiltersList);

var _class$g, _temp$4, _class2, _temp3;

let DiscoverySideBarContainerPureComponent = (_temp$4 = _class$g = class DiscoverySideBarContainerPureComponent extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.container },
      React__default.createElement(Header, {
        tabs: this.props.tabs,
        selectedTab: this.props.selectedTab,
        rightIconButton: this.props.clearAllFilters,
        rightIconButtonElement: React__default.createElement(
          IconButton$2,
          { onClick: this.props.onClearAllFilters },
          React__default.createElement(ClearFiltersIconFixme, null)
        ),
        onSelectTab: this.props.onSelectTab
      }),
      this.props.selectedTab === 'Filters' && React__default.createElement(
        'div',
        { style: { width: '100%' } },
        this.props.filtersActivePath.length === 0 && this.props.selectedFilters.length > 0 && React__default.createElement(AllFiltersList$1, {
          filters: this.props.selectedFilters // fixme
          , onClearAllFilters: this.props.onClearAllFilters,
          onClearFilter: this.props.onClearFilter
        }),
        React__default.createElement(SectionTree$2
        // todo: add filters
        , { sections: this.props.filtersSections,
          activePath: this.props.filtersActivePath,
          onNavigate: this.props.onFiltersNavigate,
          formComponents: this.props.formComponents
        })
      ),
      this.props.selectedTab === 'Browse' && React__default.createElement(
        'div',
        { 'data-testtarget': 'browse', style: { width: '100%' } },
        'this is browse content'
      )
    );
  }
}, _class$g.propTypes = {
  formComponents: objectOf(element).isRequired,
  filtersSections: sectionsShape$1.isRequired,
  selectedFilters: arrayOf(object), // see AllFiltersList.filters
  onClearAllFilters: func,
  onClearFilter: func,
  clearAllFilters: bool,

  // provided by wrapper:
  tabs: arrayOf(string).isRequired,
  selectedTab: string.isRequired,
  onSelectTab: func.isRequired,
  filtersActivePath: arrayOf(number).isRequired,
  onFiltersNavigate: func.isRequired,
  classes: shape$1({ any })
}, _class$g.defaultProps = {
  selectedFilters: []
}, _temp$4);
DiscoverySideBarContainerPureComponent.displayName = 'DiscoverySideBarContainerPureComponent';


const DiscoverySideBarContainerPure = withStyles$1(styles$b)(DiscoverySideBarContainerPureComponent);

// state provider for top level sidebar state-- selected tabs, sections etc.
let DiscoverySideBarContainer = (_temp3 = _class2 = class DiscoverySideBarContainer extends React__default.Component {
  constructor(...args) {
    var _temp2;

    return _temp2 = super(...args), this.state = {
      selectedTab: this.props.tabs[0],
      filtersActivePath: []
    }, this.handleSelectTab = (_, tab) => {
      this.setState({ selectedTab: tab });
    }, this.handleFiltersNavigate = newPath => {
      this.setState({ filtersActivePath: newPath });
    }, _temp2;
  }

  render() {
    return React__default.createElement(DiscoverySideBarContainerPure, _extends({}, this.props, {
      selectedTab: this.state.selectedTab,
      onSelectTab: this.handleSelectTab,
      filtersActivePath: this.state.filtersActivePath,
      onFiltersNavigate: this.handleFiltersNavigate
    }));
  }
}, _class2.propTypes = {
  tabs: arrayOf(string)
}, _class2.defaultProps = {
  tabs: ['Browse', 'Filters']
}, _temp3);
DiscoverySideBarContainer.displayName = 'DiscoverySideBarContainer';

var styles$f = {
  dialog: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 950,
    background: 'white',
    opacity: 0,
    height: 0,
    overflowY: 'hidden',
    transform: 'translateY(-50px)',
    boxShadow: 'rgba(0, 0, 0, 0.247059) 0 14px 45px, rgba(0, 0, 0, 0.219608) 0 10px 18px'
  },
  dialogIsOpen: {
    height: 'initial',
    opacity: 1,
    transform: 'translateY(0)',
    transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1), opacity 100ms'
  }
};

var _class$h, _temp$5;

let FullScreenDialog = (_temp$5 = _class$h = class FullScreenDialog extends React__default.Component {

  render() {
    const { classes } = this.props;
    const containerClasses = cx$1(classes['dialog'], this.props.open && classes['dialogIsOpen'], this.props.className);

    return React__default.createElement(
      'div',
      { className: containerClasses },
      this.props.children
    );
  }
}, _class$h.propTypes = {
  children: node,
  open: bool,
  className: string,
  classes: shape$1({ any })
}, _class$h.defaultProps = {}, _temp$5);
FullScreenDialog.displayName = 'FullScreenDialog';


var index$1 = withStyles$1(styles$f)(FullScreenDialog);

const body1Text$3 = muiText('body1');
const body2Text = muiText('body2');

var styles$g = {
  paper: {
    height: 65,
    marginBottom: 2
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 25px'
  },
  label: _extends({}, body2Text, {
    width: '40%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }),
  value: _extends({}, body1Text$3, {
    color: lightBlack,
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }),
  actionIconContainer: {
    width: 70
  },
  actionIcon: {
    textAlign: 'right'
  }
};

const useStyles$8 = makeStyles(styles$g);

const RaisedTextField = ({
  label,
  value,
  action,
  onClickAction,
  className,
  containerStyle,
  disabled,
  actionTooltipLabel
}) => {
  const classes = useStyles$8();
  const actionIcon = {
    edit: React__default.createElement(EditIcon, null),
    go: React__default.createElement(ArrowRightIcon$1, null)
  }[action];

  return React__default.createElement(
    Paper,
    {
      className: cx$1(classes.paper, className),
      style: containerStyle,
      square: true
    },
    React__default.createElement(
      'div',
      { className: classes.container },
      React__default.createElement(
        'div',
        { className: classes.label },
        label
      ),
      React__default.createElement(
        'div',
        { className: classes.value },
        value
      ),
      React__default.createElement(
        ConditionalToolTip,
        { title: actionTooltipLabel, placement: 'left' },
        React__default.createElement(
          'div',
          { className: classes.actionIconContainer },
          action && (actionIcon ? React__default.createElement(
            IconButton$2,
            {
              className: classes.actionIcon,
              onClick: onClickAction,
              disabled: !action || disabled
            },
            actionIcon
          ) : React__default.createElement(
            Button$2 // className={classes.actionIcon}
            ,
            { onClick: onClickAction,
              disabled: disabled
            },
            action
          ))
        )
      )
    )
  );
};

RaisedTextField.displayName = 'RaisedTextField';
RaisedTextField.propTypes = {
  className: string,
  containerStyle: objectOf(any),
  label: string,
  value: string,
  action: string,
  onClickAction: func,
  disabled: bool,
  actionTooltipLabel: string
};

const ConditionalToolTip = (_ref) => {
  let { title, children } = _ref,
      props = objectWithoutProperties(_ref, ['title', 'children']);
  return title ? React__default.createElement(
    Tooltip,
    _extends({ title: title }, props),
    children
  ) : children;
};

ConditionalToolTip.propTypes = {
  title: string,
  children: node
};

const body1Text$4 = muiText('body1');

var styles$h = {
  container: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    left: 0,
    right: 0,
    // copied from materialUi
    transition: 'margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms ,width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important',
    '&$selected': {
      background: '#f6fbff !important'
    }
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: '1px solid #e0e0e0'
  },
  leftButtonContainer: {
    flexGrow: 0,
    '& $highlight': {
      background: grey2,
      height: '100%',
      display: 'inline-block'
    }
  },
  rightContainer: _extends({
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    padding: '0 22px'
  }, body1Text$4, {
    color: darkBlack,
    '& $selected': {
      fontWeight: 400,
      color: blue3
    },
    '& $rightIconButtons': {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        height: 22
      }
    }
  }),
  selected: {},
  highlight: {},
  rightIconButtons: {}
};

var _class$i, _temp2$c;

const topBarHeight = 45;
let TopBar = (_temp2$c = _class$i = class TopBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      rightMenuOpen: false,
      rightMenuAnchorEl: null
    }, this.openRightMenu = event => {
      this.setState({
        rightMenuOpen: true,
        rightMenuAnchorEl: event.currentTarget
      });
    }, this.closeRightMenu = () => {
      this.setState({
        rightMenuOpen: false
      });
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      Paper,
      {
        style: {
          top: this.props.appBarOffset ? appBarHeight : 0,
          height: topBarHeight,
          marginLeft: this.props.leftOffset,
          background: '#fafafa'
        },
        className: cx$1(classes.container, {
          [classes.selected]: this.props.selected
        }),
        square: true,
        elevation: this.props.elevation,
        'data-test': 'container',
        'data-test-selected': cx$1({
          selected: this.props.selected
        })
      },
      this.props.renderActionButton && React__default.createElement(
        'div',
        {
          className: classes.actionButtonContainer,
          style: { width: this.props.actionButtonContainerWidth }
        },
        this.props.renderActionButton()
      ),
      React__default.createElement(
        'div',
        {
          style: { height: topBarHeight },
          className: classes.leftButtonContainer
        },
        this.props.menuButton && React__default.createElement(
          'div',
          { className: classes.highlight },
          React__default.createElement(
            IconButton$2,
            {
              style: { height: '100%' },
              onClick: this.props.onRequestOpenMenu,
              className: 'menuButton'
            },
            React__default.createElement(MenuIcon, null)
          )
        ),
        this.props.backButton && React__default.createElement(
          IconButton$2,
          {
            style: { height: '100%' },
            onClick: this.props.onClickBackButton,
            className: 'backButton',
            'data-test': 'backButton'
          },
          React__default.createElement(ArrowBackIcon, null)
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.rightContainer },
        React__default.createElement(
          'span',
          { className: cx$1({ [classes.selected]: this.props.selected }) },
          this.props.leftText
        ),
        React__default.createElement(
          'div',
          { className: classes.rightIconButtons },
          this.props.rightIconButtons,
          this.props.rightMenu && this.props.rightMenuItems && this.props.rightMenuItems.length && [React__default.createElement(
            IconButton$2,
            {
              onClick: this.openRightMenu,
              key: 'button',
              className: 'rightMenuButton'
            },
            React__default.createElement(MoreVertIcon, null)
          ), React__default.createElement(
            Menu,
            {
              key: 'menu',
              open: this.state.rightMenuOpen,
              onClose: this.closeRightMenu,
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              anchorEl: this.state.rightMenuAnchorEl,
              getContentAnchorEl: null
            },
            this.props.rightMenuItems.map(({ label, handler }) => React__default.createElement(
              MenuItem,
              { button: true, key: label, onClick: handler },
              React__default.createElement(ListItemText$2, { primary: label })
            ))
          )]
        )
      )
    );
  }
}, _class$i.propTypes = {
  appBarOffset: bool,
  elevation: number,
  leftOffset: number,
  menuButton: bool,
  backButton: bool,
  renderActionButton: func,
  actionButtonContainerWidth: number,
  selected: bool,
  rightMenu: bool,
  rightMenuItems: arrayOf(shape$1({
    label: string.isRequired,
    handler: func.isRequired
  })),
  leftText: string,
  rightIconButtons: arrayOf(element),
  onRequestOpenMenu: func,
  onClickBackButton: func,
  classes: shape$1({ any })
}, _class$i.defaultProps = {
  elevation: 2,
  leftOffset: 0,
  actionButtonContainerWidth: 245
}, _temp2$c);
TopBar.displayName = 'TopBar';


var index$2 = withStyles$1(styles$h)(TopBar);

const subheadText$1 = muiText('subhead');
const captionText$5 = muiText('caption');
const body1 = muiText('body1');

const audio1 = '#00BFA5';
const audio2 = 'rgba(0,191,165,0.05)';
const video1 = '#E81D63';
const video2 = 'rgba(233,30,99,0.05)';
const text1 = '#4A4A4A';
const text2 = 'rgba(117,117,117,0.05)';
const image1 = '#4CAF4F';
const image2 = 'rgba(76,175,80,0.05)';

var styles$i = {
  extensionListContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%'
  },
  extensionListHeader: {
    width: '100%'
  },
  extensionListTitle: _extends({}, subheadText$1, {
    paddingLeft: 20,
    color: lightBlack
  }),
  extensionListCloseButton: {
    position: 'absolute !important',
    top: 0,
    right: 0
  },
  extensionList: {
    overflowY: 'auto',
    height: '100%'
  },
  extensionTypeContainer: {
    borderRadius: 2,
    border: '1px solid',
    margin: '12px auto !important',
    width: 'calc(100% - 40px) !important',
    padding: 10,
    '& $mediaTypeKey': _extends({
      borderRadius: 2,
      color: 'white',
      textTransform: 'uppercase'
    }, captionText$5, {
      padding: '2px 7px'
    }),
    '&$audio': {
      borderColor: audio1,
      backgroundColor: audio2,
      '& $mediaTypeKey': {
        backgroundColor: audio1
      }
    },
    '&$video': {
      borderColor: video1,
      backgroundColor: video2,
      '& $mediaTypeKey': {
        backgroundColor: video1
      }
    },
    '&$text': {
      borderColor: text1,
      backgroundColor: text2,
      '& $mediaTypeKey': {
        backgroundColor: text1
      }
    },
    '&$image': {
      borderColor: image1,
      backgroundColor: image2,
      '& $mediaTypeKey': {
        backgroundColor: image1
      }
    },
    '& $mediaExtension': _extends({}, body1)
  },
  mediaTypeKey: {},
  mediaExtension: {},
  audio: {},
  video: {},
  text: {},
  image: {}
};

const useStyles$9 = makeStyles(styles$i);

const ExtensionPanel = ({ acceptedFileTypes = [], closeExtensionList }) => {
  const classes = useStyles$9();
  const readableTypeNames = {
    'video/*': 'video',
    'audio/*': 'audio',
    'image/*': 'image'
  };
  const typeMapper = {
    audio: [],
    video: [],
    image: [],
    text: []
  };
  acceptedFileTypes.forEach(t => {
    let wasCategorized = false;
    const mappedType = readableTypeNames[t] || mime.extension(t) || t;
    Object.keys(typeMapper).forEach(key => {
      if (t.includes(key)) {
        _isArray(typeMapper[key]) && typeMapper[key].push(mappedType.split('/').slice(-1)[0]);
        wasCategorized = true;
      }
    });
    if (!wasCategorized) {
      // Default insert into text category
      typeMapper.text.push(mappedType.split('/').slice(-1)[0]);
    }
  });

  return React__default.createElement(
    'div',
    { className: classes.extensionListContainer },
    React__default.createElement(
      'div',
      { className: classes.extensionListHeader },
      React__default.createElement(
        'span',
        { className: classes.extensionListTitle },
        'File Extensions'
      ),
      React__default.createElement(
        IconButton$2,
        {
          classes: {
            root: classes.extensionListCloseButton
          },
          'data-veritone-element': 'uploader-extension-close-btn',
          onClick: closeExtensionList,
          disableRipple: true },
        React__default.createElement(CloseIcon, null)
      )
    ),
    React__default.createElement(
      'div',
      { className: classes.extensionList },
      Object.keys(typeMapper).filter(key => typeMapper[key].length).map(key => React__default.createElement(
        Grid,
        {
          key: `${key}-extension-list`,
          'data-veritone-element': 'extension-list-category',
          className: cx$1(classes.extensionTypeContainer, classes[key]),
          container: true,
          spacing: 2 },
        React__default.createElement(
          Grid,
          { item: true, xs: 8, sm: 6, md: 4 },
          React__default.createElement(
            'span',
            { className: classes.mediaTypeKey },
            key
          )
        ),
        _uniq(typeMapper[key]).map(ext => React__default.createElement(
          Grid,
          { key: `${key}-extension-${ext}`, item: true, xs: 8, sm: 6, md: 4 },
          React__default.createElement(
            'span',
            {
              className: classes.mediaExtension,
              'data-veritone-element': 'extension-list-item'
            },
            ext
          )
        ))
      ))
    )
  );
};

ExtensionPanel.displayName = 'ExtensionPanel';
ExtensionPanel.propTypes = {
  acceptedFileTypes: arrayOf(string),
  closeExtensionList: func.isRequired
};

const headlineText = muiText('headline');
const display2Text = muiText('display2');
const body1Text$5 = muiText('body1');
const buttonText = muiText('button');
var styles$j = {
  fileUploader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: grey1,
    border: `4px dashed ${grey4}`,
    paddingTop: 15,
    paddingBottom: 15,
    width: '100%',
    position: 'relative',
    '& $uploaderContainer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '& $fileUploadIcon': {
        color: `${blue1} !important`,
        fontSize: '112px !important',
        lineHeight: '112px !important'
      }
    }
  },
  fileUploaderAcceptText: _extends({
    color: blue1,
    cursor: 'default'
  }, headlineText),
  flat: {
    backgroundColor: `${fullWhite} !important`
  },
  fileUploadIcon: _extends({
    color: '#9a9a9a'
  }, display2Text),
  fileUploaderSubtext: _extends({}, body1Text$5, {
    textAlign: 'center',
    textTransform: 'none',
    marginBottom: '0 !important',
    '&$subtextBlue': {
      marginLeft: 5,
      color: blue1
    }
  }),
  uploaderOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 2
  },
  extensionListOpenButton: _extends({
    position: 'absolute',
    top: 10,
    right: 10
  }, buttonText, {
    textTransform: 'none',
    fontWeight: 'normal !important',
    color: blue1,
    cursor: 'pointer'
  }),
  uploaderContainer: {},
  subtextBlue: {}
};

var _dec, _dec2, _class$j, _class2$1, _temp2$d;
const { FILE } = NativeTypes;

const boxTarget = {
  drop(props, monitor) {
    const droppedFiles = monitor.getItem().files;
    const allowableDroppedFiles = droppedFiles.filter(({ type }) => {
      // only accept dropped files of the correct type. This tries to duplicate
      // the functionality of the html5 file input.

      return props.acceptedFileTypes.includes(type) || props.acceptedFileTypes.some(acceptedType => {
        // deal with video/*, audio/* etc
        if (_endsWith(acceptedType, '/*')) {
          const typePrefix = acceptedType.match(/(.*)\/\*/)[1];
          return _startsWith(type, typePrefix);
        }

        return false;
      });
    });

    if (props.acceptedFileTypes.length) {
      if (allowableDroppedFiles.length) {
        props.onFilesSelected(allowableDroppedFiles);
      }

      const numRejectedFiles = droppedFiles.length - allowableDroppedFiles.length;
      if (numRejectedFiles > 0) {
        props.onFilesRejected(numRejectedFiles);
      }
    } else {
      props.onFilesSelected(droppedFiles);
    }
  }
};

const collect = (connect, monitor) => {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
};

let FileUploader = (_dec = DropTarget(FILE, boxTarget, collect), _dec2 = withStyles$1(styles$j), _dec(_class$j = _dec2(_class$j = (_temp2$d = _class2$1 = class FileUploader extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      showExtensionList: false
    }, this.handleFileSelection = () => {
      if (this._input.files.length > 0) {
        this.props.onFilesSelected(Array.from(this._input.files));
      }

      this._input.value = null;
    }, this.openExtensionList = () => {
      this.setState({ showExtensionList: true });
    }, this.closeExtensionList = () => {
      this.setState({ showExtensionList: false });
    }, this.setInputRef = r => this._input = r, _temp;
  }

  render() {
    const { acceptedFileTypes, connectDropTarget, isOver, classes } = this.props;
    const { showExtensionList } = this.state;

    const acceptMessage = 'Drag & Drop';
    const subMessage = 'your file(s) here, or ';

    return connectDropTarget(React__default.createElement(
      'div',
      { className: cx$1([classes.fileUploader, { [classes.flat]: this.props.useFlatStyle }]) },
      showExtensionList ? React__default.createElement(ExtensionPanel, {
        acceptedFileTypes: acceptedFileTypes,
        closeExtensionList: this.closeExtensionList }) : React__default.createElement(
        'div',
        { className: classes.uploaderContainer },
        !!acceptedFileTypes.length && React__default.createElement(
          'span',
          {
            className: classes.extensionListOpenButton,
            'data-veritone-element': 'uploader-extension-open-btn',
            onClick: this.openExtensionList },
          'Extension Types'
        ),
        React__default.createElement(
          'span',
          null,
          React__default.createElement('i', { className: cx$1(classes.fileUploadIcon, 'icon-ingest') })
        ),
        React__default.createElement(
          'span',
          { className: classes.fileUploaderAcceptText },
          acceptMessage
        ),
        React__default.createElement(
          'label',
          { htmlFor: 'file' },
          React__default.createElement(
            Button$2,
            {
              component: 'span',
              disableFocusRipple: true,
              disableRipple: true },
            React__default.createElement(
              'span',
              { className: classes.fileUploaderSubtext },
              subMessage
            ),
            React__default.createElement(
              'span',
              { className: cx$1(classes.fileUploaderSubtext, classes.subtextBlue) },
              'browse'
            )
          )
        ),
        React__default.createElement('input', {
          accept: acceptedFileTypes.join(','),
          style: { display: 'none' },
          id: 'file',
          multiple: this.props.multiple,
          type: 'file',
          onChange: this.handleFileSelection,
          ref: this.setInputRef
        })
      ),
      isOver && React__default.createElement('div', { className: classes.uploaderOverlay })
    ));
  }
}, _class2$1.propTypes = {
  acceptedFileTypes: arrayOf(string),
  onFilesSelected: func.isRequired,
  useFlatStyle: bool,
  // eslint-disable-next-line react/no-unused-prop-types
  onFilesRejected: func,
  isOver: bool.isRequired,
  connectDropTarget: func.isRequired,
  multiple: bool,
  classes: shape$1({ any })
}, _class2$1.defaultProps = {
  acceptedFileTypes: [],
  onFilesRejected: _noop
}, _temp2$d)) || _class$j) || _class$j);
FileUploader.displayName = 'FileUploader';

function formatBytes(bytes, decimals = 2) {
  if (_isUndefined(bytes)) {
    return 'Size Undetected';
  }
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const previewSize = 40;
const body1Text$6 = muiText('body1');
const filePickerRoundImage = (size, margin = 4) => ({
  width: size,
  height: size,
  margin: margin,
  borderRadius: '50%'
});

var styles$k = {
  fileList: {
    flex: '0 0 50%',
    position: 'relative',
    overflowY: 'auto',
    marginLeft: 15,
    height: '100%'
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 50,
    borderBottom: `1px solid ${grey4}`
  },
  itemPreviewContainer: {
    width: previewSize,
    marginRight: 15
  },
  itemImage: _extends({}, filePickerRoundImage(previewSize), {
    backgroundPosition: 'center',
    backgroundSize: `${previewSize}px auto`,
    backgroundRepeat: 'no-repeat'
  }),

  itemFolderIcon: _extends({}, filePickerRoundImage(previewSize), {
    color: 'white',
    backgroundColor: '#b9b9b9',
    textAlign: 'center',
    fontSize: 25,
    paddingTop: 8,
    paddingLeft: 4
  }),
  itemTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%'
  },
  itemNameText: _extends({}, body1Text$6, {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),
  itemFileSizeText: _extends({}, body1Text$6, {
    color: grey5
  }),
  itemDeleteIcon: {
    width: previewSize,
    height: previewSize,
    padding: 8
  },
  itemActionContainer: {
    display: 'flex'
  }
};

var _class$k, _temp2$e;

let FileListItem = (_temp2$e = _class$k = class FileListItem extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      dataUrl: ''
    }, this.readImageFile = file => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.setState({
          dataUrl: fileReader.result
        });
      };

      if (/^image\//i.test(file.type)) {
        fileReader.readAsDataURL(file);
      } else {
        this.setState({
          dataUrl: ''
        });
      }
    }, this.handleRemoveFile = () => {
      this.props.onRemoveFile(this.props.index);
    }, this.onResizeImage = () => {
      const { file } = this.props;
      this.props.onFileResize(file);
    }, _temp;
  }

  UNSAFE_componentWillMount() {
    this.readImageFile(this.props.file);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.file !== this.props.file) {
      this.readImageFile(nextProps.file);
    }
  }

  get isImageFile() {
    const { file } = this.props;
    const fileType = file['type'];
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    return validImageTypes.includes(fileType);
  }

  render() {
    const { classes, enableResize } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.item },
      React__default.createElement(
        'div',
        { className: classes.itemPreviewContainer },
        this.state.dataUrl.length ? React__default.createElement('div', {
          style: { backgroundImage: `url(${this.state.dataUrl})` },
          className: classes.itemImage
        }) : React__default.createElement(
          'div',
          { className: classes.itemFolderIcon },
          React__default.createElement('i', { className: 'icon-empty-folder' })
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.itemTextContainer },
        React__default.createElement(
          'span',
          { className: classes.itemNameText, 'data-test': 'itemNameText' },
          this.props.file.name
        ),
        React__default.createElement(
          'span',
          { className: classes.itemFileSizeText, 'data-test': 'itemFileSizeText' },
          formatBytes(this.props.file.size)
        )
      ),
      React__default.createElement(
        'div',
        { className: classes.itemActionContainer },
        this.isImageFile && enableResize && React__default.createElement(
          IconButton$2,
          {
            'data-test': 'filePickerResizeBtn',
            className: classes.itemDeleteIcon,
            'aria-label': 'Resize',
            onClick: this.onResizeImage
          },
          React__default.createElement(CropIcon, null)
        ),
        React__default.createElement(
          IconButton$2,
          {
            'data-test': 'filePickerDeleteBtn',
            className: classes.itemDeleteIcon,
            'aria-label': 'Delete',
            onClick: this.handleRemoveFile
          },
          React__default.createElement(DeleteIcon, null)
        )
      )
    );
  }
}, _class$k.propTypes = {
  onRemoveFile: func.isRequired,
  onFileResize: func.isRequired,
  enableResize: bool,
  file: shape$1({
    lastModified: number,
    name: string,
    size: number,
    type: string,
    webkitRelativePath: string
  }).isRequired,
  index: number.isRequired,
  classes: shape$1({ any })
}, _temp2$e);
FileListItem.displayName = 'FileListItem';


var FileListItem$1 = withStyles$1(styles$k)(FileListItem);

let FileList = class FileList extends Component {
  render() {
    const { classes, enableResize = false, onFileResize } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.fileList },
      this.props.files.map((file, index) => {
        return React__default.createElement(FileListItem$1, {
          key: `${file.name}-${file.size}`,
          index: index,
          file: file,
          onRemoveFile: this.props.onRemoveFile,
          enableResize: enableResize,
          onFileResize: onFileResize
        });
      })
    );
  }
};
FileList.displayName = 'FileList';


FileList.propTypes = {
  files: arrayOf(object).isRequired,
  onRemoveFile: func,
  classes: shape$1({ any }),
  enableResize: bool,
  onFileResize: func
};

var FileList$1 = withStyles$1(styles$k)(FileList);

var styles$l = {
  filePickerHeader: {
    width: '100%',
    minHeight: 93,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: grey1,
    borderBottom: `1px solid ${grey4}`
  },
  titleIconContainer: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 10
  },
  filePickerTitle: {
    flex: 'auto',
    fontSize: 18,
    paddingLeft: 20,
    paddingTop: 20
  },
  filePickerMessage: {
    marginLeft: 55,
    paddingBottom: 20,
    fontSize: 14
  },
  filePickerCloseButton: {
    position: 'absolute !important',
    top: 8,
    right: 5
  },
  filePickerFlatHeader: {
    padding: 20,
    paddingBottom: '0',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  count: {
    paddingLeft: '0.5em',
    color: semiBlack,
    fontSize: '0.75em'
  }
};

var _class$l, _temp2$f;

let FilePickerHeader = (_temp2$f = _class$l = class FilePickerHeader extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleTabChange = (event, value) => {
      this.props.onSelectTab(value);
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.filePickerHeader },
      React__default.createElement(
        'span',
        {
          className: classes.filePickerTitle,
          'data-veritone-element': 'picker-header-title',
          'data-test': 'filePickerTitle'
        },
        this.props.titleIcon && React__default.createElement(
          'div',
          { className: classes.titleIconContainer },
          this.props.titleIcon
        ),
        this.props.title,
        this.props.multiple && this.props.maxFiles && React__default.createElement(
          'span',
          { className: classes.count },
          this.props.fileCount,
          ' / ',
          this.props.maxFiles
        )
      ),
      this.props.onClose && React__default.createElement(
        IconButton$2,
        {
          'data-veritone-element': 'picker-header-close-btn',
          classes: {
            root: classes.filePickerCloseButton
          },
          onClick: this.props.onClose
        },
        React__default.createElement('i', { className: 'icon-close-exit' })
      ),
      this.props.message && React__default.createElement(
        'div',
        {
          className: classes.filePickerMessage,
          'data-veritone-element': 'picker-header-msg'
        },
        this.props.message
      ),
      !this.props.hideTabs && React__default.createElement(
        Tabs,
        {
          value: this.props.selectedTab,
          indicatorColor: 'primary',
          onChange: this.handleTabChange,
          className: classes.filePickerTabs
        },
        React__default.createElement(Tab, { label: 'Upload', value: 'upload' }),
        this.props.allowUrlUpload && React__default.createElement(Tab, { label: 'By URL', value: 'by-url' })
      )
    );
  }
}, _class$l.propTypes = {
  selectedTab: string,
  onSelectTab: func,
  onClose: func,
  allowUrlUpload: bool,
  multiple: bool,
  title: string,
  fileCount: number,
  maxFiles: number,
  hideTabs: bool,
  titleIcon: node,
  message: string,
  classes: shape$1({ any })
}, _class$l.defaultProps = {
  title: 'File Picker'
}, _temp2$f);
FilePickerHeader.displayName = 'FilePickerHeader';


var FilePickerHeader$1 = withStyles$1(styles$l)(FilePickerHeader);

var styles$m = {
  filePickerFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: filePickerMargin,
    backgroundColor: grey1,
    '& > *': {
      marginLeft: `calc(${filePickerMargin} / 2) !important`
    }
  },
  hasIntercom: {
    '& > *:lastChild': {
      marginRight: 80
    }
  }
};

var _class$m, _temp$6;

let FilePickerFooter = (_temp$6 = _class$m = class FilePickerFooter extends Component {

  render() {
    const {
      hasIntercom,
      onCancel,
      disabled,
      onSubmit,
      title,
      classes
    } = this.props;
    return React__default.createElement(
      'div',
      { className: cx$1(classes.filePickerFooter, {
          [classes.hasIntercom]: hasIntercom
        }) },
      React__default.createElement(
        Button$2,
        {
          'data-veritone-element': `picker-footer-cancel-button`,
          onClick: onCancel
        },
        'Cancel'
      ),
      React__default.createElement(
        Button$2,
        {
          'data-veritone-element': `picker-footer-${title}-button`,
          variant: 'contained',
          disabled: disabled,
          color: 'primary',
          onClick: onSubmit
        },
        title
      )
    );
  }
}, _class$m.propTypes = {
  disabled: bool,
  onCancel: func,
  onSubmit: func,
  title: string,
  hasIntercom: bool,
  classes: shape$1({ any })
}, _class$m.defaultProps = {
  title: 'Upload'
}, _temp$6);
FilePickerFooter.displayName = 'FilePickerFooter';


var FilePickerFooter$1 = withStyles$1(styles$m)(FilePickerFooter);

const menuText = muiText('menu');
const body1Text$7 = muiText('body1');
const captionText$6 = muiText('caption');

var styles$n = {
  urlUploader: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%'
  },
  urlTextField: _extends({}, menuText, {
    marginTop: 0,
    marginBottom: '5px !important',
    display: 'inline-block !important',
    '& $fileUrlInputError': {
      color: '#ff1744 !important'
    },
    '& $fileUrlInputFocused': {
      color: blue1
    },
    '& $fileUrlInputInkbar': {
      backgroundColor: blue1
    },
    '& $fileUrlInputInkbarError': {
      backgroundColor: '#ff1744'
    }
  }),
  fileUrlPickerInputRoot: {
    width: '90%',
    marginTop: '13px !important'
  },
  fileUlrPickerInput: {
    padding: '5px 0'
  },
  urlUploaderInfoBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: grey1,
    border: `4px dashed ${grey4}`,
    paddingTop: 15,
    paddingBottom: 15,
    marginTop: 3,
    width: '100%',
    flex: 'auto',
    textAlign: 'center'
  },
  correctUrlText: _extends({}, body1Text$7, {
    marginBottom: 15
  }),
  confirmLicenseText: _extends({}, captionText$6, {
    color: grey5
  }),
  imageContainer: {
    display: 'flex',
    marginTop: 3,
    padding: 10,
    backgroundColor: '#777'
  },
  fileImage: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    '& img': {
      alignSelf: 'center',
      width: 'auto',
      height: '100%',
      display: 'block'
    }
  },
  fileUrlInputError: {},
  fileUrlInputFocused: {},
  fileUrlInputInkbar: {},
  fileUrlInputInkbarError: {}
};

var _class$n, _temp2$g;

let UrlUploader = (_temp2$g = _class$n = class UrlUploader extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      image: '',
      fetchingImage: false,
      uploadError: false
    }, this.preventInput = evt => {
      // todo: a "retrieve" button so we can have manual input without pasting
      evt.preventDefault();
    }, this.handlePaste = evt => {
      // todo: handle fetchingImage state -- set to a timestamp, show loading > 200ms?
      this.setState({
        image: '',
        fetchingImage: true
      });

      const imageUrl = evt.clipboardData.getData('Text');

      fetch(imageUrl).then(response => {
        if (response.status === 200 || response.status === 0) {
          return response.blob();
        } else {
          throw new Error(`Error loading: ${imageUrl}`);
        }
      }).then(responseBlob => {
        if (this.validateFileType(responseBlob.type)) {
          return responseBlob;
        } else {
          throw new Error(`${imageUrl} did match any of the allowed fileTypes`);
        }
      }).then(responseBlob => {
        let fileReader = new FileReader();
        fileReader.onload = () => {
          this.setState({
            image: fileReader.result,
            fetchingImage: false,
            uploadError: false
          });
        };

        fileReader.readAsDataURL(responseBlob);
        return responseBlob;
      }).then(responseBlob => {
        const fileType = responseBlob.type;
        const extension = mime.extension(fileType);
        // make an attempt to extract a useful filename (if url has an extension),
        // otherwise use the URL.
        // https://stackoverflow.com/questions/14473180/regex-to-get-a-filename-from-a-url
        const tryFilename = /(?=\w+\.\w{3,4}$).+/;
        const urlFileName = imageUrl.match(tryFilename);
        const fileName = urlFileName || `${imageUrl}.${extension}`;

        this.props.onUpload(new File([responseBlob], fileName, {
          type: fileType
        }));

        return responseBlob;
      }).catch(error => {
        console.log(error);
        // todo: better errors
        this.setState({
          fetchingImage: false,
          uploadError: true
        });
      });
    }, this.handleChange = evt => {
      if (this.state.uploadError && !evt.target.value.length) {
        this.setState({
          image: '',
          uploadError: false
        });
      }
    }, this.validateFileType = fileType => {
      if (this.props.acceptedFileTypes.length) {
        return this.props.acceptedFileTypes.includes(fileType);
      } else {
        return true;
      }
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.urlUploader },
      React__default.createElement(
        FormControl,
        {
          className: classes.urlTextField,
          error: this.state.uploadError
        },
        React__default.createElement(
          InputLabel,
          {
            classes: {
              error: classes.fileUrlInputError,
              focused: classes.fileUrlInputFocused
            },
            htmlFor: 'url-input'
          },
          'Paste an Image URL here'
        ),
        React__default.createElement(Input$1, {
          classes: {
            root: classes.fileUrlPickerInputRoot,
            input: classes.fileUlrPickerInput
          },
          id: 'url-input',
          onKeyPress: this.preventInput,
          onPaste: this.handlePaste,
          onChange: this.handleChange
        })
      ),
      this.state.image.length ? React__default.createElement(
        'div',
        { className: classes.imageContainer },
        React__default.createElement(
          'div',
          { className: classes.fileImage },
          React__default.createElement('img', { src: this.state.image })
        )
      ) : React__default.createElement(
        'div',
        { className: classes.urlUploaderInfoBox },
        React__default.createElement(
          'span',
          { className: classes.correctUrlText },
          'If the URL is correct the image will display here.'
        ),
        React__default.createElement(
          'span',
          { className: classes.confirmLicenseText },
          'Remember, only use images that you have confirmed that you have the license to use'
        )
      )
    );
  }
}, _class$n.propTypes = {
  onUpload: func.isRequired,
  acceptedFileTypes: arrayOf(string),
  classes: shape$1({ any })
}, _class$n.defaultProps = {
  acceptedFileTypes: []
}, _temp2$g);
UrlUploader.displayName = 'UrlUploader';


var UrlUploader$1 = withStyles$1(styles$n)(UrlUploader);

const useStyles$a = makeStyles(styles$l);
const FilePickerFlatHeader = ({ title, fileCount, maxFiles }) => {
  const classes = useStyles$a();
  return React__default.createElement(
    'div',
    { className: classes.filePickerFlatHeader },
    React__default.createElement(
      Typography$2,
      { variant: 'h6' },
      title,
      '\xA0',
      React__default.createElement(
        'span',
        { className: classes.count },
        fileCount,
        '/',
        maxFiles
      )
    )
  );
};

FilePickerFlatHeader.displayName = 'FilePickerFlatHeader';
FilePickerFlatHeader.propTypes = {
  title: string,
  fileCount: number,
  maxFiles: number
};

FilePickerFlatHeader.defaultProps = {
  title: 'Uploaded',
  fileCount: 0,
  maxFiles: 1
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var cropper = createCommonjsModule(function (module, exports) {
/*!
 * Cropper.js v1.5.7
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-05-23T05:23:00.081Z
 */

(function (global, factory) {
   module.exports = factory() ;
}(commonjsGlobal, (function () {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: 200,
    minContainerHeight: 100,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */

  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */

  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */

  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */

  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */

  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */

  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */

  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */

  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */

  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */

  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */

  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */

  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */

  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */

  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */

  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */

  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);

    var ratios = [];
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;
        ratios.push(ratio);
      });
    });
    ratios.sort(function (a, b) {
      return Math.abs(a) < Math.abs(b);
    });
    return ratios[0];
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */

  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */

  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */

  function getAdjustedSizes(_ref4) // or 'cover'
  {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */

  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */

  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
        height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      canvasData.left = (containerData.width - canvasWidth) / 2;
      canvasData.top = (containerData.height - canvasHeight) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      this.initialImageData = assign({}, imageData);
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      if (this.disabled) {
        return;
      }

      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed

      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;

  var Cropper = /*#__PURE__*/function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "https://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        }

        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden

        if (!this.isImg) {
          removeClass(image, CLASS_HIDE);
        }

        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        this.cropper.parentNode.removeChild(this.cropper);
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  return Cropper;

})));
});

var reactCropper = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(React__default);

var _propTypes = _interopRequireDefault(PropTypes__default);

var _cropperjs = _interopRequireDefault(cropper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var optionProps = ['dragMode', 'aspectRatio', 'data', 'crop', // unchangeable props start from here
'viewMode', 'preview', 'responsive', 'restore', 'checkCrossOrigin', 'checkOrientation', 'modal', 'guides', 'center', 'highlight', 'background', 'autoCrop', 'autoCropArea', 'movable', 'rotatable', 'scalable', 'zoomable', 'zoomOnTouch', 'zoomOnWheel', 'wheelZoomRatio', 'cropBoxMovable', 'cropBoxResizable', 'toggleDragModeOnDblclick', 'minContainerWidth', 'minContainerHeight', 'minCanvasWidth', 'minCanvasHeight', 'minCropBoxWidth', 'minCropBoxHeight', 'ready', 'cropstart', 'cropmove', 'cropend', 'zoom'];
var unchangeableProps = optionProps.slice(4);

var ReactCropper =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactCropper, _Component);

  function ReactCropper() {
    _classCallCheck(this, ReactCropper);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReactCropper).apply(this, arguments));
  }

  _createClass(ReactCropper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var options = Object.keys(this.props).filter(function (propKey) {
        return optionProps.indexOf(propKey) !== -1;
      }).reduce(function (prevOptions, propKey) {
        return _extends({}, prevOptions, _defineProperty({}, propKey, _this.props[propKey]));
      }, {});
      this.cropper = new _cropperjs.default(this.img, options);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.src !== this.props.src) {
        this.cropper.reset().clear().replace(nextProps.src);
      }

      if (nextProps.aspectRatio !== this.props.aspectRatio) {
        this.setAspectRatio(nextProps.aspectRatio);
      }

      if (nextProps.data !== this.props.data) {
        this.setData(nextProps.data);
      }

      if (nextProps.dragMode !== this.props.dragMode) {
        this.setDragMode(nextProps.dragMode);
      }

      if (nextProps.cropBoxData !== this.props.cropBoxData) {
        this.setCropBoxData(nextProps.cropBoxData);
      }

      if (nextProps.canvasData !== this.props.canvasData) {
        this.setCanvasData(nextProps.canvasData);
      }

      if (nextProps.moveTo !== this.props.moveTo) {
        if (nextProps.moveTo.length > 1) {
          this.moveTo(nextProps.moveTo[0], nextProps.moveTo[1]);
        } else {
          this.moveTo(nextProps.moveTo[0]);
        }
      }

      if (nextProps.zoomTo !== this.props.zoomTo) {
        this.zoomTo(nextProps.zoomTo);
      }

      if (nextProps.rotateTo !== this.props.rotateTo) {
        this.rotateTo(nextProps.rotateTo);
      }

      if (nextProps.scaleX !== this.props.scaleX) {
        this.scaleX(nextProps.scaleX);
      }

      if (nextProps.scaleY !== this.props.scaleY) {
        this.scaleY(nextProps.scaleY);
      }

      if (nextProps.enable !== this.props.enable) {
        if (nextProps.enable) {
          this.enable();
        } else {
          this.disable();
        }
      }

      Object.keys(nextProps).forEach(function (propKey) {
        var isDifferentVal = nextProps[propKey] !== _this2.props[propKey];
        var isUnchangeableProps = unchangeableProps.indexOf(propKey) !== -1;

        if (typeof nextProps[propKey] === 'function' && typeof _this2.props[propKey] === 'function') {
          isDifferentVal = nextProps[propKey].toString() !== _this2.props[propKey].toString();
        }

        if (isDifferentVal && isUnchangeableProps) {
          throw new Error("prop: ".concat(propKey, " can't be change after componentDidMount"));
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.img) {
        // Destroy the cropper, this makes sure events such as resize are cleaned up and do not leak
        this.cropper.destroy();
        delete this.img;
        delete this.cropper;
      }
    }
  }, {
    key: "setDragMode",
    value: function setDragMode(mode) {
      return this.cropper.setDragMode(mode);
    }
  }, {
    key: "setAspectRatio",
    value: function setAspectRatio(aspectRatio) {
      return this.cropper.setAspectRatio(aspectRatio);
    }
  }, {
    key: "getCroppedCanvas",
    value: function getCroppedCanvas(options) {
      return this.cropper.getCroppedCanvas(options);
    }
  }, {
    key: "setCropBoxData",
    value: function setCropBoxData(data) {
      return this.cropper.setCropBoxData(data);
    }
  }, {
    key: "getCropBoxData",
    value: function getCropBoxData() {
      return this.cropper.getCropBoxData();
    }
  }, {
    key: "setCanvasData",
    value: function setCanvasData(data) {
      return this.cropper.setCanvasData(data);
    }
  }, {
    key: "getCanvasData",
    value: function getCanvasData() {
      return this.cropper.getCanvasData();
    }
  }, {
    key: "getImageData",
    value: function getImageData() {
      return this.cropper.getImageData();
    }
  }, {
    key: "getContainerData",
    value: function getContainerData() {
      return this.cropper.getContainerData();
    }
  }, {
    key: "setData",
    value: function setData(data) {
      return this.cropper.setData(data);
    }
  }, {
    key: "getData",
    value: function getData(rounded) {
      return this.cropper.getData(rounded);
    }
  }, {
    key: "crop",
    value: function crop() {
      return this.cropper.crop();
    }
  }, {
    key: "move",
    value: function move(offsetX, offsetY) {
      return this.cropper.move(offsetX, offsetY);
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      return this.cropper.moveTo(x, y);
    }
  }, {
    key: "zoom",
    value: function zoom(ratio) {
      return this.cropper.zoom(ratio);
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(ratio) {
      return this.cropper.zoomTo(ratio);
    }
  }, {
    key: "rotate",
    value: function rotate(degree) {
      return this.cropper.rotate(degree);
    }
  }, {
    key: "rotateTo",
    value: function rotateTo(degree) {
      return this.cropper.rotateTo(degree);
    }
  }, {
    key: "enable",
    value: function enable() {
      return this.cropper.enable();
    }
  }, {
    key: "disable",
    value: function disable() {
      return this.cropper.disable();
    }
  }, {
    key: "reset",
    value: function reset() {
      return this.cropper.reset();
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.cropper.clear();
    }
  }, {
    key: "replace",
    value: function replace(url, onlyColorChanged) {
      return this.cropper.replace(url, onlyColorChanged);
    }
  }, {
    key: "scale",
    value: function scale(scaleX, scaleY) {
      return this.cropper.scale(scaleX, scaleY);
    }
  }, {
    key: "scaleX",
    value: function scaleX(_scaleX) {
      return this.cropper.scaleX(_scaleX);
    }
  }, {
    key: "scaleY",
    value: function scaleY(_scaleY) {
      return this.cropper.scaleY(_scaleY);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          src = _this$props.src,
          alt = _this$props.alt,
          crossOrigin = _this$props.crossOrigin,
          style = _this$props.style,
          className = _this$props.className;
      return _react.default.createElement("div", {
        style: style,
        className: className
      }, _react.default.createElement("img", {
        crossOrigin: crossOrigin,
        ref: function ref(img) {
          _this3.img = img;
        },
        src: src,
        alt: alt === undefined ? 'picture' : alt,
        style: {
          opacity: 0
        }
      }));
    }
  }]);

  return ReactCropper;
}(_react.Component);

ReactCropper.propTypes = {
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  className: _propTypes.default.string,
  // react cropper options
  crossOrigin: _propTypes.default.string,
  src: _propTypes.default.string,
  alt: _propTypes.default.string,
  // props of option can be changed after componentDidmount
  aspectRatio: _propTypes.default.number,
  dragMode: _propTypes.default.oneOf(['crop', 'move', 'none']),
  data: _propTypes.default.shape({
    x: _propTypes.default.number,
    y: _propTypes.default.number,
    width: _propTypes.default.number,
    height: _propTypes.default.number,
    rotate: _propTypes.default.number,
    scaleX: _propTypes.default.number,
    scaleY: _propTypes.default.number
  }),
  scaleX: _propTypes.default.number,
  scaleY: _propTypes.default.number,
  enable: _propTypes.default.bool,
  cropBoxData: _propTypes.default.shape({
    left: _propTypes.default.number,
    top: _propTypes.default.number,
    width: _propTypes.default.number,
    height: _propTypes.default.number
  }),
  canvasData: _propTypes.default.shape({
    left: _propTypes.default.number,
    top: _propTypes.default.number,
    width: _propTypes.default.number,
    height: _propTypes.default.number
  }),
  zoomTo: _propTypes.default.number,
  moveTo: _propTypes.default.arrayOf(_propTypes.default.number),
  rotateTo: _propTypes.default.number,
  // cropperjs options
  // https://github.com/fengyuanchen/cropperjs#options
  // aspectRatio, dragMode, data
  viewMode: _propTypes.default.oneOf([0, 1, 2, 3]),
  preview: _propTypes.default.string,
  responsive: _propTypes.default.bool,
  restore: _propTypes.default.bool,
  checkCrossOrigin: _propTypes.default.bool,
  checkOrientation: _propTypes.default.bool,
  modal: _propTypes.default.bool,
  guides: _propTypes.default.bool,
  center: _propTypes.default.bool,
  highlight: _propTypes.default.bool,
  background: _propTypes.default.bool,
  autoCrop: _propTypes.default.bool,
  autoCropArea: _propTypes.default.number,
  movable: _propTypes.default.bool,
  rotatable: _propTypes.default.bool,
  scalable: _propTypes.default.bool,
  zoomable: _propTypes.default.bool,
  zoomOnTouch: _propTypes.default.bool,
  zoomOnWheel: _propTypes.default.bool,
  wheelZoomRatio: _propTypes.default.number,
  cropBoxMovable: _propTypes.default.bool,
  cropBoxResizable: _propTypes.default.bool,
  toggleDragModeOnDblclick: _propTypes.default.bool,
  minContainerWidth: _propTypes.default.number,
  minContainerHeight: _propTypes.default.number,
  minCanvasWidth: _propTypes.default.number,
  minCanvasHeight: _propTypes.default.number,
  minCropBoxWidth: _propTypes.default.number,
  minCropBoxHeight: _propTypes.default.number,
  ready: _propTypes.default.func,
  cropstart: _propTypes.default.func,
  cropmove: _propTypes.default.func,
  cropend: _propTypes.default.func,
  crop: _propTypes.default.func,
  zoom: _propTypes.default.func
};
ReactCropper.defaultProps = {
  src: null,
  dragMode: 'crop',
  data: null,
  scaleX: 1,
  scaleY: 1,
  enable: true,
  zoomTo: 1,
  rotateTo: 0
};
var _default = ReactCropper;
exports.default = _default;
});

var Cropper = unwrapExports(reactCropper);

var common = {
  black: '#000',
  white: '#fff'
};

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$1({}, target) : target;

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends$1({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$1({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends$1({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends$1({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo[300],
    main: indigo[500],
    dark: indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink.A200,
    main: pink.A400,
    dark: pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red[300],
    main: red[500],
    dark: red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange[300],
    main: orange[500],
    dark: orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue[300],
    main: blue[500],
    dark: blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green[300],
    main: green[500],
    dark: green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    if (!background) {
      throw new TypeError("Material-UI: missing background argument in getContrastText(".concat(background, ")."));
    }

    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$1({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  var types = {
    dark: dark,
    light: light
  };

  var paletteOutput = deepmerge(_extends$1({
    // A collection of common colors.
    common: common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$1({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, {}, casing, {}, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$1({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density


  var transform;

  if (typeof spacingInput === 'function') {
    transform = spacingInput;
  } else {

    transform = function transform(factor) {

      return spacingInput * factor;
    };
  }

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (factor) {
      var output = transform(factor);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  return muiTheme;
}

var defaultTheme = createMuiTheme();

function useTheme() {
  return useTheme$1() || defaultTheme;
}

function withStyles(stylesOrCreator, options) {
  return withStyles$1(stylesOrCreator, _extends$1({
    defaultTheme: defaultTheme
  }, options));
}

function toVal(mix) {
	var k, y, str='';
	if (mix) {
		if (typeof mix === 'object') {
			if (!!mix.push) {
				for (k=0; k < mix.length; k++) {
					if (mix[k] && (y = toVal(mix[k]))) {
						str && (str += ' ');
						str += y;
					}
				}
			} else {
				for (k in mix) {
					if (mix[k] && (y = toVal(k))) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else if (typeof mix !== 'boolean' && !mix.call) {
			str && (str += ' ');
			str += mix;
		}
	}
	return str;
}

function clsx () {
	var i=0, x, str='';
	while (i < arguments.length) {
		if (x = toVal(arguments[i++])) {
			str && (str += ' ');
			str += x;
		}
	}
	return str;
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {

  return string.charAt(0).toUpperCase() + string.slice(1);
}

var styles$o = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return createElement(Component, _extends$1({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : 'true',
    role: titleAccess ? 'img' : 'presentation',
    ref: ref
  }, other), children, titleAccess ? createElement("title", null, titleAccess) : null);
});
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$o, {
  name: 'MuiSvgIcon'
})(SvgIcon);

function createSvgIcon(path, displayName) {
  var Component = memo(forwardRef(function (props, ref) {
    return createElement(SvgIcon$1, _extends$1({}, props, {
      ref: ref
    }), path);
  }));

  Component.muiName = SvgIcon$1.muiName;
  return Component;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var config = {
  disabled: false
};

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM__default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React__default.Children.only(children);
    return (// allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, React__default.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes =  {};
TransitionGroup.defaultProps = defaultProps;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

// TODO v5: make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

var useEnhancedEffect$1 = typeof window !== 'undefined' && "production" !== 'test' ? useLayoutEffect : useEffect;
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _React$useState = useState(false),
      mountedState = _React$useState[0],
      setMountedState = _React$useState[1];

  useEnhancedEffect$1(function () {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  useEffect(function () {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return createElement(Fragment, null, mountedState ? children : fallback);
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = useCallback(function (instance) {
    var node = findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

var useEnhancedEffect$2 = typeof window === 'undefined' ? useEffect : useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect$2(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, createElement("span", {
    className: childClassName
  }));
}

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$p = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["center", "classes", "className"]);

  var _React$useState = useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = useRef(0);
  var rippleCallback = useRef(null);
  useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = useRef(null);
  var container = useRef(null);
  useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
      var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return createElement("span", _extends$1({
    className: clsx(classes.root, className),
    ref: container
  }, other), createElement(TransitionGroup, {
    component: null,
    exit: true
  }, ripples));
});
var TouchRipple$1 = withStyles(styles$p, {
  flip: false,
  name: 'MuiTouchRipple'
})(memo(TouchRipple));

var styles$q = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return findDOMNode(buttonRef.current);
  }

  var rippleRef = useRef(null);

  var _React$useState = useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    if (disabled) {
      return;
    } // Fix for https://github.com/facebook/react/issues/7769


    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter') {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);
  return createElement(ComponentProp, _extends$1({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, createElement(NoSsr, null, !disableRipple && !disabled ?
  /* TouchRipple is only needed client-side, x2 boost on the server. */
  createElement(TouchRipple$1, _extends$1({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null));
});
var ButtonBase$1 = withStyles(styles$q, {
  name: 'MuiButtonBase'
})(ButtonBase);

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

var styles$r = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return createElement(Component, _extends$1({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize(align))], display !== 'initial' && classes["display".concat(capitalize(display))]),
    ref: ref
  }, other));
});
var Typography$1 = withStyles(styles$r, {
  name: 'MuiTypography'
})(Typography);

var styles$s = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$1({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: fade(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(fade(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(fade(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && createElement("span", {
    className: clsx(classes.startIcon, classes["iconSize".concat(capitalize(size))])
  }, startIconProp);
  var endIcon = endIconProp && createElement("span", {
    className: clsx(classes.endIcon, classes["iconSize".concat(capitalize(size))])
  }, endIconProp);
  return createElement(ButtonBase$1, _extends$1({
    className: clsx(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(capitalize(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(capitalize(size))], classes["size".concat(capitalize(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
var Button$1 = withStyles(styles$s, {
  name: 'MuiButton'
})(Button);

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name;

  var _React$useRef = useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  var setValueIfUncontrolled = useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * @ignore - internal component.
 */

var FormControlContext = createContext();

function useFormControl() {
  return useContext(FormControlContext);
}

var styles$t = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return createElement(ButtonBase$1, _extends$1({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), createElement("span", {
    className: classes.label
  }, children));
});
var IconButton$1 = withStyles(styles$t, {
  name: 'MuiIconButton'
})(IconButton);

var styles$u = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = _objectWithoutProperties(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = useFormControl();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return createElement(IconButton$1, _extends$1({
    component: "span",
    className: clsx(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), createElement("input", _extends$1({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var SwitchBase$1 = withStyles(styles$u, {
  name: 'PrivateSwitchBase'
})(SwitchBase);

/**
 * @ignore - internal component.
 */

var CheckBoxOutlineBlankIcon = createSvgIcon(createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}));

/**
 * @ignore - internal component.
 */

var CheckBoxIcon = createSvgIcon(createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}));

/**
 * @ignore - internal component.
 */

var IndeterminateCheckBoxIcon = createSvgIcon(createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}));

var styles$v = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = createElement(CheckBoxIcon, null);
var defaultIcon = createElement(CheckBoxOutlineBlankIcon, null);
var defaultIndeterminateIcon = createElement(IndeterminateCheckBoxIcon, null);
var Checkbox = forwardRef(function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIcon = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  return createElement(SwitchBase$1, _extends$1({
    type: "checkbox",
    classes: {
      root: clsx(classes.root, classes["color".concat(capitalize(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: _extends$1({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: cloneElement(indeterminate ? indeterminateIcon : icon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    checkedIcon: cloneElement(indeterminate ? indeterminateIcon : checkedIcon, {
      fontSize: size === 'small' ? 'small' : 'default'
    }),
    ref: ref
  }, other));
});
var Checkbox$1 = withStyles(styles$v, {
  name: 'MuiCheckbox'
})(Checkbox);

var SIZE = 44;

function getRelativeValue(value, min, max) {
  return (Math.min(Math.max(min, value), max) - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles$w = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return createElement("div", _extends$1({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends$1({
      width: size,
      height: size
    }, rootStyle, {}, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
var CircularProgress$1 = withStyles(styles$w, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

var styles$x = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? duration.standard : _props$timeout,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout"]);

  var theme = useTheme();
  var timer = useRef();
  var wrapperRef = useRef(null);
  var autoTransitionDuration = useRef();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);

  var handleEnter = function handleEnter(node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleEntering = function handleEntering(node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  };

  var handleEntered = function handleEntered(node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  };

  var handleExiting = function handleExiting(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  };

  var addEndListener = function addEndListener(_, next) {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return createElement(Transition, _extends$1({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return createElement(Component, _extends$1({
      className: clsx(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: _extends$1({
        minHeight: collapsedHeight
      }, style),
      ref: ref
    }, childProps), createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
Collapse.muiSupportAuto = true;
var Collapse$1 = withStyles(styles$x, {
  name: 'MuiCollapse'
})(Collapse);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function isMuiElement(element, muiNames) {
  return isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/**
 * @ignore - internal component.
 */

var ListContext = createContext({});

var styles$y = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return createElement(ListContext.Provider, {
    value: context
  }, createElement(Component, _extends$1({
    className: clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
var List$1 = withStyles(styles$y, {
  name: 'MuiList'
})(List);

var styles$z = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect$3 = typeof window === 'undefined' ? useEffect : useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = _objectWithoutProperties(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = _objectWithoutProperties(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = useContext(ListContext);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = useRef(null);
  useEnhancedEffect$3(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      }
    }
  }, [autoFocus]);
  var children = Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(handleOwnRef, ref);

  var componentProps = _extends$1({
    className: clsx(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return createElement(ListContext.Provider, {
      value: childContext
    }, createElement(ContainerComponent, _extends$1({
      className: clsx(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), createElement(Component, componentProps, children), children.pop()));
  }

  return createElement(ListContext.Provider, {
    value: childContext
  }, createElement(Component, _extends$1({
    ref: handleRef
  }, componentProps), children));
});
var ListItem$1 = withStyles(styles$z, {
  name: 'MuiListItem'
})(ListItem);

var styles$A = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = forwardRef(function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = useContext(ListContext),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== Typography$1 && !disableTypography) {
    primary = createElement(Typography$1, _extends$1({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== Typography$1 && !disableTypography) {
    secondary = createElement(Typography$1, _extends$1({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary"
    }, secondaryTypographyProps), secondary);
  }

  return createElement("div", _extends$1({
    className: clsx(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
var ListItemText$1 = withStyles(styles$A, {
  name: 'MuiListItemText'
})(ListItemText);

var css$1 = "/*!\n * Cropper.js v1.5.7\n * https://fengyuanchen.github.io/cropperjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2020-05-23T05:22:57.283Z\n */\n\n.cropper_cropper-container__2uYzp {\n  direction: ltr;\n  font-size: 0;\n  line-height: 0;\n  position: relative;\n  -ms-touch-action: none;\n  touch-action: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cropper_cropper-container__2uYzp img {\n  display: block;\n  height: 100%;\n  image-orientation: 0deg;\n  max-height: none !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  width: 100%;\n}\n\n.cropper_cropper-wrap-box__2_Eg4,\n.cropper_cropper-canvas__ivx4O,\n.cropper_cropper-drag-box__3OXVl,\n.cropper_cropper-crop-box__30WMz,\n.cropper_cropper-modal__azXte {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.cropper_cropper-wrap-box__2_Eg4,\n.cropper_cropper-canvas__ivx4O {\n  overflow: hidden;\n}\n\n.cropper_cropper-drag-box__3OXVl {\n  background-color: #fff;\n  opacity: 0;\n}\n\n.cropper_cropper-modal__azXte {\n  background-color: #000;\n  opacity: 0.5;\n}\n\n.cropper_cropper-view-box__gIq0m {\n  display: block;\n  height: 100%;\n  outline: 1px solid #39f;\n  outline-color: rgba(51, 153, 255, 0.75);\n  overflow: hidden;\n  width: 100%;\n}\n\n.cropper_cropper-dashed__1_K06 {\n  border: 0 dashed #eee;\n  display: block;\n  opacity: 0.5;\n  position: absolute;\n}\n\n.cropper_cropper-dashed__1_K06.cropper_dashed-h__2Ze27 {\n  border-bottom-width: 1px;\n  border-top-width: 1px;\n  height: calc(100% / 3);\n  left: 0;\n  top: calc(100% / 3);\n  width: 100%;\n}\n\n.cropper_cropper-dashed__1_K06.cropper_dashed-v__3BRbn {\n  border-left-width: 1px;\n  border-right-width: 1px;\n  height: 100%;\n  left: calc(100% / 3);\n  top: 0;\n  width: calc(100% / 3);\n}\n\n.cropper_cropper-center__3MINO {\n  display: block;\n  height: 0;\n  left: 50%;\n  opacity: 0.75;\n  position: absolute;\n  top: 50%;\n  width: 0;\n}\n\n.cropper_cropper-center__3MINO::before,\n.cropper_cropper-center__3MINO::after {\n  background-color: #eee;\n  content: ' ';\n  display: block;\n  position: absolute;\n}\n\n.cropper_cropper-center__3MINO::before {\n  height: 1px;\n  left: -3px;\n  top: 0;\n  width: 7px;\n}\n\n.cropper_cropper-center__3MINO::after {\n  height: 7px;\n  left: 0;\n  top: -3px;\n  width: 1px;\n}\n\n.cropper_cropper-face__3vicH,\n.cropper_cropper-line__10zIo,\n.cropper_cropper-point__1ktu3 {\n  display: block;\n  height: 100%;\n  opacity: 0.1;\n  position: absolute;\n  width: 100%;\n}\n\n.cropper_cropper-face__3vicH {\n  background-color: #fff;\n  left: 0;\n  top: 0;\n}\n\n.cropper_cropper-line__10zIo {\n  background-color: #39f;\n}\n\n.cropper_cropper-line__10zIo.cropper_line-e__1jgQc {\n  cursor: ew-resize;\n  right: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper_cropper-line__10zIo.cropper_line-n__2UdnF {\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n  top: -3px;\n}\n\n.cropper_cropper-line__10zIo.cropper_line-w__2s5Kv {\n  cursor: ew-resize;\n  left: -3px;\n  top: 0;\n  width: 5px;\n}\n\n.cropper_cropper-line__10zIo.cropper_line-s__U07G0 {\n  bottom: -3px;\n  cursor: ns-resize;\n  height: 5px;\n  left: 0;\n}\n\n.cropper_cropper-point__1ktu3 {\n  background-color: #39f;\n  height: 5px;\n  opacity: 0.75;\n  width: 5px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-e__EiIXr {\n  cursor: ew-resize;\n  margin-top: -3px;\n  right: -3px;\n  top: 50%;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-n__3T3Ac {\n  cursor: ns-resize;\n  left: 50%;\n  margin-left: -3px;\n  top: -3px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-w__hsMqQ {\n  cursor: ew-resize;\n  left: -3px;\n  margin-top: -3px;\n  top: 50%;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-s__1FapE {\n  bottom: -3px;\n  cursor: s-resize;\n  left: 50%;\n  margin-left: -3px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-ne__1X7Wr {\n  cursor: nesw-resize;\n  right: -3px;\n  top: -3px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-nw__wZb_c {\n  cursor: nwse-resize;\n  left: -3px;\n  top: -3px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-sw__153W9 {\n  bottom: -3px;\n  cursor: nesw-resize;\n  left: -3px;\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-se__4_7ZW {\n  bottom: -3px;\n  cursor: nwse-resize;\n  height: 20px;\n  opacity: 1;\n  right: -3px;\n  width: 20px;\n}\n\n@media (min-width: 768px) {\n  .cropper_cropper-point__1ktu3.cropper_point-se__4_7ZW {\n    height: 15px;\n    width: 15px;\n  }\n}\n\n@media (min-width: 992px) {\n  .cropper_cropper-point__1ktu3.cropper_point-se__4_7ZW {\n    height: 10px;\n    width: 10px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cropper_cropper-point__1ktu3.cropper_point-se__4_7ZW {\n    height: 5px;\n    opacity: 0.75;\n    width: 5px;\n  }\n}\n\n.cropper_cropper-point__1ktu3.cropper_point-se__4_7ZW::before {\n  background-color: #39f;\n  bottom: -50%;\n  content: ' ';\n  display: block;\n  height: 200%;\n  opacity: 0;\n  position: absolute;\n  right: -50%;\n  width: 200%;\n}\n\n.cropper_cropper-invisible__1h2MX {\n  opacity: 0;\n}\n\n.cropper_cropper-bg__1L2cZ {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');\n}\n\n.cropper_cropper-hide__3xX92 {\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n\n.cropper_cropper-hidden__21qcT {\n  display: none !important;\n}\n\n.cropper_cropper-move__TzKje {\n  cursor: move;\n}\n\n.cropper_cropper-crop__2C8PR {\n  cursor: crosshair;\n}\n\n.cropper_cropper-disabled__2vIgX .cropper_cropper-drag-box__3OXVl,\n.cropper_cropper-disabled__2vIgX .cropper_cropper-face__3vicH,\n.cropper_cropper-disabled__2vIgX .cropper_cropper-line__10zIo,\n.cropper_cropper-disabled__2vIgX .cropper_cropper-point__1ktu3 {\n  cursor: not-allowed;\n}\n";
styleInject(css$1);

const styles$B = {
  resizeFooter: {
    paddingTop: 10
  },
  buttonResize: {
    marginRight: 10
  }
};

const useStyles$b = makeStyles(styles$B);

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

function App({ file, onSubmit, onCancel, aspectRatio }) {
  const classes = useStyles$b();
  const [src, setSrc] = React__default.useState();
  const [fileName, setFileName] = React__default.useState('');
  const [cropResult, setCropResult] = React__default.useState(null);
  let appCropper = undefined;
  const cropImage = () => {
    if (_isUndefined(appCropper.getCroppedCanvas())) {
      return;
    }
    setCropResult(appCropper.getCroppedCanvas().toDataURL());
  };
  React__default.useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
      };
      reader.readAsDataURL(file);
      setFileName(file.name);
    }
    return () => {
      setSrc();
      setFileName('');
    };
  }, [file]);

  React__default.useEffect(() => {
    if (cropResult) {
      const fileTranfered = dataURLtoFile(cropResult, `cropped-${fileName}`);
      onSubmit(fileTranfered);
    }
  }, [cropResult, fileName]);

  return React__default.createElement(
    'div',
    { className: classes.cropContainer },
    src && React__default.createElement(Cropper, {
      style: { height: 560 / aspectRatio, width: 560 },
      aspectRatio: aspectRatio,
      guides: false,
      src: src,
      ref: cropper => {
        appCropper = cropper;
      },
      zoomable: false
    }),
    React__default.createElement(
      'div',
      { className: classes.resizeFooter },
      React__default.createElement(
        Button$1,
        {
          className: classes.buttonResize,
          color: 'primary',
          variant: 'contained',
          onClick: cropImage },
        'Crop Image'
      ),
      React__default.createElement(
        Button$1,
        {
          className: classes.buttonResize,
          variant: 'outlined',
          onClick: onCancel },
        'Cancel'
      )
    )
  );
}

App.displayName = 'App';
App.propTypes = {
  file: shape$1({
    lastModified: number,
    name: string,
    size: number,
    type: string,
    webkitRelativePath: string
  }).isRequired,
  onSubmit: func.isRequired,
  onCancel: func.isRequired,
  aspectRatio: number.isRequired
};

var styles$C = {
  filePicker: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: grey1,
    maxWidth: '100%'
  },
  filePickerNonModal: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white'
  },
  filePickerPaperOverride: {
    maxWidth: '100% !important',
    maxHeight: '100% !important',
    minHeight: 411,
    position: 'relative'
  },
  filePickerBody: {
    flex: '1',
    display: 'flex',
    padding: filePickerMargin,
    overflowY: 'auto'
  },
  errorMessage: {
    textAlign: 'center',
    color: 'red',
    paddingBottom: '0.25em'
  }
};

var _class$o, _temp2$h;

let FilePicker = (_temp2$h = _class$o = class FilePicker extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      selectedTab: 'upload',
      resize: {
        showing: false,
        targetFile: null
      },
      files: [],
      errorMessage: ''
    }, this.handleRemoveFile = index => {
      this.setState(state => ({
        files: [...state.files.slice(0, index), ...state.files.slice(index + 1)]
      }));

      this.clearErrorMessage();
    }, this.handleFilesSelected = fileOrFiles => {
      const files = _isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];

      if (this.props.multiple) {
        if (this.props.maxFiles && (this.state.files.length >= this.props.maxFiles || files.length > this.props.maxFiles)) {
          // if a file was already staged, or user tried to add more than one file
          this.setState({
            errorMessage: this.props.tooManyFilesErrorMessage(this.props.maxFiles)
          });
        } else {
          this.clearErrorMessage();
        }

        this.setState(state => ({
          files: [...state.files, ...files]
        }));
      } else {
        // single mode
        if (this.state.files.length >= 1 || files.length > 1) {
          // if a file was already staged, or user tried to add more than one file
          this.setState({
            errorMessage: this.props.oneFileOnlyErrorMessage
          });
        } else {
          this.clearErrorMessage();
        }

        this.setState({
          files: [files[0]]
        });
      }
    }, this.handleFilesRejected = num => {
      const files = pluralize('file', num);
      const were = pluralize('was', num);

      this.setState({
        // prettier-ignore
        errorMessage: `${num} ${files} ${were} rejected due to filetype restrictions.`
      });
    }, this.handleTabChange = value => {
      this.setState({
        selectedTab: value
      });

      this.clearErrorMessage();
    }, this.handleCloseModal = () => {
      this.props.onRequestClose();
    }, this.handlePickFiles = () => {
      const files = this.state.files;

      this.clearErrorMessage();
      this.setState({
        files: []
      }, () => this.props.onPickFiles(files));
    }, this.onFileResize = file => {
      this.setState({
        resize: {
          showing: true,
          targetFile: file
        }
      });
    }, this.onSubmitResize = croppedFile => {
      this.setState(state => ({
        files: state.files.map(file => {
          if (`cropped-${file.name}` === croppedFile.name) {
            return croppedFile;
          }
          return file;
        })
      }));
      this.setState({
        resize: {
          showing: false,
          targetFile: null
        }
      });
    }, this.onCancalResize = () => {
      this.setState({
        resize: {
          showing: false,
          targetFile: null
        }
      });
    }, _temp;
  }

  clearErrorMessage() {
    this.setState({
      errorMessage: ''
    });
  }

  disableNextStep() {
    if (this.props.multiple && this.props.maxFiles) {
      return this.state.files.length > this.props.maxFiles || this.state.files.length === 0 || this.state.resize.showing;
    } else {
      return this.state.files.length === 0 || this.state.resize.showing;
    }
  }

  render() {
    const acceptedFileTypes = (_isString(this.props.accept) ? [this.props.accept] : this.props.accept).map(t => mime.lookup(t) || t); // use full mimetype when possible
    const { classes } = this.props;
    const { resize: {
        showing: resizeShowing,
        targetFile
      } } = this.state;

    return React__default.createElement(
      DndProvider,
      { backend: HTML },
      React__default.createElement(
        Paper,
        {
          classes: this.props.onRequestClose && {
            root: classes.filePickerPaperOverride
          },
          style: {
            height: this.props.height,
            width: this.props.width
          }
        },
        React__default.createElement(
          'div',
          {
            className: this.props.onRequestClose ? classes.filePicker : classes.filePickerNonModal,
            style: {
              height: '100%'
            }
          },
          this.props.onRequestClose ? React__default.createElement(FilePickerHeader$1, {
            selectedTab: this.state.selectedTab,
            onSelectTab: this.handleTabChange,
            onClose: this.handleCloseModal,
            allowUrlUpload: this.props.allowUrlUpload,
            title: this.props.title,
            fileCount: this.state.files.length,
            maxFiles: this.props.maxFiles,
            multiple: this.props.multiple
          }) : React__default.createElement(FilePickerFlatHeader, {
            title: this.props.title,
            fileCount: this.state.files.length,
            maxFiles: this.props.maxFiles
          }),
          this.state.selectedTab === 'upload' && React__default.createElement(
            'div',
            { className: classes.filePickerBody, 'data-test': 'filePickerBody' },
            resizeShowing ? React__default.createElement(App, {
              file: targetFile,
              aspectRatio: this.props.aspectRatio,
              onSubmit: this.onSubmitResize,
              onCancel: this.onCancalResize
            }) : React__default.createElement(
              React__default.Fragment,
              null,
              React__default.createElement(FileUploader, {
                useFlatStyle: !this.props.onRequestClose,
                onFilesSelected: this.handleFilesSelected,
                onFilesRejected: this.handleFilesRejected,
                acceptedFileTypes: acceptedFileTypes,
                multiple: this.props.multiple
              }),
              this.state.files.length > 0 && React__default.createElement(FileList$1, {
                enableResize: this.props.enableResize,
                onFileResize: this.onFileResize,
                files: this.state.files,
                onRemoveFile: this.handleRemoveFile
              })
            )
          ),
          this.state.selectedTab === 'by-url' && React__default.createElement(
            'div',
            { className: classes.filePickerBody },
            React__default.createElement(UrlUploader$1, {
              onUpload: this.handleFilesSelected,
              acceptedFileTypes: acceptedFileTypes
            })
          ),
          React__default.createElement(
            'div',
            { className: classes.errorMessage },
            this.state.errorMessage
          ),
          this.props.onRequestClose && React__default.createElement(FilePickerFooter$1, {
            onCancel: this.handleCloseModal,
            onSubmit: this.handlePickFiles,
            disabled: this.disableNextStep()
          })
        )
      )
    );
  }
}, _class$o.propTypes = {
  accept: oneOfType([arrayOf(string), string]), // extension or mimetype
  multiple: bool,
  width: number,
  height: number,
  onPickFiles: func.isRequired,
  onRequestClose: func.isRequired,
  allowUrlUpload: bool,
  maxFiles: number,
  title: string,
  tooManyFilesErrorMessage: func,
  oneFileOnlyErrorMessage: string,
  enableResize: bool,
  aspectRatio: number,
  classes: shape$1({ any })
}, _class$o.defaultProps = {
  width: 600,
  accept: [],
  multiple: false,
  allowUrlUpload: true,
  title: 'File Picker',
  tooManyFilesErrorMessage: maxFiles => `You can select up to and including ${maxFiles} files. Please remove any unnecessary files.`,
  oneFileOnlyErrorMessage: `Only one file can be selected at a time`,
  enableResize: false,
  aspectRatio: 16 / 9
}, _temp2$h);
FilePicker.displayName = 'FilePicker';


var index$3 = withStyles$1(styles$C)(FilePicker);

const progressItemBorder = '1px solid #E0E0E0';
const progressItemHeight = '52px';
const outterPadding = '16px';
const audioColor = '#00BFA5';
const videoColor = '#E81D63';
const textColor = '#4A4A4A';
const imageColor = '#4CAF4F';
const body1Text$8 = muiText('body1');
const headlineText$1 = muiText('headline');

var styles$D = {
  fileProgressItem: {
    borderBottom: progressItemBorder,
    overflow: 'hidden'
  },
  fileName: _extends({}, body1Text$8, {
    display: 'inline-block',
    color: lightBlack,
    paddingLeft: 10,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '80%',
    whiteSpace: 'nowrap',
    lineHeight: progressItemHeight,
    verticalAlign: 'text-top'
  }),
  sizeContainer: {
    display: 'inline-block',
    textAlign: 'center',
    width: 'calc(20% - 40px)',
    '& $fileSize': _extends({}, body1Text$8, {
      color: lightBlack
    }),
    '&:lastChild': {
      marginRight: 14
    }
  },
  fileIconContainer: {
    borderRadius: '100%',
    height: `calc(${progressItemHeight} - ${outterPadding})`,
    width: `calc(${progressItemHeight} - ${outterPadding})`,
    minWidth: `calc(${progressItemHeight} - ${outterPadding})`,
    display: 'inline-block',
    verticalAlign: 'middle',
    marginLeft: 14,

    '& $fileIcon': {
      display: 'block',
      margin: '0 auto',
      marginTop: 6,
      color: 'white'
    },
    '&$audio': {
      backgroundColor: audioColor
    },
    '&$video': {
      backgroundColor: videoColor
    },
    '&$image': {
      backgroundColor: imageColor
    },
    '&$text': {
      backgroundColor: textColor
    }
  },
  fileProgressItemOverlay: {
    height: progressItemHeight,
    lineHeight: progressItemHeight,
    float: 'left',
    position: 'relative',
    marginTop: `-${progressItemHeight}`,
    zIndex: 1,
    width: '100%',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center'
  },
  progressTextOverlay: {
    marginTop: `-${progressItemHeight}`,
    position: 'relative',
    float: 'left',
    width: '100%',
    '& $progressText': _extends({}, headlineText$1, {
      color: 'rgba(33,150,243,0.38)',
      lineHeight: `${progressItemHeight} !important`,
      height: progressItemHeight,
      marginLeft: 70
    })
  },
  fileProgressBar: {
    height: `${progressItemHeight} !important`,
    backgroundColor: 'white !important'
  },
  fileProgressBarPrimary: {
    backgroundColor: 'rgba(33,150,243,0.12) !important'
  },
  fileProgressBarError: {
    backgroundColor: '#FFEBEE !important'
  },
  progressText: {},
  fileIcon: {},
  fileSize: {},
  audio: {},
  video: {},
  image: {},
  text: {}
};

var _class$p, _temp2$i;

let FileProgressList = (_temp2$i = _class$p = class FileProgressList extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.getFileMediaIcon = file => {
      const type = _get(file, 'value.type');
      const { classes } = this.props;
      const icons = {
        audio: React__default.createElement(AudioIcon, { className: classes.fileIcon, 'data-test-target': 'audio' }),
        video: React__default.createElement(VideoIcon, { className: classes.fileIcon, 'data-test-target': 'video' }),
        image: React__default.createElement(ImageIcon, { className: classes.fileIcon, 'data-test-target': 'image' }),
        text: React__default.createElement(TextIcon, { className: classes.fileIcon, 'data-test-target': 'text' })
      };
      const iconKeys = Object.keys(icons);
      for (let index in iconKeys) {
        const key = iconKeys[index];
        if (type && type.includes(key)) {
          return React__default.createElement(
            'div',
            { className: cx$1(classes.fileIconContainer, classes[key]) },
            icons[key]
          );
        }
      }
      return React__default.createElement(
        'div',
        { className: cx$1(classes.fileIconContainer, classes.text) },
        icons.text
      );
    }, this.handleAbortFile = fileKey => () => {
      const { handleAbort } = this.props;
      handleAbort && handleAbort(fileKey);
    }, _temp;
  }

  render() {
    const {
      percentByFiles,
      showErrors,
      handleAbort,
      classes
    } = this.props;

    const files = !showErrors ? percentByFiles : percentByFiles.filter(file => _get(file, 'value.error') && !_get(file, 'value.aborted'));

    return React__default.createElement(
      'div',
      null,
      files.map(file => React__default.createElement(
        'div',
        {
          key: file.key,
          className: classes.fileProgressItem,
          'data-test-target': file.key },
        React__default.createElement(LinearProgress, {
          className: classes.fileProgressBar,
          classes: {
            barColorPrimary: _get(file, 'value.error') ? classes.fileProgressBarError : classes.fileProgressBarPrimary
          },
          variant: 'determinate',
          value: showErrors ? 0 : file.value.percent }),
        React__default.createElement(
          'div',
          { className: classes.fileProgressItemOverlay },
          this.getFileMediaIcon(file),
          React__default.createElement(
            'span',
            { className: classes.fileName },
            file.value.name || file.key
          ),
          React__default.createElement(
            'div',
            { className: classes.sizeContainer },
            React__default.createElement(
              'span',
              { className: classes.fileSize },
              formatBytes(file.value.size)
            )
          ),
          handleAbort && file.value.percent != 100 && React__default.createElement(
            'div',
            { className: classes.abortContainer },
            React__default.createElement(
              IconButton$2,
              { onClick: this.handleAbortFile(file.key) },
              React__default.createElement(DeleteIcon, null)
            )
          )
        ),
        !showErrors && file.value.percent != 100 && React__default.createElement(
          'div',
          { className: classes.progressTextOverlay, style: { marginLeft: `${file.value.percent}%` } },
          React__default.createElement(
            'span',
            { className: classes.progressText },
            file.value.percent,
            '%'
          )
        )
      ))
    );
  }
}, _class$p.propTypes = {
  percentByFiles: arrayOf(shape$1({
    key: string,
    value: shape$1({
      name: string,
      type: string,
      size: number,
      percent: number,
      error: string,
      aborted: string
    }).isRequired
  })).isRequired,
  showErrors: bool,
  handleAbort: func,
  classes: shape$1({ any })
}, _temp2$i);
FileProgressList.displayName = 'FileProgressList';


var FileProgressList$1 = withStyles$1(styles$D)(FileProgressList);

const progressItemHeight$1 = 52;
var styles$E = {
  container: {
    position: 'relative',
    paddingBottom: 20
  },
  contentFlexer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  progressListContainer: {
    minHeight: `calc(${progressItemHeight$1}px * 3)`,
    maxHeight: `calc(${progressItemHeight$1}px * 6)`,
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  resolveActions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 20,
    paddingBottom: 0
  }
};

var _class$q, _temp2$j;

let FileProgressDialog = (_temp2$j = _class$q = class FileProgressDialog extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleAbortAll = () => {
      const { handleAbort } = this.props;
      handleAbort && handleAbort();
    }, this.handleClose = () => {
      const { onClose } = this.props;
      this.handleAbortAll();
      onClose && onClose();
    }, _temp;
  }

  renderProgress() {
    const {
      percentByFiles,
      handleAbort,
      classes
    } = this.props;
    const closeFunc = handleAbort ? this.handleClose : null;

    return React__default.createElement(
      'div',
      null,
      React__default.createElement(FilePickerHeader$1, {
        title: 'Uploading',
        hideTabs: true,
        onClose: closeFunc }),
      React__default.createElement(
        'div',
        { className: classes.progressListContainer },
        React__default.createElement(FileProgressList$1, {
          percentByFiles: percentByFiles,
          handleAbort: handleAbort })
      )
    );
  }

  renderComplete() {
    const { classes } = this.props;
    const icon = {
      success: React__default.createElement(CheckCircle, { classes: { root: classes.resolveIcon },
        style: { fill: green$1[500] },
        'data-testtarget': 'successIcon'
      }),
      failure: React__default.createElement(Info, { classes: { root: classes.resolveIcon },
        style: { color: '#F44336' },
        'data-testtarget': 'failureIcon'
      }),
      warning: React__default.createElement(Warning, { classes: { root: classes.resolveIcon },
        style: { color: '#ffc107' },
        'data-testtarget': 'warnIcon'
      })
    }[this.props.completeStatus];

    const {
      percentByFiles,
      onClose
    } = this.props;

    const completeDialog = this.props.completeStatus !== 'success' ? React__default.createElement(
      'div',
      { className: classes.contentFlexer },
      React__default.createElement(FilePickerHeader$1, {
        title: `Upload ${this.props.completeStatus}`,
        message: this.props.progressMessage,
        titleIcon: icon,
        hideTabs: true,
        onClose: onClose }),
      React__default.createElement(
        'div',
        { className: classes.contentFlexer },
        React__default.createElement(
          'div',
          { className: classes.progressListContainer },
          React__default.createElement(FileProgressList$1, { percentByFiles: percentByFiles, showErrors: true })
        ),
        React__default.createElement(
          CardActions,
          { className: classes.resolveActions },
          React__default.createElement(
            Button$2,
            {
              onClick: this.props.onRetryDone },
            'Done'
          ),
          React__default.createElement(
            Button$2,
            {
              variant: 'contained',
              color: 'primary',
              onClick: this.props.retryRequest },
            'Retry All'
          )
        )
      )
    ) : null;

    return completeDialog;
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      Card,
      {
        className: classes.container,
        style: { width: this.props.width } },
      this.props.completeStatus ? this.renderComplete() : this.renderProgress()
    );
  }
}, _class$q.propTypes = {
  percentByFiles: arrayOf(shape$1({
    key: string,
    value: shape$1({
      name: string,
      type: string,
      size: number,
      percent: number,
      error: any
    }).isRequired
  })),
  onClose: func.isRequired,
  onRetryDone: func.isRequired,
  retryRequest: func.isRequired,
  handleAbort: func,
  // height: number,
  width: number,
  progressMessage: string,
  completeStatus: oneOf(['success', 'failure', 'warning']),
  classes: shape$1({ any })
}, _class$q.defaultProps = {
  percentByFiles: [],
  progressMessage: '',
  width: 600
}, _temp2$j);
FileProgressDialog.displayName = 'FileProgressDialog';


var index$4 = withStyles$1(styles$E)(FileProgressDialog);

const display1Text = muiText('display1');
const subheadText$2 = muiText('subhead');

var styles$F = {
  container: {
    position: 'relative',
    '& $circularProgressContainer': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& $circularProgress': {
        position: 'relative',
        top: -22
        //left: '-12,
        //zIndex: '1',
      }
    },
    '& $textContainer': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      '& $percentageContainer': {
        height: 125,
        display: 'flex',
        alignItems: 'center',
        '& $percentage': _extends({}, display1Text, {
          fontWeight: '200 !important'
        })
      },
      '& $resolutionIconContainer': {
        height: 125,
        '& $resolutionIcon': {
          height: 125,
          width: 125
        }
      },
      '& $progressMessage': _extends({}, subheadText$2, {
        height: 40,
        color: darkBlack,
        textAlign: 'center'
      })
    }
  },
  circularProgress: {},
  textContainer: {},
  percentageContainer: {},
  percentage: {},
  resolutionIconContainer: {},
  resolutionIcon: {},
  progressMessage: {},
  circularProgressContainer: {}
};

var _class$r, _temp$7;

let ProgressDialog = (_temp$7 = _class$r = class ProgressDialog extends React__default.Component {

  renderProgress() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.percentageContainer },
      React__default.createElement(
        'div',
        { className: classes.percentage },
        this.props.percentComplete,
        '%'
      )
    );
  }

  renderComplete() {
    const { classes } = this.props;
    const icon = {
      success: React__default.createElement(CheckCircle, {
        classes: {
          root: classes.resolutionIcon
        },
        style: {
          fill: green$1[500]
        },
        'data-testtarget': 'successIcon'
      }),

      failure: React__default.createElement(RemoveCircle, {
        classes: {
          root: classes.resolutionIcon
        },
        style: {
          fill: red$1[500]
        },
        'data-testtarget': 'failureIcon'
      }),

      warning: React__default.createElement(Warning, {
        classes: {
          root: classes.resolutionIcon
        },
        style: {
          fill: yellow[500]
        },
        'data-testtarget': 'warnIcon'
      })
    }[this.props.completeStatus];

    return React__default.createElement(
      'div',
      { className: classes.resolutionIconContainer },
      icon
    );
  }

  render() {
    // todo: error message, close button (when error is present)
    const { classes } = this.props;
    return React__default.createElement(
      Paper,
      {
        classes: { root: classes.container },
        style: { height: this.props.height, width: this.props.width }
      },
      React__default.createElement(
        'div',
        { className: classes.circularProgressContainer },
        !this.props.completeStatus && React__default.createElement(CircularProgress$2, {
          className: classes.circularProgress,
          size: 125,
          thickness: 1
        })
      ),
      React__default.createElement(
        'div',
        { className: classes.textContainer },
        this.props.completeStatus ? this.renderComplete() : this.renderProgress(),
        React__default.createElement(
          'div',
          { className: classes.progressMessage },
          this.props.progressMessage
        )
      )
    );
  }
}, _class$r.propTypes = {
  percentComplete: number,
  progressMessage: string,
  height: number,
  width: number,
  completeStatus: oneOf(['success', 'failure', 'warning']),
  classes: shape$1({ any })
}, _class$r.defaultProps = {
  percentComplete: 0,
  progressMessage: '',
  height: 400,
  width: 600
}, _temp$7);
ProgressDialog.displayName = 'ProgressDialog';


var index$5 = withStyles$1(styles$F)(ProgressDialog);

// based on https://github.com/erikras/redux-form-material-ui/blob/5.0/src/Checkbox.js
const Checkbox$2 = (_ref) => {
  let {
    /* eslint-disable react/prop-types, react/jsx-no-bind */
    meta,
    input: { onChange, value },
    label,
    labelProps
  } = _ref,
      inputProps = objectWithoutProperties(_ref.input, ['onChange', 'value']),
      props = objectWithoutProperties(_ref, ['meta', 'input', 'label', 'labelProps']);
  return React__default.createElement(FormControlLabel, _extends({
    control: React__default.createElement(Checkbox$3, _extends({
      checked: !!value,
      onChange: (event, isInputChecked) => {
        onChange(isInputChecked);
      }
    }, inputProps, props)),
    label: label
  }, labelProps));
};

Checkbox$2.displayName = 'Checkbox';

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addHours(dirtyDate, -amount);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  var desiredMonth = date.getMonth() + amount;
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
  return date;
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `true`        |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$1 = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

let Interval = class Interval {
  constructor({ label, start, end, window } = {}) {
    this.label = label;
    this._start = start;
    this._end = end;
    this._window = window;

    this.validate();
  }

  get start() {
    if (this._window) {
      return Interval._translateWidow(this._window).start;
    }

    return this._start;
  }

  get end() {
    if (this._window) {
      return Interval._translateWidow(this._window).end;
    }

    return this._end;
  }

  set start(val) {
    this._start = val;
    this.validate();
  }

  set end(val) {
    this._end = val;
    this.validate();
  }

  isStatic() {
    return !this._window;
  }

  isSliding() {
    return !this.isStatic();
  }

  isEqual(interval) {
    if (this.isSliding()) {
      return _isMatch(interval, {
        _window: this._window
      });
    }

    return _isMatch(interval, {
      _start: this._start,
      _end: this._end
    });
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
      _start: this._start,
      _end: this._end,
      _window: this._window
    };
  }

  toString() {
    const dateFormat = dateFormats$1.short;

    return this.label ? this.label : `${format$1(this.start, dateFormat)} – ${format$1(this.end, dateFormat)}`;
  }

  validate() {
    if (this._window) {
      if (!_isArray(this._window)) {
        throw new Error('Expected window to be an array');
      }

      if (this._window.length !== 2) {
        throw new Error('Expected window array to have two elements');
      }
    }

    if (!this._window) {
      if (!(this._start && this._end)) {
        throw new Error('Expected interval to either have _window or _start & _end keys');
      }

      if (!_isDate(this._start)) {
        throw new Error('Expected _start to be an instance of Date');
      }

      if (!_isDate(this._end)) {
        throw new Error('Expected _end to be an instance of Date');
      }
    }
  }

  static _translateWidow(window) {
    const subFn = {
      h: subHours,
      d: subDays,
      m: subMonths
    }[window[1]];

    if (!subFn) {
      throw new Error('Bucket had unexpected unit:', window[1]);
    }

    return {
      start: subFn(new Date(), window[0]),
      end: new Date()
    };
  }

  static fromJSON(jsonInterval) {
    const interval = JSON.parse(jsonInterval);

    return new Interval({
      window: interval._window,
      start: interval._start ? new Date(interval._start) : undefined,
      end: interval._end ? new Date(interval._end) : undefined
    });
  }
};

const defaultIntervals = {
  day: new Interval({
    label: 'Last day',
    window: [1, 'd']
  }),
  week: new Interval({
    label: 'Last 7 days',
    window: [7, 'd']
  }),
  month: new Interval({
    label: 'Last 30 days',
    window: [30, 'd']
  }),
  quarter: new Interval({
    label: 'Last 90 days',
    window: [90, 'd']
  }),
  year: new Interval({
    label: 'Last 365 days',
    window: [365, 'd']
  })
};

const dateFormats$1 = {
  full: 'MMM Do, yyyy hh:mmA',
  short: 'MM/dd/yyyy'
};

function format$1(date, ...args) {
  if (!date) {
    return '';
  }

  return isValid(new Date(date)) ? format(date, ...args) : '';
}

// this hopefully temporary file duplicates all the stuff in

const isStateLess = ReactComponent => ReactComponent.prototype && !ReactComponent.prototype.render;

function createComponent(MaterialUIComponent, mapProps) {
  let InputComponent = class InputComponent extends Component {
    getRenderedComponent() {
      return this.component;
    }

    render() {
      return createElement(MaterialUIComponent, _extends({}, mapProps(this.props), {
        ref: !isStateLess(MaterialUIComponent) ? el => this.component = el : null
      }));
    }
  };
  InputComponent.displayName = 'InputComponent';


  InputComponent.displayName = `ReduxFormMaterialUI${MaterialUIComponent.name}`;
  return InputComponent;
}

const mapError = (_ref) => {
  let {
    meta: { touched, error, warning } = {},
    input
  } = _ref,
      props = objectWithoutProperties(_ref, ['meta', 'input']);
  return touched && (error || warning) ? _extends({}, props, input, {
    error: Boolean(error || warning),
    helperText: error || warning
  }) : _extends({}, input, props);
};

var Select = createComponent(Select$2, (_ref) => {
  let {
    input: { onChange, value, onBlur },
    onChange: onChangeFromField,
    defaultValue
  } = _ref,
      inputProps = objectWithoutProperties(_ref.input, ['onChange', 'value', 'onBlur']),
      props = objectWithoutProperties(_ref, ['input', 'onChange', 'defaultValue']);
  return _extends({}, mapError(props), inputProps, {
    value: value,
    onChange: event => {
      onChange(event.target.value);
      if (onChangeFromField) {
        onChangeFromField(event.target.value);
      }
    },
    onBlur: () => onBlur(value)
  });
});

const DateIntervalSelect = (_ref) => {
  let {
    intervals,
    allowCustomInterval,
    customIntervalLabel
  } = _ref,
      props = objectWithoutProperties(_ref, ['intervals', 'allowCustomInterval', 'customIntervalLabel']);

  const fixedProps = _extends({}, props, {
    input: _extends({}, props.input, {
      value: props.input.value.toString()
    })
  });

  return React__default.createElement(
    Select,
    fixedProps,
    _map(intervals, (interval, id) => React__default.createElement(
      MenuItem,
      { value: interval.toString(), key: id },
      interval.label
    )),
    allowCustomInterval && React__default.createElement(
      ListItem$2,
      { value: 'custom' },
      customIntervalLabel
    )
  );
};

DateIntervalSelect.displayName = 'DateIntervalSelect';
DateIntervalSelect.defaultProps = {
  intervals: defaultIntervals,
  allowCustomInterval: true,
  customIntervalLabel: 'Custom'
};

DateIntervalSelect.propTypes = {
  input: shape$1({
    value: oneOfType([instanceOf(Interval), string])
  }),
  intervals: objectOf(instanceOf(Interval)),
  allowCustomInterval: bool,
  customIntervalLabel: string
};

var css$2 = ".styles_Cal__Day__root__33hz- {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 14.28571%;\n  list-style: none;\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n  user-select: none; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj.styles_Cal__Day__highlighted__1785c, .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:active, .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:hover {\n    position: relative;\n    z-index: 1; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj.styles_Cal__Day__highlighted__1785c:before, .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:active:before, .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:hover:before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      background-color: #EFEFEF;\n      z-index: -1; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:hover:before {\n    opacity: 0.5; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj.styles_Cal__Day__highlighted__1785c:before, .styles_Cal__Day__root__33hz-.styles_Cal__Day__enabled__25mFj:active:before {\n    opacity: 1; }\n  .styles_Cal__Day__root__33hz-:first-child {\n    position: relative; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__today__DA5um {\n    position: relative;\n    z-index: 2; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__today__DA5um > span {\n      color: #3d3d3d; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__today__DA5um.styles_Cal__Day__disabled__1DP2Q > span {\n      color: #AAA; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__today__DA5um:before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      box-shadow: inset 0 0 0 1px;\n      z-index: -1; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__today__DA5um.styles_Cal__Day__disabled__1DP2Q:before {\n      box-shadow: inset 0 0 0 1px #BBB; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz {\n    position: relative; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz > .styles_Cal__Day__month__2tWCc, .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz > .styles_Cal__Day__year__2d-i5 {\n      display: none; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz:before {\n      display: none; }\n    .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz .styles_Cal__Day__selection__je54H {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: 52px;\n      height: 52px;\n      margin-top: -26px;\n      margin-left: -26px;\n      border-radius: 50%;\n      line-height: 56px;\n      z-index: 2; }\n      .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz .styles_Cal__Day__selection__je54H .styles_Cal__Day__month__2tWCc {\n        top: 9px; }\n      .styles_Cal__Day__root__33hz-.styles_Cal__Day__selected__DnZJz .styles_Cal__Day__selection__je54H .styles_Cal__Day__day__SiK5o {\n        position: relative;\n        top: 5px;\n        font-weight: bold;\n        font-size: 18px; }\n  .styles_Cal__Day__root__33hz-.styles_Cal__Day__disabled__1DP2Q {\n    color: #AAA;\n    cursor: not-allowed; }\n\n.styles_Cal__Day__month__2tWCc, .styles_Cal__Day__year__2d-i5 {\n  position: absolute;\n  left: 0;\n  right: 0;\n  font-size: 12px;\n  line-height: 12px;\n  text-transform: capitalize; }\n\n.styles_Cal__Day__month__2tWCc {\n  top: 5px; }\n\n.styles_Cal__Day__year__2d-i5 {\n  bottom: 5px; }\n\n/*\n * Range selection styles\n */\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__start__3Hn48:after, .styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__end__1HgpD:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 50%;\n  height: 52px;\n  margin-top: -26px;\n  box-shadow: inset 56px 56px; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__disabled__1DP2Q .styles_Cal__Day__selection__je54H.styles_Cal__Day__selection__je54H {\n  background-color: #EEE !important; }\n  .styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__disabled__1DP2Q .styles_Cal__Day__selection__je54H.styles_Cal__Day__selection__je54H .styles_Cal__Day__day__SiK5o, .styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__disabled__1DP2Q .styles_Cal__Day__selection__je54H.styles_Cal__Day__selection__je54H .styles_Cal__Day__month__2tWCc {\n    color: #AAA;\n    font-weight: 300; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__start__3Hn48 .styles_Cal__Day__selection__je54H {\n  border-top-left-radius: 50%;\n  border-bottom-left-radius: 50%; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__start__3Hn48:after {\n  right: 0; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__start__3Hn48.styles_Cal__Day__end__1HgpD:after {\n  display: none; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__betweenRange__DQ-Jt .styles_Cal__Day__selection__je54H {\n  left: 0;\n  right: 0;\n  width: 100%;\n  margin-left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__betweenRange__DQ-Jt .styles_Cal__Day__day__SiK5o {\n  top: 0;\n  font-size: 16px; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__betweenRange__DQ-Jt .styles_Cal__Day__month__2tWCc {\n  display: none; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__end__1HgpD:after {\n  left: 0; }\n\n.styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__end__1HgpD .styles_Cal__Day__selection__je54H {\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n  color: inherit !important;\n  background-color: #FFF !important;\n  border: 2px solid;\n  box-sizing: border-box; }\n  .styles_Cal__Day__range__3Nl1g.styles_Cal__Day__selected__DnZJz.styles_Cal__Day__end__1HgpD .styles_Cal__Day__selection__je54H .styles_Cal__Day__day__SiK5o {\n    top: 4px; }\n.styles_Cal__Container__root__3NX_I {\n  position: relative;\n  display: table;\n  z-index: 1;\n  font: 14px 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  line-height: 1.4em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 300;\n  outline: none;\n  text-align: left; }\n  .styles_Cal__Container__root__3NX_I.styles_Cal__Container__landscape__1DM1F {\n    display: flex;\n    flex-direction: row; }\n    .styles_Cal__Container__root__3NX_I.styles_Cal__Container__landscape__1DM1F .styles_Cal__Container__wrapper__1djS6 {\n      position: relative;\n      flex-grow: 1;\n      overflow: hidden;\n      z-index: 1;\n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px; }\n\n.styles_Cal__Container__listWrapper__15E-6 {\n  position: relative;\n  overflow: hidden;\n  background-color: #FFF; }\n.styles_Cal__Header__root__2gR-z {\n  position: relative;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  overflow: hidden;\n  min-height: 98px;\n  padding: 20px;\n  line-height: 1.3;\n  font-weight: 400;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px; }\n  .styles_Cal__Header__root__2gR-z.styles_Cal__Header__landscape__2kgwV {\n    align-items: flex-start;\n    min-width: 200px;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 3px; }\n    .styles_Cal__Header__root__2gR-z.styles_Cal__Header__landscape__2kgwV .styles_Cal__Header__dateWrapper__1Y2bc.styles_Cal__Header__day__2p3rt {\n      flex-grow: 1;\n      height: 76px; }\n\n.styles_Cal__Header__wrapper__EPxPl {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  cursor: pointer; }\n  .styles_Cal__Header__wrapper__EPxPl.styles_Cal__Header__blank__Rb76q {\n    height: 58px;\n    line-height: 58px;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 18px;\n    cursor: default; }\n\n.styles_Cal__Header__dateWrapper__1Y2bc {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  color: rgba(255, 255, 255, 0.5);\n  transition: color 0.3s ease; }\n  .styles_Cal__Header__dateWrapper__1Y2bc.styles_Cal__Header__active__3FOI5 {\n    color: white; }\n  .styles_Cal__Header__dateWrapper__1Y2bc.styles_Cal__Header__day__2p3rt {\n    height: 38px;\n    font-size: 36px;\n    line-height: 36px;\n    text-transform: capitalize; }\n  .styles_Cal__Header__dateWrapper__1Y2bc.styles_Cal__Header__year__NxTte {\n    height: 20px;\n    font-size: 18px;\n    line-height: 18px; }\n\n.styles_Cal__Header__date__RNHMq {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.styles_Cal__Header__range__3dUVc {\n  display: flex;\n  flex-grow: 1; }\n  .styles_Cal__Header__range__3dUVc .styles_Cal__Header__dateWrapper__1Y2bc {\n    overflow: visible; }\n  .styles_Cal__Header__range__3dUVc .styles_Cal__Header__wrapper__EPxPl:first-child:before, .styles_Cal__Header__range__3dUVc .styles_Cal__Header__wrapper__EPxPl:first-child:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -50px;\n    margin-left: -50px;\n    border-top: 100px solid transparent;\n    border-bottom: 100px solid transparent;\n    border-left: 60px solid; }\n  .styles_Cal__Header__range__3dUVc .styles_Cal__Header__wrapper__EPxPl:first-child:before {\n    color: rgba(255, 255, 255, 0.15);\n    transform: translateX(1px); }\n  .styles_Cal__Header__range__3dUVc .styles_Cal__Header__wrapper__EPxPl:last-child {\n    margin-left: 60px; }\n  .styles_Cal__Header__range__3dUVc .styles_Cal__Header__wrapper__EPxPl .styles_Cal__Header__date__RNHMq {\n    white-space: nowrap;\n    z-index: 1; }\n.styles_Cal__Today__root__2_rUN {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 6px;\n  box-sizing: border-box;\n  transform: translate3d(0, -100%, 0);\n  font-weight: 500;\n  line-height: 0;\n  z-index: 10;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  transition-delay: 0.3s; }\n  .styles_Cal__Today__root__2_rUN.styles_Cal__Today__show__1bqmO {\n    transform: translate3d(0, 0, 0);\n    transition-delay: 0s; }\n    .styles_Cal__Today__root__2_rUN.styles_Cal__Today__show__1bqmO .styles_Cal__Today__chevron__1ZZE5 {\n      transition: transform 0.3s ease; }\n  .styles_Cal__Today__root__2_rUN .styles_Cal__Today__chevron__1ZZE5 {\n    position: absolute;\n    top: 50%;\n    margin-top: -6px;\n    margin-left: 5px;\n    transform: rotate(270deg);\n    transition: transform 0.3s ease; }\n  .styles_Cal__Today__root__2_rUN.styles_Cal__Today__chevronUp__3wH38 .styles_Cal__Today__chevron__1ZZE5 {\n    transform: rotate(180deg); }\n  .styles_Cal__Today__root__2_rUN.styles_Cal__Today__chevronDown__3LSKG .styles_Cal__Today__chevron__1ZZE5 {\n    transform: rotate(360deg); }\n.styles_Cal__MonthList__root__3af9u {\n  width: 100% !important;\n  background-color: #FFF;\n  -webkit-overflow-scrolling: touch; }\n  .styles_Cal__MonthList__root__3af9u.styles_Cal__MonthList__scrolling__1dEvs > div {\n    pointer-events: none; }\n  .styles_Cal__MonthList__root__3af9u.styles_Cal__MonthList__scrolling__1dEvs label {\n    opacity: 1; }\n.styles_Cal__Weekdays__root__ry_vP {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.04); }\n\n.styles_Cal__Weekdays__day__3q0NZ {\n  padding: 15px 0;\n  flex-basis: 14.28571%;\n  flex-grow: 1;\n  font-weight: 500;\n  text-align: center; }\n.styles_Cal__Years__root__tnuqn {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F9F9F9; }\n  .styles_Cal__Years__root__tnuqn:before, .styles_Cal__Years__root__tnuqn:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    height: 50px;\n    pointer-events: none;\n    z-index: 1; }\n  .styles_Cal__Years__root__tnuqn:before {\n    top: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%); }\n  .styles_Cal__Years__root__tnuqn:after {\n    bottom: 0;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 100%); }\n\n.styles_Cal__Years__list__13JOz {\n  box-sizing: border-box; }\n  .styles_Cal__Years__list__13JOz.styles_Cal__Years__center__1FTi4 {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n\n.styles_Cal__Years__year__3Qu0B {\n  display: flex;\n  padding: 0 20px;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  -webkit-user-select: none;\n  box-sizing: border-box; }\n  .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__withMonths__3GvM1 {\n    border-bottom: 1px solid #E9E9E9; }\n    .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__withMonths__3GvM1 label {\n      height: 88px;\n      padding-top: 12px;\n      box-sizing: border-box; }\n  .styles_Cal__Years__year__3Qu0B label {\n    flex-basis: 42%; }\n    .styles_Cal__Years__year__3Qu0B label span {\n      flex-shrink: 0;\n      color: #333; }\n  .styles_Cal__Years__year__3Qu0B ol {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    padding: 0;\n    font-size: 14px; }\n    .styles_Cal__Years__year__3Qu0B ol li {\n      display: flex;\n      width: 44px;\n      height: 44px;\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: center;\n      list-style: none;\n      border-radius: 50%;\n      box-sizing: border-box;\n      color: #444;\n      font-weight: 400;\n      text-transform: capitalize; }\n      .styles_Cal__Years__year__3Qu0B ol li.styles_Cal__Years__currentMonth__BewLQ {\n        border: 1px solid; }\n      .styles_Cal__Years__year__3Qu0B ol li.styles_Cal__Years__selected__3cCJi {\n        position: relative;\n        z-index: 1;\n        background-color: blue;\n        color: #FFF !important;\n        border: 0; }\n      .styles_Cal__Years__year__3Qu0B ol li.styles_Cal__Years__disabled__3-dad {\n        cursor: not-allowed;\n        color: #AAA; }\n        .styles_Cal__Years__year__3Qu0B ol li.styles_Cal__Years__disabled__3-dad:hover {\n          background-color: inherit; }\n      .styles_Cal__Years__year__3Qu0B ol li:hover {\n        background-color: #EFEFEF; }\n  .styles_Cal__Years__year__3Qu0B:hover label > span, .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__active__ZVO53 label > span {\n    color: inherit; }\n  .styles_Cal__Years__year__3Qu0B:hover, .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__active__ZVO53 {\n    position: relative;\n    z-index: 2; }\n  .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__active__ZVO53 {\n    font-size: 32px; }\n  .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__currentYear__3qSOo {\n    position: relative; }\n    .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__currentYear__3qSOo label > span {\n      min-width: 50px;\n      padding-bottom: 5px;\n      border-bottom: 3px solid; }\n    .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__currentYear__3qSOo.styles_Cal__Years__active__ZVO53 label > span {\n      min-width: 85px; }\n  .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__first__14Mq6 {\n    padding-top: 40px; }\n  .styles_Cal__Years__year__3Qu0B.styles_Cal__Years__last__37p33 {\n    padding-bottom: 40px; }\n.styles_Cal__Animation__enter__3-6xs {\n  opacity: 0;\n  transform: translate3d(0, -100%, 0);\n  transition: 0.25s ease; }\n\n.styles_Cal__Animation__enter__3-6xs.styles_Cal__Animation__enterActive__2M-rv {\n  opacity: 1;\n  transform: translate3d(0, 0, 0); }\n\n.styles_Cal__Animation__leave__1h5CR {\n  transform: translate3d(0, 0, 0);\n  transition: 0.25s ease; }\n\n.styles_Cal__Animation__leave__1h5CR.styles_Cal__Animation__leaveActive__jFBXK {\n  opacity: 0;\n  transform: translate3d(0, 100%, 0); }\n.styles_Cal__Slider__root__3PjH6, .styles_Cal__Slider__slide__IIHte {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n\n.styles_Cal__Slider__root__3PjH6 {\n  overflow: hidden; }\n\n.styles_Cal__Slider__slide__IIHte {\n  padding: 20px 65px; }\n  .styles_Cal__Slider__slide__IIHte:first-child {\n    padding-left: 20px; }\n\n.styles_Cal__Slider__wrapper__3uJzA {\n  height: 100%;\n  transition: transform 0.3s ease; }\n\n.styles_Cal__Slider__arrow__3KeDG {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 100%;\n  opacity: 0.7;\n  cursor: pointer;\n  border-left: 1px solid rgba(255, 255, 255, 0.1); }\n  .styles_Cal__Slider__arrow__3KeDG svg {\n    width: 15px; }\n  .styles_Cal__Slider__arrow__3KeDG:hover {\n    opacity: 1; }\n\n.styles_Cal__Slider__arrowRight__3I4yW {\n  right: 0; }\n\n.styles_Cal__Slider__arrowLeft__1s-dM {\n  left: 0;\n  transform: scaleX(-1); }\n.styles_Cal__transition__enter__3h5O6 {\n  opacity: 0; }\n\n.styles_Cal__transition__enterActive__2ovlW {\n  opacity: 1;\n  transition: opacity 0.3s ease; }\n\n.styles_Cal__transition__leave__1eFPQ {\n  opacity: 1; }\n\n.styles_Cal__transition__leaveActive__QYo6D {\n  opacity: 0;\n  transition: opacity 0.3s ease; }\n.styles_Cal__Month__rows__15xWw {\n  position: relative;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.05) 100%); }\n\n.styles_Cal__Month__row__3UiV9 {\n  padding: 0;\n  margin: 0; }\n  .styles_Cal__Month__row__3UiV9:first-child {\n    text-align: right; }\n    .styles_Cal__Month__row__3UiV9:first-child li {\n      background-color: #FFF;\n      box-shadow: 0 -1px 0 #E9E9E9; }\n  .styles_Cal__Month__row__3UiV9:nth-child(2) {\n    box-shadow: 0 -1px 0 #E9E9E9; }\n  .styles_Cal__Month__row__3UiV9.styles_Cal__Month__partial__2-G9h:first-child li:first-child {\n    box-shadow: 0px -1px 0 #E9E9E9, inset 1px 0 0 #E9E9E9; }\n  .styles_Cal__Month__row__3UiV9.styles_Cal__Month__partial__2-G9h:last-of-type li {\n    position: relative;\n    z-index: 1; }\n\n.styles_Cal__Month__label__1oKfZ {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  font-size: 30px;\n  font-weight: 500;\n  z-index: 3;\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.6);\n  opacity: 0;\n  transition: opacity 0.3s ease; }\n  .styles_Cal__Month__label__1oKfZ > span {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: capitalize; }\n  .styles_Cal__Month__label__1oKfZ.styles_Cal__Month__partialFirstRow__3Idvi {\n    top: 56px; }\n";
styleInject(css$2);

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime();
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR$1;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

var _class$s, _temp2$k;
const RangedCalendar = withRange(Calendar$2);

let DateRangePicker = (_temp2$k = _class$s = class DateRangePicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleSelectCustomDate = ({ eventType, start, end }) => {
      if (eventType === EVENT_TYPE.END) {
        this.props.input.onChange(differenceInHours(end, start) > 0 ? new Interval({ start, end }) : // single day selection is full day
        new Interval({ start, end: endOfDay(end) }));
      }
    }, _temp;
  }

  get minViewableDate() {
    return this.props.minViewableDate || this.props.minDate ? startOfMonth(this.props.minDate) : startOfMonth(subYears(new Date(), 3));
  }

  get maxViewableDate() {
    return this.props.maxViewableDate || this.props.maxDate ? endOfMonth(this.props.maxDate) : endOfMonth(new Date());
  }

  render() {
    // const defaultCalendarDate = {
    //   start: subDays(new Date(), 2),
    //   end: new Date()
    // };

    return React__default.createElement(InfiniteCalendar, {
      Component: RangedCalendar,
      min: this.minViewableDate,
      max: this.maxViewableDate,
      minDate: this.props.minDate,
      maxDate: this.props.maxDate,
      selected: this.props.input.value || false,
      onSelect: this.handleSelectCustomDate,
      locale: {
        headerFormat: 'MMM Do'
      }
      // theme={{
      //   // headerColor: '#4caf50',
      //   // weekdayColor: '#00c753'
      // }}
    });
  }
}, _class$s.propTypes = {
  minViewableDate: instanceOf(Date),
  maxViewableDate: instanceOf(Date),
  minDate: instanceOf(Date),
  maxDate: instanceOf(Date),
  // maxSelectionSizeMs: number, // todo
  input: shape$1({
    value: oneOfType([instanceOf(Interval), string]), // string to handle null "empty-string" value
    onChange: func
  })
}, _class$s.defaultProps = {}, _temp2$k);
DateRangePicker.displayName = 'DateRangePicker';

/* eslint-disable react/prop-types */
const Input = (_ref) => {
  let { meta, input } = _ref,
      props = objectWithoutProperties(_ref, ['meta', 'input']);

  return React__default.createElement(Input$1, _extends({}, input, props));
};

Input.displayName = 'Input';

var styles$G = {
  container: {
    '& svg': {
      height: 18,
      width: 18
    }
  }
};

const RadioGroupComponent = createComponent(RadioGroup$1, (_ref) => {
  let {
    input: { onChange, value },
    meta,
    onChange: onChangeFromField,
    classes
  } = _ref,
      inputProps = objectWithoutProperties(_ref.input, ['onChange', 'value']),
      props = objectWithoutProperties(_ref, ['input', 'meta', 'onChange', 'classes']);
  return _extends({}, inputProps, props, {
    value,
    onChange: (event, value) => {
      onChange(value);
      if (onChangeFromField) {
        onChangeFromField(value);
      }
    },
    classes: _extends({}, classes, {
      root: classes.container
    })
  });
});

var RadioGroup = withStyles$1(styles$G)(RadioGroupComponent);

var TextField = createComponent(TextField$1, (_ref) => {
  let props = objectWithoutProperties(_ref, ['defaultValue']);
  return _extends({}, mapError(props));
});

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  return year;
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * var result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * var result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * var result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * var result = isDate({})
 * //=> false
 */
function isDate(value) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

var MILLISECONDS_IN_HOUR$2 = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var fullTime = timestamp + time;
    var fullTimeDate = new Date(fullTime);
    offset = getTimezoneOffsetInMilliseconds(fullTimeDate); // Adjust time when it's coming from DST

    var fullTimeDateNextDay = new Date(fullTime);
    fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
    var offsetDiff = getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) - offset;

    if (offsetDiff > 0) {
      offset += offsetDiff;
    }
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR$2 + minutes * MILLISECONDS_IN_MINUTE$1 + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR$2 + minutes * MILLISECONDS_IN_MINUTE$1);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var styles$H = {
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    '& $todayIcon': {
      color: lightBlack,
      marginRight: 25
    }
  },
  dateTimeTZ: {
    '& input': {
      color: lightBlack,
      borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
      padding: '3px 0'
    }
  },
  todayIcon: {}
};

var _class$t, _temp2$l;
const useStyles$c = makeStyles(styles$H);
let DateTimePicker = (_temp2$l = _class$t = class DateTimePicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleDateChange = ({ target }) => {
      const newDate = target.value;
      const isoDate = parseISO(newDate);
      if (!isValid(isoDate) || getYear(isoDate) > 9999) {
        return;
      }
      this.props.input.onChange(isoDate);
    }, _temp;
  }

  render() {
    const _props = this.props,
          { input, min, max } = _props,
          rest = objectWithoutProperties(_props, ['input', 'min', 'max']);
    let { timeZone, classes } = this.props;

    // some components are not passing timezone, so we need to find it out
    // eslint-disable-next-line lodash/prefer-lodash-typecheck
    if (typeof timeZone === 'boolean' && timeZone) {
      timeZone = getTimeZone(input.value);
    }

    return React__default.createElement(
      'div',
      { className: classes.container },
      this.props.showIcon && React__default.createElement(Today, { className: classes.todayIcon }),
      React__default.createElement(DateTimeSelector, _extends({
        min: min && specialDateTimeFormat(min),
        max: max && specialDateTimeFormat(max),
        value: specialDateTimeFormat(input.value || new Date()),
        onChange: this.handleDateChange
      }, rest)),
      timeZone && React__default.createElement(TimeZoneField, _extends({ value: timeZone }, rest))
    );
  }
}, _class$t.propTypes = {
  min: instanceOf(Date),
  max: instanceOf(Date),
  showIcon: bool,
  timeZone: oneOfType([string, bool]),
  input: shape$1({
    value: instanceOf(Date).isRequired,
    onChange: func
  }).isRequired,
  readOnly: bool,
  classes: shape$1({ any })
}, _temp2$l);
DateTimePicker.displayName = 'DateTimePicker';


// T is special character, so build the date string manually
const specialDateTimeFormat = date => format(new Date(date), 'yyyy-MM-dd HH:mm').replace(' ', 'T');

const DateTimeSelector = (_ref) => {
  let { value, min, max, onChange, readOnly } = _ref,
      rest = objectWithoutProperties(_ref, ['value', 'min', 'max', 'onChange', 'readOnly']);

  return React__default.createElement(TextField$1, {
    type: 'datetime-local',
    min: min,
    max: max,
    value: value,
    onChange: onChange,
    InputProps: {
      readOnly: readOnly
    }
  });
};

DateTimeSelector.displayName = 'DateTimeSelector';
DateTimeSelector.propTypes = {
  min: instanceOf(Date),
  max: instanceOf(Date),
  value: string.isRequired,
  onChange: func.isRequired,
  readOnly: bool
};

const TimeZoneField = (_ref2) => {
  let { value } = _ref2,
      rest = objectWithoutProperties(_ref2, ['value']);

  const classes = useStyles$c();
  return value ? React__default.createElement(TextField$1, {
    className: classes.dateTimeTZ,
    value: value,
    InputProps: {
      disableUnderline: true
    },
    disabled: true
  }) : null;
};

TimeZoneField.propTypes = {
  value: string.isRequired
};

function getTimeZone(date) {
  let tzDate = date;
  if (isDate(tzDate)) {
    const tzMatch = tzDate.toTimeString().match(/\(([^)]+)\)$/);
    if (tzMatch && tzMatch.length > 1) {
      const tzParts = tzMatch[1].split(' ');
      if (tzParts.length > 1) {
        return tzParts.map(part => part[0]).join('');
      }
      return tzMatch[1];
    }
  }
  return '';
}

var DateTimePicker$1 = withStyles$1(styles$H)(DateTimePicker);

const body1Text$9 = muiText('body1');

var styles$I = {
  container: {
    display: 'flex',
    alignItems: 'flex-end',
    '& $separator': _extends({}, body1Text$9, {
      color: lightBlack,
      padding: '0 10px'
    }),
    '& $dateTimeTZ': {
      width: 40,
      '& input': {
        color: lightBlack,
        borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
        padding: '3px 0'
      }
    }
  },
  separator: {},
  dateTimeTZ: {}
};

var _class$u, _temp2$m;

let TimeRangePicker = (_temp2$m = _class$u = class TimeRangePicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleChangeStart = ({ target: { value } }) => {
      this.props.input.onChange({
        start: value,
        end: this.props.input.value.end,
        timeZone: this.props.input.value.timeZone
      });
    }, this.handleChangeEnd = ({ target: { value } }) => {
      this.props.input.onChange({
        start: this.props.input.value.start,
        end: value,
        timeZone: this.props.input.value.timeZone
      });
    }, _temp;
  }

  getTimeZone() {
    const tzDate = new Date();
    if (isDate(tzDate)) {
      const tzMatch = tzDate.toTimeString().match(/\(([^)]+)\)$/);
      if (tzMatch && tzMatch.length > 1) {
        const tzParts = tzMatch[1].split(' ');
        if (tzParts.length > 1) {
          return tzParts.map(part => part[0]).join('');
        }
        return tzMatch[1];
      }
    }
    return '';
  }

  render() {
    let { timeZone, classes } = this.props;

    // some components are not passing timezone, so we need to find it out
    // eslint-disable-next-line lodash/prefer-lodash-typecheck
    if (typeof timeZone === 'boolean' && timeZone) {
      timeZone = this.props.input.value.timeZone || this.getTimeZone();
    }

    return React__default.createElement(
      'div',
      { className: classes.container },
      React__default.createElement(TimeSelector, {
        value: this.props.input.value.start,
        onChange: this.handleChangeStart,
        readOnly: this.props.readOnly
      }),
      timeZone && React__default.createElement(TextField$1, {
        className: classes.dateTimeTZ,
        value: timeZone,
        InputProps: {
          disableUnderline: true
        },
        disabled: true
      }),
      React__default.createElement(
        'span',
        { className: classes.separator },
        'to'
      ),
      React__default.createElement(TimeSelector, {
        value: this.props.input.value.end,
        onChange: this.handleChangeEnd,
        readOnly: this.props.readOnly
      }),
      timeZone && React__default.createElement(TextField$1, {
        className: classes.dateTimeTZ,
        value: timeZone,
        InputProps: {
          disableUnderline: true,
          readOnly: this.props.readOnly
        },
        disabled: true
      })
    );
  }
}, _class$u.propTypes = {
  input: shape$1({
    value: shape$1({
      start: string,
      end: string,
      timeZone: string
    }).isRequired,
    onChange: func.isRequired
  }).isRequired,
  readOnly: bool,
  timeZone: oneOfType([string, bool]),
  classes: shape$1({ any })
}, _temp2$m);
TimeRangePicker.displayName = 'TimeRangePicker';


const TimeSelector = ({ value, onChange, readOnly }) => {
  return React__default.createElement(TextField$1, {
    type: 'time',
    value: value,
    onChange: onChange,
    InputProps: { readOnly }
  });
};

TimeSelector.displayName = 'TimeSelector';
TimeSelector.propTypes = {
  value: string,
  onChange: func,
  readOnly: bool
};

var TimeRangePicker$1 = withStyles$1(styles$I)(TimeRangePicker);

// based on https://github.com/erikras/redux-form-material-ui/blob/5.0/src/Checkbox.js
const Switch = (_ref) => {
  let {
    /* eslint-disable react/prop-types, react/jsx-no-bind */
    meta,
    input: { onChange, value },
    label,
    labelProps
  } = _ref,
      inputProps = objectWithoutProperties(_ref.input, ['onChange', 'value']),
      props = objectWithoutProperties(_ref, ['meta', 'input', 'label', 'labelProps']);
  return React__default.createElement(FormControlLabel, _extends({
    control: React__default.createElement(LibSwitch, _extends({
      checked: !!value,
      onChange: (event, isSwitchChecked) => {
        onChange(isSwitchChecked);
      }
    }, inputProps, props)),
    label: label
  }, labelProps));
};

Switch.displayName = 'Switch';



var index$6 = /*#__PURE__*/Object.freeze({
  Checkbox: Checkbox$2,
  DateIntervalSelect: DateIntervalSelect,
  DateRangePicker: DateRangePicker,
  Input: Input,
  RadioGroup: RadioGroup,
  Select: Select,
  TextField: TextField,
  DateTimePicker: DateTimePicker$1,
  TimeRangePicker: TimeRangePicker$1,
  Switch: Switch
});

const AppContainer = ({
  topBarOffset,
  appBarOffset,
  appFooterOffset,
  leftOffset,
  children,
  classes
}) => {
  const paddingBottom = {
    short: appFooterHeightShort,
    tall: appFooterHeightTall
  };
  let paddingTop = 'initial';
  if (topBarOffset && appBarOffset) {
    paddingTop = appBarHeight + topBarHeight;
  } else if (topBarOffset) {
    paddingTop = topBarHeight;
  } else if (appBarOffset) {
    paddingTop = appBarHeight;
  }

  const outerStyle = {
    height: '100%',
    paddingTop: paddingTop,
    paddingBottom: paddingBottom[appFooterOffset],
    paddingLeft: _isNumber(leftOffset) ? leftOffset : 'initial',
    overflowX: 'hidden'
  };

  // todo: anims when styles change
  return React__default.createElement(
    'div',
    { style: outerStyle, className: classes.root },
    React__default.createElement(
      'div',
      {
        style: {
          height: '100%',
          width: `calc(100% - ${outerStyle.paddingLeft}`,
          overflowX: 'hidden'
        },
        className: classes.inner
      },
      children
    )
  );
};

AppContainer.displayName = 'AppContainer';
AppContainer.propTypes = {
  children: node,
  leftOffset: number,
  topBarOffset: bool,
  appBarOffset: bool,
  appFooterOffset: oneOf(['short', 'tall']),
  classes: shape$1({
    root: string,
    inner: string
  })
};

AppContainer.defaultProps = {
  classes: {}
};

var veritoneIcon = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22133px%22%20height%3D%22120px%22%20viewBox%3D%220%200%20133%20120%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EIcon%20Transparent%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Icon-Transparent%22%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-2%22%20opacity%3D%220.36%22%20points%3D%2276.5644%200.0003%2094.7794%2031.2713%20113.0444%200.0003%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-3%22%20opacity%3D%220.9%22%20points%3D%22113.0436%200.0003%2042.9526%20120.0003%2089.9366%20120.0003%20132.8896%2046.1493%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Fill-12%22%20opacity%3D%220.36%22%20points%3D%2219.853244%200%200%2046.1668073%2042.9686773%20120.045%2066.4820639%2079.8311745%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const buttonText$1 = muiText('button');

var styles$J = {
  resetButtonStyles: {
    background: 'none',
    border: 0,
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    overflow: 'visible',
    padding: 0,
    appearance: 'button',
    userSelect: 'none',
    cursor: 'pointer',
    '&:focus': {
      //outline: 0,
    }
  },
  button: _extends({}, buttonText$1, {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white',
    backgroundColor: blue1,
    borderRadius: 2,
    padding: '8px 20px',
    '& img': {
      height: 20
    },
    '& $textContainer': {
      paddingLeft: 8
    }
  }),
  textContainer: {}
};

const useStyles$d = makeStyles(styles$J);

const OAuthLoginButton = ({ onClick, iconOnly, className }) => {
  const classes = useStyles$d();
  return React__default.createElement(
    'button',
    {
      onClick: onClick,
      className: cx$1(classes.button, classes.resetButtonStyles, className)
    },
    React__default.createElement('img', { src: veritoneIcon }),
    !iconOnly && React__default.createElement(
      'div',
      { className: classes.textContainer },
      'Sign In With Veritone'
    )
  );
};

OAuthLoginButton.displayName = 'OAuthLoginButton';
OAuthLoginButton.propTypes = {
  onClick: func,
  iconOnly: bool,
  className: string
};

var chainFunction = function chain(){
  var len = arguments.length;
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i];

  args = args.filter(function(fn){ return fn != null });

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
};

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

var browser = warning;

var ChildMapping = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  React__default.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}
});

unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;

var TransitionGroup_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _chainFunction2 = _interopRequireDefault(chainFunction);



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _warning2 = _interopRequireDefault(browser);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];
});

unwrapExports(TransitionGroup_1);

var hasClass_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];
});

unwrapExports(hasClass_1);

var addClass_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;



var _hasClass2 = _interopRequireDefault(hasClass_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];
});

unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

var inDOM = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];
});

unwrapExports(inDOM);

var requestAnimationFrame = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _inDOM2 = _interopRequireDefault(inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];
});

unwrapExports(requestAnimationFrame);

var properties = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;



var _inDOM2 = _interopRequireDefault(inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}
});

unwrapExports(properties);
var properties_1 = properties.animationEnd;
var properties_2 = properties.animationDelay;
var properties_3 = properties.animationTiming;
var properties_4 = properties.animationDuration;
var properties_5 = properties.animationName;
var properties_6 = properties.transitionEnd;
var properties_7 = properties.transitionDuration;
var properties_8 = properties.transitionDelay;
var properties_9 = properties.transitionTiming;
var properties_10 = properties.transitionProperty;
var properties_11 = properties.transform;

var PropTypes = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);
});

unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.nameShape;
var PropTypes_2 = PropTypes.transitionTimeout;

var CSSTransitionGroupChild_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _addClass2 = _interopRequireDefault(addClass_1);



var _removeClass2 = _interopRequireDefault(removeClass);



var _requestAnimationFrame2 = _interopRequireDefault(requestAnimationFrame);





var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (properties.transitionEnd) events.push(properties.transitionEnd);
if (properties.animationEnd) events.push(properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, ReactDOM__default.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];
});

unwrapExports(CSSTransitionGroupChild_1);

var CSSTransitionGroup_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1);



var _CSSTransitionGroupChild2 = _interopRequireDefault(CSSTransitionGroupChild_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];
});

unwrapExports(CSSTransitionGroup_1);

var reactAddonsCssTransitionGroup = CSSTransitionGroup_1;

function injectInto(children, props) {
  return React__default.Children.map(children, child => {
    return React__default.cloneElement(child, props);
  });
}

// symbol that will cause a column to render its loading state if passed in from rowGetter
const LOADING = '@@LOADING';

var styles$K = {
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  spin: {
    animation: '$spin 750ms linear infinite'
  }
};

var _class$v, _temp2$n;

let RefreshButton = (_temp2$n = _class$v = class RefreshButton extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      animating: false,
      animationTimeout: null
    }, this.handleClick = () => {
      clearTimeout(this.state.animationTimeout);

      this.setState({
        animating: true,
        animationTimeout: setTimeout(() => this.setState({ animating: false }), 750)
      });

      this.props.onRefresh();
    }, _temp;
  }

  componentWillUnmount() {
    clearTimeout(this.state.animationTimeout);
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      IconButton$2,
      {
        className: cx$1(this.props.className, {
          [classes['spin']]: this.state.animating
        }),
        disabled: this.props.disabled,
        onClick: this.handleClick
      },
      React__default.createElement(RefreshIcon, null)
    );
  }
}, _class$v.propTypes = {
  onRefresh: func.isRequired,
  disabled: bool,
  className: string,
  classes: shape$1({ any })
}, _temp2$n);
RefreshButton.displayName = 'RefreshButton';


var RefreshButton$1 = withStyles$1(styles$K)(RefreshButton);

const captionText$7 = muiText('caption');
var styles$L = {
  tableWrapper: {
    display: 'block',
    overflow: 'auto'
  },
  splitTableWrapper: {
    display: 'block',
    overflow: 'hidden'
  },
  table: {
    tableLayout: 'fixed',
    width: '100%'
  },
  tableCell: {
    whiteSpace: 'normal',
    paddingRight: '24px !important'
  },
  focusTable: {
    transition: 'all 200ms ease',
    transitionProperty: 'max-height, margin-top, margin-bottom'
  },
  leave: {
    '& $focusedRow': {
      maxHeight: 250,
      marginTop: '15px !important',
      marginBottom: '15px !important'
    }
  },
  leaveActive: {
    '& $focusedRow': {
      maxHeight: 48,
      overflow: 'hidden',
      marginTop: '0 !important',
      marginBottom: '0 !important'
    }
  },
  enter: {
    '& $focusedRow': {
      maxHeight: 48,
      overflow: 'hidden',
      marginTop: '0 !important',
      marginBottom: '0 !important'
    }
  },
  enterActive: {
    '& $focusedRow': {
      maxHeight: 250,
      marginTop: '15px !important',
      marginBottom: '15px !important'
    }
  },
  paginatedFooter: {
    color: `${lightBlack} !important`,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
    '& $rowsPerPage': _extends({}, captionText$7, {
      paddingRight: 28
    }),
    '& $perPage': _extends({}, captionText$7, {
      marginRight: 32
    }),
    '& $numItems': {
      paddingRight: 32
    },
    '& $pageLeft, $pageRight, $refresh': {
      '& button': {
        width: '24px !important',
        height: '24px !important'
      },
      padding: '0 !important'
    },
    '& $pageLeft': {
      marginRight: '24px !important'
    },
    '& $pageRight': {
      marginRight: '0 !important'
    }
  },
  pageLeft: {},
  pageRight: {},
  refresh: {},
  rowsPerPage: {},
  perPage: {},
  numItems: {},
  focusedRow: {}
};

var _class$w, _temp2$o;
let PaginatedTableFooter = (_temp2$o = _class$w = class PaginatedTableFooter extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleFirstPageButtonClick = event => {
      this.props.onChangePage(0);
    }, this.handleBackButtonClick = event => {
      this.props.onChangePage(this.props.page - 1);
    }, this.handleNextButtonClick = event => {
      this.props.onChangePage(this.props.page + 1);
    }, this.handleLastPageButtonClick = event => {
      this.props.onChangePage(Math.max(0, Math.ceil(this.props.rowCount / this.props.perPage) - 1));
    }, _temp;
  }

  render() {
    const { rowCount, page, perPage, classes } = this.props;
    const firstItem = page * perPage + 1;
    const lastItem = Math.min(page * perPage + perPage, rowCount);

    return React__default.createElement(
      TableCell,
      {
        colSpan: this.props.colSpan,
        style: {
          textAlign: 'right'
        }
      },
      React__default.createElement(
        'div',
        { className: classes['paginatedFooter'] },
        React__default.createElement(
          'span',
          { className: classes['rowsPerPage'] },
          'Rows per page:'
        ),
        React__default.createElement(
          Select$2,
          {
            value: this.props.perPage,
            onChange: this.props.onChangePerPage,
            className: classes['perPage'],
            style: {
              width: '4em',
              padding: '0 5px',
              margin: '0 5px'
            },
            autoWidth: true
          },
          React__default.createElement(
            MenuItem,
            { value: 10 },
            '10'
          ),
          React__default.createElement(
            MenuItem,
            { value: 20 },
            '20'
          ),
          React__default.createElement(
            MenuItem,
            { value: 30 },
            '30'
          )
        ),
        React__default.createElement(
          'span',
          { className: classes['numItems'] },
          firstItem,
          '\u2013',
          lastItem,
          ' of ',
          rowCount
        ),
        React__default.createElement(
          IconButton$2,
          {
            onClick: this.handleFirstPageButtonClick,
            disabled: page === 0
          },
          React__default.createElement(FirstPageIcon, null)
        ),
        React__default.createElement(
          IconButton$2,
          {
            className: cx$1(classes['pageLeft'], 'pageLeft'),
            onClick: this.handleBackButtonClick,
            disabled: page === 0
          },
          React__default.createElement(KeyboardArrowLeft, null)
        ),
        React__default.createElement(
          IconButton$2,
          {
            className: cx$1(classes['pageRight'], 'pageRight'),
            onClick: this.handleNextButtonClick,
            disabled: page >= Math.ceil(rowCount / perPage) - 1
          },
          React__default.createElement(ArrowRightIcon$1, null)
        ),
        React__default.createElement(
          IconButton$2,
          {
            onClick: this.handleLastPageButtonClick,
            disabled: page >= Math.ceil(rowCount / perPage) - 1
          },
          React__default.createElement(LastPageIcon, null)
        ),
        this.props.onRefreshPageData && React__default.createElement(RefreshButton$1, {
          onRefresh: this.props.onRefreshPageData,
          className: cx$1(classes['refresh'], 'refresh')
        })
      )
    );
  }
}, _class$w.propTypes = {
  page: number.isRequired,
  perPage: number.isRequired,
  onChangePage: func.isRequired,
  onChangePerPage: func.isRequired,
  onRefreshPageData: func,
  rowCount: number,
  colSpan: number,
  classes: shape$1({ any })
}, _class$w.defaultProps = {
  colSpan: 1
}, _temp2$o);
PaginatedTableFooter.displayName = 'PaginatedTableFooter';


PaginatedTableFooter.muiName = 'TableFooter';

var PaginatedTableFooter$1 = withStyles$1(styles$L)(PaginatedTableFooter);

const withPagination = WrappedTable => {
  var _class, _temp2;

  let WrappedWithPagination = (_temp2 = _class = class WrappedWithPagination extends React__default.Component {
    constructor(...args) {
      var _temp;

      return _temp = super(...args), this.state = {
        page: 0,
        rowsPerPage: this.props.initialItemsPerPage
      }, this.getDisplayedItemIndices = () => {
        const firstItem = this.state.page * this.state.rowsPerPage;
        const lastItem = this.state.page * this.state.rowsPerPage + this.state.rowsPerPage - 1;

        return [firstItem, lastItem];
      }, this.rowGetter = i => {
        const requestedIndex = i + this.state.rowsPerPage * this.state.page;

        return requestedIndex <= this.props.rowCount ? this.props.rowGetter(i + this.state.rowsPerPage * this.state.page) : undefined;
      }, this.handlePageChange = page => {
        let lastPossiblePage = Math.ceil(this.props.rowCount / this.state.rowsPerPage) - 1;

        if (lastPossiblePage < 0) {
          lastPossiblePage = 0;
        }

        // don't show empty pages
        this.setState({
          page: page > lastPossiblePage ? lastPossiblePage : page
        });
      }, this.handleRowsPerPageChange = e => {
        this.setState({
          page: 0,
          rowsPerPage: Number(e.target.value)
        });
      }, this.handleRefreshData = () => {
        const [firstItem, lastItem] = this.getDisplayedItemIndices();

        this.props.onRefreshPageData({
          start: firstItem,
          end: lastItem
        });
      }, this.callOnShowCellRange = () => {
        const [firstItem, lastItem] = this.getDisplayedItemIndices();

        this.props.onShowCellRange({
          start: firstItem,
          end: lastItem
        });
      }, this.translateCellClick = (row, columnKey, ...rest) => {
        return this.props.onCellClick(row + this.state.page * this.state.rowsPerPage, columnKey, ...rest);
      }, this.translateFocusedRow = () => {
        // focused row is null unless the row is on this page
        const min = this.state.rowsPerPage * this.state.page;
        const max = this.state.rowsPerPage - 1 + this.state.rowsPerPage * this.state.page;

        return _isNumber(this.props.focusedRow) && this.props.focusedRow >= min && this.props.focusedRow <= max ? this.props.focusedRow - this.state.page * this.state.rowsPerPage : null;
      }, _temp;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.rowCount < this.props.rowCount) {
        // if the dataset is a different size, flip to first page
        return this.setState({ page: 0 });
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (this.state.page !== prevState.page || this.state.rowsPerPage !== prevState.rowsPerPage) {
        this.callOnShowCellRange();
      }
    }

    render() {
      let [firstItem, lastItem] = this.getDisplayedItemIndices();
      lastItem = Math.min(lastItem, this.props.rowCount - 1);

      const rowCount = this.props.rowCount > 0 ? lastItem - firstItem + 1 : 0;
      const restProps = _omit(this.props, ['rowGetter', 'initialItemsPerPage', 'onRefreshPageData']);

      return React__default.createElement(WrappedTable, _extends({}, restProps, {
        rowGetter: this.rowGetter,
        rowCount: rowCount,
        footerElement: React__default.createElement(PaginatedTableFooter$1, {
          page: this.state.page,
          perPage: this.state.rowsPerPage,
          onChangePage: this.handlePageChange,
          onChangePerPage: this.handleRowsPerPageChange,
          colSpan: this.props.children.length,
          rowCount: this.props.rowCount,
          onRefreshPageData: this.props.onRefreshPageData ? this.handleRefreshData : undefined
        }),
        onCellClick: this.translateCellClick,
        focusedRow: this.translateFocusedRow(),
        onShowCellRange: _noop
      }));
    }
  }, _class.propTypes = {
    rowGetter: func.isRequired,
    rowCount: number.isRequired,
    initialItemsPerPage: number,
    focusedRow: number,
    onCellClick: func,
    onShowCellRange: func,
    onRefreshPageData: func,
    children: node
  }, _class.defaultProps = {
    initialItemsPerPage: 10,
    onShowCellRange: _noop,
    onCellClick: _noop
  }, _temp2);
  WrappedWithPagination.displayName = 'WrappedWithPagination';


  return WrappedWithPagination;
};

const withBasicBehavior = WrappedTable => {
  var _class, _temp2;

  let WrappedWithBasicBehavior = (_temp2 = _class = class WrappedWithBasicBehavior extends React__default.Component {
    constructor(...args) {
      var _temp;

      return _temp = super(...args), this.getRowData = (i, ...rest) => {
        const rowData = this.props.rowGetter(i, ...rest);

        return this.props.loadingIndices.includes(i) && !rowData ? LOADING : rowData;
      }, this.renderEmptyTable = () => React__default.createElement(
        'div',
        null,
        this.props.failedLoadingIndices.length ? this.props.emptyFailureMessage : this.props.loadingIndices.length ? this.props.loadingMessage : this.props.emptyMessage
      ), _temp;
    }

    render() {
      const restProps = _omit(this.props, ['loadingIndices', 'failedLoadingIndices', 'loadingMessage', 'emptyMessage', 'emptyFailureMessage', 'rowGetter']);

      return React__default.createElement(WrappedTable, _extends({
        emptyRenderer: this.renderEmptyTable
      }, restProps, {
        rowGetter: this.getRowData
      }));
    }
  }, _class.propTypes = {
    loadingIndices: arrayOf(oneOfType([string, number])),
    failedLoadingIndices: arrayOf(oneOfType([string, number])),
    loadingMessage: string,
    emptyMessage: string,
    emptyFailureMessage: string,
    rowGetter: func.isRequired
  }, _class.defaultProps = {
    loadingIndices: [],
    failedLoadingIndices: [],
    loadingMessage: 'Loading...',
    emptyMessage: 'Nothing to see here!',
    emptyFailureMessage: 'Table items failed to load.'
  }, _temp2);
  WrappedWithBasicBehavior.displayName = 'WrappedWithBasicBehavior';


  return WrappedWithBasicBehavior;
};

var _class$x, _temp$8, _class2$2, _temp2$p;

const useStyles$e = makeStyles(styles$L);
/*
 * BASE TABLE
 */

let _Table = (_temp$8 = _class$x = class _Table extends React__default.Component {

  render() {
    const { classes } = this.props;
    const restProps = _omit(this.props, ['onShowCellRange', 'renderFocusedRowDetails']);

    return React__default.createElement(
      reactAddonsCssTransitionGroup,
      {
        transitionEnter: true,
        transitionLeave: false,
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200,
        transitionName: {
          enter: classes['enter'],
          enterActive: classes['enterActive'],
          leave: classes['leave'],
          leaveActive: classes['leaveActive']
        },
        component: 'div'
      },
      _isNumber(this.props.focusedRow) && this.props.rowCount > 0 && this.props.renderFocusedRowDetails ? React__default.createElement(SplitTableContainer, _extends({}, restProps, {
        focusedRow: this.props.focusedRow,
        renderFocusedRowDetails: this.props.renderFocusedRowDetails,
        key: 'split'
      })) : React__default.createElement(NormalTableContainer, _extends({}, restProps, { key: 'normal' }))
    );
  }
}, _class$x.propTypes = {
  rowGetter: func.isRequired,
  rowCount: number.isRequired,
  rowRange: arrayOf(number),
  rowHeight: number,
  width: number,
  footerElement: node,
  focusedRow: number,
  renderFocusedRowDetails: func,
  onShowCellRange: func,
  emptyRenderer: func,
  children: node, // children should be Columns
  showHeader: bool,
  classes: shape$1({ any })
}, _class$x.defaultProps = {
  rowHeight: 75,
  onShowCellRange: _noop,
  emptyRenderer: _noop,
  showHeader: true
}, _temp$8);

_Table.displayName = '_Table';


/*
 * Table body when no row is focused
 */

const NormalTableContainer = (_ref) => {
  let {
    rowCount,
    footerHeight = 56,
    footerElement,
    children,
    emptyRenderer,
    showHeader
  } = _ref,
      rest = objectWithoutProperties(_ref, ['rowCount', 'footerHeight', 'footerElement', 'children', 'emptyRenderer', 'showHeader']);

  const classes = useStyles$e();
  return React__default.createElement(
    Paper,
    { elevation: 1, className: classes['tableWrapper'] },
    React__default.createElement(
      MuiTable,
      null,
      showHeader && React__default.createElement(
        TableHead,
        { rowCount: rowCount },
        children
      ),
      rowCount === 0 ? React__default.createElement(
        MuiTableBody,
        null,
        React__default.createElement(
          TableRow,
          null,
          React__default.createElement(
            TableCell,
            { colSpan: children.length },
            emptyRenderer()
          )
        )
      ) : React__default.createElement(
        TableBody,
        _extends({}, rest, { rowRangeEnd: rowCount }),
        children
      )
    ),
    footerElement && React__default.createElement(
      MuiTable,
      null,
      React__default.createElement(
        TableFooter,
        { style: { height: footerHeight } },
        React__default.createElement(
          TableRow,
          null,
          footerElement
        )
      )
    )
  );
};

NormalTableContainer.displayName = 'NormalTableContainer';
NormalTableContainer.propTypes = {
  rowCount: number,
  footerHeight: number,
  footerElement: node,
  emptyRenderer: func,
  showHeader: bool,
  children: node
};

/*
 * Table body when a focus row is active
 */
let SplitTableContainer = (_temp2$p = _class2$2 = class SplitTableContainer extends React__default.Component {

  render() {
    const _props = this.props,
          {
      onCellClick,
      focusedRow,
      renderFocusedRowDetails,
      rowCount,
      footerHeight,
      footerElement,
      children,
      rowGetter,
      showHeader,
      classes
    } = _props,
          rest = objectWithoutProperties(_props, ['onCellClick', 'focusedRow', 'renderFocusedRowDetails', 'rowCount', 'footerHeight', 'footerElement', 'children', 'rowGetter', 'showHeader', 'classes']);

    const restProps = _omit(rest, ['emptyRenderer', 'showHeader']);

    return React__default.createElement(
      'div',
      null,
      React__default.createElement(
        Paper,
        { elevation: 1, className: classes['splitTableWrapper'] },
        React__default.createElement(
          MuiTable,
          { className: cx$1(styles$L.table) },
          showHeader && React__default.createElement(
            TableHead,
            { rowCount: rowCount },
            children
          ),
          rowCount === 0 ? React__default.createElement(
            MuiTableBody,
            null,
            React__default.createElement(
              TableRow,
              null,
              React__default.createElement(
                TableCell,
                { colSpan: children.length },
                this.props.emptyRenderer()
              )
            )
          ) : React__default.createElement(
            TableBody,
            _extends({}, restProps, {
              rowRangeEnd: focusedRow,
              rowGetter: rowGetter,
              onCellClick: onCellClick
            }),
            children
          )
        )
      ),
      React__default.createElement(
        Paper,
        {
          elevation: 1,
          style: {
            marginTop: 15,
            marginBottom: 15
          },
          className: cx$1(classes['focusTable'], classes['focusedRow'], classes['splitTableWrapper']),
          key: focusedRow
        },
        React__default.createElement(
          MuiTable,
          { className: cx$1(styles$L.table) },
          React__default.createElement(
            MuiTableBody,
            null,
            React__default.createElement(
              TableRow,
              { style: { maxHeight: 48, height: this.props.rowHeight } },
              injectInto(children, {
                data: rowGetter(focusedRow),
                row: focusedRow,
                onCellClick
              })
            ),
            React__default.createElement(
              TableRow,
              null,
              React__default.createElement(
                TableCell,
                {
                  colSpan: children.length,
                  style: { whiteSpace: 'inherit', padding: 0 }
                },
                renderFocusedRowDetails(rowGetter(focusedRow))
              )
            )
          )
        )
      ),
      React__default.createElement(
        Paper,
        { elevation: 1, className: classes['splitTableWrapper'] },
        React__default.createElement(
          MuiTable,
          { className: cx$1(styles$L.table) },
          React__default.createElement(
            TableBody,
            _extends({}, restProps, {
              rowRangeStart: this.props.focusedRow + 1,
              rowRangeEnd: rowCount,
              rowGetter: rowGetter,
              onCellClick: onCellClick
            }),
            children
          )
        ),
        footerElement && React__default.createElement(
          MuiTable,
          null,
          React__default.createElement(
            TableFooter,
            { style: { height: footerHeight } },
            React__default.createElement(
              TableRow,
              null,
              footerElement
            )
          )
        )
      )
    );
  }
}, _class2$2.propTypes = {
  focusedRow: number,
  onCellClick: func,
  rowCount: number,
  rowHeight: number,
  footerHeight: number,
  footerElement: node,
  renderFocusedRowDetails: func,
  rowGetter: func,
  emptyRenderer: func,
  showHeader: bool,
  children: node,
  classes: shape$1({ any })
}, _temp2$p);
SplitTableContainer.displayName = 'SplitTableContainer';


/*
 * Common body between tables
 */
const TableBody = (_ref2) => {
  let {
    children,
    rowRangeStart,
    rowRangeEnd,
    rowGetter,
    rowHeight,
    focusedRow,
    onCellClick
  } = _ref2,
      rest = objectWithoutProperties(_ref2, ['children', 'rowRangeStart', 'rowRangeEnd', 'rowGetter', 'rowHeight', 'focusedRow', 'onCellClick']);

  return React__default.createElement(
    MuiTableBody,
    null,
    (rowRangeStart ? _range(rowRangeStart, rowRangeEnd) : _range(rowRangeEnd)).map(r => React__default.createElement(
      TableRow,
      {
        key: r,
        style: { height: rowHeight },
        hover: true,
        selected: r == focusedRow
      },
      injectInto(children, {
        data: rowGetter(r),
        row: r,
        onCellClick
      })
    ))
  );
};
TableBody.displayName = 'TableBody';
TableBody.propTypes = {
  rowRangeStart: number,
  rowRangeEnd: number,
  rowHeight: number,
  rowGetter: func,
  focusedRow: number,
  children: node,
  onCellClick: func
};
TableBody.muiName = 'TableBody'; // trick MUI into thinking this is a MuiTableBody

/*
 * To be used as children of the base table
 */
const Column = (_ref3) => {
  let {
    data,
    dataKey,
    header,
    cellRenderer,
    cursorPointer = true,
    align = 'left',
    style,
    row,
    onCellClick,
    width
  } = _ref3,
      rest = objectWithoutProperties(_ref3, ['data', 'dataKey', 'header', 'cellRenderer', 'cursorPointer', 'align', 'style', 'row', 'onCellClick', 'width']);

  const classes = useStyles$e();
  function renderData() {
    if (data === LOADING) {
      return 'Loading...';
    }

    return _isFunction(cellRenderer) ? cellRenderer(_get(data, dataKey), data) : String(_get(data, dataKey) || '');
  }

  function handleCellClick(e) {
    return onCellClick(row, dataKey, e);
  }

  return React__default.createElement(
    TableCell,
    _extends({}, _omit(rest, ['transformActions']), {
      className: classes['tableCell'],
      style: _extends({
        cursor: cursorPointer ? 'pointer' : 'initial',
        textAlign: align,
        width
      }, style),
      onClick: onCellClick && handleCellClick
    }),
    data && renderData()
  );
};

Column.displayName = 'Column';
Column.propTypes = {
  data: oneOfType([objectOf(any), string]),
  dataKey: oneOfType([string, arrayOf(string)]).isRequired,
  header: string,
  cellRenderer: func,
  cursorPointer: bool,
  align: oneOf(['left', 'right', 'center']),
  style: objectOf(oneOfType([string, number])),
  row: number,
  onCellClick: func,
  width: oneOfType([string, number])
};

const TableHead = ({ children, rowCount }) => {
  const classes = useStyles$e();
  return React__default.createElement(
    MuiTableHead,
    null,
    React__default.createElement(
      TableRow,
      null,
      React__default.Children.map(children, c => React__default.createElement(
        TableCell,
        {
          className: classes['table-cell'],
          key: c.props.header,
          style: {
            textAlign: c.props.align || 'left',
            width: c.props.width
          }
        },
        c.props.header
      ))
    )
  );
};

TableHead.displayName = 'TableHead';
TableHead.propTypes = {
  rowCount: number.isRequired,
  children: node
};
/*
 * Table with pagination functions
 */
const Table = withBasicBehavior(withStyles$1(styles$L)(_Table));
const PaginatedTable = withBasicBehavior(withPagination(withStyles$1(styles$L)(_Table)));

var _class$y, _temp2$q;

let MenuColumn = (_temp2$q = _class$y = class MenuColumn extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      open: false,
      anchorEl: null
    }, this.openMenu = event => {
      this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    }, this.closeMenu = () => {
      this.setState({
        open: false
      });
    }, this.handleClick = (action, ...rest) => {
      this.setState({ open: false }, () => {
        this.props.onSelectItem(action, ...rest);
      });
    }, this.renderMenuCell = (actions = [], data, ...rest) => {
      const self = this;
      const allActions = this.props.transformActions(this.props.actions, data) || _difference([...this.props.transformActions(actions, data), ...this.props.additionalActions], this.props.excludeActions);

      function handleClickMenuItem(event) {
        event.persist();
        const action = event.target.getAttribute('data-action');
        if (action) {
          self.handleClick(action, data, ...rest);
        }
      }

      return allActions.length > 0 && React__default.createElement(
        'div',
        null,
        React__default.createElement(
          IconButton$2,
          {
            'aria-label': 'Actions',
            'aria-owns': this.state.anchorEl ? 'actions-menu' : null,
            'aria-haspopup': 'true',
            onClick: this.openMenu
          },
          React__default.createElement(MoreVertIcon, null)
        ),
        React__default.createElement(
          Menu,
          {
            id: 'actions-menu',
            anchorEl: this.state.anchorEl,
            anchorOrigin: { horizontal: 'left', vertical: 'top' },
            transformOrigin: { horizontal: 'left', vertical: 'top' },
            open: this.state.open,
            onClose: this.closeMenu
          },
          this.sortActions(allActions).map((s, i) => s === '@@divider' ? React__default.createElement(Divider, { key: 'divider' }) : React__default.createElement(
            MenuItem,
            {
              key: s,
              onClick: handleClickMenuItem,
              'data-action': s
            },
            _startCase(_camelCase(this.props.transformLabel(s)))
          ))
        )
      );
    }, _temp;
  }

  sortActions(actions) {
    const protectedActions = _intersection(actions, this.props.protectedActions);
    const unprotectedActions = _without(actions, ...protectedActions);

    return [...unprotectedActions, unprotectedActions.length >= 1 && protectedActions.length >= 1 && '@@divider', ...protectedActions].filter(a => !!a);
  }

  render() {
    return React__default.createElement(Column, _extends({
      cursorPointer: false,
      width: 50,
      align: 'right',
      cellRenderer: this.renderMenuCell
    }, _omit(this.props, 'actions', 'onSelectItem', 'protectedActions', 'additionalActions', 'excludeActions', 'transformLabel'), {
      style: _extends({ paddingRight: 0 }, this.props.style)
    }));
  }
}, _class$y.propTypes = {
  actions: arrayOf(string),
  onSelectItem: func,
  protectedActions: arrayOf(string),
  additionalActions: arrayOf(string),
  excludeActions: arrayOf(string),
  transformLabel: func,
  transformActions: func,
  style: objectOf(any),
  dataKey: string
}, _class$y.defaultProps = {
  onSelectItem: _noop,
  protectedActions: ['delete'],
  transformLabel: l => l,
  transformActions: a => a,
  additionalActions: [],
  excludeActions: [],
  dataKey: ''
}, _temp2$q);
MenuColumn.displayName = 'MenuColumn';

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') ;

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) ;

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown';
    this.options = options;
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.key + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.key + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends$1({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$1({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.key, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.key, this.style, options);
  };

  return FontFaceRule;
}();
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@font-face' ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(key, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$1({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped
    }, ruleOptions); // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // For e.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins$$1 = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins$$1.onProcessRule, plugins$$1);
  }
  /**
   * Register a rule in `.map` and `.classes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.onUpdate(data, this.get(name), options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.onUpdate(data, this.index[index], options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins$$1 = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins$$1.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins$$1.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$1({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = this.rules.get(name);
    if (!rule) return false;
    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis$1 = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}
/**
 * Set a style property.
 */


function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
}
/**
 * Remove a style property.
 */


function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
  }
}
/**
 * Set the selector.
 */


function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
}
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    index = maxIndex;
  }

  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
    return false;
  }

  return container.cssRules[index];
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // browsers remove those rules.
    // TODO figure out if its a bug and if it is known.
    // Workaround is to redeploy the sheet.

    if (this.hasInsertedRules) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element);
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        // We need to render the container without children first.
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), index);

        if (latestNativeParent === false) {
          return false;
        }
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;

    var nativeRule = _insertRule(nativeParent, ruleStr, index);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    rule.renderable = nativeRule;
    return nativeRule;
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    var cssRules = this.element.sheet.cssRules;

    for (var index = 0; index < cssRules.length; index++) {
      if (cssRule === cssRules[index]) return index;
    }

    return -1;
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.0.0-alpha.24";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$1({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends$1({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   */
  ;

  _proto.createRule = function createRule$$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends$1({}, options, {
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins$$1 = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins$$1[_key] = arguments[_key];
    }

    plugins$$1.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var index$7 = create();

// http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return `${s4()}-${s4()}-${s4()}`;
}

var _class$z, _temp$9;

const defaultVSDKTheme = {
  palette: {
    primary: {
      light: blue$1[300],
      main: blue$1[500],
      dark: blue$1[700]
    }
  },
  typography: {
    button: {
      fontWeight: 400
    }
  }
};

const jss = create(_extends({}, jssPreset()));

const generateClassName = createGenerateClassName({
  productionPrefix: `vsdk-${guid()}`,
  seed: `vsdk-${guid()}`
});

let VeritoneSDKThemeProvider = (_temp$9 = _class$z = class VeritoneSDKThemeProvider extends React__default.Component {

  render() {
    const mergedTheme = createMuiTheme$1(merge({}, defaultVSDKTheme, this.props.theme));

    return React__default.createElement(
      StylesProvider,
      {
        jss: jss,
        generateClassName: this.props.generateClassName || generateClassName
      },
      React__default.createElement(
        ThemeProvider,
        { theme: mergedTheme },
        this.props.children
      )
    );
  }
}, _class$z.propTypes = {
  theme: objectOf(any),
  children: node,
  generateClassName: func
}, _temp$9);

VeritoneSDKThemeProvider.displayName = 'VeritoneSDKThemeProvider';
function withVeritoneSDKThemeProvider(theme) {
  return function decorator(Class) {
    var _class2, _temp2;

    let WrappedWithVeritoneSDKThemeProvider = (_temp2 = _class2 = class WrappedWithVeritoneSDKThemeProvider extends React__default.Component {

      render() {
        const _props = this.props,
              { forwardedRef } = _props,
              rest = objectWithoutProperties(_props, ['forwardedRef']);
        return React__default.createElement(
          VeritoneSDKThemeProvider,
          { theme: theme },
          React__default.createElement(Class, _extends({ ref: forwardedRef }, rest))
        );
      }
    }, _class2.propTypes = {
      forwardedRef: oneOfType([func, object])
    }, _temp2);
    WrappedWithVeritoneSDKThemeProvider.displayName = 'WrappedWithVeritoneSDKThemeProvider';


    function forwardRef(props, ref) {
      return React__default.createElement(WrappedWithVeritoneSDKThemeProvider, _extends({}, props, { forwardedRef: ref }));
    }

    const name = Class.displayName || Class.name;
    forwardRef.displayName = `WrappedWithVeritoneSDKThemeProvider(${name})`;

    return React__default.forwardRef(forwardRef);
  };
}

var styles$M = {
  iconSize: {
    fontSize: '1.5rem !important'
  },
  engineCategoryIcon: {
    color: grey6,
    margin: '0 0.25em !important',
    padding: '0 !important',
    width: 'auto !important',
    height: 'auto !important'
  },
  deleteIcon: {
    color: minBlack,
    margin: 'auto 0.1em auto 0.25em !important',
    fontSize: '1.25em !important',
    '&:hover:not([disabled])': {
      color: lightBlack
    }
  },
  searchPill: {
    transition: 'background-color 0.1s linear 0.1s',
    borderRadius: '1.25em',
    margin: '0.1em important',
    padding: '0.1em important',
    display: 'inline-flex',
    '&:not([disabled])': {
      cursor: 'pointer'
    }
  },
  searchPillWithoutDelete: {
    paddingRight: '1em',
    '&:disabled': {
      display: 'none'
    }
  },
  searchPillBackgroundColor: {
    backgroundColor: `${lightBlue50} !important`,
    '&:hover:not([disabled])': {
      backgroundColor: `${grey2} !important`
    }
  },
  searchPillHighlightedBackgroundColor: {
    backgroundColor: `${minBlack} !important`,
    '&:hover:not([disabled])': {
      backgroundColor: semiBlack
    }
  },
  searchPillExcludeBackgroundColor: {
    backgroundColor: `${lightRed50} !important`,
    '&:hover:not([disabled])': {
      backgroundColor: `${grey2} !important`
    }
  },
  searchPillSelectedColor: {
    color: `${darkWhite} !important`
  },
  searchPillSelectedBackgroundColor: {
    backgroundColor: `${minBlack} !important`
  }
};

var _class$A, _temp2$r;

let SearchPill = (_temp2$r = _class$A = class SearchPill extends React__default.PureComponent {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleDelete = e => {
      e.stopPropagation();
      this.props.onDelete(e);
    }, _temp;
  }

  getBackgroundColor() {
    const { classes } = this.props;
    let backgroundColor = classes.searchPillBackgroundColor;
    let dataTest = 'searchPillBackgroundColor';
    if (this.props.selected) {
      backgroundColor = classes.searchPillSelectedBackgroundColor;
      dataTest = 'searchPillSelectedBackgroundColor';
    } else if (this.props.highlighted) {
      backgroundColor = classes.searchPillHighlightedBackgroundColor;
      dataTest = 'searchPillHighlightedBackgroundColor';
    } else if (this.props.exclude) {
      backgroundColor = classes.searchPillExcludeBackgroundColor;
      dataTest = 'searchPillExcludeBackgroundColor';
    }
    return {
      backgroundColor,
      dataTest
    };
  }

  render() {
    const { classes } = this.props;
    const { backgroundColor, dataTest } = this.getBackgroundColor();
    return React__default.createElement(LibChip, {
      classes: {
        root: cx$1(classes.searchPill, { [classes.searchPillWithoutDelete]: !this.props.onDelete }, backgroundColor),
        label: cx$1({
          [classes.searchPillSelectedColor]: this.props.selected
        })
      },
      icon: React__default.createElement(Icon, {
        className: this.props.engineCategoryIcon,
        classes: {
          root: cx$1([classes.engineCategoryIcon, { [classes.searchPillSelectedColor]: this.props.selected }])
        }
      }),
      label: this.props.label,
      onDelete: this.props.onDelete,
      onClick: this.props.onClick,
      disabled: this.props.disabled || !this.props.onClick,
      'data-test': dataTest
    });
  }
}, _class$A.propTypes = {
  engineCategoryIcon: string.isRequired,
  onClick: func,
  onDelete: func,
  label: string.isRequired,
  highlighted: bool,
  selected: bool,
  exclude: bool,
  disabled: bool,
  classes: shape$1({ any })
}, _temp2$r);
SearchPill.displayName = 'SearchPill';


var SearchPill$1 = withStyles$1(styles$M)(SearchPill);

var _class$B, _temp2$s;

let HorizontalScroll = (_temp2$s = _class$B = class HorizontalScroll extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      offsetLeft: 0,
      showScrollButtons: false
    }, this.scrollContent = null, this.keepScrolling = false, this.continueScrolling = false, this.continueScrolling = amount => {
      this.setState((prevState, props) => {
        let newOffsetLeft = prevState.offsetLeft + amount;
        if (newOffsetLeft < 0) {
          newOffsetLeft = 0;
        } else if (newOffsetLeft > this.scrollContent.scrollWidth - this.scrollContent.clientWidth) {
          newOffsetLeft = this.scrollContent.scrollWidth - this.scrollContent.clientWidth;
        }

        this.scrollContent.scrollLeft = newOffsetLeft;
        return { offsetLeft: newOffsetLeft };
      });
    }, this.scrollLeft = e => {
      this.scroll(-1 * this.props.scrollAmount);
    }, this.scrollRight = e => {
      this.scroll(this.props.scrollAmount);
    }, this.stopScrolling = e => {
      if (this.keepScrolling) {
        window.clearInterval(this.keepScrolling);
        this.keepScrolling = undefined;
      }
    }, this.setScrollContent = ref => {
      this.scrollContent = ref;
      this.setState({
        showScrollButtons: ref && ref.scrollWidth > ref.clientWidth
      });
    }, _temp;
  }

  componentWillUnmount() {
    this.stopScrolling();
  }

  scroll(amount) {
    if (!this.keepScrolling) {
      this.continueScrolling(amount);
      this.keepScrolling = window.setInterval(this.continueScrolling, 50, amount);
    }
  }

  render() {
    return React__default.createElement(
      Fragment,
      null,
      React__default.createElement(
        'div',
        { onMouseDown: this.scrollLeft, onMouseUp: this.stopScrolling },
        this.state.showScrollButtons ? this.props.leftScrollButton : undefined
      ),
      React__default.createElement(
        'div',
        {
          ref: this.setScrollContent,
          style: {
            overflowX: 'hidden'
          }
        },
        this.props.children
      ),
      React__default.createElement(
        'div',
        { onMouseDown: this.scrollRight, onMouseUp: this.stopScrolling },
        this.state.showScrollButtons ? this.props.rightScrollButton : undefined
      )
    );
  }
}, _class$B.propTypes = {
  leftScrollButton: node.isRequired,
  rightScrollButton: node.isRequired,
  scrollAmount: number,
  children: node.isRequired
}, _class$B.defaultProps = {
  scrollAmount: 20
}, _temp2$s);
HorizontalScroll.displayName = 'HorizontalScroll';

var Google = createCommonjsModule(function (module, exports) {
(function(root, factory) {

	if (root === null) {
		throw new Error('Google-maps package can be used only in browser');
	}

	{
		module.exports = factory();
	}

})(typeof window !== 'undefined' ? window : null, function() {


	var googleVersion = '3.31';

	var script = null;

	var google = null;

	var loading = false;

	var callbacks = [];

	var onLoadEvents = [];

	var originalCreateLoaderMethod = null;


	var GoogleMapsLoader = {};


	GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';

	GoogleMapsLoader.KEY = null;

	GoogleMapsLoader.LIBRARIES = [];

	GoogleMapsLoader.CLIENT = null;

	GoogleMapsLoader.CHANNEL = null;

	GoogleMapsLoader.LANGUAGE = null;

	GoogleMapsLoader.REGION = null;

	GoogleMapsLoader.VERSION = googleVersion;

	GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';


	GoogleMapsLoader._googleMockApiObject = {};


	GoogleMapsLoader.load = function(fn) {
		if (google === null) {
			if (loading === true) {
				if (fn) {
					callbacks.push(fn);
				}
			} else {
				loading = true;

				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
					ready(fn);
				};

				GoogleMapsLoader.createLoader();
			}
		} else if (fn) {
			fn(google);
		}
	};


	GoogleMapsLoader.createLoader = function() {
		script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = GoogleMapsLoader.createUrl();

		document.body.appendChild(script);
	};


	GoogleMapsLoader.isLoaded = function() {
		return google !== null;
	};


	GoogleMapsLoader.createUrl = function() {
		var url = GoogleMapsLoader.URL;

		url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;

		if (GoogleMapsLoader.KEY) {
			url += '&key=' + GoogleMapsLoader.KEY;
		}

		if (GoogleMapsLoader.LIBRARIES.length > 0) {
			url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
		}

		if (GoogleMapsLoader.CLIENT) {
			url += '&client=' + GoogleMapsLoader.CLIENT;
		}

		if (GoogleMapsLoader.CHANNEL) {
			url += '&channel=' + GoogleMapsLoader.CHANNEL;
		}

		if (GoogleMapsLoader.LANGUAGE) {
			url += '&language=' + GoogleMapsLoader.LANGUAGE;
		}

		if (GoogleMapsLoader.REGION) {
			url += '&region=' + GoogleMapsLoader.REGION;
		}

		if (GoogleMapsLoader.VERSION) {
			url += '&v=' + GoogleMapsLoader.VERSION;
		}

		return url;
	};


	GoogleMapsLoader.release = function(fn) {
		var release = function() {
			GoogleMapsLoader.KEY = null;
			GoogleMapsLoader.LIBRARIES = [];
			GoogleMapsLoader.CLIENT = null;
			GoogleMapsLoader.CHANNEL = null;
			GoogleMapsLoader.LANGUAGE = null;
			GoogleMapsLoader.REGION = null;
			GoogleMapsLoader.VERSION = googleVersion;

			google = null;
			loading = false;
			callbacks = [];
			onLoadEvents = [];

			if (typeof window.google !== 'undefined') {
				delete window.google;
			}

			if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
				delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
			}

			if (originalCreateLoaderMethod !== null) {
				GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
				originalCreateLoaderMethod = null;
			}

			if (script !== null) {
				script.parentElement.removeChild(script);
				script = null;
			}

			if (fn) {
				fn();
			}
		};

		if (loading) {
			GoogleMapsLoader.load(function() {
				release();
			});
		} else {
			release();
		}
	};


	GoogleMapsLoader.onLoad = function(fn) {
		onLoadEvents.push(fn);
	};


	GoogleMapsLoader.makeMock = function() {
		originalCreateLoaderMethod = GoogleMapsLoader.createLoader;

		GoogleMapsLoader.createLoader = function() {
			window.google = GoogleMapsLoader._googleMockApiObject;
			window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
		};
	};


	var ready = function(fn) {
		var i;

		loading = false;

		if (google === null) {
			google = window.google;
		}

		for (i = 0; i < onLoadEvents.length; i++) {
			onLoadEvents[i](google);
		}

		if (fn) {
			fn(google);
		}

		for (i = 0; i < callbacks.length; i++) {
			callbacks[i](google);
		}

		callbacks = [];
	};


	return GoogleMapsLoader;

});
});

var styles$N = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  loadingSpinner: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '1em'
  },
  loadingLabel: {
    width: '100%',
    textAlign: 'center'
  }
};

var _class$C, _temp2$t;

const MARKER = 'marker';
const CIRCLE = 'circle';
const UNIT_OF_DISTANCE = 'm';

let GeoPicker = (_temp2$t = _class$C = class GeoPicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.googleMaps = null, this._googleMapsMountPoint = null, this._lastMarker = null, this._lastCircle = null, this.drawingManager = null, this.mountGoogleMaps = google => {
      // don't mount if it's already been unmounted
      if (!this._googleMapsMountPoint) {
        return;
      }

      const MAP_OPTIONS = {
        zoom: this.props.defaultZoom,
        center: {
          lng: this.props.defaultLongitude,
          lat: this.props.defaultLatitude
        }
      };

      this.googleMaps = new google.maps.Map(this._googleMapsMountPoint, MAP_OPTIONS);

      // enable input if not read only
      if (!this.props.readOnly) {
        this.drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: GeoPicker.GEOINPUT_OPTIONS[this.props.geoType],
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_CENTER,
            drawingModes: [GeoPicker.GEOINPUT_OPTIONS[this.props.geoType]]
          },
          circleOptions: GeoPicker.CIRCLE_OPTIONS
        });

        this.drawingManager.setMap(this.googleMaps);
      }

      // render the point or distance
      if (GeoPicker.GEOINPUT_OPTIONS[this.props.geoType] === MARKER) {
        // single point
        if (this.props.location) {
          let position = {
            lat: this.props.location.latitude,
            lng: this.props.location.longitude
          };

          this._lastMarker = new google.maps.Marker({
            position: position
          });

          this._lastMarker.setMap(this.googleMaps);
          this.googleMaps.panTo(position);
        }

        if (!this.props.readOnly) {
          google.maps.event.addListener(this.drawingManager, 'markercomplete', this.onDrawMarker);
        }
      } else if (GeoPicker.GEOINPUT_OPTIONS[this.props.geoType] === CIRCLE) {
        // radius based distance
        if (this.props.location) {
          this._lastCircle = new google.maps.Circle(_extends({}, GeoPicker.CIRCLE_OPTIONS, {
            center: {
              lat: this.props.location.latitude,
              lng: this.props.location.longitude
            },
            radius: this.props.location.distance,
            map: this.googleMaps
          }));

          this.googleMaps.fitBounds(this._lastCircle.getBounds());
        }

        if (!this.props.readOnly) {
          google.maps.event.addListener(this.drawingManager, 'circlecomplete', this.onDrawCircle);
        }
      }
    }, this.clearDraw = () => {
      if (this._lastCircle) {
        this._lastCircle.setMap(null);
        this._lastCircle = null;
      }

      if (this._lastMarker) {
        this._lastMarker.setMap(null);
        this._lastMarker = null;
      }
    }, this.onDrawCircle = event => {
      this.clearDraw();
      this._lastCircle = event;

      this.googleMaps.fitBounds(event.getBounds());

      if (this.props.onSelectGeolocation) {
        this.props.onSelectGeolocation({
          distance: event.radius,
          latitude: event.center.lat(),
          longitude: event.center.lng(),
          units: GeoPicker.UNIT_OF_DISTANCE
        });
      }
    }, this.onDrawMarker = event => {
      this.clearDraw();
      this._lastMarker = event;

      if (this.props.onSelectGeolocation) {
        this.props.onSelectGeolocation({
          latitude: event.position.lat(),
          longitude: event.position.lng()
        });
      }
    }, this.loadGoogleMaps = ref => {
      this._googleMapsMountPoint = ref;
      Google.KEY = this.props.gmapsAPIKey;
      Google.LIBRARIES = ['places', 'drawing'];
      Google.load(this.mountGoogleMaps);
    }, _temp;
  }

  componentWillUnmount() {
    Google.release();
  }

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      {
        ref: this.loadGoogleMaps,
        style: { width: '100%', height: '100%', display: 'flex' }
      },
      React__default.createElement(
        'div',
        { className: classes.loadingContainer },
        React__default.createElement(CircularProgress$2, {
          className: classes.loadingSpinner,
          size: 100,
          thickness: 1
        }),
        React__default.createElement(
          Typography$2,
          { className: classes.loadingLabel },
          'Loading Google Maps'
        )
      )
    );
  }
}, _class$C.CIRCLE_OPTIONS = {
  fillColor: '#aaaaaa',
  fillOpacity: 0.35,
  clickable: false,
  editable: false,
  strokeOpacity: 0.75,
  strokeWeight: 2,
  strokeColor: '#222222',
  zIndex: 1
}, _class$C.GEOINPUT_OPTIONS = {
  point: MARKER,
  radius: CIRCLE
}, _class$C.propTypes = {
  gmapsAPIKey: string.isRequired,
  defaultZoom: number,
  defaultLatitude: number,
  defaultLongitude: number,
  geoType: oneOf(['point', 'radius']).isRequired,
  location: oneOfType([shape$1({
    distance: number,
    latitude: number,
    longitude: number,
    units: oneOf([UNIT_OF_DISTANCE])
  }), shape$1({
    latitude: number,
    longitude: number
  })]),
  readOnly: bool,
  onSelectGeolocation: func,
  classes: shape$1({ any })
}, _class$C.defaultProps = {
  defaultZoom: 14,
  defaultLatitude: 33.62,
  defaultLongitude: -117.92
}, _temp2$t);
GeoPicker.displayName = 'GeoPicker';


var index$8 = withStyles$1(styles$N)(GeoPicker);

var _class$D, _temp2$u;

const styles$O = {
  underline: {
    '&::before': {
      right: '1em !important'
    },
    '&::after': {
      right: '1em !important'
    }
  }
};

let ExpandableInputField = (_temp2$u = _class$D = class ExpandableInputField extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      expanded: false
    }, this.resetSearch = evt => {
      if (this.props.onReset) {
        this.props.onReset(evt);
      }
      if (this._inputRef) {
        this._inputRef.focus();
      }
    }, this.showSearchBar = evt => {
      this.setState({
        expanded: true
      });
    }, this.hideSearchBar = evt => {
      if (!this.props.value || this.props.value.trim().length === 0) {
        this.setState({
          expanded: false
        });
      }
      if (this.props.onBlur) {
        this.props.onBlur(evt);
      }
    }, this.onKeyPress = evt => {
      if (evt.key === 'Enter' && this.props.onSearch) {
        this.props.onSearch(evt.target.value);
      }
    }, this.setInputRef = ref => {
      this._inputRef = ref;
    }, _temp;
  }

  render() {
    const { classes } = this.props;
    if (this.state.expanded) {
      return React__default.createElement(
        Grow,
        { 'in': true },
        React__default.createElement(TextField$1, {
          value: this.props.value,
          autoFocus: true,
          inputProps: {
            onBlur: this.hideSearchBar
          },
          inputRef: this.setInputRef,
          onKeyPress: this.onKeyPress,
          onChange: this.props.onChange,
          onFocus: this.props.onFocus,
          InputProps: {
            classes: {
              underline: cx$1(classes['underline'])
            },
            endAdornment: React__default.createElement(
              IconButton$2,
              { onClick: this.resetSearch, disableRipple: true },
              React__default.createElement(CloseIcon, null)
            )
          }
        })
      );
    } else {
      return React__default.createElement(
        IconButton$2,
        { onClick: this.showSearchBar },
        this.props.icon
      );
    }
  }
}, _class$D.propTypes = {
  onSearch: func,
  value: string,
  onChange: func,
  onReset: func,
  icon: node.isRequired,
  onFocus: func,
  onBlur: func,
  classes: shape$1({ any })
}, _temp2$u);
ExpandableInputField.displayName = 'ExpandableInputField';


var index$9 = withStyles$1(styles$O)(ExpandableInputField);

let SearchBarError = class SearchBarError extends Error {
  constructor(...args) {
    super(...args);
    Error.captureStackTrace(this, SearchBarError);
  }
};

function getGroupsFromSearchParameters(searchParameters) {
  const groups = {};
  let startOfGroup = null;
  let treeLevel = 0;
  for (let i = 0; i < searchParameters.length; i++) {
    if (searchParameters[i].value === '(') {
      if (treeLevel === 0) {
        startOfGroup = searchParameters[i].id;
      }
      treeLevel++;
    } else if (searchParameters[i].value === ')') {
      treeLevel--;
      if (treeLevel === 0) {
        // we use a recursive descent to render searchParameters.
        // as a result, it's easy to look backwards one parameter, but hard to look forward.
        // afterGroup allows us to figure out how to render nested groups.
        groups[startOfGroup] = {
          endOfGroup: i,
          afterGroup: searchParameters[i + 1] && searchParameters[i + 1].conditionType
        };
        startOfGroup = null;
      }
    }
  }

  return groups;
}

const getTranscriptLabel = modalState => {
  return {
    full: modalState.search,
    abbreviation: _truncate(modalState.search, { length: 13 }),
    exclude: false
  };
};

const getSentimentLabel = modalState => {
  return {
    full: modalState.search === 'positive' ? 'Positive' : 'Negative',
    abbreviation: modalState.search === 'positive' ? 'Positive' : 'Negative'
  };
};

const getOCRLabel = modalState => {
  return {
    full: modalState.search,
    abbreviation: _truncate(modalState.search, { length: 13 })
  };
};

const getFingerPrintLabel = modalState => {
  return {
    full: modalState.label,
    abbreviation: _truncate(modalState.label, { length: 13 }),
    exclude: modalState.exclude,
    thumbnail: modalState.image
  };
};

const getFaceLabel = modalState => {
  return {
    full: modalState.label,
    abbreviation: _truncate(modalState.label, { length: 13 }),
    exclude: modalState.exclude,
    thumbnail: modalState.image
  };
};

const getObjectLabel = modalState => {
  const truncatedLabel = _truncate(modalState.label, { length: 13 });
  return {
    full: modalState.type === 'fullText' ? `CONTAINS: ${modalState.label}` : modalState.label,
    abbreviation: modalState.type === 'fullText' ? `CONTAINS: ${truncatedLabel}` : truncatedLabel,
    thumbnail: modalState.image,
    exclude: modalState.exclude
  };
};

const getLogoLabel = modalState => {
  const truncatedLabel = _truncate(modalState.label, { length: 13 });
  return {
    full: modalState.type === 'fullText' ? `CONTAINS: ${modalState.label}` : modalState.label,
    abbreviation: modalState.type === 'fullText' ? `CONTAINS: ${truncatedLabel}` : truncatedLabel,
    exclude: modalState.exclude,
    thumbnail: modalState.image
  };
};

const getTagLabel = modalState => {
  return {
    full: modalState.label,
    abbreviation: _truncate(modalState.label, { length: 13 }),
    exclude: modalState.exclude
  };
};

const getStructuredDataLabel = modalState => {
  const OPERATOR_ABRV = {
    is: 'IS',
    is_not: 'IS NOT',
    gte: '>=',
    lte: '<=',
    gt: '>',
    lt: '<',
    contains: 'CONTAINS',
    not_contains: 'EXCLUDES',
    within: 'WITHIN',
    range: 'BETWEEN'
  };

  const getAbbreviation = modalState => {
    if (modalState.operator === 'range') {
      return `${modalState.field.split('.').slice(-1)[0]} ${OPERATOR_ABRV[modalState.operator]} (${modalState.value1},${modalState.value2})`;
    } else if (modalState.operator === 'within') {
      return `${Number(modalState.value1.distance.toFixed(0))} meters of ${Number(modalState.value1.latitude.toFixed(2))}, ${Number(modalState.value1.longitude.toFixed(2))}`;
    } else {
      return `${modalState.field.split('.').slice(-1)[0]} ${OPERATOR_ABRV[modalState.operator]} ${modalState.value1}`;
    }
  };
  return {
    full: getAbbreviation(modalState),
    abbreviation: getAbbreviation(modalState),
    exclude: _includes(modalState.operator, 'not'),
    thumbnail: null
  };
};

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR$3 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR$3 + minutes * MILLISECONDS_IN_MINUTE$2 + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'(.*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
 *
 * `backupDate` must be passed for correct work of the function.
 * If you're not sure which `backupDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   toDate('2016-01-01')
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} backupDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;

  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBackupDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1 // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale$1.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).reverse();
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyBackupDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

const fromUTCToLocal = inputTime => {
  const converted = parse(`${inputTime}:00Z`, 'hh:mm:ssX', new Date());
  return format(converted, 'HH:mm');
};

// ISO 8601
const daysOfTheWeek = [{
  isoWeekday: 1,
  name: 'Mon'
}, // MONDAY
{
  isoWeekday: 2,
  name: 'Tue'
}, {
  isoWeekday: 3,
  name: 'Wed'
}, {
  isoWeekday: 4,
  name: 'Thu'
}, {
  isoWeekday: 5,
  name: 'Fri'
}, {
  isoWeekday: 6,
  name: 'Sat'
}, {
  isoWeekday: 0,
  name: 'Sun' // SUNDAY
}];

const getTimeLabel = modalState => {
  let label = '';
  if (modalState.search.dayPartStartTime && modalState.search.dayPartEndTime) {
    let dayPartStartTime = modalState.search.dayPartStartTime;
    let dayPartEndTime = modalState.search.dayPartEndTime;

    if (modalState.search.stationBroadcastTime === false) {
      dayPartStartTime = fromUTCToLocal(dayPartStartTime);
      dayPartEndTime = fromUTCToLocal(dayPartEndTime);
    }

    const startTime = format(parse(dayPartStartTime, 'hh:mm', new Date()), 'hh:mm a');
    const endTime = format(parse(dayPartEndTime, 'hh:mm', new Date()), 'hh:mm a');

    label = `${startTime}-${endTime}`;
    if (modalState.search.stationBroadcastTime) {
      const selectedDays = daysOfTheWeek.filter(dayOfTheWeek => modalState.search.selectedDays[dayOfTheWeek.isoWeekday]).map(dayOfTheWeek => dayOfTheWeek.name).join();
      label += selectedDays.length ? ` (${selectedDays})` : '';
    }
  }
  return {
    full: label,
    abbreviation: _truncate(label, { length: 13 }),
    thumbnail: null
  };
};

const getGeolocationLabel = modalState => {
  const roundLocation = num => num ? Math.round(num * 100) / 100 : '?';

  return {
    full: `${roundLocation(modalState.latitude)} : ${roundLocation(modalState.longitude)}`,
    abbreviation: `${roundLocation(modalState.latitude)} : ${roundLocation(modalState.longitude)}`,
    thumbnail: null
  };
};

const transcript = {
  name: 'Transcript',
  iconClass: 'icon-transcription',
  getLabel: getTranscriptLabel
};
const sentiment = {
  name: 'Sentiment',
  iconClass: 'icon-sentiment',
  getLabel: getSentimentLabel
};
const ocr = {
  name: 'OCR',
  iconClass: 'icon-ocr',
  getLabel: getOCRLabel
};
const fingerprint = {
  name: 'Fingerprint',
  iconClass: 'icon-finger_print3',
  getLabel: getFingerPrintLabel
};
const face = {
  name: 'Face',
  iconClass: 'icon-face',
  getLabel: getFaceLabel
};
const obj = {
  name: 'Object',
  iconClass: 'icon-object_detection',
  getLabel: getObjectLabel
};
const logo = {
  name: 'Logo Recognition',
  iconClass: 'icon-logo-detection',
  getLabel: getLogoLabel
};
const tag = {
  name: 'Tag Search',
  iconClass: 'icon-tag',
  getLabel: getTagLabel
};
const sdo = {
  name: 'Structured Data',
  iconClass: 'icon-third-party-data',
  getLabel: getStructuredDataLabel
};
const time = {
  name: 'Time Search',
  iconClass: 'icon-calendar',
  getLabel: getTimeLabel
};
const geolocation = {
  name: 'Geolocation',
  iconClass: 'icon-gps',
  getLabel: getGeolocationLabel
};
const engineCategories = {
  '67cd4dd0-2f75-445d-a6f0-2f297d6cd182': transcript,
  'f2554098-f14b-4d81-9be1-41d0f992a22f': sentiment,
  '3b4ac603-9bfa-49d3-96b3-25ca3b502325': ocr,
  '6faad6b7-0837-45f9-b161-2f6bf31b7a07': face,
  '088a31be-9bd6-4628-a6f0-e4004e362ea0': obj,
  '17d62b84-8b49-465b-a6be-fe3ea3bc8f05': fingerprint,
  '5a511c83-2cbd-4f2d-927e-cd03803a8a9c': logo,
  'tag-search-id': tag,
  'time-search-id': time,
  '203ad7c2-3dbd-45f9-95a6-855f911563d0': geolocation,
  'sdo-search-id': sdo
};

var styles$P = {
  searchGroup: {
    display: 'inline-flex',
    padding: '0.2em',
    alignItems: 'center',
    border: `1px dashed ${blue1}`,
    borderRadius: '2em',
    flexWrap: 'nowrap'
  },
  searchGroupNestedLeft: {
    display: 'inline-flex',
    alignItems: 'center',
    paddingLeft: '0.2em',
    borderLeft: `1px dashed ${blue2}`,
    borderRadius: '2em'
  },
  searchGroupNestedRight: {
    display: 'inline-flex',
    alignItems: 'center',
    paddingRight: '0.2em',
    borderRight: `1px dashed ${blue2}`,
    borderRadius: '2em'
  },
  joiningOperator: {
    padding: '0 0.25em',
    display: 'inline-flex',
    alignItems: 'center'
  },
  searchBarContainer: {
    display: 'inline-flex',
    alignContent: 'center',
    alignItems: 'center'
  },
  tooltipContainer: {
    display: 'inline-flex'
  }
};

var _class$E, _temp2$v;

const useStyles$f = makeStyles(styles$P);

// need to look forward and backwards one search parameter, as well as take into the account the rendering level
// because we render ((hello) and world ) as (hello) and world)
const getGroupStyling = ({ before, after, level }) => {
  const classes = useStyles$f();

  return cx$1({
    [classes['searchGroupNestedLeft']]: before && before !== 'group',
    [classes['searchGroupNestedRight']]: after && after !== 'group',
    [classes['searchGroup']]: level === 0
  });
};

const SearchParameters = ({ parameters, level, disableTooltip }) => {
  const classes = useStyles$f();
  const groups = getGroupsFromSearchParameters(parameters);
  const searchParameters = [];
  for (let i = 0; i < parameters.length; i++) {
    const searchParameter = parameters[i];
    if (searchParameter.conditionType === 'group' && searchParameter.value === '(') {
      // render a group recursively
      if (!(searchParameter.id in groups)) {
        throw new SearchBarError('Cannot render the search bar because there is an unclosed group');
      }
      const group = groups[searchParameter.id];
      const before = parameters[i - 1] && parameters[i - 1].conditionType;
      const after = group.afterGroup;

      searchParameters.push(React__default.createElement(
        'span',
        { className: getGroupStyling({ before, after, level }), key: searchParameter.id },
        React__default.createElement(SearchParameters, {
          level: 1 + level,
          parameters: parameters.slice(1 + i, group.endOfGroup),
          disableTooltip: disableTooltip
        })
      ));

      // skip to the end of the group, continue rendering
      i = group.endOfGroup;
    } else if (searchParameter.conditionType in engineCategories) {
      // render an engineCategory subpill
      const engine = engineCategories[searchParameter.conditionType];
      const { abbreviation, exclude, full } = engine.getLabel(searchParameter.value);

      searchParameters.push(React__default.createElement(
        Tooltip,
        {
          title: full,
          placement: 'bottom',
          disableHoverListener: disableTooltip,
          key: searchParameter.id
        },
        React__default.createElement(
          'div',
          { className: classes['tooltipContainer'] },
          React__default.createElement(SearchPill$1, {
            label: abbreviation,
            exclude: exclude,
            engineCategoryIcon: engine.iconClass,
            disabled: true
          })
        )
      ));
    } else if (searchParameter.conditionType === 'join') {
      // render a joining operator
      searchParameters.push(React__default.createElement(
        'span',
        { className: classes['joiningOperator'], key: searchParameter.id },
        searchParameter.value,
        ' '
      ));
    } else if (searchParameter.conditionType !== 'group') {
      throw new SearchBarError('Invalid search parameter', searchParameter);
    }
  }

  return React__default.createElement(
    Fragment,
    null,
    searchParameters
  );
};

SearchParameters.displayName = 'SearchParameters';
SearchParameters.propTypes = {
  parameters: arrayOf(shape$1({
    id: string.isRequired,
    value: oneOfType([object, string]),
    conditionType: string.isRequired
  })),
  level: number,
  disableTooltip: bool
};

SearchParameters.defaultProps = {
  level: 0
};

let SearchBar = (_temp2$v = _class$E = class SearchBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      hasError: false
    }, _temp;
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return React__default.createElement(
        'div',
        null,
        'Invalid searchQuery'
      );
    } else {
      return React__default.createElement(SearchParameters, {
        parameters: this.props.parameters,
        disableTooltip: this.props.disableTooltip
      });
    }
  }
}, _class$E.propTypes = {
  parameters: arrayOf(shape$1({
    id: string.isRequired,
    value: oneOfType([object, string]),
    conditionType: string.isRequired
  })),
  disableTooltip: bool
}, _class$E.defaultProps = {
  disableTooltip: false
}, _temp2$v);
SearchBar.displayName = 'SearchBar';

var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index$a (resultFn) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;

  var lastThis = void 0;
  var lastArgs = [];
  var lastResult = void 0;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    lastResult = resultFn.apply(this, newArgs);
    return lastResult;
  };

  return result;
}

// export function getMousePosition(e) {
//   // https://stackoverflow.com/questions/8389156
//   let el = e.target,
//     x = 0,
//     y = 0;
//
//   // fixme -- scroll position seems to not be taken into account
//   while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
//     console.log(el.scrollTop)
//     x += el.offsetLeft - el.scrollLeft;
//     y += el.offsetTop - el.scrollTop;
//     el = el.offsetParent;
//   }
//
//   x = e.clientX - x;
//   y = e.clientY - y;
//
//   return { x: x, y: y };
// }

function getMousePosition(e) {
  let el = e.target,
      el_left = 0,
      el_top = 0,
      x,
      y;

  while (el.offsetParent) {
    el_left += el.offsetLeft;
    el_top += el.offsetTop;
    el = el.offsetParent;
  }

  el = e.target;
  while (el.parentNode) {
    el_left -= el.scrollLeft;
    el_top -= el.scrollTop;
    el = el.parentNode;
  }

  x = e.clientX;
  y = e.clientY;

  x -= el_left;
  y -= el_top;

  return { x, y };
}

function hasCommandModifier(e) {
  const platform = navigator.platform;
  const isOSX = platform.includes('Mac');
  return e && isOSX ? !!e.metaKey && !e.altKey : isCtrlKeyCommand(e);
}

function isCtrlKeyCommand(e) {
  return !!e.ctrlKey && !e.altKey;
}

const withContextProps = (ContextConsumer, mapContextToProps) => Component => setDisplayName(wrapDisplayName(Component, 'withContextProps'))(props => React__default.createElement(
  ContextConsumer,
  null,
  context => React__default.createElement(Component, _extends({}, props, mapContextToProps(context)))
));

const handleSize = 6;

var styles$Q = {
  resizeHandle: {
    backgroundColor: 'white',
    width: `${handleSize}px !important`,
    height: `${handleSize}px !important`
  },
  resizeHandleHorizontal: {
    top: `calc(50% - ${handleSize / 2}) !important`
  },
  resizeHandleVertical: {
    left: `calc(50% - ${handleSize / 2}) !important`
  },
  clearfix: {
    '&::after': {
      content: '',
      clear: 'both',
      display: 'table'
    }
  }
};

var _class$F, _temp2$w;

const OverlayPositioningContext = React__default.createContext({
  top: 0,
  left: 0,
  height: 0,
  width: 0
});
let OverlayPositioningProvider = (_temp2$w = _class$F = class OverlayPositioningProvider extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      overlayPosition: { top: 0, left: 0, height: 0, width: 0 }
    }, this.measuredChildRef = null, this.resizeObserver = null, this.pollingInterval = null, this.measureChild = (element = this.measuredChildRef) => {
      // calculate the actual size of the element we're going to lay on top of
      const {
        height: screenHeight,
        width: screenWidth
      } = element.getBoundingClientRect();
      const { contentWidth, contentHeight } = this.props;

      const ratioScreen = screenWidth / screenHeight;
      const ratioContent = contentWidth / contentHeight;

      const [width, height] = ratioScreen > ratioContent ? [contentWidth * screenHeight / contentHeight, screenHeight] : [screenWidth, contentHeight * screenWidth / contentWidth];

      // figure out what styles need to be applied to the overlay component so that
      // it aligns with the content (considering letter/pillarboxing)
      const measuredOverlayPosition = {
        top: (screenHeight - height) / 2,
        left: (screenWidth - width) / 2,
        height,
        width
      };

      if (!_isEqual(this.state.overlayPosition, measuredOverlayPosition)) {
        this.setState({
          overlayPosition: measuredOverlayPosition
        });
      }
    }, this.setMeasuredChildRef = r => {
      if (!r) {
        return;
      }

      this.measuredChildRef = r;

      if (!window.ResizeObserver) {
        clearInterval(this.pollingInterval);
        // poll for changes in the measured element's size
        this.pollingInterval = setInterval(this.measureChild, 250);
        return;
      }

      // use ResizeObserver if available (Chrome only), to avoid polling
      this.resizeObserver = new ResizeObserver(([entry]) => {
        this.measureChild(entry.target);
      });

      this.resizeObserver.observe(r);
    }, _temp;
  } // eslint-disable-line
  // eslint-disable-line


  componentWillUnmount() {
    clearInterval(this.pollingInterval);
    this.resizeObserver && this.resizeObserver.disconnect();
  }

  componentDidUpdate() {
    this.measureChild();
  }

  render() {
    // clearfix and float are to make sure the "measured child" div sizes
    // exactly to the size of its child content in fixed/fluid width scenarios
    const { classes } = this.props;
    return React__default.createElement(
      OverlayPositioningContext.Provider,
      { value: this.state.overlayPosition },
      React__default.createElement(
        'div',
        { className: cx$1({ [classes.clearfix]: this.props.fixedWidth }) },
        React__default.createElement(
          'div',
          {
            className: cx$1(this.props.contentClassName),
            style: {
              float: this.props.fixedWidth ? 'left' : 'none',
              position: 'relative',
              verticalAlign: 'bottom'
            },
            ref: this.setMeasuredChildRef
          },
          this.props.children
        )
      )
    );
  }
}, _class$F.propTypes = {
  contentHeight: number,
  contentWidth: number,
  fixedWidth: bool,
  children: node,
  contentClassName: string,
  classes: shape$1({ any })
}, _class$F.defaultProps = {}, _temp2$w);
OverlayPositioningProvider.displayName = 'OverlayPositioningProvider';


var OverlayPositioningProvider$1 = withStyles$1(styles$Q)(OverlayPositioningProvider);

var _class$G, _temp2$x;
// import {} from 'lodash';

let OverlayToolBar = (_temp2$x = _class$G = class OverlayToolBar extends React__default.PureComponent {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      menuAnchorEl: null
    }, this.handleOpenMenu = event => {
      this.setState({ menuAnchorEl: event.currentTarget });
    }, this.handleCloseMenu = e => {
      const itemIndex = e.target.getAttribute('data-itemindex');

      if (itemIndex) {
        this.props.menuItems[Number(itemIndex)].onClick(this.props.focusedBoundingBoxId);
      }

      this.setState({ menuAnchorEl: null });
    }, _temp;
  }

  render() {
    return React__default.createElement(
      Slide,
      { 'in': this.props.visible, direction: 'up' },
      React__default.createElement(
        'div',
        {
          style: {
            position: 'absolute',
            backgroundColor: 'rgb(243, 243, 243, 0.87)',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: 4,
            bottom: this.props.bottomOffset,
            width: '100%'
          }
        },
        React__default.createElement(
          'div',
          { style: { flexGrow: 1 } },
          React__default.createElement(
            IconButton$2,
            { onClick: this.props.onMinimize },
            React__default.createElement(ArrowDownIcon, null)
          )
        ),
        this.props.children,
        !!this.props.menuItems.length && React__default.createElement(
          Fragment,
          null,
          React__default.createElement(
            'div',
            {
              style: {
                borderRight: '1px solid rgba(0, 0, 0, 0.54)',
                height: 25
              }
            },
            ' '
          ),
          React__default.createElement(
            IconButton$2,
            { onClick: this.handleOpenMenu },
            React__default.createElement(MoreVertIcon, null)
          ),
          React__default.createElement(
            Menu,
            {
              anchorEl: this.state.menuAnchorEl,
              open: !!this.state.menuAnchorEl,
              onClose: this.handleCloseMenu,
              transformOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
              }
            },
            this.props.menuItems.map((option, i) => React__default.createElement(
              MenuItem,
              {
                key: option.label,
                'data-itemindex': i,
                onClick: this.handleCloseMenu
              },
              option.label
            ))
          )
        )
      )
    );
  }
}, _class$G.propTypes = {
  visible: bool,
  children: node,
  onMinimize: func,
  menuItems: arrayOf(shape$1({
    label: string.isRequired,
    onClick: func.isRequired
  })),
  bottomOffset: number,
  focusedBoundingBoxId: string
}, _class$G.defaultProps = {
  menuItems: [],
  bottomOffset: 0
}, _temp2$x);
OverlayToolBar.displayName = 'OverlayToolBar';

var _class$H, _temp2$y;

let OverlayConfirmMenu = (_temp2$y = _class$H = class OverlayConfirmMenu extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      menuAnchorEl: null
    }, _temp;
  }

  render() {
    return React__default.createElement(
      OverlayToolBar,
      {
        visible: this.props.visible,
        onMinimize: this.props.onMinimize,
        bottomOffset: this.props.bottomOffset
      },
      React__default.createElement(
        Button$2,
        {
          size: 'small',
          color: 'default',
          onClick: this.props.onCancel,
          style: { marginRight: 5 }
        },
        'Cancel'
      ),
      React__default.createElement(
        'div',
        {
          style: {
            borderRight: '1px solid #E0E0E0'
          }
        },
        ' '
      ),
      React__default.createElement(
        Button$2,
        {
          size: 'small',
          color: 'primary',
          onClick: this.props.onConfirm,
          style: { marginLeft: 5 }
        },
        this.props.confirmLabel
      )
    );
  }
}, _class$H.propTypes = {
  confirmLabel: string.isRequired,
  visible: bool,
  onConfirm: func.isRequired,
  onCancel: func.isRequired,
  onMinimize: func.isRequired,
  bottomOffset: number
}, _class$H.defaultProps = {}, _temp2$y);
OverlayConfirmMenu.displayName = 'OverlayConfirmMenu';

var _class$I, _temp$a;

let OverlayActionsMenu = (_temp$a = _class$I = class OverlayActionsMenu extends React__default.PureComponent {

  render() {
    return React__default.createElement(
      OverlayToolBar,
      {
        visible: this.props.visible,
        onMinimize: this.props.onMinimize,
        menuItems: this.props.menuItems,
        bottomOffset: this.props.bottomOffset,
        focusedBoundingBoxId: this.props.focusedBoundingBoxId
      },
      React__default.createElement(
        IconButton$2,
        { onClick: this.props.onDelete },
        React__default.createElement(DeleteIcon, null)
      ),
      this.props.onConfirm && React__default.createElement(
        IconButton$2,
        { onClick: this.props.onConfirm },
        React__default.createElement(CheckCircle, null)
      )
    );
  }
}, _class$I.propTypes = {
  visible: bool,
  onMinimize: func,
  onDelete: func,
  onConfirm: func,
  menuItems: arrayOf(shape$1({
    label: string.isRequired,
    onClick: func.isRequired
  })),
  bottomOffset: number,
  focusedBoundingBoxId: string
}, _class$I.defaultProps = {}, _temp$a);
OverlayActionsMenu.displayName = 'OverlayActionsMenu';

var reactDraggable = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(ReactDOM__default, React__default);
})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func /*: any*/) /*: boolean*/ {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num /*: any*/) /*: boolean*/ {
  return typeof num === 'number' && !isNaN(num);
}

function int(a /*: string*/) /*: number*/ {
  return parseInt(a, 10);
}

function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
  if (props[propName]) {
    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.styleHacks = styleHacks;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(0);

var _getPrefix = __webpack_require__(19);

var _getPrefix2 = _interopRequireDefault(_getPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*:: import type {ControlPosition, MouseTouchEvent} from './types';*/


var matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  }

  // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable
  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc](selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
  var node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/ {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node /*: HTMLElement*/) /*: number*/ {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}

// Get from offsetParent
function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

  return { x: x, y: y };
}

function createCSSTransform(_ref) /*: Object*/ {
  var x = _ref.x,
      y = _ref.y;

  // Replace unitless items with px
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
}

function createSVGTransform(_ref3) /*: string*/ {
  var x = _ref3.x,
      y = _ref3.y;

  return 'translate(' + x + ',' + y + ')';
}

function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {background: transparent;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {background: transparent;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc /*: ?Document*/) {
  try {
    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
    window.getSelection().removeAllRanges(); // remove selection caused by scroll
  } catch (e) {
    // probably IE
  }
}

function styleHacks() /*: Object*/ {
  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Workaround IE pointer events; see #51
  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
  return _extends({
    touchAction: 'none'
  }, childStyle);
}

function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
      el.className += ' ' + className;
    }
  }
}

function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(17)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(0);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  var bounds = draggable.props.bounds;

  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;

    var ownerWindow = ownerDocument.defaultView;
    var boundNode = void 0;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);

  return [x, y];
}

function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  var node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0, deltaY: 0,
      lastX: x, lastY: y,
      x: x, y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX, deltaY: y - state.lastY,
      lastX: state.lastX, lastY: state.lastY,
      x: x, y: y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX,
    y: draggable.state.y + coreData.deltaY,
    deltaX: coreData.deltaX,
    deltaY: coreData.deltaY,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
  var node = _reactDom2.default.findDOMNode(draggable);
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


// Simple abstraction for dragging events names.
/*:: import type {Element as ReactElement} from 'react';*/
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
var dragEventFor = eventsFor.mouse;

/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/
/*:: export type DraggableBounds = {
  left: number,
  right: number,
  top: number,
  bottom: number,
};*/
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
/*:: export type ControlPosition = {x: number, y: number};*/


//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

/*:: export type DraggableCoreProps = {
  allowAnyClick: boolean,
  cancel: string,
  children: ReactElement<any>,
  disabled: boolean,
  enableUserSelectHack: boolean,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
};*/

var DraggableCore = function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  function DraggableCore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN, lastY: NaN,
      touchIdentifier: null
    }, _this.handleDragStart = function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      var ownerDocument = thisNode.ownerDocument;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({ touchIdentifier: touchIdentifier });

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
      if (position == null) return; // not possible but satisfies flow
      var x = position.x,
          y = position.y;

      // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log2.default)('calling', _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      _this.setState({
        dragging: true,

        lastX: x,
        lastY: y
      });

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    }, _this.handleDrag = function (e) {

      // Prevent scrolling on mobile devices, like ipad/iphone.
      if (e.type === 'touchmove') e.preventDefault();

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var _deltaX = x - _this.state.lastX,
            _deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, _deltaX, _deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        _deltaX = _snapToGrid2[0];
        _deltaY = _snapToGrid2[1];

        if (!_deltaX && !_deltaY) return; // skip useless drag
        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    }, _this.handleDragStop = function (e) {
      if (!_this.state.dragging) return;

      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      // Call event handler
      _this.props.onStop(e, coreEvent);

      if (thisNode) {
        // Remove event handlers
        (0, _log2.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    }, _this.onMouseDown = function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    }, _this.onMouseUp = function (e) {
      dragEventFor = eventsFor.mouse;

      return _this.handleDragStop(e);
    }, _this.onTouchStart = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStart(e);
    }, _this.onTouchEnd = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStop(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraggableCore, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
      var thisNode = _reactDom2.default.findDOMNode(this);
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;

        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }

    // Same as onMouseDown (start drag), but now consider this a touch device.

  }, {
    key: 'render',
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
        style: (0, _domFns.styleHacks)(this.props.children.props.style),

        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(_react2.default.Component);

DraggableCore.displayName = 'DraggableCore';
DraggableCore.propTypes = {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes2.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes2.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes2.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
    if (process.browser === true && props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes2.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes2.default.string,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes2.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes2.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes2.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
};
DraggableCore.defaultProps = {
  allowAnyClick: false, // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
};
exports.default = DraggableCore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


var Draggable = __webpack_require__(13).default;

// Previous versions of this lib exported <Draggable> as the root export. As to not break
// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = __webpack_require__(10).default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _DraggableCore = __webpack_require__(10);

var _DraggableCore2 = _interopRequireDefault(_DraggableCore);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ControlPosition, DraggableBounds, DraggableCoreProps} from './DraggableCore';*/
/*:: import type {DraggableEventHandler} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
/*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean
};*/


//
// Define <Draggable>
//

/*:: export type DraggableProps = {
  ...$Exact<DraggableCoreProps>,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: DraggableBounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  position: ControlPosition,
};*/

var Draggable = function (_React$Component) {
  _inherits(Draggable, _React$Component);

  function Draggable(props /*: DraggableProps*/) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

    _this.onDragStart = function (e, coreData) {
      (0, _log2.default)('Draggable: onDragStart: %j', coreData);

      // Short-circuit if user's callback killed it.
      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
      // Kills start event on core as well, so move handlers are never bound.
      if (shouldStart === false) return false;

      _this.setState({ dragging: true, dragged: true });
    };

    _this.onDrag = function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log2.default)('Draggable: onDrag: %j', coreData);

      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        x: uiData.x,
        y: uiData.y
      };

      // Keep within bounds.
      if (_this.props.bounds) {
        // Save original x and y.
        var _x = newState.x,
            _y = newState.y;

        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY;

        // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY;

        // Recalculate slack by noting how much was shaved by the boundPosition handler.
        newState.slackX = _this.state.slackX + (_x - newState.x);
        newState.slackY = _this.state.slackY + (_y - newState.y);

        // Update the event we fire to reflect what really happened after bounds took effect.
        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      }

      // Short-circuit if user's callback killed it.
      var shouldUpdate = _this.props.onDrag(e, uiData);
      if (shouldUpdate === false) return false;

      _this.setState(newState);
    };

    _this.onDragStop = function (e, coreData) {
      if (!_this.state.dragging) return false;

      // Short-circuit if user's callback killed it.
      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
      if (shouldStop === false) return false;

      (0, _log2.default)('Draggable: onDragStop: %j', coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        dragging: false,
        slackX: 0,
        slackY: 0
      };

      // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
      var controlled = Boolean(_this.props.position);
      if (controlled) {
        var _this$props$position = _this.props.position,
            _x2 = _this$props$position.x,
            _y2 = _this$props$position.y;

        newState.x = _x2;
        newState.y = _y2;
      }

      _this.setState(newState);
    };

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,

      // Whether or not we have been dragged before.
      dragged: false,

      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,

      // Used for compensating for out-of-bounds drags
      slackX: 0, slackY: 0,

      // Can only determine if SVG after mounting
      isElementSVG: false
    };
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
        // eslint-disable-next-line
        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof window.SVGElement) {
        this.setState({ isElementSVG: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps /*: Object*/) {
      // Set x/y if position has changed
      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
    }
  }, {
    key: 'render',
    value: function render() /*: ReactElement<any>*/ {
      var _classNames;

      var style = {},
          svgTransform = null;

      // If this is controlled, we don't want to move it - unless it's dragging.
      var controlled = Boolean(this.props.position);
      var draggable = !controlled || this.state.dragging;

      var position = this.props.position || this.props.defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,

        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
      };

      // If this element was SVG, we use the `transform` attribute.
      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts);
      }

      var _props = this.props,
          defaultClassName = _props.defaultClassName,
          defaultClassNameDragging = _props.defaultClassNameDragging,
          defaultClassNameDragged = _props.defaultClassNameDragged;


      var children = _react2.default.Children.only(this.props.children);

      // Mark with class while dragging
      var className = (0, _classnames2.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.createElement(
        _DraggableCore2.default,
        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
        _react2.default.cloneElement(children, {
          className: className,
          style: _extends({}, children.props.style, style),
          transform: svgTransform
        })
      );
    }
  }]);

  return Draggable;
}(_react2.default.Component);

Draggable.displayName = 'Draggable';
Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {

  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    left: _propTypes2.default.number,
    right: _propTypes2.default.number,
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number
  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),

  defaultClassName: _propTypes2.default.string,
  defaultClassNameDragging: _propTypes2.default.string,
  defaultClassNameDragged: _propTypes2.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: { x: 0, y: 0 },
  position: null
});
exports.default = Draggable;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(16);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(8);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/ {
  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

  var style = window.document.documentElement.style;

  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
}

function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
}

function kebabToTitleCase(str /*: string*/) /*: string*/ {
  var out = '';
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
exports.default = getPrefix();

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ());
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] };

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});

});

var Draggable = unwrapExports(reactDraggable);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var styles$R = {
  base: {
    position: 'absolute',
    userSelect: 'none',
    MsUserSelect: 'none'
  },
  top: {
    width: '100%',
    height: '10px',
    top: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  right: {
    width: '10px',
    height: '100%',
    top: '0px',
    right: '-5px',
    cursor: 'col-resize'
  },
  bottom: {
    width: '100%',
    height: '10px',
    bottom: '-5px',
    left: '0px',
    cursor: 'row-resize'
  },
  left: {
    width: '10px',
    height: '100%',
    top: '0px',
    left: '-5px',
    cursor: 'col-resize'
  },
  topRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    top: '-10px',
    cursor: 'ne-resize'
  },
  bottomRight: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '-10px',
    bottom: '-10px',
    cursor: 'se-resize'
  },
  bottomLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    bottom: '-10px',
    cursor: 'sw-resize'
  },
  topLeft: {
    width: '20px',
    height: '20px',
    position: 'absolute',
    left: '-10px',
    top: '-10px',
    cursor: 'nw-resize'
  }
};

var Resizer = (function (props) {
  return createElement(
    'div',
    {
      className: props.className,
      style: _extends$2({}, styles$R.base, styles$R[props.direction], props.replaceStyles || {}),
      onMouseDown: function onMouseDown(e) {
        props.onResizeStart(e, props.direction);
      },
      onTouchStart: function onTouchStart(e) {
        props.onResizeStart(e, props.direction);
      }
    },
    props.children
  );
});

var userSelectNone = {
  userSelect: 'none',
  MozUserSelect: 'none',
  WebkitUserSelect: 'none',
  MsUserSelect: 'none'
};

var userSelectAuto = {
  userSelect: 'auto',
  MozUserSelect: 'auto',
  WebkitUserSelect: 'auto',
  MsUserSelect: 'auto'
};

var clamp$1 = function clamp(n, min, max) {
  return Math.max(Math.min(n, max), min);
};
var snap = function snap(n, size) {
  return Math.round(n / size) * size;
};

var endsWith = function endsWith(str, searchStr) {
  return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
};

var getStringSize = function getStringSize(n) {
  if (endsWith(n.toString(), 'px')) return n.toString();
  if (endsWith(n.toString(), '%')) return n.toString();
  return n + 'px';
};

var definedProps = ['style', 'className', 'grid', 'bounds', 'size', 'defaultSize', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'lockAspectRatio', 'lockAspectRatioExtraWidth', 'lockAspectRatioExtraHeight', 'enable', 'handleStyles', 'handleClasses', 'handleWrapperStyle', 'handleWrapperClass', 'children', 'onResizeStart', 'onResize', 'onResizeStop', 'handleComponent'];

var baseClassName = '__resizable_base__';

var Resizable = function (_React$Component) {
  inherits(Resizable, _React$Component);

  function Resizable(props) {
    classCallCheck(this, Resizable);

    var _this = possibleConstructorReturn(this, (Resizable.__proto__ || Object.getPrototypeOf(Resizable)).call(this, props));

    _this.state = {
      isResizing: false,
      resizeCursor: 'auto',
      width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
      height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
      direction: 'right',
      original: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    };

    _this.updateExtendsProps(props);
    _this.onResizeStart = _this.onResizeStart.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);

    if (typeof window !== 'undefined') {
      window.addEventListener('mouseup', _this.onMouseUp);
      window.addEventListener('mousemove', _this.onMouseMove);
      window.addEventListener('mouseleave', _this.onMouseUp);
      window.addEventListener('touchmove', _this.onMouseMove);
      window.addEventListener('touchend', _this.onMouseUp);
    }
    return _this;
  }

  createClass(Resizable, [{
    key: 'updateExtendsProps',
    value: function updateExtendsProps(props) {
      this.extendsProps = Object.keys(props).reduce(function (acc, key) {
        if (definedProps.indexOf(key) !== -1) return acc;
        acc[key] = props[key];
        return acc;
      }, {});
    }
  }, {
    key: 'getParentSize',
    value: function getParentSize() {
      var base = this.base;

      if (!base) return { width: window.innerWidth, height: window.innerHeight };
      // INFO: To calculate parent width with flex layout
      var wrapChanged = false;
      var wrap = this.parentNode.style.flexWrap;
      var minWidth = base.style.minWidth;
      if (wrap !== 'wrap') {
        wrapChanged = true;
        this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
      }
      base.style.position = 'relative';
      base.style.minWidth = '100%';
      var size = {
        width: base.offsetWidth,
        height: base.offsetHeight
      };
      base.style.position = 'absolute';
      if (wrapChanged) this.parentNode.style.flexWrap = wrap;
      base.style.minWidth = minWidth;
      return size;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var size = this.size;

      this.setState({
        width: this.state.width || size.width,
        height: this.state.height || size.height
      });
      var parent = this.parentNode;
      if (!(parent instanceof HTMLElement)) return;
      if (this.base) return;
      var element = document.createElement('div');
      element.style.width = '100%';
      element.style.height = '100%';
      element.style.position = 'absolute';
      element.style.transform = 'scale(0, 0)';
      element.style.left = '-2147483647px';
      element.style.flex = '0';
      if (element.classList) {
        element.classList.add(baseClassName);
      } else {
        element.className += baseClassName;
      }
      parent.appendChild(element);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      this.updateExtendsProps(next);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseleave', this.onMouseUp);
        window.removeEventListener('touchmove', this.onMouseMove);
        window.removeEventListener('touchend', this.onMouseUp);
        var parent = this.parentNode;
        var base = this.base;

        if (!base || !parent) return;
        if (!(parent instanceof HTMLElement) || !(base instanceof Node)) return;
        parent.removeChild(base);
      }
    }
  }, {
    key: 'calculateNewSize',
    value: function calculateNewSize(newSize, kind) {
      var propsSize = this.propsSize && this.propsSize[kind];
      return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    }
  }, {
    key: 'onResizeStart',
    value: function onResizeStart(event, direction) {
      var clientX = 0;
      var clientY = 0;
      if (event.nativeEvent instanceof MouseEvent) {
        clientX = event.nativeEvent.clientX;
        clientY = event.nativeEvent.clientY;

        // When user click with right button the resize is stuck in resizing mode
        // until users clicks again, dont continue if right click is used.
        // HACK: MouseEvent does not have `which` from flow-bin v0.68.
        if (event.nativeEvent.which === 3) {
          return;
        }
      } else if (event.nativeEvent instanceof TouchEvent) {
        clientX = event.nativeEvent.touches[0].clientX;
        clientY = event.nativeEvent.touches[0].clientY;
      }
      if (this.props.onResizeStart) {
        this.props.onResizeStart(event, direction, this.resizable);
      }

      // Fix #168
      if (this.props.size) {
        if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
          this.setState({ height: this.props.size.height });
        }
        if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
          this.setState({ width: this.props.size.width });
        }
      }

      this.setState({
        original: {
          x: clientX,
          y: clientY,
          width: this.size.width,
          height: this.size.height
        },
        isResizing: true,
        resizeCursor: window.getComputedStyle(event.target).cursor,
        direction: direction
      });
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      if (!this.state.isResizing) return;
      var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
      var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
      var _state = this.state,
          direction = _state.direction,
          original = _state.original,
          width = _state.width,
          height = _state.height;
      var _props = this.props,
          lockAspectRatio = _props.lockAspectRatio,
          lockAspectRatioExtraHeight = _props.lockAspectRatioExtraHeight,
          lockAspectRatioExtraWidth = _props.lockAspectRatioExtraWidth;
      var _props2 = this.props,
          maxWidth = _props2.maxWidth,
          maxHeight = _props2.maxHeight,
          minWidth = _props2.minWidth,
          minHeight = _props2.minHeight;

      // TODO: refactor

      var parentSize = this.getParentSize();
      if (maxWidth && typeof maxWidth === 'string' && endsWith(maxWidth, '%')) {
        var _ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * _ratio;
      }
      if (maxHeight && typeof maxHeight === 'string' && endsWith(maxHeight, '%')) {
        var _ratio2 = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * _ratio2;
      }
      if (minWidth && typeof minWidth === 'string' && endsWith(minWidth, '%')) {
        var _ratio3 = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * _ratio3;
      }
      if (minHeight && typeof minHeight === 'string' && endsWith(minHeight, '%')) {
        var _ratio4 = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * _ratio4;
      }
      maxWidth = typeof maxWidth === 'undefined' ? undefined : Number(maxWidth);
      maxHeight = typeof maxHeight === 'undefined' ? undefined : Number(maxHeight);
      minWidth = typeof minWidth === 'undefined' ? undefined : Number(minWidth);
      minHeight = typeof minHeight === 'undefined' ? undefined : Number(minHeight);

      var ratio = typeof lockAspectRatio === 'number' ? lockAspectRatio : original.width / original.height;
      var newWidth = original.width;
      var newHeight = original.height;
      if (/right/i.test(direction)) {
        newWidth = original.width + (clientX - original.x);
        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
      }
      if (/left/i.test(direction)) {
        newWidth = original.width - (clientX - original.x);
        if (lockAspectRatio) newHeight = (newWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
      }
      if (/bottom/i.test(direction)) {
        newHeight = original.height + (clientY - original.y);
        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
      }
      if (/top/i.test(direction)) {
        newHeight = original.height - (clientY - original.y);
        if (lockAspectRatio) newWidth = (newHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
      }

      if (this.props.bounds === 'parent') {
        var parent = this.parentNode;
        if (parent instanceof HTMLElement) {
          var parentRect = parent.getBoundingClientRect();
          var parentLeft = parentRect.left;
          var parentTop = parentRect.top;

          var _resizable$getBoundin = this.resizable.getBoundingClientRect(),
              _left = _resizable$getBoundin.left,
              _top = _resizable$getBoundin.top;

          var boundWidth = parent.offsetWidth + (parentLeft - _left);
          var boundHeight = parent.offsetHeight + (parentTop - _top);
          maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
          maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
      } else if (this.props.bounds === 'window') {
        if (typeof window !== 'undefined') {
          var _resizable$getBoundin2 = this.resizable.getBoundingClientRect(),
              _left2 = _resizable$getBoundin2.left,
              _top2 = _resizable$getBoundin2.top;

          var _boundWidth = window.innerWidth - _left2;
          var _boundHeight = window.innerHeight - _top2;
          maxWidth = maxWidth && maxWidth < _boundWidth ? maxWidth : _boundWidth;
          maxHeight = maxHeight && maxHeight < _boundHeight ? maxHeight : _boundHeight;
        }
      } else if (this.props.bounds instanceof HTMLElement) {
        var targetRect = this.props.bounds.getBoundingClientRect();
        var targetLeft = targetRect.left;
        var targetTop = targetRect.top;

        var _resizable$getBoundin3 = this.resizable.getBoundingClientRect(),
            _left3 = _resizable$getBoundin3.left,
            _top3 = _resizable$getBoundin3.top;

        if (!(this.props.bounds instanceof HTMLElement)) return;
        var _boundWidth2 = this.props.bounds.offsetWidth + (targetLeft - _left3);
        var _boundHeight2 = this.props.bounds.offsetHeight + (targetTop - _top3);
        maxWidth = maxWidth && maxWidth < _boundWidth2 ? maxWidth : _boundWidth2;
        maxHeight = maxHeight && maxHeight < _boundHeight2 ? maxHeight : _boundHeight2;
      }

      var computedMinWidth = typeof minWidth === 'undefined' ? 10 : minWidth;
      var computedMaxWidth = typeof maxWidth === 'undefined' || maxWidth < 0 ? newWidth : maxWidth;
      var computedMinHeight = typeof minHeight === 'undefined' ? 10 : minHeight;
      var computedMaxHeight = typeof maxHeight === 'undefined' || maxHeight < 0 ? newHeight : maxHeight;

      if (lockAspectRatio) {
        var extraMinWidth = (computedMinHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
        var extraMaxWidth = (computedMaxHeight - lockAspectRatioExtraHeight) * ratio + lockAspectRatioExtraWidth;
        var extraMinHeight = (computedMinWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
        var extraMaxHeight = (computedMaxWidth - lockAspectRatioExtraWidth) / ratio + lockAspectRatioExtraHeight;
        var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
        var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
        var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
        var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
        newWidth = clamp$1(newWidth, lockedMinWidth, lockedMaxWidth);
        newHeight = clamp$1(newHeight, lockedMinHeight, lockedMaxHeight);
      } else {
        newWidth = clamp$1(newWidth, computedMinWidth, computedMaxWidth);
        newHeight = clamp$1(newHeight, computedMinHeight, computedMaxHeight);
      }
      if (this.props.grid) {
        newWidth = snap(newWidth, this.props.grid[0]);
      }
      if (this.props.grid) {
        newHeight = snap(newHeight, this.props.grid[1]);
      }

      var delta = {
        width: newWidth - original.width,
        height: newHeight - original.height
      };

      if (width && typeof width === 'string' && endsWith(width, '%')) {
        var percent = newWidth / parentSize.width * 100;
        newWidth = percent + '%';
      }

      if (height && typeof height === 'string' && endsWith(height, '%')) {
        var _percent = newHeight / parentSize.height * 100;
        newHeight = _percent + '%';
      }

      this.setState({
        width: this.calculateNewSize(newWidth, 'width'),
        height: this.calculateNewSize(newHeight, 'height')
      });

      if (this.props.onResize) {
        this.props.onResize(event, direction, this.resizable, delta);
      }
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(event) {
      var _state2 = this.state,
          isResizing = _state2.isResizing,
          direction = _state2.direction,
          original = _state2.original;

      if (!isResizing) return;
      var delta = {
        width: this.size.width - original.width,
        height: this.size.height - original.height
      };
      if (this.props.onResizeStop) {
        this.props.onResizeStop(event, direction, this.resizable, delta);
      }
      if (this.props.size) {
        this.setState(this.props.size);
      }
      this.setState({ isResizing: false, resizeCursor: 'auto' });
    }
  }, {
    key: 'updateSize',
    value: function updateSize(size) {
      this.setState({ width: size.width, height: size.height });
    }
  }, {
    key: 'renderResizer',
    value: function renderResizer() {
      var _this2 = this;

      var _props3 = this.props,
          enable = _props3.enable,
          handleStyles = _props3.handleStyles,
          handleClasses = _props3.handleClasses,
          handleWrapperStyle = _props3.handleWrapperStyle,
          handleWrapperClass = _props3.handleWrapperClass,
          handleComponent = _props3.handleComponent;

      if (!enable) return null;
      var resizers = Object.keys(enable).map(function (dir) {
        if (enable[dir] !== false) {
          return createElement(
            Resizer,
            {
              key: dir,
              direction: dir,
              onResizeStart: _this2.onResizeStart,
              replaceStyles: handleStyles && handleStyles[dir],
              className: handleClasses && handleClasses[dir]
            },
            handleComponent && handleComponent[dir] ? createElement(handleComponent[dir]) : null
          );
        }
        return null;
      });

      // #93 Wrap the resize box in span (will not break 100% width/height)
      return createElement(
        'span',
        { className: handleWrapperClass, style: handleWrapperStyle },
        resizers
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var userSelect = this.state.isResizing ? userSelectNone : userSelectAuto;
      return createElement(
        'div',
        _extends$2({
          ref: function ref(c) {
            if (c) {
              _this3.resizable = c;
            }
          },
          style: _extends$2({
            position: 'relative'
          }, userSelect, this.props.style, this.sizeStyle, {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: 'border-box'
          }),
          className: this.props.className
        }, this.extendsProps),
        this.state.isResizing && createElement('div', {
          style: {
            height: '100%',
            width: '100%',
            backgroundColor: 'rgba(0,0,0,0)',
            cursor: '' + (this.state.resizeCursor || 'auto'),
            opacity: '0',
            position: 'fixed',
            zIndex: '9999',
            top: '0',
            left: '0',
            bottom: '0',
            right: '0'
          }
        }),
        this.props.children,
        this.renderResizer()
      );
    }
  }, {
    key: 'parentNode',
    get: function get$$1() {
      return this.resizable.parentNode;
    }
  }, {
    key: 'propsSize',
    get: function get$$1() {
      return this.props.size || this.props.defaultSize;
    }
  }, {
    key: 'base',
    get: function get$$1() {
      var parent = this.parentNode;
      if (!parent) return undefined;
      return [].concat(toConsumableArray(parent.children)).find(function (n) {
        if (n instanceof HTMLElement) {
          return n.classList.contains(baseClassName);
        }
        return undefined;
      });
    }
  }, {
    key: 'size',
    get: function get$$1() {
      var width = 0;
      var height = 0;
      if (typeof window !== 'undefined') {
        width = this.resizable.offsetWidth;
        height = this.resizable.offsetHeight;
      }
      return { width: width, height: height };
    }
  }, {
    key: 'sizeStyle',
    get: function get$$1() {
      var _this4 = this;

      var size = this.props.size;

      var getSize = function getSize(key) {
        if (typeof _this4.state[key] === 'undefined' || _this4.state[key] === 'auto') return 'auto';
        if (_this4.propsSize && _this4.propsSize[key] && endsWith(_this4.propsSize[key].toString(), '%')) {
          if (endsWith(_this4.state[key].toString(), '%')) return _this4.state[key].toString();
          var parentSize = _this4.getParentSize();
          var value = Number(_this4.state[key].toString().replace('px', ''));
          var percent = value / parentSize[key] * 100;
          return percent + '%';
        }
        return getStringSize(_this4.state[key]);
      };
      var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? getStringSize(size.width) : getSize('width');
      var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? getStringSize(size.height) : getSize('height');
      return { width: width, height: height };
    }
  }]);
  return Resizable;
}(Component);

Resizable.defaultProps = {
  onResizeStart: function onResizeStart() {},
  onResize: function onResize() {},
  onResizeStop: function onResizeStop() {},
  enable: {
    top: true,
    right: true,
    bottom: true,
    left: true,
    topRight: true,
    bottomRight: true,
    bottomLeft: true,
    topLeft: true
  },
  style: {},
  grid: [1, 1],
  lockAspectRatio: false,
  lockAspectRatioExtraWidth: 0,
  lockAspectRatioExtraHeight: 0
};

var classCallCheck$1 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits$1 = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn$1 = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var resizableStyle = {
  width: 'auto',
  height: 'auto',
  display: 'inline-block',
  position: 'absolute',
  top: 0,
  left: 0
};

var Rnd = function (_React$Component) {
  inherits$1(Rnd, _React$Component);

  function Rnd(props) {
    classCallCheck$1(this, Rnd);

    var _this = possibleConstructorReturn$1(this, (Rnd.__proto__ || Object.getPrototypeOf(Rnd)).call(this, props));

    _this.state = {
      z: props.z,
      original: {
        x: 0,
        y: 0
      },
      bounds: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      maxWidth: props.maxWidth,
      maxHeight: props.maxHeight,
      isMounted: false
    };
    _this.onResizeStart = _this.onResizeStart.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    _this.onResizeStop = _this.onResizeStop.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrag = _this.onDrag.bind(_this);
    _this.onDragStop = _this.onDragStop.bind(_this);
    _this.getMaxSizesFromProps = _this.getMaxSizesFromProps.bind(_this);
    return _this;
  }

  createClass$1(Rnd, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.z !== nextProps.z) {
        this.setState({ z: nextProps.z });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setParentPosition();
    }
  }, {
    key: 'getParentSize',
    value: function getParentSize() {
      return this.resizable.getParentSize();
    }
  }, {
    key: 'getMaxSizesFromProps',
    value: function getMaxSizesFromProps() {
      var maxWidth = typeof this.props.maxWidth === 'undefined' ? Number.MAX_SAFE_INTEGER : this.props.maxWidth;
      var maxHeight = typeof this.props.maxHeight === 'undefined' ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
      return { maxWidth: maxWidth, maxHeight: maxHeight };
    }
  }, {
    key: 'getSelfElement',
    value: function getSelfElement() {
      if (!this) return null;
      return findDOMNode(this);
    }
  }, {
    key: 'setParentPosition',
    value: function setParentPosition() {
      var element = this.getSelfElement();
      if (element instanceof Element) {
        var parent = element.parentNode;
        if (!parent || typeof window === 'undefined') return;
        if (!(parent instanceof HTMLElement)) return;
        if (getComputedStyle(parent).position !== 'static') {
          this.setState({ isMounted: true });
          return;
        }
        parent.style.position = 'relative';
        this.setState({ isMounted: true });
      }
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(e, data) {
      if (this.props.onDragStart) {
        this.props.onDragStart(e, data);
      }
      if (!this.props.bounds) return;
      var parent = this.resizable && this.resizable.parentNode;
      var target = this.props.bounds === 'parent' ? parent : document.querySelector(this.props.bounds);
      if (!(target instanceof HTMLElement) || !(parent instanceof HTMLElement)) {
        return;
      }
      var targetRect = target.getBoundingClientRect();
      var targetLeft = targetRect.left;
      var targetTop = targetRect.top;
      var parentRect = parent.getBoundingClientRect();
      var parentLeft = parentRect.left;
      var parentTop = parentRect.top;
      var left = targetLeft - parentLeft;
      var top = targetTop - parentTop;
      if (!this.resizable) return;
      this.setState({
        bounds: {
          top: top,
          right: left + (target.offsetWidth - this.resizable.size.width),
          bottom: this.props._freeBottomBounds // eslint-disable-line
          ? 2147483647 : top + (target.offsetHeight - this.resizable.size.height),
          left: left
        }
      });
    }
  }, {
    key: 'onDrag',
    value: function onDrag(e, data) {
      if (this.props.onDrag) {
        this.props.onDrag(e, data);
      }
    }
  }, {
    key: 'onDragStop',
    value: function onDragStop(e, data) {
      if (this.props.onDragStop) {
        this.props.onDragStop(e, data);
      }
    }
  }, {
    key: 'onResizeStart',
    value: function onResizeStart(e, dir, refToElement) {
      e.stopPropagation();
      this.setState({
        original: { x: this.draggable.state.x, y: this.draggable.state.y }
      });
      if (this.props.bounds) {
        var parent = this.resizable && this.resizable.parentNode;
        var target = this.props.bounds === 'parent' ? parent : document.querySelector(this.props.bounds);
        var self = this.getSelfElement();
        if (self instanceof Element && target instanceof HTMLElement && parent instanceof HTMLElement) {
          var _getMaxSizesFromProps = this.getMaxSizesFromProps(),
              _maxWidth = _getMaxSizesFromProps.maxWidth,
              _maxHeight = _getMaxSizesFromProps.maxHeight;

          var parentSize = this.getParentSize();
          if (_maxWidth && typeof _maxWidth === 'string') {
            if (_maxWidth.endsWith('%')) {
              var ratio = Number(_maxWidth.replace('%', '')) / 100;
              _maxWidth = parentSize.width * ratio;
            } else if (_maxWidth.endsWith('px')) {
              _maxWidth = Number(_maxWidth.replace('px', ''));
            }
          }
          if (_maxHeight && typeof _maxHeight === 'string') {
            if (_maxHeight.endsWith('%')) {
              var _ratio = Number(_maxHeight.replace('%', '')) / 100;
              _maxHeight = parentSize.width * _ratio;
            } else if (_maxHeight.endsWith('px')) {
              _maxHeight = Number(_maxHeight.replace('px', ''));
            }
          }
          var selfRect = self.getBoundingClientRect();
          var selfLeft = selfRect.left;
          var selfTop = selfRect.top;
          var targetRect = target.getBoundingClientRect();
          var targetLeft = targetRect.left;
          var targetTop = targetRect.top;
          if (/left/i.test(dir) && this.resizable) {
            var max = selfLeft - targetLeft + this.resizable.size.width;
            this.setState({ maxWidth: max > Number(_maxWidth) ? _maxWidth : max });
          }
          if (/right/i.test(dir)) {
            var _max = target.offsetWidth + (targetLeft - selfLeft);
            this.setState({ maxWidth: _max > Number(_maxWidth) ? _maxWidth : _max });
          }
          if (/top/i.test(dir) && this.resizable) {
            var _max2 = selfTop - targetTop + this.resizable.size.height;
            this.setState({
              maxHeight: _max2 > Number(_maxHeight) ? _maxHeight : _max2
            });
          }
          if (/bottom/i.test(dir)) {
            var _max3 = target.offsetHeight + (targetTop - selfTop);
            this.setState({
              maxHeight: _max3 > Number(_maxHeight) ? _maxHeight : _max3
            });
          }
        }
      } else {
        this.setState({
          maxWidth: this.props.maxWidth,
          maxHeight: this.props.maxHeight
        });
      }
      if (this.props.onResizeStart) {
        this.props.onResizeStart(e, dir, refToElement);
      }
    }
  }, {
    key: 'onResize',
    value: function onResize(e, direction, refToResizableElement, delta) {
      var x = void 0;
      var y = void 0;
      if (/left/i.test(direction)) {
        x = this.state.original.x - delta.width;
        this.draggable.setState({ x: x });
      }
      if (/top/i.test(direction)) {
        y = this.state.original.y - delta.height;
        this.draggable.setState({ y: y });
      }
      if (this.props.onResize) {
        this.props.onResize(e, direction, refToResizableElement, delta, {
          x: x || this.draggable.state.x,
          y: y || this.draggable.state.y
        });
      }
    }
  }, {
    key: 'onResizeStop',
    value: function onResizeStop(e, direction, refToResizableElement, delta) {
      var _getMaxSizesFromProps2 = this.getMaxSizesFromProps(),
          maxWidth = _getMaxSizesFromProps2.maxWidth,
          maxHeight = _getMaxSizesFromProps2.maxHeight;

      this.setState({ maxWidth: maxWidth, maxHeight: maxHeight });
      if (this.props.onResizeStop) {
        var _position = {
          x: this.draggable.state.x,
          y: this.draggable.state.y
        };
        this.props.onResizeStop(e, direction, refToResizableElement, delta, _position);
      }
    }
  }, {
    key: 'updateSize',
    value: function updateSize(size) {
      if (!this.resizable) return;
      this.resizable.updateSize({ width: size.width, height: size.height });
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition(position) {
      this.draggable.setState(position);
    }
  }, {
    key: 'updateZIndex',
    value: function updateZIndex(z) {
      this.setState({ z: z });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var cursorStyle = this.props.disableDragging || this.props.dragHandleClassName ? { cursor: 'normal' } : { cursor: 'move' };
      var innerStyle = _extends$3({}, resizableStyle, {
        zIndex: this.state.z
      }, cursorStyle, this.props.style);
      // HACK: Wait for setting relative to parent element.
      if (!this.state.isMounted) return createElement('div', null);
      var maxHeight = this.props._freeBottomBounds ? 2147483647 : this.state.maxHeight; // eslint-disable-line
      return createElement(
        Draggable,
        {
          ref: function ref(c) {
            _this2.draggable = c;
          },
          handle: this.props.dragHandleClassName,
          defaultPosition: this.props.default,
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop,
          axis: this.props.dragAxis,
          disabled: this.props.disableDragging,
          grid: this.props.dragGrid,
          bounds: this.props.bounds ? this.state.bounds : undefined,
          position: this.props.position,
          enableUserSelectHack: this.props.enableUserSelectHack,
          cancel: this.props.cancel
        },
        createElement(
          Resizable,
          _extends$3({}, this.props.extendsProps, {
            className: this.props.className,
            ref: function ref(c) {
              _this2.resizable = c;
            },
            defaultSize: this.props.default,
            size: this.props.size,
            enable: this.props.enableResizing,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            style: innerStyle,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            maxWidth: this.state.maxWidth,
            maxHeight: maxHeight,
            grid: this.props.resizeGrid,
            handleWrapperClass: this.props.resizeHandleWrapperClass,
            handleWrapperStyle: this.props.resizeHandleWrapperStyle,
            lockAspectRatio: this.props.lockAspectRatio,
            lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth,
            lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight,
            handleStyles: this.props.resizeHandleStyles,
            handleClasses: this.props.resizeHandleClasses
          }),
          this.props.children
        )
      );
    }
  }]);
  return Rnd;
}(Component);

Rnd.defaultProps = {
  maxWidth: Number.MAX_SAFE_INTEGER,
  maxHeight: Number.MAX_SAFE_INTEGER,
  onResizeStart: function onResizeStart() {},
  onResize: function onResize() {},
  onResizeStop: function onResizeStop() {},
  onDragStart: function onDragStart() {},
  onDrag: function onDrag() {},
  onDragStop: function onDragStop() {}
};

var _class$J, _temp$b;
let RndBox = (_temp$b = _class$J = class RndBox extends React__default.Component {

  render() {
    const resizeHandleSize = 6;
    const handleShift = resizeHandleSize / 2;
    const { classes } = this.props;

    return React__default.createElement(Rnd, _extends({
      resizeHandleStyles: {
        topLeft: { left: -handleShift, top: -handleShift },
        topRight: { right: -handleShift, top: -handleShift },
        bottomLeft: { left: -handleShift, bottom: -handleShift },
        bottomRight: { right: -handleShift, bottom: -handleShift },
        right: { right: -handleShift },
        left: { left: -handleShift },
        top: { top: -handleShift },
        bottom: { bottom: -handleShift }
      },
      resizeHandleClasses: {
        topLeft: classes.resizeHandle,
        topRight: classes.resizeHandle,
        bottomLeft: classes.resizeHandle,
        bottomRight: classes.resizeHandle,
        right: cx$1(classes.resizeHandle, classes.resizeHandleHorizontal),
        left: cx$1(classes.resizeHandle, classes.resizeHandleHorizontal),
        top: cx$1(classes.resizeHandle, classes.resizeHandleVertical),
        bottom: cx$1(classes.resizeHandle, classes.resizeHandleVertical)
      },
      bounds: 'parent'
    }, this.props));
  }
}, _class$J.propTypes = {
  classes: shape$1({ any })
}, _class$J.defaultProps = {}, _temp$b);
RndBox.displayName = 'RndBox';


var RndBox$1 = withStyles$1(styles$Q)(RndBox);

function pixelXYWidthHeightToPercentagePoly({ x, y, width, height }, contentWidth, contentHeight) {
  // translate from internal (x, y, width, height) format to veritone's
  // percentage-based vertex format
  return [
  // top-left
  {
    x: x / contentWidth,
    y: y / contentHeight
  },
  // top-right
  {
    x: (x + width) / contentWidth,
    y: y / contentHeight
  },
  // bottom-right
  {
    x: (x + width) / contentWidth,
    y: (y + height) / contentHeight
  },
  // bottom-left
  {
    x: x / contentWidth,
    y: (y + height) / contentHeight
  }];
}

function percentagePolyToPixelXYWidthHeight(poly, contentWidth, contentHeight) {
  const pixelBoundingBox = boundingBox(poly).map(({ x, y }) => percentageToPixelCoords({ x, y, contentWidth, contentHeight }));

  return pixelBoundingBoxToXYWidthHeight(pixelBoundingBox);
}

function boundingBox(vertices) {
  const xVals = vertices.map(({ x }) => x);
  const yVals = vertices.map(({ y }) => y);

  const minX = Math.min.apply(null, xVals);
  const maxX = Math.max.apply(null, xVals);
  const minY = Math.min.apply(null, yVals);
  const maxY = Math.max.apply(null, yVals);

  return [
  // top-left
  { x: minX, y: minY },
  // top-right
  { x: maxX, y: minY },
  // bottom-right
  { x: maxX, y: maxY },
  // bottom-left
  { x: minX, y: maxY }];
}

function percentageToPixelCoords({ x, y, contentWidth, contentHeight }) {
  return {
    x: x * contentWidth,
    y: y * contentHeight
  };
}

function pixelBoundingBoxToXYWidthHeight([tl, tr, br, bl]) {
  return {
    x: tl.x,
    y: tl.y,
    width: tr.x - tl.x,
    height: bl.y - tl.y
  };
}

var _dec$1, _dec2$1, _class$K, _class2$3, _temp2$z;

let Overlay = (_dec$1 = withContextProps(OverlayPositioningContext.Consumer, context => ({
  overlayPositioningContext: context
})), _dec2$1 = branch(
// do not render if we don't have a workable overlayPositioningContext
props => !(props.overlayPositioningContext.width && props.overlayPositioningContext.height), renderNothing), _dec$1(_class$K = _dec2$1(_class$K = (_temp2$z = _class2$3 = class Overlay extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      boundingBoxPositions: [], // set in getDerivedStateFromProps
      focusedBoundingBoxId: null,
      stagedBoundingBoxPosition: {},
      userMinimizedConfirmMenu: false,
      userActingOnBoundingBox: false,
      drawingInitialBoundingBox: false
    }, this.handleResizeExistingBox = (e, direction, ref, delta, position) => {
      this.removeStagedBoundingBox();

      this.setState(state => {
        const focusedId = ref.getAttribute('data-boxid');
        const focusedIndex = _findIndex(state.boundingBoxPositions, {
          id: focusedId
        });

        state.boundingBoxPositions[focusedIndex].boundingPoly = _extends({
          width: ref.offsetWidth,
          height: ref.offsetHeight
        }, position);

        return _extends({}, state, {
          userActingOnBoundingBox: true
        });
      });
    }, this.handleResizeStagedBox = (e, direction, ref, delta, position) => {
      this.setState(state => ({
        userActingOnBoundingBox: true,
        stagedBoundingBoxPosition: _extends({}, state.stagedBoundingBoxPosition, {
          width: ref.offsetWidth,
          height: ref.offsetHeight
        }, position)
      }));
    }, this.handleResizeStagedBoxStop = () => {
      this.setState({
        userActingOnBoundingBox: false,
        userMinimizedConfirmMenu: false
      });
    }, this.handleResizeExistingBoxStop = (e, direction, ref, delta, position) => {
      const focusedId = ref.getAttribute('data-boxid');
      const focusedIndex = _findIndex(this.state.boundingBoxPositions, {
        id: focusedId
      });

      this.props.onChangeBoundingBox(_extends({}, this.state.boundingBoxPositions[focusedIndex], {
        boundingPoly: pixelXYWidthHeightToPercentagePoly(this.state.boundingBoxPositions[focusedIndex].boundingPoly, this.props.overlayPositioningContext.width, this.props.overlayPositioningContext.height)
      }));

      this.setState({
        userActingOnBoundingBox: false,
        userMinimizedConfirmMenu: false
      });
    }, this.handleDragStagedBox = (e, d) => {
      this.setState({ userActingOnBoundingBox: true });
    }, this.handleDragExistingBox = () => {
      this.removeStagedBoundingBox();

      this.setState({ userActingOnBoundingBox: true });
    }, this.handleDragExistingBoxStop = (e, { node, x, y }) => {
      const focusedId = node.getAttribute('data-boxid');
      const focusedIndex = _findIndex(this.state.boundingBoxPositions, {
        id: focusedId
      });

      const draggedObject = _extends({}, this.state.boundingBoxPositions[focusedIndex].boundingPoly, {
        x,
        y
      });

      this.props.onChangeBoundingBox(_extends({}, this.state.boundingBoxPositions[focusedIndex], {
        boundingPoly: pixelXYWidthHeightToPercentagePoly(draggedObject, this.props.overlayPositioningContext.width, this.props.overlayPositioningContext.height)
      }));

      this.setState({
        userActingOnBoundingBox: false,
        userMinimizedConfirmMenu: false
      });
    }, this.handleDragStagedBoxStop = (e, d) => {
      this.setState(state => ({
        stagedBoundingBoxPosition: _extends({}, state.stagedBoundingBoxPosition, {
          x: d.x,
          y: d.y
        }),
        userActingOnBoundingBox: false,
        userMinimizedConfirmMenu: false
      }));
    }, this.handleClickBox = e => {
      e.stopPropagation();

      // fixme: try to ignore clicks that are the result of mouseup after resize/drag
      const focusedId = e.target.getAttribute('data-boxid');

      // full read/add only
      if (this.props.readOnly || this.props.addOnly) {
        return;
      }

      // individual box marked as readonly
      const focusedIndex = _findIndex(this.state.boundingBoxPositions, {
        id: focusedId
      });
      if (_get(this.state.boundingBoxPositions[focusedIndex], 'readOnly')) {
        return;
      }

      this.removeStagedBoundingBox();

      this.setState(state => {
        return {
          focusedBoundingBoxId: focusedId ? focusedId : state.focusedBoundingBoxId
        };
      });
    }, this.confirmStagedBoundingBox = () => {
      if (this.hasStagedBoundingBox()) {
        const id = guid();
        this.props.onAddBoundingBox({
          boundingPoly: pixelXYWidthHeightToPercentagePoly(this.state.stagedBoundingBoxPosition, this.props.overlayPositioningContext.width, this.props.overlayPositioningContext.height),
          id: id
        });

        if (this.props.autofocus) {
          this.setState({ focusedBoundingBoxId: id });
        }

        this.removeStagedBoundingBox();
      }
    }, this.removeStagedBoundingBox = () => {
      // delete staged box
      this.setState({
        stagedBoundingBoxPosition: {}
      });
    }, this.minimizeConfirmMenu = () => {
      this.setState({ userMinimizedConfirmMenu: true });
    }, this.handleBackgroundMouseDown = e => {
      if (this.props.readOnly) {
        return;
      }

      if (this.state.drawingInitialBoundingBox) {
        // click while drawing; finish drawing
        // fixme -- separate logic
        this.handleBackgroundMouseUp();
        return;
      }

      // deal with dragging out an initial box on a blank canvas
      const { x: mouseX, y: mouseY } = getMousePosition(e);

      const largerContextDimension = Math.max(this.props.overlayPositioningContext.width, this.props.overlayPositioningContext.height);

      this.setState({
        drawingInitialBoundingBox: true,
        userActingOnBoundingBox: true,
        stagedBoundingBoxPosition: {
          x: mouseX,
          y: mouseY,
          // "one-click" box size. 10% of the larger of content width/height.
          width: largerContextDimension * 0.1,
          height: largerContextDimension * 0.1
        }
      });
    }, this.handleBackgroundMouseMove = e => {
      if (this.state.drawingInitialBoundingBox) {
        const { x: mouseX, y: mouseY } = getMousePosition(e);

        this.setState(state => {
          const width = mouseX - state.stagedBoundingBoxPosition.x;
          const height = mouseY - state.stagedBoundingBoxPosition.y;

          return {
            stagedBoundingBoxPosition: {
              // prevent weird behavior when box width is set to a negative value,
              // and don't allow boxes too small to interact with (~< 15px)
              width: width < 15 ? 15 : width,
              height: height < 15 ? 15 : height,
              x: state.stagedBoundingBoxPosition.x,
              y: state.stagedBoundingBoxPosition.y
            }
          };
        });
      }
    }, this.handleBackgroundMouseUp = () => {
      if (this.state.drawingInitialBoundingBox) {
        if (this.props.autoCommit) {
          this.confirmStagedBoundingBox();
        }

        this.setState({
          drawingInitialBoundingBox: false,
          userActingOnBoundingBox: false,
          userMinimizedConfirmMenu: false
        });
      }
    }, this.handleDelete = () => {
      this.props.onDeleteBoundingBox(this.state.focusedBoundingBoxId);

      this.setState({
        userActingOnBoundingBox: false,
        focusedBoundingBoxId: null
      });
    }, this.hasStagedBoundingBox = () => {
      return _isNumber(this.state.stagedBoundingBoxPosition.x) && _isNumber(this.state.stagedBoundingBoxPosition.y) && _isNumber(this.state.stagedBoundingBoxPosition.width) && _isNumber(this.state.stagedBoundingBoxPosition.height);
    }, _temp;
  }

  // memoize so we don't update/render on every video frame
  /* eslint-disable-next-line react/sort-comp */


  static getDerivedStateFromProps(props) {
    return {
      boundingBoxPositions: Overlay.mapPolysToInternalFormat(props.initialBoundingBoxPolys, props.overlayPositioningContext.width, props.overlayPositioningContext.height)
    };
  }


  render() {
    const { top, left, height, width } = this.props.overlayPositioningContext;

    const showingConfirmMenu = this.hasStagedBoundingBox() && !this.state.userActingOnBoundingBox && !this.state.userMinimizedConfirmMenu;

    const showingActionsMenu = _isString(this.state.focusedBoundingBoxId) && !this.state.userActingOnBoundingBox && !this.state.userMinimizedConfirmMenu && this.state.boundingBoxPositions.some(el => el.id === this.state.focusedBoundingBoxId);

    const boundingBoxCommonStyles = {
      // this seems to fix some rendering jank
      // (half of overlay would not render sometimes)
      willChange: 'left, top, width, height'
    };

    return React__default.createElement(
      'div',
      {
        style: _extends({
          position: 'absolute',
          overflow: 'hidden',
          top,
          left,
          height,
          width,
          pointerEvents: this.props.readOnly ? 'none' : 'auto'
        }, this.props.wrapperStyles)
      },
      this.state.boundingBoxPositions.map(({
        id,
        overlayObjectType,
        readOnly,
        boundingPoly: { x, y, width, height }
      }) => React__default.createElement(RndBox$1, {
        key: id,
        extendsProps: {
          'data-boxid': id,
          onClick: this.handleClickBox
        },
        style: _extends({}, boundingBoxCommonStyles, this.props.defaultBoundingBoxStyles, this.props.stylesByObjectType[overlayObjectType], {
          // do not let this box interfere with mouse events as we draw out
          // the initial bounding box
          pointerEvents: readOnly || this.props.readOnly || this.props.addOnly || this.state.drawingInitialBoundingBox ? 'none' : 'auto'
        }),
        size: { width, height },
        position: { x, y },
        onDragStop: this.handleDragExistingBoxStop,
        onDrag: this.handleDragExistingBox,
        onResize: this.handleResizeExistingBox,
        onResizeStop: this.handleResizeExistingBoxStop,
        disableDragging: readOnly || this.props.readOnly || this.props.addOnly,
        enableResizing: !readOnly && !this.props.readOnly && !this.props.addOnly && this.state.focusedBoundingBoxId === id ? undefined : false
      })),
      this.hasStagedBoundingBox() && !this.props.readOnly && React__default.createElement(RndBox$1, {
        style: _extends({}, boundingBoxCommonStyles, this.props.defaultBoundingBoxStyles, this.props.stagedBoundingBoxStyles, {
          // do not let this box interfere with mouse events as we draw it out
          pointerEvents: this.state.drawingInitialBoundingBox ? 'none' : 'auto'
        }),
        size: {
          width: this.state.stagedBoundingBoxPosition.width,
          height: this.state.stagedBoundingBoxPosition.height
        },
        position: {
          x: this.state.stagedBoundingBoxPosition.x,
          y: this.state.stagedBoundingBoxPosition.y
        },
        onDragStop: this.handleDragStagedBoxStop,
        onDrag: this.handleDragStagedBox,
        onResize: this.handleResizeStagedBox,
        onResizeStop: this.handleResizeStagedBoxStop,
        enableResizing:
        // don't show handles during initial drag placement
        this.state.drawingInitialBoundingBox ? false : undefined
      }),
      showingConfirmMenu && !this.props.readOnly && React__default.createElement(OverlayConfirmMenu, {
        visible: showingConfirmMenu,
        confirmLabel: this.props.confirmLabel,
        onConfirm: this.confirmStagedBoundingBox,
        onCancel: this.removeStagedBoundingBox,
        onMinimize: this.minimizeConfirmMenu,
        bottomOffset: this.props.toolBarOffset
      }),
      showingActionsMenu && !this.props.addOnly && !this.props.readOnly && React__default.createElement(OverlayActionsMenu, {
        visible: showingActionsMenu,
        onMinimize: this.minimizeConfirmMenu,
        menuItems: this.props.actionMenuItems,
        onDelete: this.handleDelete
        // onConfirm={this.handleConfirmChange}
        , bottomOffset: this.props.toolBarOffset,
        focusedBoundingBoxId: this.state.focusedBoundingBoxId
      }),
      React__default.createElement('div', {
        style: {
          width: '100%',
          height: '100%',
          cursor: this.props.readOnly ? 'auto' : 'crosshair'
        },
        onMouseDown: this.handleBackgroundMouseDown,
        onMouseUp: this.handleBackgroundMouseUp,
        onMouseMove: this.handleBackgroundMouseMove
      })
    );
  }
}, _class2$3.propTypes = {
  confirmLabel: string,
  readOnly: bool,
  addOnly: bool,
  autoCommit: bool,
  overlayPositioningContext: shape$1({
    top: number.isRequired,
    left: number.isRequired,
    width: number.isRequired,
    height: number.isRequired
  }).isRequired,
  wrapperStyles: objectOf(any),
  defaultBoundingBoxStyles: objectOf(any),
  stagedBoundingBoxStyles: objectOf(any),
  stylesByObjectType: objectOf(objectOf(any)),
  toolBarOffset: number,
  onAddBoundingBox: func.isRequired,
  onDeleteBoundingBox: func.isRequired,
  onChangeBoundingBox: func.isRequired,
  initialBoundingBoxPolys: arrayOf(shape$1({
    // unique ID
    id: string.isRequired,
    // optional type for styles + future stuff maybe
    // (corresponds to props.stylesByObjectType)
    overlayObjectType: string,
    readOnly: bool,
    // vertices
    boundingPoly: arrayOf(shape$1({
      x: number.isRequired,
      y: number.isRequired
    }).isRequired).isRequired
  })),
  actionMenuItems: arrayOf(shape$1({
    label: string.isRequired,
    onClick: func.isRequired
  })),
  autofocus: bool
}, _class2$3.defaultProps = {
  confirmLabel: 'Add',
  readOnly: false,
  addOnly: false,
  initialBoundingBoxPolys: [],
  toolBarOffset: 0,
  stagedBoundingBoxStyles: {},
  stylesByObjectType: {},
  defaultBoundingBoxStyles: {
    backgroundColor: 'rgba(255,100,100, .5)',
    border: '1px solid #fff'
  }
}, _class2$3.mapPolysToInternalFormat = index$a((polys, width, height) => polys.map((_ref) => {
  let { boundingPoly } = _ref,
      rest = objectWithoutProperties(_ref, ['boundingPoly']);
  return _extends({
    boundingPoly: percentagePolyToPixelXYWidthHeight(boundingPoly, width, height)
  }, rest);
}), _isEqual), _temp2$z)) || _class$K) || _class$K);
Overlay.displayName = 'Overlay';

var styles$S = {
  statusPill: {
    height: 20,
    width: 'fit-content',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    '& $statusPillText': {
      fontSize: 10,
      fontWeight: 'bold',
      lineHeight: '11px',
      padding: '4px 8px',
      textTransform: 'uppercase'
    }
  },
  statusPillText: {}
};

var _class$L, _temp$c;

const white = '#FFFFFF';
const stateStyles = {
  active: {
    backgroundColor: green$1['A700'],
    color: white
  },
  inactive: {
    backgroundColor: grey$1[500],
    color: white
  },
  paused: {
    backgroundColor: white,
    border: `1px solid ${blueGrey[500]}`,
    color: blueGrey[500]
  },
  processing: {
    backgroundColor: blue$1[500],
    color: white
  }
};

let StatusPill = (_temp$c = _class$L = class StatusPill extends React__default.Component {

  render() {
    const pillStyles = stateStyles[this.props.status || 'processing'];
    const { classes } = this.props;

    return React__default.createElement(
      Lozenge,
      {
        backgroundColor: pillStyles.backgroundColor,
        textColor: pillStyles.color,
        border: pillStyles.border,
        className: classes.statusPill,
        'data-test': 'statusPill'
      },
      React__default.createElement(
        'span',
        { className: classes.statusPillText, 'data-test': 'statusPillText' },
        this.props.status
      )
    );
  }
}, _class$L.propTypes = {
  status: string,
  classes: shape$1({ any })
}, _class$L.defaultProps = {
  status: 'processing'
}, _temp$c);
StatusPill.displayName = 'StatusPill';


var index$b = withStyles$1(styles$S)(StatusPill);

const titleText$1 = muiText('title');

var styles$T = {
  modalHeader: {
    backgroundColor: '#1f2532',
    '& span': {
      color: grey1
    }
  },
  fullScreenTopBar: {
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& $topBarTitle': _extends({}, titleText$1, {
      color: grey1,
      alignSelf: 'center'
    }),
    '& $iconGroup': {
      display: 'flex',
      justifyContent: 'space-between',
      alignSelf: 'center'
    }
  },
  icon: {
    color: fullWhite
  },
  topBarTitle: {},
  iconGroup: {}
};

var _class$M, _temp$d;

let ModalHeader = (_temp$d = _class$M = class ModalHeader extends React__default.Component {

  render() {
    const { classes } = this.props;
    return React__default.createElement(
      'div',
      { className: classes.modalHeader },
      React__default.createElement(
        'div',
        { className: classes.fullScreenTopBar },
        React__default.createElement(
          'span',
          { className: classes.topBarTitle },
          this.props.title
        ),
        React__default.createElement(
          'div',
          { className: classes.iconGroup },
          this.props.icons
        )
      ),
      React__default.createElement(
        'div',
        null,
        this.props.children
      )
    );
  }
}, _class$M.propTypes = {
  children: node,
  title: string,
  icons: arrayOf(element),
  classes: shape$1({ any })
}, _class$M.defaultProps = {
  icons: []
}, _temp$d);
ModalHeader.displayName = 'ModalHeader';


var index$c = withStyles$1(styles$T)(ModalHeader);

var styles$U = {
  condensedButton: {
    paddingLeft: '0 !important',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    backgroundColor: `${barelyBlack} !important`,
    '&:hover:not([disabled]):not($selected)': {
      backgroundColor: 'rgba(33, 150, 243, 0.1) !important'
    }
  },
  selected: {
    borderColor: `${blue400} !important`,
    backgroundColor: 'rgba(33, 150, 243, 0.18) !important',
    '&:hover': {
      backgroundColor: 'unset !important'
    }
  },
  condensed: {
    height: '1.7em !important'
  }
};

const useStyles$g = makeStyles(styles$U);

function SelectionButton(props) {
  const classes = useStyles$g();
  return React__default.createElement(
    Button$2,
    {
      className: cx$1([classes.condensedButton, { [classes.selected]: props.selected }]),
      variant: 'outlined',
      onClick: props.toggleSelection
    },
    React__default.createElement(Radio$1, {
      classes: { root: classes.condensed },
      className: classes.condensed,
      color: 'primary',
      checked: props.selected,
      onChange: props.toggleSelection
    }),
    props.children
  );
}

SelectionButton.displayName = 'SelectionButton';
SelectionButton.propTypes = {
  selected: bool,
  toggleSelection: func,
  children: node
};

var _class$N, _temp2$A;

let RestartMediaButton = (_temp2$A = _class$N = class RestartMediaButton extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleClick = () => {
      if (this.props.actions) {
        this.props.actions.seek(0);
      }
    }, _temp;
  }

  render() {
    return React__default.createElement('button', {
      className: cx$1(this.props.className, 'video-react-control', 'video-react-button', 'video-react-icon', 'video-react-icon-skip-previous'),
      onClick: this.handleClick,
      type: 'button'
    });
  }
}, _class$N.propTypes = {
  actions: shape$1({
    seek: func.isRequired
  }),
  className: string
}, _temp2$A);
RestartMediaButton.displayName = 'RestartMediaButton';

var _class$O, _temp2$B;

let VideoSource = (_temp2$B = _class$O = class VideoSource extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      src: null
    }, _temp;
  }

  UNSAFE_componentWillMount() {
    shaka.polyfill.installAll();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { video, src, streams, disablePreload } = nextProps;
    const dashUri = this.getStreamUri(streams, 'dash');
    const hlsUri = this.getStreamUri(streams, 'hls');
    const streamUri = dashUri || hlsUri;
    // check if browser supports playing hls & dash with shaka player
    const browserSupportsShaka = shaka.Player.isBrowserSupported();
    let sourceUri;
    if (video && streamUri && browserSupportsShaka) {
      if (streamUri === this.state.streamUri) {
        // media already loaded
        return;
      }
      if (!this.player) {
        this.player = new shaka.Player(video);
        //TODO if session cookie is not available, will need to set Authorization header on request using auth token
        if (_includes(streamUri, 'veritone.com/media-streamer/stream') || _includes(streamUri, 'veritone.com/v3/stream/')) {
          this.player.getNetworkingEngine().registerRequestFilter(function (type, request) {
            if (type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
              request.allowCrossSiteCredentials = true;
            }
          });
        }
      }
      if (disablePreload) {
        video.onplay = () => {
          video.onplay = null;
          this.player.load(streamUri).then(() => {
            video.play();
            return;
          }).catch(err => {
            console.log('error loading video with shaka player', err);
          });
        };
      } else {
        this.player.load(streamUri).catch(err => {
          console.log('error loading video with shaka player', err);
        });
      }
      this.setState({
        streamUri: streamUri
      });
    } else if (hlsUri && video.canPlayType('application/vnd.apple.mpegurl')) {
      // iOS does not work with the shaka-player. check if browser has native HLS support,
      // if it does then set src to HLS manifest (primarily for safari on iOS)
      sourceUri = hlsUri;
    } else {
      sourceUri = src;
    }
    if (sourceUri && sourceUri !== this.state.src) {
      this.setState({
        src: sourceUri
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { video, disablePreload } = this.props;
    if (!disablePreload && video && this.state.src && this.state.src !== prevState.src) {
      video.load();
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.unload();
    }
  }

  getStreamUri(streams, protocol) {
    const stream = _find(streams, { protocol });
    return _get(stream, 'uri');
  }

  render() {
    return this.state.src && React__default.createElement('source', { src: this.state.src });
  }
}, _class$O.propTypes = {
  video: shape$1({
    canPlayType: func.isRequired,
    load: func.isRequired
  }),
  src: string,
  streams: arrayOf(shape$1({
    protocol: string.isRequired,
    uri: string.isRequired
  })),
  disablePreload: bool
}, _temp2$B);
VideoSource.displayName = 'VideoSource';

function getPolysForTime(series, timeMs) {
  return series.filter(({ startTimeMs, stopTimeMs }) => startTimeMs <= timeMs && timeMs <= stopTimeMs).map(({ object }) => object);
}

var styles$V = {
  '@global': {
    '.video-react': {
      '@global': {
        '.video-react-big-play-button.video-react-big-play-button-center': {
          top: '50%',
          left: '50%',
          marginLeft: '-0.75em !important',
          marginTop: '-0.75em !important',
          height: '1.5em',
          width: '1.5em',
          borderRadius: '1em',
          border: 'none'
        },
        '.video-react-poster': {
          backgroundSize: 'cover !important'
        }
      },
      '& .video-react-control-bar': {
        backgroundColor: 'black',
        fontFamily: 'Roboto, sans-serif',
        outline: 'none !important'
      },
      '& .video-react-control': {
        width: '3em'
      },
      '& .video-react-time-control': {
        paddingLeft: '0.5em',
        paddingRight: '0.5em'
      },
      '& .video-react-control-text, .video-react-mouse-display, .video-react-mouse-display::after, .video-react-play-progress::after': {
        fontFamily: 'Roboto !important'
      },
      '& .video-react-slider:focus': {
        textShadow: 'none',
        boxShadow: 'none'
      }
    }
  }
};

var _class$P, _temp2$C;

let MediaPlayerComponent = (_temp2$C = _class$P = class MediaPlayerComponent extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.handleAddBoundingBox = newBox => {
      this.props.onAddBoundingBox(newBox, this.props.currentTime * 1000);
    }, _temp;
  }

  componentDidMount() {
    if (this.props.onPlayerRefReady) {
      const playerRef = _get(this.props.myForwardedRef, 'current');
      if (playerRef) {
        this.props.onPlayerRefReady(playerRef);
      }
    }
  }

  render() {
    const _props = this.props,
          {
      src,
      streams,
      overlayContentClassName,
      reactPlayerClassName,
      useOverlayControlBar,
      isFullscreen,
      btnRestart,
      btnReplay,
      btnForward,
      btnPlayToggle,
      btnVolume,
      btnFullscreenToggle,
      ctrlProgress,
      displayTime,
      autoHide,
      autoHideTime,
      classes
    } = _props,
          props = objectWithoutProperties(_props, ['src', 'streams', 'overlayContentClassName', 'reactPlayerClassName', 'useOverlayControlBar', 'isFullscreen', 'btnRestart', 'btnReplay', 'btnForward', 'btnPlayToggle', 'btnVolume', 'btnFullscreenToggle', 'ctrlProgress', 'displayTime', 'autoHide', 'autoHideTime', 'classes']);

    const currentPolys = getPolysForTime(this.props.boundingPolySeries || [], this.props.currentTime * 1000);

    return React__default.createElement(
      OverlayPositioningProvider$1,
      {
        contentHeight: this.props.videoHeight,
        contentWidth: this.props.videoWidth,
        fixedWidth: !props.fluid,
        contentClassName: overlayContentClassName
      },
      this.props.hasStarted && React__default.createElement(Overlay, {
        wrapperStyles: { zIndex: 100 },
        onAddBoundingBox: this.handleAddBoundingBox,
        onDeleteBoundingBox: this.props.onDeleteBoundingBox,
        onChangeBoundingBox: this.props.onChangeBoundingBox,
        initialBoundingBoxPolys: this.props.boundingPolySeries ? currentPolys : undefined,
        actionMenuItems: this.props.actionMenuItems,
        addOnly: this.props.addOnly,
        readOnly: this.props.readOnly || !this.props.paused,
        autoCommit: this.props.autoCommit,
        stagedBoundingBoxStyles: props.stagedBoundingBoxStyles,
        stylesByObjectType: props.stylesByObjectType,
        defaultBoundingBoxStyles: props.defaultBoundingBoxStyles,
        autofocus: props.autofocus
      }),
      React__default.createElement(
        Player,
        _extends({
          className: cx$1(classes.mediaPlayer, reactPlayerClassName),
          ref: this.props.myForwardedRef,
          store: this.context.store
        }, props),
        React__default.createElement(
          ControlBar,
          {
            className: cx$1('video-react', classes.mediaPlayerControls),
            autoHide: autoHide,
            autoHideTime: autoHideTime,
            disableDefaultControls: true,
            disableCompletely: !useOverlayControlBar && !isFullscreen
          },
          btnRestart && React__default.createElement(RestartMediaButton, { order: 1.1 }),
          btnReplay && React__default.createElement(ReplayControl, { seconds: 10, order: 1.2 }),
          btnForward && React__default.createElement(ForwardControl, { seconds: 10, order: 1.3 }),
          btnPlayToggle && React__default.createElement(PlayToggle, { order: 2 }),
          displayTime && React__default.createElement(CurrentTimeDisplay, { order: 3.1 }),
          displayTime && React__default.createElement(TimeDivider, { order: 3.2 }),
          displayTime && React__default.createElement(DurationDisplay, { order: 3.3 }),
          ctrlProgress && React__default.createElement(ProgressControl, { order: 6 }),
          btnVolume && React__default.createElement(VolumeMenuButton, { vertical: ctrlProgress, order: 7 }),
          btnFullscreenToggle && React__default.createElement(FullscreenToggle, { order: 8 })
        ),
        React__default.createElement(VideoSource, {
          isVideoChild: true,
          src: src,
          streams: streams,
          disablePreload: props.preload === 'none' ? true : false
        }),
        React__default.createElement(BigPlayButton, { position: 'center', className: classes.mediaPlayButton })
      )
    );
  }
}, _class$P.propTypes = {
  src: string,
  streams: arrayOf(shape$1({
    protocol: string,
    uri: string
  })),
  overlayContentClassName: string,
  reactPlayerClassName: string,
  boundingPolySeries: arrayOf(shape$1({
    startTimeMs: number.isRequired,
    stopTimeMs: number.isRequired,
    object: shape$1({
      id: string.isRequired,
      overlayObjectType: string,
      boundingPoly: arrayOf(shape$1({ x: number.isRequired, y: number.isRequired })).isRequired
    })
  })),
  onAddBoundingBox: func,
  onDeleteBoundingBox: func,
  onChangeBoundingBox: func,
  onPlayerRefReady: func,

  defaultBoundingBoxStyles: objectOf(any),
  stagedBoundingBoxStyles: objectOf(any),
  stylesByObjectType: objectOf(objectOf(any)),

  actionMenuItems: arrayOf(shape$1({
    label: string.isRequired,
    onClick: func.isRequired
  })),
  readOnly: bool,
  addOnly: bool,
  autoCommit: bool,
  width: oneOfType([string, number]),
  height: oneOfType([string, number]),
  // fluid = 100% width by default, see video-react docs
  fluid: bool,
  videoHeight: number,
  videoWidth: number,
  hasStarted: bool,
  isActive: bool,
  paused: bool,
  currentTime: number,
  autofocus: bool,
  myForwardedRef: objectOf(any),
  useOverlayControlBar: bool,
  isFullscreen: bool,
  btnRestart: bool,
  btnReplay: bool,
  btnForward: bool,
  btnPlayToggle: bool,
  btnVolume: bool,
  btnFullscreenToggle: bool,
  ctrlProgress: bool,
  displayTime: bool,
  autoHide: bool,
  autoHideTime: number,
  classes: shape$1({ any })
}, _class$P.contextTypes = {
  // need to pass our app's redux store to the Player, or else it will create
  // its own internal store that we can't integrate with
  store: object
}, _class$P.defaultProps = {
  fluid: true,
  onAddBoundingBox: _noop,
  onDeleteBoundingBox: _noop,
  onChangeBoundingBox: _noop,
  useOverlayControlBar: false,
  btnRestart: true,
  btnReplay: true,
  btnForward: true,
  btnPlayToggle: true,
  btnVolume: true,
  btnFullscreenToggle: true,
  ctrlProgress: true,
  displayTime: true,
  autoHide: true,
  autoHideTime: 1000
}, _temp2$C);
MediaPlayerComponent.displayName = 'MediaPlayerComponent';


var MediaPlayerComponent$1 = withStyles$1(styles$V)(MediaPlayerComponent);

const iconSize = 24;
const buttonSize = 48;
const transitionTime = '0.2s';

var styles$W = {
  lightbox: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: `opacity ${transitionTime}`,
    '&$open': {
      opacity: 1,
      display: 'flex'
    },
    '&$hidden': {
      display: 'none'
    },
    '&$fullscreen': {
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
      position: 'absolute'
    },
    '& > $background': {
      width: '100%',
      height: '100%',
      position: 'absolute',
      backgroundColor: lightBlack
    },
    '& > $content': {
      width: 'fit-content',
      height: 'fit-content',
      position: 'relative',
      boxShadow: '0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)',
      '& > $closeButton': {
        top: -buttonSize / 2 + iconSize / 8,
        right: -buttonSize / 2 + iconSize / 8,
        position: 'absolute',
        '& $closeButtonIcon': {
          borderRadius: iconSize / 2,
          color: fullBlack,
          backgroundColor: fullWhite,
          opacity: 0.6,
          transition: `opacity ${transitionTime}`
        },
        '&:hover $closeButtonIcon': {
          opacity: 1
        }
      }
    }
  },
  open: {},
  hidden: {},
  fullscreen: {},
  background: {},
  content: {},
  closeButton: {},
  closeButtonIcon: {}
};

var _class$Q, _temp2$D;

let Lightbox = (_temp2$D = _class$Q = class Lightbox extends Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      hidden: false,
      open: this.props.open
    }, this.setVisibility = visible => {
      if (!visible) {
        const { data, onClose } = this.props;
        this.setState({ open: false });
        setTimeout(() => {
          this.setState({ hidden: true });
          onClose && onClose(data);
        }, 200);
      } else {
        this.setState({ hidden: false });
        setTimeout(() => {
          this.setState({ open: true });
        }, 50);
      }
    }, this.handleBackdropClick = event => {
      const {
        data,
        onBackdropClick,
        selfClosing,
        closeOnBackdropClick
      } = this.props;

      onBackdropClick && onBackdropClick(event, data);
      selfClosing && closeOnBackdropClick && this.setVisibility(false);
    }, this.handleCloseButtonClick = event => {
      const { data, selfClosing, onCloseButtonClick } = this.props;

      onCloseButtonClick && onCloseButtonClick(event, data);
      selfClosing && this.setVisibility(false);
    }, _temp;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    nextProps.open !== this.props.open && this.setVisibility(nextProps.open);
  }

  render() {
    const {
      children,
      fullscreen,
      closeButton,
      className,
      buttonClassName,
      contentClassName,
      classes
    } = this.props;

    return React__default.createElement(
      'div',
      {
        className: cx$1(classes.lightbox, className, {
          [classes.open]: this.state.open,
          [classes.hidden]: this.state.hidden,
          [classes.fullscreen]: fullscreen
        }),
        'data-test': cx$1({
          open: this.state.open,
          hidden: this.state.hidden
        })
      },
      React__default.createElement('div', {
        className: cx$1(classes.background),
        onClick: this.handleBackdropClick,
        'data-test': 'background'
      }),
      React__default.createElement(
        'div',
        { className: cx$1(classes.content, contentClassName) },
        cloneElement(children),
        closeButton && React__default.createElement(
          IconButton$2,
          {
            'aria-label': 'Close',
            onClick: this.handleCloseButtonClick,
            className: cx$1(classes.closeButton, buttonClassName)
          },
          React__default.createElement(Cancel, { className: cx$1(classes.closeButtonIcon) })
        )
      )
    );
  }
}, _class$Q.propTypes = {
  open: bool,
  fullscreen: bool,
  closeButton: bool,
  selfClosing: bool,
  closeOnBackdropClick: bool,
  onClose: func,
  onBackdropClick: func,
  onCloseButtonClick: func,
  children: node.isRequired,
  className: string,
  buttonClassName: string,
  contentClassName: string,
  data: objectOf(any),
  classes: shape$1({ any })
}, _class$Q.defaultProps = {
  open: true,
  fullscreen: true,
  closeButton: true,
  selfClosing: true,
  closeOnBackdropClick: true
}, _temp2$D);
Lightbox.displayName = 'Lightbox';


var index$d = withStyles$1(styles$W)(Lightbox);

function createSvgIcon$1(path, displayName) {
  var Component = React__default.memo(React__default.forwardRef(function (props, ref) {
    return React__default.createElement(SvgIcon$2, _extends$1({
      ref: ref
    }, props), path);
  }));

  Component.muiName = SvgIcon$2.muiName;
  return Component;
}

var AddCircleOutline = createSvgIcon$1(React__default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}));

var CardTravel = createSvgIcon$1(React__default.createElement("path", {
  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
}));

var ChevronRight = createSvgIcon$1(React__default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));

var Clear = createSvgIcon$1(React__default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));

var CloudUploadOutlined = createSvgIcon$1(React__default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
}));

var DeleteOutlined = createSvgIcon$1(React__default.createElement("path", {
  d: "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
}));

var DragHandleOutlined = createSvgIcon$1(React__default.createElement("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}));

var MoreHoriz = createSvgIcon$1(React__default.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}));

var Search = createSvgIcon$1(React__default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}));

var Work = createSvgIcon$1(React__default.createElement("path", {
  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
}));

var styles$X = {
  aside: {
    width: 220,
    padding: '10px !important',
    backgroundColor: '#E8EAED',
    display: 'flex',
    flexFlow: 'column',
    position: 'relative',
    zIndex: 10,
    height: '100%'
  },
  navigationItem: {
    padding: '8px 10px !important',
    borderRadius: '0 20px 20px 0 !important',
    '& .icon, svg': {
      color: '#616e7b',
      marginRight: 0,
      fontSize: 20
    },
    '& span': {
      fontSize: 14,
      color: '#616e7b'
    }
  },
  icon: {
    color: '#616e7b',
    marginRight: 0,
    fontSize: 20
  },
  spacer: {
    flexGrow: 1
  },
  divider: {
    marginTop: 16,
    marginBottom: 20,
    marginLeft: 12,
    marginRight: 8
  },
  selected: {
    background: '#cfdfed !important',
    '& *, span': {
      color: '#1767D2'
    }
  },
  uploadButton: {
    border: '1px solid #2196F3 !important',
    width: 'auto !important',
    alignSelf: 'center',
    padding: '8px !important',
    '& svg': {
      color: '#2196F3 !important',
      margin: '0 !important',
      marginLeft: '8px !important'
    },
    '& div': {
      '& span': {
        color: '#2196F3 !important'
      }
    }
  }
};

const useStyles$h = makeStyles(styles$X);
const LeftNavigationPanel = ({
  availablePickerTypes,
  currentPickerType,
  toggleContentView
}) => {
  const classes = useStyles$h();
  const navMap = {
    folder: React__default.createElement(
      ListItem$2
      /* eslint-disable react/jsx-no-bind */
      ,
      { onClick: () => toggleContentView('folder'),
        className: cx$1({ [classes.selected]: currentPickerType === 'folder' }, classes['navigationItem']),
        button: true
      },
      React__default.createElement(
        ListItemIcon,
        null,
        React__default.createElement(CardTravel, null)
      ),
      React__default.createElement(
        ListItemText$2,
        null,
        'My Files'
      )
    ),
    stream: React__default.createElement(
      ListItem$2
      /* eslint-disable react/jsx-no-bind */
      ,
      { onClick: () => toggleContentView('stream'),
        className: cx$1({ [classes.selected]: currentPickerType === 'stream' }, classes['navigationItem']),
        button: true
      },
      React__default.createElement(
        ListItemIcon,
        { className: cx$1(classes['icon']) },
        React__default.createElement('div', { className: 'icon-streams' })
      ),
      React__default.createElement(
        ListItemText$2,
        null,
        'Stream'
      )
    ),
    upload: React__default.createElement(
      ListItem$2
      /* eslint-disable react/jsx-no-bind */
      ,
      { onClick: () => toggleContentView('upload'),
        className: cx$1({ [classes.selected]: currentPickerType === 'upload' }, classes['navigationItem']),
        button: true
      },
      React__default.createElement(
        ListItemIcon,
        null,
        React__default.createElement(CloudUploadOutlined, null)
      ),
      React__default.createElement(
        ListItemText$2,
        null,
        'New Upload'
      )
    )
  };

  return React__default.createElement(
    Paper,
    null,
    React__default.createElement(
      List$2,
      { component: 'nav', className: classes.aside },
      availablePickerTypes.map(pickerType => React__default.createElement(
        'div',
        { key: `navigation-btn-${pickerType}` },
        navMap[pickerType]
      ))
    )
  );
};

LeftNavigationPanel.displayName = 'LeftNavigationPanel';
LeftNavigationPanel.propTypes = {
  availablePickerTypes: arrayOf(string).isRequired,
  currentPickerType: oneOf(['folder', 'stream', 'upload']),
  toggleContentView: func.isRequired
};

const styles$Y = {
  infinteWrapper: {
    height: '100%',
    overflowY: 'auto'
  },
  loadingHidden: {
    opacity: 0
  },
  loadingContainer: {
    minHeight: 80,
    display: 'flex',
    justifyContent: 'center'
  }
};

const useStyles$i = makeStyles(styles$Y);

function InfiniteLoaderWrapper({
  isLoading,
  threshold,
  triggerPagination,
  classes,
  children,
  loadingComponent
}) {
  const muiClasses = useStyles$i();
  const containerRef = useRef(null);
  // const getViewWindow = () => {
  //   const boundingClient = containerRef.current.getBoundingClientRect();
  //   return {
  //     top: boundingClient.top,
  //     bottom: boundingClient.bottom
  //   }
  // }
  const debouncedTriggerPagination = _debounce(triggerPagination, 1000);
  const onScroll = () => {
    const container = containerRef.current;
    if (!isLoading && container) {
      if (container.scrollTop + container.clientHeight > container.scrollHeight - threshold) {
        // UX improvement: Go to end of container
        container.scrollTop = container.scrollTop + threshold;
        debouncedTriggerPagination();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll, true);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return React__default.createElement(
    'div',
    { className: cx$1(muiClasses['infinteWrapper'], classes.container), ref: containerRef },
    children,
    React__default.createElement(
      'div',
      { className: muiClasses['loadingContainer'] },
      isLoading && loadingComponent
    )
  );
}

InfiniteLoaderWrapper.displayName = 'InfiniteLoaderWrapper';
InfiniteLoaderWrapper.propTypes = {
  isLoading: bool,
  threshold: number,
  classes: objectOf(string),
  loadingComponent: node,
  triggerPagination: func,
  children: oneOfType([arrayOf(node), node])
};

InfiniteLoaderWrapper.defaultProps = {
  threshold: 80,
  classes: {},
  loadingComponent: React__default.createElement(
    'div',
    { style: {
        minHeight: 80,
        display: 'flex',
        justifyContent: 'center'
      } },
    React__default.createElement(CircularProgress$2, { size: 50 })
  )
};

var styles$Z = {
  nullStateView: {
    paddingTop: '25vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& $titleText': {
      color: darkBlack,
      fontSize: 20,
      fontWeight: 300,
      lineHeight: '24px',
      marginBottom: 10
    },
    '& $buttonStyle': {
      marginTop: 20,
      width: 'fit-content',
      height: 36
    }
  },
  inWidgetView: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column',
    '& $titleText': {
      color: darkBlack,
      fontSize: 20,
      fontWeight: 300,
      lineHeight: '24px',
      marginBottom: 10
    },

    '& $buttonStyle': {
      marginTop: 20,
      width: 'fit-content',
      height: 36
    }
  },
  titleText: {},
  buttonStyle: {}
};

const useStyles$j = makeStyles(styles$Z);

const NullState = ({ imgProps, titleText, btnProps, children, inWidgets }) => {
  const classes = useStyles$j();
  const containerClassName = inWidgets ? classes.inWidgetView : classes.nullStateView;

  return React__default.createElement(
    'div',
    { className: containerClassName },
    imgProps && React__default.createElement('img', imgProps),
    titleText && React__default.createElement(
      'div',
      { className: classes.titleText },
      titleText
    ),
    children,
    btnProps && React__default.createElement(
      Button$2,
      {
        className: classes.buttonStyle,
        variant: 'contained',
        color: 'primary',
        onClick: btnProps.onClick
      },
      btnProps.text
    )
  );
};

NullState.displayName = 'NullState';
NullState.propTypes = {
  imgProps: shape$1({
    src: string.isRequired,
    alt: string
  }),
  titleText: string,
  btnProps: shape$1({
    onClick: func.isRequired,
    text: string.isRequired
  }),
  children: node,
  inWidgets: bool
};

var PropTypes$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;



var _propTypes2 = _interopRequireDefault(PropTypes__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);
});

unwrapExports(PropTypes$1);
var PropTypes_1$1 = PropTypes$1.classNamesShape;
var PropTypes_2$1 = PropTypes$1.timeoutsShape;
var PropTypes_3 = PropTypes$1.transitionTimeout;

var Transition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;



var PropTypes = _interopRequireWildcard(PropTypes__default);



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(ReactDOM__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;
});

unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING;
var Transition_3 = Transition_1.ENTERED;
var Transition_4 = Transition_1.ENTERING;
var Transition_5 = Transition_1.EXITED;
var Transition_6 = Transition_1.UNMOUNTED;

var CSSTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var PropTypes = _interopRequireWildcard(PropTypes__default);



var _addClass2 = _interopRequireDefault(addClass_1);



var _removeClass2 = _interopRequireDefault(removeClass);



var _react2 = _interopRequireDefault(React__default);



var _Transition2 = _interopRequireDefault(Transition_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: PropTypes$1.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass$1(node, className);
    activeClassName && removeClass$1(node, activeClassName);
    doneClassName && removeClass$1(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  {};

exports.default = CSSTransition;
module.exports = exports['default'];
});

unwrapExports(CSSTransition_1);

var ChildMapping$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, React__default.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React__default.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}
});

unwrapExports(ChildMapping$1);
var ChildMapping_1$1 = ChildMapping$1.getChildMapping;
var ChildMapping_2$1 = ChildMapping$1.mergeChildMappings;

var TransitionGroup_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _react2 = _interopRequireDefault(React__default);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disables exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      children: (0, ChildMapping$1.getChildMapping)(props.children, function (child) {
        return (0, React__default.cloneElement)(child, {
          onExited: _this.handleExited.bind(_this, child),
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, ChildMapping$1.getChildMapping)(nextProps.children);

    var children = (0, ChildMapping$1.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, React__default.isValidElement)(child)) return;

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, React__default.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, React__default.cloneElement)(child, {
          onExited: _this2.handleExited.bind(_this2, child),
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, React__default.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, React__default.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, React__default.cloneElement)(child, {
              onExited: _this2.handleExited.bind(_this2, child),
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, ChildMapping$1.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];
});

unwrapExports(TransitionGroup_1$1);

var ReplaceTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _propTypes2 = _interopRequireDefault(PropTypes__default);



var _react2 = _interopRequireDefault(React__default);





var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, ReactDOM__default.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  {};

exports.default = ReplaceTransition;
module.exports = exports['default'];
});

unwrapExports(ReplaceTransition_1);

var reactTransitionGroup = createCommonjsModule(function (module) {



var _CSSTransition2 = _interopRequireDefault(CSSTransition_1);



var _ReplaceTransition2 = _interopRequireDefault(ReplaceTransition_1);



var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1$1);



var _Transition2 = _interopRequireDefault(Transition_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};
});

unwrapExports(reactTransitionGroup);
var reactTransitionGroup_1 = reactTransitionGroup.Transition;
var reactTransitionGroup_2 = reactTransitionGroup.TransitionGroup;
var reactTransitionGroup_3 = reactTransitionGroup.ReplaceTransition;
var reactTransitionGroup_4 = reactTransitionGroup.CSSTransition;

var styles$_ = {
  mediaPanelContainer: {
    flexBasis: 0,
    transition: 'flex-basis 500ms',
    backgroundColor: '#f4fafe',
    overflow: 'hidden',
    flexShrink: 0,
    zIndex: 1,
    padding: 20,
    borderLeft: `1px solid ${grey4}`
  },
  mediaInfoContainer: {
    padding: 0,
    display: 'flex',
    flexFlow: 'column',
    maxHeight: '100%',
    alignContent: 'flex-start'
  },
  tableContainer: {
    marginTop: '1rem'
  },
  tableRow: {
    height: '1.5rem !important',
    borderBottom: '0 !important'
  },
  tableCell: {
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0,
    borderBottom: '0 !important'
  },
  tableFirstColumn: {
    padding: '0 !important',
    paddingLeft: '0.5rem',
    fontSize: 14,
    color: minBlack
  },
  tdoName: {
    textAlign: 'center',
    marginTop: '1rem !important',
    fontSize: '18px !important',
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  },
  iconInfo: {
    fontSize: '200px !important',
    alignSelf: 'center',
    color: blue1
  },
  imagePreview: {
    maxHeight: 300,
    objectFit: 'contain'
  },
  infoDetails: {
    paddingLeft: 16,
    paddingRight: 16
  },
  mediaInfoBtnContainer: {
    display: 'flex',
    flexDirection: 'row-reverse'
  }
};

const useStyles$k = makeStyles(styles$_);
// eslint-disable-next-line react/display-name
const MediaPlayer = React__default.forwardRef((props, ref) => React__default.createElement(MediaPlayerComponent$1, _extends({}, props, { forwardedRef: ref })));

const tdoShape = shape$1({
  name: string.isRequired,
  startDateTime: string,
  stopDateTime: string,
  thumbnailUrl: string,
  sourceImageUrl: string,
  primaryAsset: shape$1({
    id: string,
    contentType: string,
    signedUri: string
  }),
  streams: arrayOf(shape$1({
    uri: string,
    protocol: string
  })),
  createdDateTime: string.isRequired,
  modifiedDateTime: string.isRequired,
  childNode: node
});

const formatDateString = date => {
  return format(parseISO(date), 'dddd, MMM d, yyyy [at] h:mm a..aaa');
};

const getDuration = (startTime, stopTime) => {
  if (startTime && stopTime) {
    const duration = (new Date(stopTime).getTime() - new Date(startTime).getTime()) / 1000;
    return Math.floor(duration);
  }
};

const displayNumber = (number, digits = 2) => {
  if (number === 0) {
    return '0'.repeat(digits);
  }
  return number < Math.pow(10, digits - 1) ? `${'0'.repeat(Math.floor(Math.log10(number)) + 1)}${number}` : number;
};

const formatAsDuration = seconds => {
  const hourNumber = Math.floor(seconds / 3600);

  const minuteNumber = Math.floor((seconds - hourNumber * 3600) / 60);

  const secondNumber = Math.floor((seconds - hourNumber * 3600 - minuteNumber * 60) % 60);

  return `${displayNumber(hourNumber)}:` + `${displayNumber(minuteNumber)}:` + `${displayNumber(secondNumber)}`;
};

const MediaInfo = ({ selectedItem, width, onPlayerRefReady, playerRef, toggleMediaInfoPanel }) => {
  const classes = useStyles$k();
  const itemType = selectedItem.type === 'folder' ? 'folder' : _get(selectedItem, 'primaryAsset.contentType', 'application').split('/')[0];
  const duration = getDuration(selectedItem.startDateTime, selectedItem.stopDateTime);
  return React__default.createElement(
    'div',
    { className: classes['mediaInfoContainer'], style: { width } },
    toggleMediaInfoPanel && React__default.createElement(
      'div',
      { 'data-veritone-element': 'close-button', className: classes['mediaInfoBtnContainer'] },
      React__default.createElement(
        Tooltip,
        { title: 'Hide Details', placement: 'left' },
        React__default.createElement(
          IconButton$2
          /* eslint-disable react/jsx-no-bind */
          ,
          { onClick: () => toggleMediaInfoPanel(false)
          },
          React__default.createElement(CloseIcon, null)
        )
      )
    ),
    (() => {
      switch (itemType) {
        case 'folder':
          return React__default.createElement(Folder$1, { className: classes['iconInfo'] });
        case 'doc':
        case 'application':
          return React__default.createElement(InsertDriveFile, { className: classes['iconInfo'] });
        case 'video':
        case 'audio':
          return React__default.createElement(MediaPlayer, {
            ref: playerRef,
            onPlayerRefReady: onPlayerRefReady,
            src: selectedItem.primaryAsset.signedUri,
            streams: selectedItem.streams,
            poster: selectedItem.thumbnailUrl,
            readOnly: true,
            fluid: true,
            useOverlayControlBar: true,
            preload: 'none',
            btnRestart: false,
            btnReplay: false,
            btnForward: false,
            autoHide: true,
            autoHideTime: 1000
          });
        case 'image':
          return React__default.createElement('img', {
            src: _get(selectedItem, 'primaryAsset.signedUri'),
            alt: selectedItem.name,
            className: classes['imagePreview']
          });
        default:
          return null;
      }
    })(),
    React__default.createElement(
      Typography$2,
      { className: classes['tdoName'] },
      selectedItem.name
    ),
    React__default.createElement(
      'div',
      { className: classes['infoDetails'] },
      React__default.createElement(
        MuiTable,
        { className: classes['tableContainer'] },
        React__default.createElement(
          MuiTableBody,
          null,
          React__default.createElement(
            TableRow,
            { className: classes['tableRow'] },
            React__default.createElement(
              TableCell,
              {
                className: cx$1(classes['tableCell'], classes['tableFirstColumn'])
              },
              'Created'
            ),
            React__default.createElement(
              TableCell,
              {
                className: classes['tableCell']
              },
              React__default.createElement(
                'span',
                { 'data-veritone-element': 'media-panel-created-date' },
                formatDateString(selectedItem.createdDateTime)
              )
            )
          ),
          React__default.createElement(
            TableRow,
            null,
            React__default.createElement(
              TableCell,
              {
                className: cx$1(classes['tableCell'], classes['tableFirstColumn'])
              },
              'Modified'
            ),
            React__default.createElement(
              TableCell,
              {
                className: classes['tableCell']
              },
              React__default.createElement(
                'span',
                { 'data-veritone-element': 'media-panel-modified-date' },
                formatDateString(selectedItem.modifiedDateTime)
              )
            )
          ),
          !!duration && React__default.createElement(
            TableRow,
            { className: classes['tableRow'] },
            React__default.createElement(
              TableCell,
              {
                className: cx$1(classes['tableCell'], classes['tableFirstColumn'])
              },
              'Duration'
            ),
            React__default.createElement(
              TableCell,
              { className: classes['tableCell'] },
              React__default.createElement(
                'span',
                { 'data-veritone-element': 'media-panel-duration' },
                formatAsDuration(duration)
              )
            )
          )
        )
      ),
      !!selectedItem.childNode && selectedItem.childNode
    )
  );
};

MediaInfo.displayName = 'MediaInfo';
MediaInfo.propTypes = {
  selectedItem: tdoShape,
  width: number,
  onPlayerRefReady: func,
  playerRef: shape$1({
    current: object
  }),
  toggleMediaInfoPanel: func
};

const transitionStyle = width => ({
  entering: {
    flexBasis: width + 40
  },
  entered: {
    flexBasis: width + 40
  }
});

const MediaInfoPanel = (_ref) => {
  let { open, selectedItems = [], width } = _ref,
      props = objectWithoutProperties(_ref, ['open', 'selectedItems', 'width']);

  const classes = useStyles$k();
  const selectedItem = selectedItems.length ? selectedItems[0] : null;
  const transitionStyleByWidth = transitionStyle(width);
  return React__default.createElement(
    reactTransitionGroup_1,
    { 'in': open && selectedItems.length > 0, timeout: 500 },
    state => React__default.createElement(
      'div',
      {
        className: classes['mediaPanelContainer'],
        style: transitionStyleByWidth[state]
      },
      selectedItems.length > 1 ? React__default.createElement(
        'div',
        null,
        'You have selected ',
        selectedItems.length,
        ' items'
      ) : selectedItem ? React__default.createElement(MediaInfo, _extends({
        selectedItem: selectedItem,
        width: width
      }, props)) : null
    )
  );
};

MediaInfoPanel.displayName = 'MediaInfoPanel';
MediaInfoPanel.propTypes = {
  open: bool,
  width: number,
  selectedItems: arrayOf(tdoShape),
  onPlayerRefReady: func,
  playerRef: shape$1({
    current: object
  })
};

MediaInfoPanel.defaultProps = {
  width: 450
};

var itemShape = shape$1({
  id: string.isRequired,
  type: oneOf(['folder', 'tdo']).isRequired,
  name: string,
  primaryAsset: shape$1({
    name: string,
    contentType: string.isRequired,
    signedUri: string
  }),
  createdDateTime: string.isRequired,
  modifiedDateTime: string.isRequired
});

var styles$$ = {
  tableFirstColumnText: {
    paddingLeft: '12px',
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
  },
  tableFirstColumnFolder: {
    color: darkBlack,
    fontWeight: 500
  },
  tableRowText: {
    visibility: 'visible',
    position: 'absolute',
    lineHeight: 1.5,
    top: 0,
    padding: '15px 0'
  },
  tableFirstColumn: {
    display: 'flex',
    alignItems: 'center'
  },
  tableIcon: {
    color: lightBlack
  },
  tableRowHead: {
    height: '0 !important',
    padding: '0 !important'
  },
  tableRowHeadHidden: {
    height: '0 !important',
    lineHeight: '0 !important',
    visibility: 'hidden',
    whiteSpace: 'nowrap',
    padding: '0'
  },
  tableRow: {
    borderBottom: '0 !important',
    color: lightBlack,
    cursor: 'pointer',
    userSelect: 'none',
    paddingRight: '0 !important',
    paddingLeft: '8px !important',
    maxWidth: '0',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  selected: {
    background: faintBlack
  },
  unsupported: {
    '&:not($selected)': {
      '& td': {
        color: minBlack,
        '& svg': {
          color: minBlack
        }
      }
    }
  }
};

const FILE_ICONS = {
  'folder': Folder$1,
  'audio': KeyboardVoice,
  'video': Videocam,
  'doc': InsertDriveFile
};

const useStyles$l = makeStyles(styles$$);
const formatDateString$1 = date => {
  return format(parseISO(date), 'MMM d, yyyy h:mm a..aaa');
};
const useHideWrap = (children, key) => React__default.createElement(
  Hidden,
  { key: key, initialWidth: 'md', smDown: true },
  children
);

useHideWrap.displayName = 'useHideWrap';
const FolderListView = ({
  items,
  highlightedItems,
  onHighlightItem,
  onSelectItem,
  isAcceptedType
}) => {
  const classes = useStyles$l();
  const headers = ['Name', 'Created Date Time', 'Modified Date Time', 'Type'];
  const hiddenIndices = [1, 2];
  function handleDoubleClick(event) {
    const id = event.currentTarget.getAttribute('id');
    const type = event.currentTarget.getAttribute('type');
    onSelectItem && onSelectItem([{ id, type }]);
  }  return React__default.createElement(
    MuiTable,
    null,
    React__default.createElement(
      MuiTableHead,
      null,
      React__default.createElement(
        TableRow,
        { className: classes['tableRowHead'] },
        headers.map((header, index) => {
          const content = React__default.createElement(
            TableCell,
            {
              key: header,
              className: cx$1(classes['tableRowHeadHidden'], classes['tableRow']),
              align: 'right'
            },
            header,
            React__default.createElement(
              'div',
              { className: classes['tableRowText'] },
              header
            )
          );
          return hiddenIndices.includes(index) ? useHideWrap(content, header) : content;
        })
      )
    ),
    React__default.createElement(
      MuiTableBody,
      null,
      items.map(({
        id,
        type,
        name,
        primaryAsset,
        createdDateTime,
        modifiedDateTime
      }, index) => {
        const iconCategory = _get(primaryAsset, 'contentType', 'doc').split('/')[0];
        const FileIcon = type === 'folder' ? Folder$1 : FILE_ICONS[iconCategory] || FILE_ICONS['doc'];
        const isSupported = isAcceptedType && isAcceptedType({ primaryAsset });
        return React__default.createElement(
          TableRow,
          {
            'data-veritone-element': 'folder-list-item',
            className: cx$1({
              [classes.selected]: highlightedItems[id],
              [classes.unsupported]: !isSupported && type !== 'folder'
            }),
            id: id,
            key: id,
            type: type,
            'data-id': id,
            'data-index': index,
            'data-type': type,
            onClick: onHighlightItem,
            onDoubleClick: handleDoubleClick,
            'data-test': cx$1({ selected: highlightedItems[id] })
          },
          React__default.createElement(
            TableCell,
            {
              scope: 'row',
              className: classes['tableRow']
            },
            React__default.createElement(
              'div',
              { className: cx$1(classes['tableFirstColumn']) },
              React__default.createElement(FileIcon, { className: classes['tableIcon'] }),
              React__default.createElement(
                'span',
                { className: cx$1(classes['tableFirstColumnText'], {
                    [classes['tableFirstColumnFolder']]: type === 'folder'
                  })
                },
                name
              )
            )
          ),
          useHideWrap(React__default.createElement(
            TableCell,
            { align: 'right', className: classes['tableRow'] },
            formatDateString$1(createdDateTime)
          )),
          useHideWrap(React__default.createElement(
            TableCell,
            { align: 'right', className: classes['tableRow'] },
            formatDateString$1(modifiedDateTime)
          )),
          React__default.createElement(
            TableCell,
            { align: 'right', className: classes['tableRow'] },
            type === 'folder' ? 'folder' : _get(primaryAsset, 'contentType', 'doc')
          )
        );
      })
    )
  );
};

FolderListView.displayName = 'FolderListView';
FolderListView.propTypes = {
  onSelectItem: func,
  items: arrayOf(itemShape),
  onHighlightItem: func,
  highlightedItems: objectOf(bool),
  isAcceptedType: func
};

const useStyles$m = makeStyles({
  progress: {
    textAlign: 'center'
  }
});
const FolderLoading = ({ message, size }) => {
  const classes = useStyles$m();
  return React__default.createElement(
    'div',
    { className: cx$1(classes["progress"]) },
    React__default.createElement(CircularProgress$2, { size: size }),
    React__default.createElement(
      'div',
      null,
      message
    )
  );
};

FolderLoading.displayName = 'FolderLoading';
FolderLoading.propTypes = {
  message: string,
  size: number
};

var styles$10 = {
  selected: {
    border: '1px solid rgba(33, 150, 243, 0.75) !important'
  },
  gridviewContainer: {
    display: 'flex !important',
    flexWrap: 'wrap',
    margin: '0 auto'
  },
  gridviewItem: {
    margin: 10,
    maxWidth: 240,
    flex: '1 0 32%',
    cursor: 'pointer',
    border: '1px solid rgba(0, 0, 0, 0.12)'
  },
  iconMedia: {
    fontSize: '60px !important',
    color: '#42A4F5'
  },
  itemName: {
    display: 'inline-block',
    maxWidth: 240,
    color: 'rgba(0, 0, 0, 0.87)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: 14,
    fontWeight: 500
  },
  itemMedia: {
    display: 'flex !important',
    backgroundColor: '#FAFAFA',
    alignItems: 'center',
    justifyContent: 'center',
    height: 135
  },
  itemCard: {
    maxWidth: 310
  },
  itemCardContent: {
    padding: '12px !important'
  },
  itemCardContentSelected: {
    backgroundColor: '#F1F8FE'
  },
  itemCardName: {
    display: 'flex !important',
    alignItems: 'center'
  },
  typeIcon: {
    marginLeft: 6
  },
  itemTimestyle: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 12
  }
};

const useStyles$n = makeStyles(styles$10);

const FILE_ICONS$1 = {
  'folder': Folder$1,
  'audio': KeyboardVoice,
  'video': Videocam,
  'doc': InsertDriveFile
};

function SimpleMediaCard(props) {
  const classes = useStyles$n();
  const { item, isSelected } = props;
  const { type, name, primaryAsset, modifiedDateTime, streams } = item;
  const url = () => {
    const streamUri = _get(streams, 'uri');
    const signedUri = _get(primaryAsset, 'signedUri');
    return streamUri || signedUri;
  };
  const iconCategory = _get(primaryAsset, 'contentType', 'doc').split('/')[0];
  const FileIcon = type === 'folder' ? Folder$1 : FILE_ICONS$1[iconCategory] || FILE_ICONS$1['doc'];
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      Card,
      { className: cx$1(classes["itemCard"]) },
      url() ? React__default.createElement(MediaPlayerComponent$1, {
        muted: true,
        readOnly: true,
        fluid: true,
        useOverlayControlBar: true,
        src: url()
      }) : React__default.createElement(
        CardMedia,
        { className: cx$1(classes["itemMedia"]) },
        React__default.createElement(FileIcon, { className: cx$1(classes["iconMedia"]) })
      ),
      React__default.createElement(
        CardContent,
        { className: cx$1(classes["itemCardContent"], { [classes['itemCardContentSelected']]: isSelected }) },
        React__default.createElement(
          Typography$2,
          {
            className: cx$1(classes["itemCardName"]),
            gutterBottom: true,
            variant: "h5",
            component: "h2"
          },
          React__default.createElement(
            "div",
            { className: cx$1(classes["itemName"]) },
            name
          ),
          React__default.createElement(FileIcon, { className: cx$1(classes["typeIcon"]) })
        ),
        React__default.createElement(
          Typography$2,
          { className: cx$1(classes["itemTimestyle"]), component: "p" },
          modifiedDateTime
        )
      )
    )
  );
}

SimpleMediaCard.displayName = "SimpleMediaCard";
SimpleMediaCard.propTypes = {
  item: itemShape,
  isSelected: PropTypes__default.bool
};

const useStyles$o = makeStyles(styles$10);

const FolderGridView = ({
  items,
  highlightedItems,
  onHighlightItem,
  onSelectItem
}) => {
  const classes = useStyles$o();
  return React__default.createElement(
    'div',
    { className: cx$1(classes["gridviewContainer"]) },
    items.map((item, index) => React__default.createElement(
      'div',
      {
        className: cx$1(classes["gridviewItem"], { [classes['selected']]: highlightedItems[item.id] }),
        id: item.id,
        type: item.type,
        key: item.id,
        'data-id': item.id,
        'data-index': index,
        onClick: onHighlightItem,
        onDoubleClick: onSelectItem
      },
      React__default.createElement(SimpleMediaCard, {
        item: item,
        isSelected: highlightedItems[item.id]
      })
    ))
  );
};

FolderGridView.displayName = 'FolderGridView';
FolderGridView.propTypes = {
  onSelectItem: func,
  items: arrayOf(itemShape),
  onHighlightItem: func,
  highlightedItems: objectOf(bool)
};

var styles$11 = {
  folderPaper: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'stretch'
  },
  folderViewContainer: {
    display: 'flex',
    height: '100%'
  },
  folderViewContent: {
    position: 'relative',
    paddingTop: 48,
    width: '100%',
    height: '100%',
    transition: 'width 500ms',
    '&.panelOpen': {
      width: 'calc(100% - 340px)'
    }
  },
  folderNullStateContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    textAlign: 'center'
  }
};

var _class$R, _temp2$E;

const genArray = (a, b) => new Array(Math.max(a, b) - Math.min(a, b) + 1).fill(0).map((_, i) => i + Math.min(a, b));

const LoadingState = () => React__default.createElement(FolderLoading, {
  message: 'Loading Message',
  size: 100
});

LoadingState.displayName = 'LoadingState';
let FolderViewContainer = (_temp2$E = _class$R = class FolderViewContainer extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      highlightedItems: {}
    }, this.handleKeyPress = event => {
      const eventKeyCode = event.keyCode;
      const { lastIndex = 0, shiftIndex, highlightedItems } = this.state;
      const { items, multiple } = this.props;
      if (eventKeyCode === 38 && eventKeyCode === 40 && items.length && this.noneHighligthedItem(highlightedItems)) {
        this.onHighlight(0);
        return;
      }
      // Up
      if (eventKeyCode === 38 && lastIndex > 0) {
        event.preventDefault();
        if (event.shiftKey && multiple) {
          const currentIndex = isNaN(shiftIndex) ? lastIndex : shiftIndex;
          const shiftHighlightIndex = Math.max(currentIndex - 1, 0);
          this.onShiftHighlight(shiftHighlightIndex);
          this.needScrollIntoView(shiftHighlightIndex);
        } else {
          const currentIndex = Math.max((lastIndex || 0) - 1, 0);
          this.onHighlight(parseInt(currentIndex, 10));
          this.needScrollIntoView(currentIndex);
        }
        return;
      }

      // Down
      if (eventKeyCode === 40 && lastIndex < items.length - 1) {
        event.preventDefault();
        if (event.shiftKey && multiple) {
          const currentIndex = isNaN(shiftIndex) ? lastIndex : shiftIndex;
          const shiftHighlightIndex = Math.min(currentIndex + 1, items.length - 1);
          this.onShiftHighlight(shiftHighlightIndex);
          this.needScrollIntoView(shiftHighlightIndex);
        } else {
          const currentIndex = Math.min((lastIndex || 0) + 1, items.length - 1);
          this.onHighlight(currentIndex);
          this.needScrollIntoView(currentIndex);
        }
        return;
      }

      // Enter/Return
      if (eventKeyCode === 13) {
        this.onSubmit();
      }
    }, this.needScrollIntoView = itemIndex => {
      const { items } = this.props;
      const itemId = items[itemIndex].id;
      const itemEl = document.getElementById(itemId);
      const itemElBounding = itemEl.getBoundingClientRect();

      const {
        top: topView,
        bottom: bottomView
      } = this.scrollRef.current.getViewWindow();
      if (itemElBounding.top < topView) {
        itemEl.scrollIntoView();
      }
      if (itemElBounding.bottom > bottomView) {
        itemEl.scrollIntoView({ block: 'end' });
      }
    }, this.onShiftHighlight = index => {
      const { items } = this.props;
      this.setState(({ lastIndex, highlightedItems }) => this.noneHighligthedItem(highlightedItems) ? {
        lastIndex: index,
        highlightedItems: {
          [items[index].id]: true
        },
        shiftIndex: index
      } : {
        shiftIndex: index,
        highlightedItems: _extends({}, genArray(lastIndex, index).map(itemIndex => items[itemIndex].id).reduce((highlighting, itemId) => _extends({}, highlighting, {
          [itemId]: true
        }), {}))
      });
    }, this.onHighlight = index => {
      const itemId = this.props.items[index].id;
      this.setState(({ highlightedItems }) => ({
        highlightedItems: {
          [itemId]: !highlightedItems[itemId]
        },
        lastIndex: index,
        shiftIndex: index
      }), this.reloadPlayer);
    }, this.noneHighligthedItem = highlightedItems => Object.keys(highlightedItems).filter(key => highlightedItems[key]).length === 0, this.onHighlightItem = event => {
      const { multiple } = this.props;
      const index = event.currentTarget.getAttribute('data-index');
      const holdingShift = event.shiftKey;
      const holdingCtrl = event.ctrlKey;
      const holdingCmd = hasCommandModifier(event);
      if (!multiple || !holdingShift && !holdingCtrl && !holdingCmd) {
        this.onHighlight(parseInt(index, 10));
      }
      if (holdingCtrl || holdingCmd) {
        const itemId = this.props.items[index].id;
        this.setState(({ highlightedItems }) => ({
          highlightedItems: _extends({}, highlightedItems, {
            [itemId]: !highlightedItems[itemId]
          }),
          shiftIndex: parseInt(index, 10)
        }), this.reloadPlayer);
      }
      if (holdingShift) {
        this.onShiftHighlight(parseInt(index, 10));
      }
    }, this.onSubmit = () => {
      const { items, onSelectItem, onError } = this.props;
      const { highlightedItems } = this.state;
      const selectedItems = items.filter(i => highlightedItems[i.id]);
      // Validate selected tdos are accepted content types
      const hasInvalidItem = selectedItems.filter(i => i.type === 'tdo').find(i => !this.isAcceptedType(i));
      if (hasInvalidItem) {
        return onError && onError();
      }
      const selectedNodes = selectedItems.map(i => ({ id: i.id, type: i.type }));
      onSelectItem && onSelectItem(selectedNodes);
    }, this.reloadPlayer = () => {
      if (this.mediaPlayer && this.playerRef && this.playerRef.current) {
        this.mediaPlayer.load();
      }
    }, this.onPlayerRefReady = ref => {
      this.mediaPlayer = ref;
    }, this.isAcceptedType = item => {
      const { supportedFormats } = this.props;
      const itemType = _get(item, 'primaryAsset.contentType');
      if (supportedFormats.length) {
        if (itemType) {
          const category = itemType.split('/')[0];
          return supportedFormats.includes(itemType) || supportedFormats.includes(`${category}/*`);
        }
      } else {
        return true;
      }
      return false;
    }, this.handleOnSelectItem = (selectedNodes = []) => {
      const { onSelectItem, items, onError } = this.props;
      if (selectedNodes.length) {
        const item = items.find(i => i.id === selectedNodes[0].id);
        if (item.type === 'tdo' && this.isAcceptedType(item) || item.type === 'folder') {
          onSelectItem(selectedNodes);
        } else {
          onError && onError();
        }
      }
    }, this.scrollRef = React__default.createRef(), this.playerRef = React__default.createRef(), _temp;
  }

  componentDidMount() {
    this.props.triggerPagination();
    document.addEventListener('keydown', this.handleKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyPress);
  }

  // Used for double clicks (1 item)


  render() {
    const {
      isLoading,
      isLoaded,
      isError,
      viewType,
      items,
      triggerPagination,
      onCancel,
      availablePickerTypes,
      toggleContentView,
      isFullScreen,
      showMediaInfoPanel,
      toggleMediaInfoPanel,
      classes
    } = this.props;

    const { highlightedItems } = this.state;

    if (isError) {
      return React__default.createElement(
        Paper,
        null,
        React__default.createElement(
          'div',
          { className: classes['folderNullStateContainer'] },
          React__default.createElement(
            'div',
            null,
            'Error Loading data'
          ),
          React__default.createElement(
            'span',
            null,
            isError
          ),
          React__default.createElement(
            IconButton$2,
            { onClick: triggerPagination },
            React__default.createElement(RefreshIcon, null)
          )
        )
      );
    }

    const hasUpload = availablePickerTypes.includes('upload');
    const nullstateBtnProps = hasUpload ? { text: 'UPLOAD', onClick: () => toggleContentView('upload') } : undefined;
    const nullstateText = hasUpload && 'Click upload button to add content';
    if (items.length === 0 && isLoaded) {
      return React__default.createElement(
        'div',
        { className: classes['folderNullStateContainer'] },
        React__default.createElement(
          NullState,
          {
            imgProps: {
              src: 'https://static.veritone.com/veritone-ui/no-files-folders.svg',
              alt: 'No files'
            },
            titleText: 'No files here',
            btnProps: nullstateBtnProps,
            inWidgets: true
          },
          nullstateText
        )
      );
    }

    if (items.length === 0 && isLoading) {
      return React__default.createElement(
        'div',
        { className: classes['folderNullStateContainer'] },
        React__default.createElement(LoadingState, null)
      );
    }

    const selectedItems = items.filter(item => highlightedItems[item.id]);
    const mediaPanelEnabled = showMediaInfoPanel && !!selectedItems.length && viewType === 'list';

    return React__default.createElement(
      Paper,
      { className: classes['folderPaper'] },
      React__default.createElement(
        'div',
        { className: classes['folderViewContainer'] },
        React__default.createElement(
          'div',
          { className: cx$1(classes['folderViewContent'], {
              [`${classes['panelOpen']}`]: mediaPanelEnabled
            }) },
          React__default.createElement(
            InfiniteLoaderWrapper,
            {
              isLoading: isLoading,
              triggerPagination: triggerPagination,
              ref: this.scrollRef
            },
            viewType === 'list' ? React__default.createElement(FolderListView, {
              items: items,
              onHighlightItem: this.onHighlightItem,
              onSelectItem: this.handleOnSelectItem,
              highlightedItems: highlightedItems,
              isAcceptedType: this.isAcceptedType
            }) : React__default.createElement(FolderGridView, {
              items: items,
              onHighlightItem: this.onHighlightItem,
              onSelectItem: this.handleOnSelectItem,
              highlightedItems: highlightedItems,
              isAcceptedType: this.isAcceptedType
            })
          )
        ),
        mediaPanelEnabled && React__default.createElement(MediaInfoPanel, {
          open: mediaPanelEnabled,
          playerRef: this.playerRef,
          onPlayerRefReady: this.onPlayerRefReady,
          selectedItems: selectedItems,
          toggleMediaInfoPanel: toggleMediaInfoPanel,
          width: 300
        })
      ),
      React__default.createElement(FilePickerFooter$1, {
        title: 'Open',
        onCancel: onCancel,
        disabled: this.noneHighligthedItem(highlightedItems),
        onSubmit: this.onSubmit,
        hasIntercom: isFullScreen
      })
    );
  }
}, _class$R.propTypes = {
  availablePickerTypes: arrayOf(string),
  toggleContentView: func,
  supportedFormats: arrayOf(string),
  viewType: oneOf(['list', 'grid']),
  items: arrayOf(itemShape),
  onSelectItem: func,
  isLoading: bool,
  isLoaded: bool,
  isError: bool,
  triggerPagination: func,
  onCancel: func,
  onError: func,
  isFullScreen: bool,
  showMediaInfoPanel: bool,
  toggleMediaInfoPanel: func,
  multiple: bool,
  classes: shape$1({ any })
}, _class$R.defaultProps = {
  items: [],
  availablePickerTypes: [],
  supportedFormats: []
}, _temp2$E);
FolderViewContainer.displayName = 'FolderViewContainer';


var FolderViewContainer$1 = withStyles$1(styles$11)(FolderViewContainer);

var styles$12 = {
  uploaderContainer: {
    display: 'flex',
    flexFlow: 'column',
    height: 'calc(100% - 64px)'
  },
  uploaderContent: {
    flexGrow: 1,
    display: 'flex',
    flexFlow: 'column',
    padding: 16
  },
  uploaderUploadArea: {
    flexGrow: 1,
    display: 'flex',
    height: '100%'
  },
  uploaderFileList: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between'
  },
  uploadProgressContainer: {
    overflowY: 'auto',
    maxHeight: 240
  },
  uploaderRetryButtonContainer: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row'
  }
};

const useStyles$p = makeStyles(styles$12);

const UploadViewContainer = ({
  accept,
  onFilesSelected,
  onReject,
  uploadPickerState,
  uploadStatusMsg,
  uploadSuccess,
  uploadWarning,
  uploadError,
  uploadedFiles,
  percentByFiles,
  onCancel,
  onUpload,
  handleAbort,
  onRetryDone,
  retryRequest,
  onDeleteFile,
  multiple,
  containerStyle,
  onRemoveFile,
  isFullScreen
}) => {
  const classes = useStyles$p();
  const completeStatus = {
    [uploadSuccess]: 'success',
    [uploadWarning]: 'warning',
    [uploadError]: 'failure'
  }[true];
  const icon = {
    success: React__default.createElement(CheckCircle, { style: { fill: green$1[500] } }),
    failure: React__default.createElement(Info, { style: { color: '#F44336' } }),
    warning: React__default.createElement(Warning, { style: { color: '#ffc107' } })
  }[completeStatus];
  const uploadDisabled = percentByFiles && percentByFiles.length > 0 && percentByFiles.some(percent => percent.value.percent > 0) || uploadedFiles && !uploadedFiles.length;

  return React__default.createElement(
    'div',
    { className: classes['uploaderContainer'], style: containerStyle },
    React__default.createElement(
      'div',
      { className: classes['uploaderContent'] },
      uploadPickerState === 'selecting' ? React__default.createElement(
        'div',
        { className: classes['uploaderUploadArea'] },
        React__default.createElement(
          DndProvider,
          { backend: HTML },
          React__default.createElement(FileUploader, {
            acceptedFileTypes: accept,
            onFilesSelected: onFilesSelected,
            multiple: multiple,
            onFilesRejected: onReject
          })
        ),
        uploadedFiles && !!uploadedFiles.length && React__default.createElement(FileList$1, {
          files: uploadedFiles,
          onRemoveFile: onRemoveFile
        })
      ) : React__default.createElement(
        'div',
        { className: classes['uploaderFileList'] },
        React__default.createElement(
          'div',
          null,
          React__default.createElement(FilePickerHeader$1, {
            title: completeStatus ? `Upload ${completeStatus}` : 'Uploading',
            titleIcon: icon,
            message: uploadStatusMsg,
            hideTabs: true }),
          React__default.createElement(
            'div',
            { className: classes['uploadProgressContainer'] },
            React__default.createElement(FileProgressList$1, {
              percentByFiles: percentByFiles,
              handleAbort: handleAbort,
              showErrors: completeStatus && completeStatus !== 'success'
            })
          )
        ),
        completeStatus && completeStatus !== 'success' && percentByFiles && !!percentByFiles.length && React__default.createElement(
          'div',
          {
            className: classes['uploaderRetryButtonContainer'],
            'data-veritone-element': 'picker-retry-controls'
          },
          React__default.createElement(
            Button$2,
            {
              onClick: onRetryDone },
            'Done'
          ),
          React__default.createElement(
            Button$2,
            {
              variant: 'contained',
              color: 'primary',
              onClick: retryRequest },
            'Retry All'
          )
        )
      )
    ),
    React__default.createElement(FilePickerFooter$1, {
      title: 'Upload',
      onCancel: onCancel,
      disabled: uploadDisabled,
      onSubmit: onUpload,
      hasIntercom: isFullScreen
    })
  );
};

UploadViewContainer.displayName = 'UploadViewContainer';
UploadViewContainer.propTypes = {
  accept: arrayOf(string),
  onFilesSelected: func.isRequired,
  onUpload: func.isRequired,
  onCancel: func,
  onDeleteFile: func,
  onReject: func,
  multiple: bool,
  containerStyle: shape$1({
    heigh: number,
    width: number
  }),
  percentByFiles: arrayOf(shape$1({
    key: string,
    value: shape$1({
      type: string,
      percent: number,
      size: number,
      error: string
    })
  })),
  uploadPickerState: string,
  uploadStatusMsg: string,
  uploadSuccess: oneOfType([string, bool]),
  uploadError: oneOfType([string, bool]),
  uploadWarning: oneOfType([string, bool]),
  uploadedFiles: arrayOf(object),
  handleAbort: func,
  onRetryDone: func,
  retryRequest: func,
  onRemoveFile: func,
  isFullScreen: bool
};

UploadViewContainer.defaultProps = {
  accept: [],
  multiple: true
};

const lightBlackColor = lightBlack;

var styles$13 = {
  breadcrumbContainer: {
    display: 'flex',
    fontSize: '1rem',
    alignItems: 'center',
    borderRadius: 2,
    minWidth: 300,
    flex: 'auto',
    marginLeft: 10,
    width: '100%'
  },
  greyBackround: {
    backgroundColor: '#F5F5F5'
  },
  iconColor: {
    color: lightBlack
  },
  iconSpacer: {
    marginLeft: 10
  },
  textItem: {
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  rootIcon: {
    color: blue1,
    fontSize: '24px !important'
  },
  crumbItem: {
    padding: '0 8px !important',
    minWidth: '0 !important',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: lightBlack,
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    textTransform: 'none !important'
  },
  crumbItemDisable: {
    color: `${lightBlack} !important`
  },
  fontIcon: {
    fontSize: '1.5rem',
    adding: '0 0.5rem',
    color: lightBlack
  }
};

const useStyles$q = makeStyles(styles$13);

const BreadcrumbItem = ({
  name,
  id,
  index,
  icon,
  onClick,
  isHidden = false,
  isDisabled = false
}) => {
  const classes = useStyles$q();
  return isHidden ? React__default.createElement(
    MenuItem,
    {
      onClick: onClick,
      'data-id': id,
      'data-index': index,
      disabled: isDisabled
    },
    name
  ) : React__default.createElement(
    Button$2,
    {
      onClick: onClick,
      'data-id': id,
      'data-index': index,
      className: cx$1(classes.crumbItem, isDisabled ? classes.crumbItemDisable : {}),
      disabled: isDisabled
    },
    icon,
    React__default.createElement(
      'span',
      { className: cx$1({
          [classes['iconSpacer']]: icon && name,
          [classes.textItem]: true
        }) },
      name
    )
  );
};

BreadcrumbItem.propTypes = {
  id: string.isRequired,
  index: number,
  name: string,
  isHidden: bool,
  icon: node,
  onClick: func,
  isDisabled: bool
};

var _class$S, _temp2$F;

let Breadcrumbs = (_temp2$F = _class$S = class Breadcrumbs extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      anchorEl: null
    }, this.onSpreadClick = event => {
      this.setState({
        anchorEl: event.currentTarget
      });
    }, this.clickAway = () => {
      this.setState({
        anchorEl: null
      });
    }, this.onCrumbClick = event => {
      let elementData = Object.assign({}, event.currentTarget.dataset);
      this.props.onCrumbClick(elementData);
    }, this.handleClose = event => {
      event.stopPropagation();
    }, _temp;
  }

  render() {
    const {
      pathList,
      maxItems,
      seperator,
      isStream,
      classes,
      isEnableSuiteCase = true,
      isEnableBackground = true,
      defaultRootTitle = 'My Files',
      loading = false
    } = this.props;

    const { anchorEl } = this.state;

    const {
      0: firstCrumb,
      [pathList.length - 1]: lastCrumb
    } = pathList;
    const hiddenCrumbs = pathList.slice(1, pathList.length - 1);
    const icon = isStream ? React__default.createElement('div', { className: cx$1('icon-streams', classes['rootIcon']) }) : React__default.createElement(Work, { className: classes['rootIcon'] });
    if (loading) {
      return React__default.createElement(
        'div',
        {
          className: cx$1(classes.breadcrumbContainer, isEnableBackground ? classes.greyBackround : {})
        },
        React__default.createElement(CircularProgress$2, { size: 20 })
      );
    }
    return React__default.createElement(
      'div',
      {
        className: cx$1(classes.breadcrumbContainer, isEnableBackground ? classes.greyBackround : {})
      },
      isEnableSuiteCase && React__default.createElement(
        React__default.Fragment,
        { key: 'root' },
        React__default.createElement(BreadcrumbItem, {
          id: 'root',
          icon: icon,
          index: 0,
          key: 'root',
          name: pathList.length ? '' : defaultRootTitle,
          onClick: this.onCrumbClick
        }),
        !!pathList.length && seperator
      ),
      pathList.length < maxItems ? pathList.map((crumb, index) => React__default.createElement(
        React__default.Fragment,
        { key: crumb.id },
        index === 0 && React__default.createElement(BreadcrumbItem, _extends({}, crumb, {
          index: index + 1,
          key: crumb.id,
          onClick: this.onCrumbClick
        })),
        index > 0 && seperator,
        index > 0 && React__default.createElement(BreadcrumbItem, _extends({}, crumb, {
          index: index + 1,
          key: crumb.id,
          onClick: this.onCrumbClick
        }))
      )) : React__default.createElement(
        React__default.Fragment,
        null,
        React__default.createElement(BreadcrumbItem, _extends({}, firstCrumb, {
          index: 1,
          key: firstCrumb.id,
          onClick: this.onCrumbClick
        })),
        seperator,
        React__default.createElement(
          Button$2,
          {
            className: classes['crumbItem'],
            onClick: this.onSpreadClick
          },
          React__default.createElement(MoreHoriz, { className: classes['iconColor'] })
        ),
        seperator,
        React__default.createElement(BreadcrumbItem, _extends({}, lastCrumb, {
          index: pathList.length,
          key: lastCrumb.id,
          onClick: this.onCrumbClick
        })),
        React__default.createElement(
          Popover,
          {
            open: Boolean(anchorEl),
            anchorEl: anchorEl,
            onClick: this.clickAway,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            }
          },
          React__default.createElement(
            MenuList,
            { role: 'menu' },
            hiddenCrumbs.map(({ id, name }, index) => React__default.createElement(BreadcrumbItem, {
              key: id,
              isHidden: true,
              id: id,
              index: index + 2,
              name: name,
              onClick: this.onCrumbClick
            }))
          )
        )
      )
    );
  }
}, _class$S.propTypes = {
  pathList: arrayOf(shape$1({
    id: string.isRequired,
    name: string
  })),
  maxItems: number,
  seperator: oneOfType([string, node]),
  onCrumbClick: func.isRequired,
  isStream: bool,
  classes: shape$1({ any }),
  isEnableSuiteCase: bool,
  isEnableBackground: bool,
  defaultRootTitle: string,
  loading: bool
}, _class$S.defaultProps = {
  maxItems: 5,
  seperator: React__default.createElement(ChevronRight, { style: { color: lightBlackColor } })
}, _temp2$F);
Breadcrumbs.displayName = 'Breadcrumbs';


var BreadCrums = withStyles$1(styles$13)(Breadcrumbs);

var styles$14 = {
  root: {
    flexGrow: 1,
    position: 'relative',
    zIndex: 9,
    minWidth: 870
  },
  headerBar: {
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24) !important'
  },
  header: {
    backgroundColor: 'white',
    alignItems: 'stretch !important',
    paddingTop: 12,
    paddingBottom: 12,
    height: 60,
    minHeight: 60
  },
  button: {
    flexBasis: '108px !important'
  },
  uploadButton: {
    border: '1px solid #2196F3 !important',
    borderRadius: '1px !important',
    color: '#2196F3 !important'
  },
  backButton: {
    color: 'rgba(0, 0, 0, 0.54) !important'
  },
  iconButton: {
    marginRight: 8
  },
  icon: {
    color: 'rgba(0,0,0,0.26'
  },
  divider: {
    width: 1,
    backgroundColor: 'rgba(0,0,0,0.26)',
    marginTop: 5,
    marginBottom: 5,
    alignSelf: 'stretch'
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  view: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  spacer: {
    width: '1re'
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.5
  }
};

let HeaderBar = class HeaderBar extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      anchorEl: null
    }, this.sortAbilities = [{
      text: 'Name',
      type: 'name'
    }, {
      text: 'Created date',
      type: 'createdDatetime'
    }, {
      text: 'Modified date',
      type: 'modifiedDatetime'
    }], this.onOpenSort = event => {
      this.setState({
        anchorEl: event.currentTarget
      });
    }, this.clickAway = () => {
      this.setState({
        anchorEl: null
      });
    }, _temp;
  }

  render() {
    const {
      // viewType,
      // onToggleView,
      onSort,
      // onSearch,
      // onClear,
      onCrumbClick,
      pathList,
      currentPickerType,
      toggleMediaInfoPanel,
      showMediaInfoPanel,
      classes
    } = this.props;
    const { anchorEl } = this.state;
    return React__default.createElement(
      'div',
      { className: classes.root },
      React__default.createElement(
        AppBar$1,
        {
          position: 'static',
          color: 'default',
          className: classes['headerBar']
        },
        React__default.createElement(
          Toolbar,
          { className: classes.header },
          React__default.createElement(BreadCrums, {
            pathList: pathList,
            onCrumbClick: onCrumbClick,
            isStream: currentPickerType === 'stream'
          }),
          currentPickerType !== 'upload' && React__default.createElement('div', { style: { flexGrow: 1 } }),
          currentPickerType !== 'upload' && React__default.createElement(
            'div',
            {
              id: 'media-info-toggle',
              className: cx$1(classes['buttonGroup'], classes.icon, { [classes.disabled]: currentPickerType === 'upload' })
            },
            React__default.createElement(
              IconButton$2,
              {
                'data-veritone-element': 'media-panel-toggle',
                color: showMediaInfoPanel ? 'primary' : 'default'
                /* eslint-disable react/jsx-no-bind */
                , onClick: () => toggleMediaInfoPanel() },
              React__default.createElement(InfoOutlined, null)
            )
          )
        )
      ),
      React__default.createElement(
        Popover,
        {
          open: Boolean(anchorEl),
          anchorEl: anchorEl,
          onClick: this.clickAway,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          }
        },
        React__default.createElement(
          MenuList,
          { role: 'menu' },
          this.sortAbilities.map(({ text, type }) => React__default.createElement(
            MenuItem,
            { key: type, 'data-type': type, onClick: onSort },
            text
          ))
        )
      )
    );
  }
};
HeaderBar.displayName = 'HeaderBar';


HeaderBar.propTypes = {
  pathList: arrayOf(shape$1({
    label: string,
    id: string
  })),
  onCrumbClick: func,
  // onSearch: func,
  // onClear: func,
  // onBack: func,
  // viewType: oneOf(['list', 'grid']),
  // onToggleView: func,
  // onUpload: func,
  onSort: func,
  currentPickerType: oneOf(['folder', 'stream', 'upload']),
  toggleMediaInfoPanel: func,
  showMediaInfoPanel: bool,
  classes: shape$1({ any })
};

HeaderBar.defaultProps = {
  pathList: [{
    label: ''
  }]
};

var HeaderBar$1 = withStyles$1(styles$14)(HeaderBar);

var _class$T, _temp2$G;

const styles$15 = {
  dataPickerContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  },
  dataPickerContentContainer: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'stretch',
    width: '100%',
    height: '100%'
  }
};
const StreamView = () => React__default.createElement(
  Paper,
  null,
  React__default.createElement(
    'div',
    { style: { width: '100%', height: '100%' } },
    'Stream view'
  ),
  ';'
);
StreamView.displayName = 'StreamView';
const UNSUPPORTED_FORMAT_ERROR = 'Unsupported format detected';
const MAX_ITEM_ERROR = 'Max selected items allowed has been exceeded: ';
const MULTIPLE_ERROR = 'Only one file is allowed';

let DataPicker = (_temp2$G = _class$T = class DataPicker extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      uploadedFiles: [],
      viewType: 'list'
    }, this.toggleContentView = pickerType => {
      const { setPickerType } = this.props;
      pickerType && setPickerType && setPickerType(pickerType);
    }, this.toggleViewType = event => {
      this.setState({
        viewType: event.currentTarget.dataset.type
      });
    }, this.handleFilesSelected = fileOrFiles => {
      const { multiple, maxItems, onErrorMsg } = this.props;
      const { uploadedFiles } = this.state;

      const selectedFiles = _isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
      const totalFileCount = uploadedFiles.length + selectedFiles.length;
      if (multiple) {
        if (maxItems && totalFileCount > maxItems) {
          onErrorMsg && onErrorMsg(MAX_ITEM_ERROR + maxItems)();
          return;
        }
      } else {
        if (totalFileCount > 1) {
          onErrorMsg && onErrorMsg(MULTIPLE_ERROR)();
          return;
        }
      }
      this.setState({
        uploadedFiles: [...uploadedFiles, ...selectedFiles]
      });
    }, this.handleRemoveFile = index => {
      const { uploadedFiles } = this.state;
      if (uploadedFiles[index]) {
        const clonedFiles = uploadedFiles.slice();
        clonedFiles.splice(index, 1);
        this.setState({
          uploadedFiles: clonedFiles
        });
      }
    }, this.handleOnUpload = () => {
      const { onUpload } = this.props;
      const { uploadedFiles } = this.state;
      onUpload && onUpload(uploadedFiles);
      this.setState({ uploadedFiles: [] });
    }, this.handleOnSelectItem = selectedNodes => {
      const { multiple, maxItems, onSelectItem, onErrorMsg } = this.props;
      if (multiple) {
        if (maxItems && maxItems < selectedNodes.length) {
          onErrorMsg(MAX_ITEM_ERROR + maxItems)();
          return;
        }
      } else {
        if (selectedNodes.length > 1) {
          onErrorMsg(MULTIPLE_ERROR)();
          return;
        }
      }
      onSelectItem && onSelectItem(selectedNodes);
    }, this.toggleMediaInfoPanel = value => {
      this.setState(prevState => ({
        showMediaInfoPanel: _isUndefined(value) ? !prevState.showMediaInfoPanel : value
      }));
    }, _temp;
  }

  render() {
    const { viewType } = this.state;
    const {
      availablePickerTypes,
      currentPickerType,
      triggerPagination,
      items,
      onCancel,
      supportedFormats,
      isLoading,
      pathList,
      onCrumbClick,
      onSearch,
      onClear,
      onSort,
      multiple,
      maxItems,
      handleAbort,
      onRetryDone,
      retryRequest,
      uploadPickerState,
      uploadStatusMsg,
      uploadSuccess,
      uploadError,
      uploadWarning,
      percentByFiles,
      isLoaded,
      isError,
      onErrorMsg,
      height,
      width,
      classes
    } = this.props;
    const { uploadedFiles, showMediaInfoPanel } = this.state;
    const showHeader = availablePickerTypes.includes('folder');
    const showLeftNav = availablePickerTypes.length > 1 && uploadPickerState !== 'uploading';
    const isFullScreen = !height && !width;
    return React__default.createElement(
      'div',
      { className: classes['dataPickerContainer'] },
      showLeftNav && React__default.createElement(LeftNavigationPanel, {
        availablePickerTypes: availablePickerTypes,
        currentPickerType: currentPickerType,
        toggleContentView: this.toggleContentView
      }),
      React__default.createElement(
        'div',
        { className: classes['dataPickerContentContainer'] },
        showHeader && React__default.createElement(HeaderBar$1, {
          viewType: viewType,
          onToggleView: this.toggleViewType,
          currentPickerType: currentPickerType,
          pathList: pathList,
          onCrumbClick: onCrumbClick,
          onSearch: onSearch,
          onClear: onClear,
          onSort: onSort,
          showMediaInfoPanel: showMediaInfoPanel,
          toggleMediaInfoPanel: this.toggleMediaInfoPanel
        }),
        (() => {
          switch (currentPickerType) {
            case 'upload':
              return React__default.createElement(UploadViewContainer, {
                multiple: multiple,
                maxItems: maxItems,
                uploadPickerState: uploadPickerState,
                uploadStatusMsg: uploadStatusMsg,
                uploadSuccess: uploadSuccess,
                uploadWarning: uploadWarning,
                uploadError: uploadError,
                accept: supportedFormats,
                onCancel: onCancel,
                onUpload: this.handleOnUpload,
                onFilesSelected: this.handleFilesSelected,
                handleAbort: handleAbort,
                onRetryDone: onRetryDone,
                retryRequest: retryRequest,
                onReject: onErrorMsg(UNSUPPORTED_FORMAT_ERROR),
                uploadedFiles: uploadedFiles,
                onRemoveFile: this.handleRemoveFile,
                percentByFiles: percentByFiles,
                isFullScreen: isFullScreen
              });
            case 'folder':
              return React__default.createElement(FolderViewContainer$1, {
                multiple: multiple,
                maxItems: maxItems,
                availablePickerTypes: availablePickerTypes,
                toggleContentView: this.toggleContentView,
                supportedFormats: supportedFormats,
                items: items,
                viewType: viewType,
                triggerPagination: triggerPagination,
                onSelectItem: this.handleOnSelectItem,
                onCancel: onCancel,
                isLoading: isLoading,
                isLoaded: isLoaded,
                isError: isError,
                onError: onErrorMsg(UNSUPPORTED_FORMAT_ERROR),
                isFullScreen: isFullScreen,
                showMediaInfoPanel: showMediaInfoPanel,
                toggleMediaInfoPanel: this.toggleMediaInfoPanel
              });
            case 'stream':
              return React__default.createElement(StreamView, null);

            default:
              return null;
          }
        })()
      )
    );
  }
}, _class$T.propTypes = {
  availablePickerTypes: arrayOf(string),
  currentPickerType: string,
  setPickerType: func.isRequired,
  triggerPagination: func.isRequired,
  items: arrayOf(object),
  onSelectItem: func,
  multiple: bool,
  maxItems: number,
  isLoaded: bool,
  isLoading: bool,
  onSort: func,
  onCrumbClick: func,
  pathList: arrayOf(object),
  onSearch: func,
  onClear: func,
  onUpload: func,
  handleAbort: func,
  onRetryDone: func,
  retryRequest: func,
  uploadPickerState: string,
  uploadStatusMsg: string,
  uploadSuccess: oneOfType([string, bool]),
  uploadError: oneOfType([string, bool]),
  uploadWarning: oneOfType([string, bool]),
  onCancel: func,
  supportedFormats: arrayOf(string),
  isError: bool,
  onErrorMsg: func,
  percentByFiles: arrayOf(shape$1({
    key: string,
    value: shape$1({
      name: string,
      percent: number,
      size: number
    })
  })),
  height: number,
  width: number,
  classes: shape$1({ any })
}, _class$T.defaultProps = {
  items: [],
  pathList: [],
  supportedFormats: [],
  uploadStatusMsg: '',
  uploadSuccess: '',
  uploadError: '',
  uploadWarning: '',
  onErrorMsg: () => {}
}, _temp2$G);
DataPicker.displayName = 'DataPicker';


var index$e = withStyles$1(styles$15)(DataPicker);

var styles$16 = {
  folderTreeContainer: {
    height: '100%',
    backgroundColor: '#FFF',
    overflow: 'auto'
  },
  folderItemContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  folderItem: {
    marginRight: '10px',
    fontSize: '25px',
    lineHeight: 'inherit',
    color: '#555'
  },
  selected: {
    color: '#2196f3'
  },
  folderIcon: {
    color: '#f0c56a',
    fontSize: '25px',
    lineHeight: 'inherit'
  },
  contentIcon: {
    color: '#555',
    marginRight: '10px',
    fontSize: '25px',
    lineHeight: 'inherit'
  },
  expandIcon: {
    minWidth: '20px',
    width: '20px',
    height: '20px',
    color: 'rgb(85, 85, 85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loading: {
    textAlign: 'center',
    padding: '10px'
  },
  iconMenu: {
    display: 'none'
  },
  listItem: {
    padding: '5px 0 !important',
    minHeight: '42px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
      '& $iconMenu': {
        display: 'block'
      }
    }
  },
  iconProgress: {
    display: 'block',
    padding: '0 5px'
  },
  folder: {
    padding: '0 !important',
    cursor: 'pointer'
  },
  subFolder: {
    display: 'block !important',
    padding: '0 !important',
    marginLeft: '20px !important'
  },
  highlighted: {
    backgroundColor: 'rgba(0, 0, 0, 0.07) !important'
  },
  listItemText: {
    width: '100%',
    lineHeight: '15px',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    textTransform: 'none',
    fontSize: '13px !important',
    fontFamily: 'Roboto',
    paddingLeft: '5px',
    userSelect: 'none'
  }
};

const useStyles$r = makeStyles$1(theme => _extends({}, styles$16));

function ExpandIcon({ folder, opening, onExpand }) {
  const classes = useStyles$r();
  const folderId = _get(folder, 'id');
  const expanded = _includes(opening, folderId);
  const expandStyle = expanded ? 'icon-sort-desc' : 'icon-caret-right';
  if (folder.contentType !== 'folder' || !folder.hasContent) {
    return React__default.createElement('div', { style: {
        width: 20,
        minWidth: 20
      }
    });
  }
  return React__default.createElement('div', {
    onClick: onExpand(folderId),
    className: cx$1([expandStyle, classes.expandIcon])
  });
}
ExpandIcon.displayName = 'ExpandIcon';
ExpandIcon.propTypes = {
  folder: shape$1(Object),
  onExpand: func,
  opening: arrayOf(oneOfType([number, string]))
};

const useStyles$s = makeStyles$1(theme => _extends({}, styles$16));
function FolderIcon({
  folder,
  highlightedIds,
  isRootFolder,
  isOpening,
  selectable
}) {
  const classes = useStyles$s();
  const folderId = _get(folder, 'id');
  if (isRootFolder) {
    const selected = _includes(highlightedIds, folderId) ? classes.selected : null;
    return React__default.createElement('div', { className: cx$1(['icon-work', classes.folderItem, selected]) });
  }
  const folderIcon = isOpening && folder.childs && folder.childs.length > 0 || _includes(highlightedIds, folderId) && !selectable ? 'icon-open-folder' : folder.hasContent ? 'icon-full-folder' : 'icon-empty-folder';
  switch (folder.contentType) {
    case 'folder':
      return React__default.createElement('div', { className: cx$1([folderIcon, classes.folderIcon]) });
    case 'collection':
      return React__default.createElement('div', { className: cx$1(['icon-collections2', classes.contentIcon]) });
    case 'watchlist':
      return React__default.createElement('div', { className: cx$1(['icon-watchlist', classes.contentIcon]) });
    case 'tdo':
      return React__default.createElement('div', { className: cx$1(['icon-applications', classes.contentIcon]) });
    default:
      return React__default.createElement('div', { className: cx$1(['icon-results', classes.contentIcon]) });
  }
}
FolderIcon.propTypes = {
  folder: shape$1(Object),
  highlightedIds: arrayOf(oneOfType([number, string])),
  isRootFolder: bool,
  isOpening: bool,
  selectable: bool
};

var styles$17 = {
    folderMenuButton: {
        width: '30px !important',
        height: '30px !important',
        margin: '0 5px !important',
        padding: '0 !important'
    }
};

/* eslint-disable react/jsx-no-bind */

const useStyles$t = makeStyles$1(theme => _extends({}, styles$17));

function FolderMenu({
  folderAction,
  onMenuClick,
  folder
}) {
  const classes = useStyles$t();
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    event.stopPropagation();
    const type = event.target.getAttribute('data-type');
    setAnchorEl(null);
    onMenuClick(folder, type);
  };

  return React__default.createElement(
    'div',
    null,
    React__default.createElement(
      IconButton$2,
      {
        className: classes.folderMenuButton,
        'aria-controls': 'simple-menu',
        'aria-haspopup': 'true',
        onClick: handleClick
      },
      React__default.createElement(MoreVertIcon, { style: { fontSize: 20 } })
    ),
    React__default.createElement(
      Menu,
      {
        id: 'folder-tree-menu',
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose
      },
      folderAction.map(item => React__default.createElement(
        MenuItem,
        {
          key: item.id,
          'data-type': item.type,
          onClick: handleClose
        },
        item.name
      ))
    )
  );
}

FolderMenu.displayName = 'FolderMenu';
FolderMenu.propTypes = {
  folderAction: arrayOf(Object),
  onMenuClick: func,
  folder: shape$1(Object)
};

const useStyles$u = makeStyles$1(theme => _extends({}, styles$16));

function Folder({
  opening = [],
  folders,
  childs,
  folder,
  selected,
  isRootFolder,
  onChange,
  onExpand,
  selectable,
  isEnableShowingContent,
  folderAction,
  onMenuClick,
  searchingStatus,
  processingFolder,
  level
}) {
  const classes = useStyles$u();
  const folderId = _get(folder, 'id');
  const isOpening = _includes(opening, folderId);
  const folderLabel = _get(folder, 'name', 'My organization');
  const selectedIds = Object.keys(selected).map(item => {
    if (!isNaN(item)) {
      return parseInt(item);
    }
    return item;
  });
  const isChecked = id => _includes(selectedIds, !isNaN(id) ? parseInt(id) : id);

  const isIndeterminate = folderId => {
    const folder = folders.byId[folderId];
    const childs = _flattenDeep(getAllChildId(folder, folders));
    const childsReprocess = childs.map(item => {
      if (!isNaN(item)) {
        return parseInt(item);
      }
      return item;
    });
    const diff = _difference(childsReprocess, selectedIds);
    return diff.length > 0 && childs.length !== 0 && diff.length < childs.length;
  };

  const isProgressing = _includes(processingFolder, folderId);

  const onChangeItem = folder => () => {
    onChange(folder);
  };

  if (_isNil(folder)) {
    return null;
  }

  if (folder.contentType !== 'folder' && !isEnableShowingContent) {
    return null;
  }

  return React__default.createElement(
    List$1,
    { className: classes.folder },
    React__default.createElement(
      ListItem$1,
      {
        'data-id': folderId,
        onClick: onChangeItem(folder),
        className: cx$1({
          [classes.highlighted]: _includes(selectedIds, folderId) && !selectable,
          [classes.listItem]: true
        })
      },
      React__default.createElement('div', { style: { minWidth: level * 15, width: level * 15 } }),
      !searchingStatus && React__default.createElement(ExpandIcon, {
        onExpand: onExpand,
        folder: folder,
        opening: opening,
        isEnableShowingContent: isEnableShowingContent
      }),
      selectable && React__default.createElement(Checkbox$1, {
        checked: isChecked(folderId),
        indeterminate: isIndeterminate(folderId),
        color: 'primary'
      }),
      React__default.createElement(FolderIcon, {
        folder: folder,
        highlightedIds: selectedIds,
        isRootFolder: isRootFolder,
        isOpening: isOpening,
        selectable: selectable
      }),
      React__default.createElement(ListItemText$1, {
        className: classes.listItemText,
        primary: folderLabel
      }),
      isProgressing && React__default.createElement(
        'div',
        { className: classes.iconProgress },
        React__default.createElement(CircularProgress$1, {
          variant: 'indeterminate',
          size: 16
        })
      ),
      folderAction.length > 0 && !isRootFolder && React__default.createElement(
        'div',
        { className: classes.iconMenu },
        React__default.createElement(FolderMenu, {
          folderAction: folderAction,
          folder: folder,
          onMenuClick: onMenuClick
        })
      )
    ),
    React__default.createElement(
      Collapse$1,
      { 'in': isOpening, style: { padding: 0 } },
      React__default.createElement(
        List$1,
        { disablePadding: true },
        childs.map(child => {
          const nestedChilds = child.childs || [];
          if (_isEmpty(child)) {
            return null;
          }
          return React__default.createElement(Folder, {
            key: child.id,
            isRootFolder: false,
            selectable: selectable,
            selected: selected,
            isEnableShowingContent: isEnableShowingContent,
            onChange: onChange,
            opening: opening,
            onExpand: onExpand,
            rootIds: folders.rootIds,
            folder: folders.byId[child.id],
            childs: nestedChilds.map(childId => folders.byId[childId] || {}),
            folders: folders,
            folderAction: folderAction,
            onMenuClick: onMenuClick,
            searchingStatus: searchingStatus,
            processingFolder: processingFolder,
            level: level + 1
          });
        })
      )
    )
  );
}

Folder.displayName = 'Folder';
Folder.propTypes = {
  childs: arrayOf(Object),
  opening: arrayOf(Object),
  folders: shape$1(Object),
  folder: shape$1(Object),
  selected: shape$1(Object),
  isRootFolder: bool,
  onChange: func,
  onExpand: func,
  selectable: bool,
  isEnableShowingContent: bool,
  folderAction: arrayOf(Object),
  onMenuClick: func,
  searchingStatus: bool,
  processingFolder: arrayOf(Object),
  level: number
};

const useStyles$v = makeStyles$1(theme => _extends({}, styles$16));

const getAllChildId = (item, foldersData) => {
  if (_isNil(item)) {
    return [];
  }
  if (_isNil(item.childs) || _isEmpty(item.childs)) {
    return [item.id];
  } else {
    return [item.id, ...item.childs.map(subitem => getAllChildId(foldersData.byId[subitem], foldersData))];
  }
};

const getAllParentId = (item, folderDataFlatten) => {
  if (_isNil(item) || _isNil(item.parentId)) {
    return [];
  } else {
    return [item.parentId, ...getAllParentId(folderDataFlatten.byId[item.parentId], folderDataFlatten)];
  }
};

const getFolderIds = (folders, isEnableShowRootFolder) => {
  const rootIds = _get(folders, 'rootIds', []);
  if (rootIds.length === 0) {
    return Object.values(folders.byId).filter(folder => _isNil(folder.parentId)).map(item => item.id);
  }
  if (isEnableShowRootFolder) {
    return rootIds;
  }
  const allChildId = rootIds.map(rootId => _get(folders, ['byId', rootId, 'childs'], []));
  return _flatten(allChildId);
};

function FolderTree({
  selectable,
  defaultOpening = [],
  processingFolder = [],
  isEnableShowContent,
  isEnableShowRootFolder,
  foldersData,
  onChange,
  onExpand,
  selected = {},
  folderAction = [],
  onMenuClick
}) {
  const [opening, setopening] = useState([]);
  const classes = useStyles$v();
  React__default.useEffect(() => {
    if (defaultOpening.length > 0) {
      setopening([...opening, ...defaultOpening]);
    }
  }, [defaultOpening]);
  const handleOpenFolder = folderId => event => {
    event.stopPropagation();
    const newOpening = _includes(opening, folderId) ? opening.filter(item => item !== folderId) : [...opening, folderId];
    setopening(newOpening);
    !_includes(opening, folderId) && onExpand(folderId);
  };
  const onChangeSelectedFolder = folder => {
    if (!selectable) {
      onChange({
        [folder.id]: true
      });
    } else {
      const folderId = folder.id;
      const allChildId = _flattenDeep(getAllChildId(folder, foldersData));
      const allParentId = _flattenDeep(getAllParentId(folder, foldersData));
      const parentFolder = foldersData.byId[folder.parentId] || {};
      const childs = parentFolder.childs || [];

      if (selected[folderId]) {
        const childsRemove = allChildId.reduce((acum, currentValue) => {
          return _extends({}, acum, {
            [currentValue]: undefined
          });
        }, {});
        const parentRemove = allParentId.reduce((acum, currentValue) => {
          return _extends({}, acum, {
            [currentValue]: undefined
          });
        }, {});
        const selectedFolder = _extends({}, selected, childsRemove, parentRemove, {
          [folderId]: undefined
        });
        const newSelected = _pickBy(selectedFolder, _identity);
        onChange(_extends({}, newSelected) || {});
      } else {
        const newSelected = allChildId.reduce((acum, currentValue) => {
          return _extends({}, acum, {
            [currentValue]: true
          });
        }, {});
        const selectedIds = Object.keys(_extends({}, selected, newSelected)).map(item => {
          if (!isNaN(item)) {
            return parseInt(item);
          }
          return item;
        });        const diff = _difference(childs, selectedIds);
        if (diff.length === 0 && childs.length !== 0) {
          return onChangeSelectedFolder(parentFolder);
        }
        onChange(_extends({}, selected, newSelected) || {});
      }
    }
  };

  const rootIds = _get(foldersData, 'rootIds', []);
  const dataForMapping = getFolderIds(foldersData, isEnableShowRootFolder);
  return React__default.createElement(
    'div',
    { className: classes.folderTreeContainer },
    dataForMapping.map(folderId => {
      const childs = foldersData.byId[folderId].childs || [];
      const folder = foldersData.byId[folderId];
      if (_isNil(folder)) {
        return null;
      }
      return React__default.createElement(Folder, {
        key: folderId,
        folderAction: folderAction,
        onMenuClick: onMenuClick,
        isRootFolder: _includes(rootIds, folderId),
        selectable: selectable,
        selected: selected,
        isEnableShowingContent: isEnableShowContent,
        onChange: onChangeSelectedFolder,
        opening: opening,
        onExpand: handleOpenFolder,
        rootIds: foldersData.rootIds,
        folder: foldersData.byId[folderId],
        childs: childs.map(childId => foldersData.byId[childId] || {}),
        folders: foldersData,
        processingFolder: processingFolder,
        level: 0
      });
    })
  );
}

FolderTree.displayName = 'FolderTree';
FolderTree.propTypes = {
  selectable: bool,
  foldersData: shape$1(Object),
  selected: shape$1(Object),
  onChange: func,
  onExpand: func,
  folderAction: arrayOf(Object),
  isEnableShowContent: bool,
  isEnableShowRootFolder: bool,
  processingFolder: arrayOf(Object),
  defaultOpening: arrayOf(Object),
  onMenuClick: func
};

var styles$18 = {
  searchBoxRoot: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #e3e3e3',
    '& $input': {
      marginLeft: '8px',
      flex: '1'
    },
    '& $iconButton': {
      padding: '10px'
    }
  },
  input: {},
  iconButton: {},
  closeIcon: {
    color: '#7e7e7e'
  }
};

const useStyles$w = makeStyles$1(() => _extends({}, styles$18));

function Searchbox({
  onSearch,
  onClearSearch,
  placeholder = 'Search'
}) {
  const classes = useStyles$w();
  const inputRef = React__default.createRef();
  const [focusing, setFocusing] = React__default.useState(false);
  const [data, setData] = React__default.useState('');

  function handleSearch() {
    if (!focusing && !data) {
      setFocusing(true);
      inputRef.current.focus();
    } else {
      setFocusing(false);
      if (data) {
        onSearch(data);
      }
    }
  }
  function handleChangeInput(event) {
    setData(event.target.value);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      if (!data && onClearSearch) {
        onClearSearch();
        return;
      }
      onSearch(data);
    }
  }
  function handleRemoveText() {
    setData('');
    if (onClearSearch) {
      onClearSearch();
    } else {
      onSearch('');
    }
  }
  return React__default.createElement(
    'div',
    { 'data-test': 'folderTreeSearchBox', className: classes.searchBoxRoot },
    React__default.createElement(InputBase, {
      onChange: handleChangeInput,
      inputRef: inputRef,
      value: data,
      className: classes.input,
      placeholder: placeholder,
      inputProps: { 'aria-label': 'Search-input' },
      onKeyDown: handleKeyDown
    }),
    data !== '' ? React__default.createElement(
      IconButton$2,
      {
        className: classes.iconButton,
        onClick: handleRemoveText,
        size: 'small'
      },
      React__default.createElement(CloseIcon, { color: 'action' })
    ) : React__default.createElement(
      IconButton$2,
      {
        onClick: handleSearch,
        className: classes.iconButton,
        'aria-label': 'search-button'
      },
      React__default.createElement(SearchIcon, null)
    )
  );
}
Searchbox.displayName = 'Searchbox';
Searchbox.propTypes = {
  onSearch: func.isRequired,
  placeholder: string,
  onClearSearch: func
};

var styles$19 = {
  folderNameField: {
    paddingBottom: '20px !important'
  },
  actionNewField: {
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '20px'
  },
  dialogContent: {
    overflow: 'hidden !important'
  },
  folderTreeCard: {
    overflow: 'auto !important',
    maxHeight: '350px'
  },
  buttonStyles: {
    padding: '6px 16px !important'
  },
  title: {
    fontSize: 15
  }
};

const useStyles$x = makeStyles$1(theme => _extends({}, styles$19));

function DeleteFolder({
  open,
  folder = {},
  handleClose,
  handleSubmit
}) {
  const classes = useStyles$x();
  const [approvedText, setapprovedText] = React__default.useState('');
  const isFolderWithContent = () => {
    return _get(folder, 'hasContent', false);
  };

  const getDialogTitle = () => {
    if (isFolderWithContent()) {
      return 'Delete Folder and Collection';
    }
    return 'Delete Folder';
  };

  const getContent = () => {
    const folderName = _get(folder, 'name', '');
    const folderNameToDisplay = folderName.length > 50 ? `${folderName.substring(0, 50)}...` : folderName;
    if (isFolderWithContent()) {
      return 'You will delete this Folder and its collection(s). Performing this action will delete all infomation including folders and contents.';
    }
    return `You will delete "${folderNameToDisplay}" and its contents. Would you like to continue?`;
  };
  const onDelete = () => {
    handleSubmit(folder);
  };

  const onChaneDeleteField = e => {
    const value = event.target.value;
    setapprovedText(value);
  };

  return React__default.createElement(
    'div',
    null,
    React__default.createElement(
      Dialog,
      {
        fullWidth: true,
        maxWidth: 'sm',
        open: open,
        onClose: handleClose,
        'aria-labelledby': 'create-folder'
      },
      React__default.createElement(
        DialogTitle,
        { id: 'create-folder' },
        React__default.createElement(
          Typography$2,
          { className: classes.title },
          getDialogTitle()
        )
      ),
      React__default.createElement(
        DialogContent,
        { className: classes.dialogContent },
        React__default.createElement(
          'div',
          { className: classes.actionNewField },
          getContent()
        ),
        isFolderWithContent() && React__default.createElement(
          'div',
          { className: classes.folderNameField },
          React__default.createElement(
            'div',
            null,
            'To continue, type ',
            React__default.createElement(
              'b',
              null,
              'DELETE'
            ),
            ' in box to confirm.'
          ),
          React__default.createElement(TextField$1, {
            autoFocus: true,
            margin: 'dense',
            onChange: onChaneDeleteField,
            id: 'deleleConfirm',
            type: 'text'
          })
        )
      ),
      React__default.createElement(
        DialogActions,
        null,
        React__default.createElement(
          Button$2,
          {
            onClick: handleClose,
            color: 'primary',
            className: classes.buttonStyles
          },
          'Cancel'
        ),
        React__default.createElement(
          Button$2,
          {
            disabled: isFolderWithContent() && approvedText !== 'DELETE',
            onClick: onDelete,
            color: 'primary',
            className: classes.buttonStyles
          },
          'Submit'
        )
      )
    )
  );
}
DeleteFolder.displayName = 'DeleteFolder';
DeleteFolder.propTypes = {
  open: bool,
  folder: shape$1(Object).isRequired,
  handleClose: func,
  handleSubmit: func
};

var styles$1a = {
  title: {
    fontSize: 15
  },
  folderNameField: {
    paddingBottom: '20px !important'
  },
  actionNewField: {
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '20px'
  },
  dialogContent: {
    overflow: 'hidden !important'
  },
  folderTreeCard: {
    overflow: 'auto !important',
    maxHeight: '240px',
    minHeight: '200px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#fff'
  },
  buttonStyles: {
    padding: '6px 16px !important'
  },
  counterText: {
    fontSize: '12px ',
    lineHeight: '14px',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2)',
    opacity: '1',
    marginTop: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
};

const useStyles$y = makeStyles$1(theme => _extends({}, styles$1a));

const actionType = {
  1: 'New Folder',
  2: 'Move Folder',
  3: 'Edit Folder'
};

function EditFolder({
  open,
  isNewFolder = false,
  type,
  isEnableEditName = false,
  isEnableEditFolder = false,
  currentFolder = {},
  handleClose,
  handleSubmit,
  foldersData,
  onExpand,
  defaultOpening = [],
  processingFolder = [],
  handerClickNewFolder
}) {
  const classes = useStyles$y();
  const [folderName, setFolderName] = React__default.useState('');
  const [stateOpen, setOpen] = React__default.useState(false);
  const [error, setError] = React__default.useState('');
  const [selectedFolder, setSelectedFolder] = React__default.useState({});
  React__default.useEffect(() => {
    if (!_isNil(currentFolder)) {
      const folderName = _get(currentFolder, 'name');
      setFolderName(folderName);
      setError('');
    }
    return () => {
      setFolderName('');
    };
  }, [currentFolder]);

  React__default.useEffect(() => {
    if (stateOpen !== open) {
      setOpen(open);
    }
  }, [open]);

  React__default.useEffect(() => {
    setFolderName('');
    setError('');
    return () => {
      setFolderName('');
      setError('');
    };
  }, []);

  const onChange = event => {
    const { value } = event.target;
    if (value.length > 50) {
      return;
    }
    setFolderName(value);
    validate(value);
  };

  const onSelectFolder = folders => {
    setSelectedFolder(folders);
  };

  const onUpdate = () => {
    validate(folderName);
    if (error === '') {
      setOpen(false);
      setTimeout(() => {
        handleSubmit(selectedFolder, folderName.trim());
      }, 500);
    }
  };

  const validate = folderNameToValid => {
    if (folderNameToValid.trim().length === 0) {
      return setError('Folder name must not be empty');
    }
    setError('');
  };

  const foldersDataReprocess = () => {
    return _extends({}, foldersData, {
      allId: [...foldersData.allId.filter(item => item !== currentFolder.id)],
      byId: _omit(foldersData.byId, currentFolder.id)
    });
  };

  const handlerNewFolder = () => {
    handerClickNewFolder(selectedFolder);
  };

  const handleCloseWrapper = e => {
    setOpen(false);
    setTimeout(() => {
      handleClose(e);
    }, 500);
  };

  const getSubmitStatus = () => {
    if (type === 3) {
      return folderName === '';
    }
    return folderName === '' || _isEmpty(selectedFolder);
  };

  const getCounter = () => {
    return `${folderName.length}/50`;
  };

  return React__default.createElement(
    'div',
    null,
    React__default.createElement(
      Dialog,
      {
        fullWidth: true,
        maxWidth: 'sm',
        open: stateOpen,
        onClose: handleCloseWrapper,
        'aria-labelledby': 'create-folder'
      },
      React__default.createElement(
        DialogTitle,
        { id: 'create-folder' },
        React__default.createElement(
          Typography$2,
          { className: classes.title },
          actionType[type]
        )
      ),
      React__default.createElement(
        DialogContent,
        { className: classes.dialogContent },
        isEnableEditName && React__default.createElement(
          'div',
          { className: classes.folderNameField },
          React__default.createElement(TextField$1, {
            autoFocus: true,
            margin: 'dense',
            id: 'folder-name',
            label: 'Folder Name',
            type: 'text',
            error: error.length !== 0,
            helperText: error,
            value: folderName,
            onChange: onChange,
            fullWidth: true
          }),
          React__default.createElement(
            'div',
            { className: classes.counterText },
            getCounter()
          )
        ),
        isEnableEditFolder && React__default.createElement(
          'div',
          { className: classes.actionNewField },
          React__default.createElement(
            'div',
            null,
            'Choose a Folder'
          ),
          !isNewFolder && React__default.createElement(
            Button$2,
            {
              color: 'primary',
              className: classes.buttonStyles,
              onClick: handlerNewFolder
            },
            'NEW FOLDER'
          )
        ),
        isEnableEditFolder && React__default.createElement(
          'div',
          { className: classes.folderTreeCard },
          React__default.createElement(FolderTree, {
            selectable: false,
            loading: false,
            foldersData: foldersDataReprocess(),
            onChange: onSelectFolder,
            onExpand: onExpand,
            isEnableShowContent: false,
            isEnableShowRootFolder: true,
            selected: selectedFolder,
            defaultOpening: defaultOpening,
            processingFolder: processingFolder
          })
        )
      ),
      React__default.createElement(
        DialogActions,
        null,
        React__default.createElement(
          Button$2,
          {
            className: classes.buttonStyles,
            onClick: handleCloseWrapper,
            color: 'primary'
          },
          'Cancel'
        ),
        React__default.createElement(
          Button$2,
          {
            disabled: getSubmitStatus(),
            className: classes.buttonStyles,
            onClick: onUpdate,
            color: 'primary'
          },
          'Submit'
        )
      )
    )
  );
}
EditFolder.displayName = 'EditFolder';
EditFolder.propTypes = {
  open: bool,
  isEnableEditName: bool,
  isEnableEditFolder: bool,
  isNewFolder: bool,
  type: number,
  currentFolder: shape$1(Object),
  handleClose: func,
  handleSubmit: func,
  foldersData: shape$1(Object),
  onExpand: func,
  handerClickNewFolder: func,
  defaultOpening: arrayOf(Object),
  processingFolder: arrayOf(Object)
};

var styles$1b = {
  folderNameField: {
    paddingBottom: '20px !important'
  },
  buttonStyles: {
    padding: '6px 16px !important'
  },
  title: {
    fontSize: 15
  },
  counterText: {
    fontSize: '12px ',
    lineHeight: '14px',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2)',
    opacity: '1',
    marginTop: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
};

const useStyles$z = makeStyles$1(theme => _extends({}, styles$1b));

function CreateFolder({
  open,
  parentFolder,
  handleClose,
  handleSubmit
}) {
  const classes = useStyles$z();
  const [folderName, setFolderName] = React__default.useState('');
  const [error, setError] = React__default.useState('');
  React__default.useEffect(() => {
    if (!open) {
      setFolderName('');
      setError('');
    }
  }, [open]);
  const onChange = event => {
    const { value } = event.target;
    if (value.length > 50) {
      return;
    }
    setFolderName(value);
    validate(value);
  };

  const onCreate = () => {
    validate(folderName);
    if (error === '') {
      handleSubmit(folderName.trim(), parentFolder.id);
    }
  };

  React__default.useEffect(() => {
    setFolderName('');
    setError('');
    return () => {
      setFolderName('');
      setError('');
    };
  }, []);

  const validate = folderNameToValid => {
    if (folderNameToValid.trim().length === 0) {
      return setError('Folder name must not be empty');
    }
    setError('');
  };

  const getContent = () => {
    const parentFolderName = _get(parentFolder, 'name', 'Root Folder');
    return `Create folder within "${parentFolderName}"`;
  };

  const getCounter = () => {
    return `${folderName.length}/50`;
  };

  return React__default.createElement(
    Dialog,
    {
      fullWidth: true,
      maxWidth: 'sm',
      open: open,
      onClose: handleClose,
      'aria-labelledby': 'create-folder'
    },
    React__default.createElement(
      DialogTitle,
      { id: 'create-folder' },
      React__default.createElement(
        Typography$2,
        { className: classes.title },
        'Create Folder'
      )
    ),
    React__default.createElement(
      DialogContent,
      null,
      React__default.createElement(
        DialogContentText,
        null,
        getContent()
      ),
      React__default.createElement(
        'div',
        { className: classes.folderNameField },
        React__default.createElement(TextField$1, {
          autoFocus: true,
          margin: 'dense',
          id: 'folder-name',
          label: 'Folder Name',
          type: 'text',
          error: error.length !== 0,
          helperText: error,
          value: folderName,
          onChange: onChange,
          fullWidth: true
        }),
        React__default.createElement(
          'div',
          { className: classes.counterText },
          getCounter()
        )
      )
    ),
    React__default.createElement(
      DialogActions,
      null,
      React__default.createElement(
        Button$2,
        {
          onClick: handleClose,
          color: 'primary',
          className: classes.buttonStyles
        },
        'Cancel'
      ),
      React__default.createElement(
        Button$2,
        {
          disabled: folderName === '',
          onClick: onCreate,
          color: 'primary',
          className: classes.buttonStyles
        },
        'Create'
      )
    )
  );
}
CreateFolder.displayName = 'CreateFolder';
CreateFolder.propTypes = {
  open: bool,
  parentFolder: shape$1(Object),
  handleClose: func,
  handleSubmit: func
};

const useStyles$A = makeStyles$1(theme => _extends({}, styles$16));

function NullState$1() {
  const classes = useStyles$A();
  return React__default.createElement(
    'div',
    { className: classes.loading },
    React__default.createElement(CircularProgress$2, null)
  );
}
NullState$1.displayName = 'NullState';

const useStyles$B = makeStyles$1(theme => _extends({}, styles$16));

function NullState$2({ message }) {
  const classes = useStyles$B();
  return React__default.createElement(
    'div',
    { className: classes.loading },
    message
  );
}
NullState$2.displayName = 'NullState';
NullState$2.propTypes = {
  message: string
};

var styles$1c = {
  container: {
    zIndex: 1000
  },
  popperCustom: {
    zIndex: 1000
  },
  newButton: {
    width: '200px !important',
    height: '38px !important',
    padding: '0 !important',
    backgroundColor: '#2196F3 !important',
    color: '#fff !important',
    boxShadow: '0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149) !important',
    '&:hover': {
      backgroundColor: '#1976d2 !important',
      boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149) !important'
    }
  },
  newText: {
    color: '#FFF',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '16px',
    marginLeft: 8
  },
  arrowIcon: {
    position: 'absolute !important',
    right: '8px !important'
  },
  listItemText: {
    padding: '0 !important',
    color: 'rgba(0,0,0,0.87);',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: '1rem',
    lineHeight: '1.5em'
  },
  listItemIcon: {
    fontSize: 20,
    minWidth: 0,
    marginRight: 16
  }
};

/* eslint-disable react/jsx-no-bind */

const useStyles$C = makeStyles(styles$1c);

function VuiNewButton({ actions }) {
  const classes = useStyles$C();
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const [usePopper, setUsePopper] = React__default.useState(false);
  const handleClick = event => {
    if (usePopper) {
      setAnchorEl(event.currentTarget);
    } else {
      actions[0] && actions[0].actionClick();
    }
  };
  const handleClose = event => {
    setAnchorEl(null);
  };
  const handleClickItem = ({ actionClick }) => event => {
    actionClick();
    handleClose();
  };
  React__default.useEffect(() => {
    if (actions.length > 1) {
      setUsePopper(true);
    }
    return () => {
      setUsePopper(false);
    };
  }, [actions]);
  const openPopper = Boolean(anchorEl);
  const id = openPopper ? 'simple-popover' : undefined;
  return React__default.createElement(
    'div',
    { className: cx$1(classes["container"]) },
    React__default.createElement(
      Button$2,
      {
        'aria-describedby': id,
        className: cx$1(classes['newButton']),
        onClick: handleClick
      },
      React__default.createElement(Add, { className: cx$1(classes['addIcon']) }),
      React__default.createElement(
        'span',
        { className: cx$1(classes['newText']) },
        'NEW'
      ),
      usePopper && React__default.createElement(ArrowDown, { className: cx$1(classes['arrowIcon']) })
    ),
    usePopper && React__default.createElement(
      Popper,
      {
        id: id,
        open: openPopper,
        anchorEl: anchorEl,
        className: cx$1(classes['popperCustom']),
        transition: true,
        disablePortal: true },
      ({ TransitionProps, placement }) => React__default.createElement(
        Grow,
        _extends({}, TransitionProps, {
          id: 'menu-list-grow',
          style: {
            transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            width: 200,
            zIndex: 100
          }
        }),
        React__default.createElement(
          Paper,
          null,
          React__default.createElement(
            ClickAwayListener,
            { onClickAway: handleClose },
            React__default.createElement(
              MenuList,
              null,
              actions.map(action => {
                const icon = action.icon;
                return React__default.createElement(
                  MenuItem,
                  { key: action.id, onClick: handleClickItem(action) },
                  React__default.createElement(
                    ListItemIcon,
                    { className: classes.listItemIcon },
                    React__default.createElement('span', {
                      className: icon
                    })
                  ),
                  React__default.createElement(
                    ListItemText$2,
                    {
                      className: cx$1(classes['listItemText']),
                      inset: true
                    },
                    React__default.createElement(
                      'span',
                      { className: cx$1(classes['listItemText']) },
                      action.name
                    )
                  )
                );
              })
            )
          )
        )
      )
    )
  );
}

VuiNewButton.displayName = 'VuiNewButton';
VuiNewButton.propTypes = {
  actions: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.number,
    name: PropTypes__default.string,
    icon: PropTypes__default.string,
    actionClick: PropTypes__default.func
  }))
};

var styles$1d = {
  subappbarContainer: {
    display: 'flex',
    height: 48,
    alignItems: 'center',
    borderBottom: '1px solid #e3e3e3',
    width: '100%'
  },
  buttonContainerReact: {
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    left: 0,
    color: '#2195F3',
    textTransform: 'initial',
    cursor: 'default',
    width: 239,
    padding: 0
  },
  breadcrumbContainerSubappbar: {
    width: 'calc(100% - 240px)'
  }
};

/* eslint-disable react/jsx-no-bind */

const useStyles$D = makeStyles(styles$1d);

function SubAppbar({ actions, pathList, onCrumbClick, loading }) {
  const classes = useStyles$D();

  return React__default.createElement(
    'div',
    { className: cx$1(classes['subappbarContainer']) },
    React__default.createElement(
      'div',
      { className: cx$1(classes['buttonContainerReact']) },
      React__default.createElement(VuiNewButton, { actions: actions })
    ),
    React__default.createElement(
      'div',
      { className: cx$1(classes['breadcrumbContainerSubappbar']) },
      React__default.createElement(BreadCrums, {
        loading: loading,
        onCrumbClick: onCrumbClick,
        pathList: pathList,
        isEnableSuiteCase: false,
        defaultRootTitle: 'Org collections',
        isEnableBackground: false
      })
    )
  );
}
SubAppbar.displayName = 'SubAppbar';
SubAppbar.propTypes = {
  actions: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.number,
    name: PropTypes__default.string,
    icon: PropTypes__default.string,
    actionClick: PropTypes__default.func
  })),
  pathList: PropTypes__default.arrayOf(PropTypes__default.shape({
    id: PropTypes__default.string,
    name: PropTypes__default.string
  })),
  onCrumbClick: PropTypes__default.func,
  loading: PropTypes__default.bool
};

var styles$1e = {
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%'
  },
  colorContainer: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 8,
    alignItems: 'flex-start'
  },
  searchBarContainer: {
    padding: '0 8px',
    height: 48,
    display: 'flex',
    alignItems: 'center'
  },
  iconColor: {
    color: '#5f6368'
  },
  input: {
    width: '100%',
    gridColumnStart: 2,
    gridColumnEnd: 8,
    fontSize: '16px !important'
  },
  clearButton: {
    gridColumn: 9
  },
  loadingIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  focusedColor: {
    backgroundColor: '#fff'
  }
};

// eslint-disable-next-line
const Div = ({ className, children }) => React__default.createElement(
  'div',
  { className: className },
  children
);
Div.displayName = 'Div';
let SimpleSearchBarBaseComponent = class SimpleSearchBarBaseComponent extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderKey: 101,
      isLoading: true,
      focused: false
    };

    this.clickAway = () => {
      if (this.props.resetOnClickAway) {
        this.props.onChange('');
        this.setState({
          focused: false,
          renderKey: Math.random()
        });
      } else {
        this.setState({
          focused: false
        });
      }
    };

    this.onFocus = () => {
      this.setState({ focused: true });
    };

    this.onChange = event => {
      const newVal = event.target.value;
      if (newVal !== this.props.value && this.props.onChange) {
        this.props.onChange(newVal);
      }
    };

    this.clear = () => {
      this.props.onChange && this.props.onChange('');
      this.props.onClear && this.props.onClear('');
      this.setState({
        value: '',
        focused: false,
        renderKey: Math.random()
      });
    };

    this.onKeyDown = key => {
      // handle esc
      if (this.state.focused && key.keyCode === 27) {
        this.clear();
      }
      // handle enter
      else if (key.keyCode === 13) {
          this.props.onSubmit();
        }
    };
  }

  render() {
    const {
      clickAway,
      onKeyDown,
      clear,
      state: { focused, renderKey },
      props: {
        onSubmit,
        value,
        autocompleteResults,
        placeholder,
        autocomplete,
        isLoading,
        marginTop,
        width,
        classes
      }
    } = this;

    const PaperOrDiv = focused ? Paper : Div;
    const showClear = !!value;
    const showExtension = !!(autocomplete && autocompleteResults && autocompleteResults.length && value && focused);

    let _width;
    if (!width && !_isNumber(width)) {
      _width = '512px';
    } else if (_isNumber(width)) {
      _width = width + 'px';
    } else {
      _width = width;
    }

    return (
      // render key added to force render during cleanup
      React__default.createElement(
        ClickAwayListener,
        { onClickAway: clickAway, key: renderKey },
        React__default.createElement(
          'div',
          { style: { marginTop }, className: classes.wrapper },
          React__default.createElement(
            PaperOrDiv,
            {
              style: {
                borderRadius: 8
              },
              className: cx$1({
                [classes.colorContainer]: true,
                [classes.focusedColor]: focused
              })
            },
            React__default.createElement(
              'div',
              { 'data-test': 'simpleSearchBarContainer', className: classes.searchBarContainer, style: { width: _width } },
              React__default.createElement(
                IconButton$2,
                { 'data-test': 'simpleSearchBarIcon', disabled: !focused, onClick: onSubmit },
                React__default.createElement(Search, { className: classes.iconColor })
              ),
              React__default.createElement(Input$1, {
                'data-test': 'simpleSearchBarInput'
                // handle esc and enter
                , onKeyDown: onKeyDown
                // disable browser auto complete
                , autoComplete: 'false'
                // remove material's underline
                , disableUnderline: true,
                placeholder: placeholder || 'Search',
                autoFocus: focused,
                value: value,
                onChange: this.onChange,
                onFocus: this.onFocus,
                className: cx$1(classes.input),
                key: renderKey + 1
              }),
              React__default.createElement(
                Zoom,
                { 'in': !!(focused && showClear && isLoading) },
                React__default.createElement(
                  'div',
                  { 'data-test': 'simpleSearchBarLoadingIcon', className: cx$1(classes.loadingIcon) },
                  React__default.createElement(CircularProgress$2, { size: 20 })
                )
              ),
              React__default.createElement(
                Zoom,
                { 'in': showClear, className: cx$1(classes.clearButton) },
                React__default.createElement(
                  IconButton$2,
                  { 'data-test': 'simpleSearchBarClearIcon', onClick: this.clear },
                  React__default.createElement(Clear, null)
                )
              )
            ),
            showExtension && React__default.createElement(
              Fragment,
              null,
              React__default.createElement(Divider, null),
              React__default.createElement(
                'div',
                { style: { overflow: 'scroll', background: 'white' } },
                autocompleteResults.map(result => {
                  // if we have plain string array
                  // eslint-disable-next-line lodash/prefer-lodash-typecheck
                  if (typeof result === 'string') {
                    return React__default.createElement(
                      MenuItem,
                      {
                        key: result
                        // eslint-disable-next-line react/jsx-no-bind
                        , onClick: () => clear() || result.onClick(result)
                      },
                      result
                    );
                  }
                  // if we have data groups
                  else {
                      if (result.data && result.data.length) {
                        // get the template
                        let TemplateComponent = result.template;
                        return React__default.createElement(
                          Fragment,
                          { key: Math.random() },
                          // map data to template
                          result.data.map(data => {
                            // eslint-disable-next-line lodash/prefer-lodash-typecheck
                            if (typeof data === 'string') {
                              return React__default.createElement(
                                MenuItem,
                                {
                                  key: data
                                  // eslint-disable-next-line react/jsx-no-bind
                                  , onClick: () => clear() || result.onClick(data)
                                },
                                TemplateComponent(data)
                              );
                            } else {
                              return React__default.createElement(
                                MenuItem,
                                {
                                  key: data.id || data.key
                                  // eslint-disable-next-line react/jsx-no-bind
                                  , onClick: () => clear() || result.onClick(data)
                                },
                                React__default.createElement(TemplateComponent, data)
                              );
                            }
                          }),
                          React__default.createElement(Divider, null)
                        );
                      }
                    }
                })
              )
            )
          )
        )
      )
    );
  }
};
SimpleSearchBarBaseComponent.displayName = 'SimpleSearchBarBaseComponent';


SimpleSearchBarBaseComponent.propTypes = {
  autocomplete: bool,
  onChange: func,
  onSubmit: func,
  onClear: func,
  value: string,
  isLoading: bool,
  placeholder: string,
  autocompleteResults: arrayOf(shape$1({
    template: oneOfType([element, func]),
    // literally array of any
    data: arrayOf(any),
    onClick: func
  })),
  resetOnClickAway: bool,
  marginTop: string,
  width: oneOfType([string, number]),
  classes: shape$1({ any })
};

const SimpleSearchBarBase = withStyles$1(styles$1e)(SimpleSearchBarBaseComponent);

var _class$U, _temp2$H;

let SimpleSearchBarController = (_temp2$H = _class$U = class SimpleSearchBarController extends React__default.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = {
      value: ''
    }, this.onChange = value => {
      this.setState({ value });
    }, this.onSubmit = data => {
      this.props.onSubmit(this.state.value);
    }, _temp;
  }

  render() {
    let {
      state: { value },
      props: { autocompleteResults, marginTop },
      onChange,
      onSubmit
    } = this;

    return React__default.createElement(SimpleSearchBarBase, {
      resetOnClickAway: true,
      autocomplete: true,
      onChange: onChange,
      onSubmit: onSubmit,
      value: value,
      autocompleteResults: autocompleteResults || [],
      placeholder: 'Search',
      marginTop: marginTop
    });
  }
}, _class$U.propTypes = {
  onSubmit: func,
  autocompleteResults: arrayOf(any),
  marginTop: string
}, _temp2$H);
SimpleSearchBarController.displayName = 'SimpleSearchBarController';

/**
 * Simple text component, takes string and returns it as react component
 * @param text
 * @returns {*}
 * @constructor
 */
const SimpleText = text => React__default.createElement(
  Fragment,
  null,
  text
);
SimpleText.displayName = 'SimpleText';

/**
 * Sample entity template
 * Any template could be passed into auto complete result along with data
 * Styles intentionally kept here
 * @param name
 * @param description
 * @param image
 * @returns {*}
 * @constructor
 */
const EntitySearchTemplate = ({ name, description, image }) => {
  return React__default.createElement(
    'div',
    {
      style: {
        display: 'grid',
        gridTemplateColumns: '48px auto',
        gridTemplateRows: '16px 16px',
        gridColumnGap: '8px',
        gridRowGap: '8px'
      }
    },
    React__default.createElement(
      'div',
      { style: { gridColumn: '1 1', gridRow: '1 2' } },
      React__default.createElement(Avatar$1, { src: image })
    ),
    React__default.createElement(
      'div',
      { style: { gridColumnStart: 2, gridRowStart: 1 } },
      name
    ),
    React__default.createElement(
      'div',
      { style: { gridColumnStart: 2, gridRowStart: 2 } },
      React__default.createElement(
        Typography$2,
        { variant: 'caption' },
        description
      )
    )
  );
};

EntitySearchTemplate.displayName = 'EntitySearchTemplate';
EntitySearchTemplate.propTypes = {
  name: string,
  image: string,
  description: string
};

var _class$V, _temp$e;

let SimpleSearchBar = (_temp$e = _class$V = class SimpleSearchBar extends SimpleSearchBarController {
  render() {
    return React__default.createElement(SimpleSearchBarBase, _extends({
      autocomplete: false,
      onChange: this.onChange,
      value: this.state.value,
      onSubmit: this.onSubmit
    }, this.props));
  }
}, _class$V.propTypes = {
  onSubmit: func
}, _temp$e);
SimpleSearchBar.displayName = 'SimpleSearchBar';

var useStyles$E = makeStyles$1(_ => createStyles({
  previewContainer: {
    'display': 'flex',
    'align-items': 'center'
  },
  previewContainerSelected: {
    'border': '1px dashed #a5a5a5'
  },
  previewIcon: {
    'margin': '0 0 0 8px',
    'cursor': 'pointer'
  },
  helpIcon: {
    'font-size': '14px'
  },
  itemCheckbox: {
    'display': 'flex',
    'align-items': 'center'
  },
  previewContent: {
    'width': '80% !important',
    'padding-left': '20px',
    'padding-bottom': '20px'
  },
  previewAction: {
    'display': 'flex',
    'margin-left': '20px'
  },
  dialogFooter: {
    'margin': '15px'
  },
  itemPreview: {
    'margin-bottom': '20px'
  },
  titleParagraph: {
    'margin-top': '0'
  },
  box: {
    'border-width': '1px',
    'border-color': 'rgba(0, 0, 0, 0.23)',
    'width': '100%',
    'border-radius': '5px'
  },
  formItem: {
    'margin-top': '20px !important'
  },
  ratingBox: {
    'width': '100%',
    'margin-bottom': '0 !important'
  }
}));

function Checkboxes({
  label,
  required,
  name,
  onChange,
  instruction,
  value,
  items,
  error
}) {
  const styles = useStyles$E({});

  const handleChange = React__default.useCallback(e => {
    const isItemChecked = value.includes(e.target.value);
    if (isItemChecked) {
      onChange({
        name,
        value: value.filter(itemValue => itemValue !== e.target.value)
      });
    } else {
      onChange({ name, value: [...value, e.target.value] });
    }
  }, [name, value, onChange]);

  return React__default.createElement(
    FormControl,
    {
      error: error.length > 0,
      fullWidth: true,
      className: styles.formItem
    },
    React__default.createElement(
      Box,
      {
        component: 'fieldset',
        className: styles.box
      },
      label && React__default.createElement(
        Typography$2,
        { component: 'legend', variant: 'caption' },
        label + `${required ? '*' : ''}`
      ),
      React__default.createElement(
        FormGroup,
        null,
        items.map(item => {
          return React__default.createElement(FormControlLabel, {
            key: item.id,
            className: styles.itemCheckbox,
            control: React__default.createElement(Checkbox$3, {
              value: item.value,
              checked: value.includes(item.value),
              onChange: handleChange,
              color: 'primary',
              name: name
            }),
            label: item.value
          });
        })
      )
    ),
    (error || instruction) && React__default.createElement(
      FormHelperText,
      { variant: 'outlined' },
      error || instruction
    )
  );
}

Checkboxes.displayName = 'Checkboxes';
Checkboxes.propTypes = {
  label: string,
  name: string,
  required: bool,
  instruction: string,
  value: arrayOf(string),
  onChange: func,
  items: arrayOf(shape$1({
    id: string,
    value: string
  })),
  error: string
};

Checkboxes.defaultProps = {
  value: [],
  items: [],
  onChange: () => {},
  error: ''
};

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date)) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

var DateFnsUtils = /** @class */ (function () {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function (value, count) {
        return addDays(value, count);
    };
    DateFnsUtils.prototype.isValid = function (value) {
        return isValid(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function (value, comparing) {
        return differenceInMilliseconds(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function (value, comparing) {
        return isAfter(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function (value, comparing) {
        return isBefore(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function (value) {
        return startOfDay(value);
    };
    DateFnsUtils.prototype.endOfDay = function (value) {
        return endOfDay(value);
    };
    DateFnsUtils.prototype.getHours = function (value) {
        return getHours(value);
    };
    DateFnsUtils.prototype.setHours = function (value, count) {
        return setHours(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function (value, count) {
        return setMinutes(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function (value) {
        return getSeconds(value);
    };
    DateFnsUtils.prototype.setSeconds = function (value, count) {
        return setSeconds(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function (value, comparing) {
        return isSameDay(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function (value) {
        return startOfMonth(value);
    };
    DateFnsUtils.prototype.endOfMonth = function (value) {
        return endOfMonth(value);
    };
    DateFnsUtils.prototype.getYear = function (value) {
        return getYear(value);
    };
    DateFnsUtils.prototype.setYear = function (value, count) {
        return setYear(value, count);
    };
    DateFnsUtils.prototype.date = function (value) {
        if (typeof value === "undefined") {
            return new Date();
        }
        if (value === null) {
            return null;
        }
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function (value, formatString) {
        if (value === "") {
            return null;
        }
        return parse(value, formatString, new Date(), { locale: this.locale });
    };
    DateFnsUtils.prototype.format = function (date, formatString) {
        return format(date, formatString, { locale: this.locale });
    };
    DateFnsUtils.prototype.isEqual = function (date, comparing) {
        if (date === null && comparing === null) {
            return true;
        }
        return isEqual(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function (date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function (date, value) {
        return isAfter(date, endOfDay(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function (date, value) {
        return isBefore(date, startOfDay(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function (date, value) {
        return isBefore(date, startOfYear(value));
    };
    DateFnsUtils.prototype.isAfterYear = function (date, value) {
        return isAfter(date, endOfYear(value));
    };
    DateFnsUtils.prototype.formatNumber = function (numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function (date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function (date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function (date, count) {
        return setMonth(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function (ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function (date) {
        return addMonths(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function (date) {
        return addMonths(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function (date) {
        var firstMonth = startOfYear(date);
        var monthArray = [firstMonth];
        while (monthArray.length < 12) {
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function (date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function () {
        var _this = this;
        var now = new Date();
        return eachDayOfInterval({
            start: startOfWeek(now, { locale: this.locale }),
            end: endOfWeek(now, { locale: this.locale })
        }).map(function (day) { return _this.format(day, "EEEEEE"); });
    };
    DateFnsUtils.prototype.getWeekArray = function (date) {
        var start = startOfWeek(startOfMonth(date), { locale: this.locale });
        var end = endOfWeek(endOfMonth(date), { locale: this.locale });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while (isBefore(current, end)) {
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function (start, end) {
        var startDate = startOfYear(start);
        var endDate = endOfYear(end);
        var years = [];
        var current = startDate;
        while (isBefore(current, endDate)) {
            years.push(current);
            current = addYears(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function (date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function (date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function (date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function (date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function (date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function (date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function (date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function (date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function (date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}());

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MuiPickersContext = createContext(null);
var MuiPickersUtilsProvider = function MuiPickersUtilsProvider(_ref) {
  var Utils = _ref.utils,
      children = _ref.children,
      locale = _ref.locale,
      libInstance = _ref.libInstance;
  var utils = useMemo(function () {
    return new Utils({
      locale: locale,
      instance: libInstance
    });
  }, [Utils, libInstance, locale]);
  return createElement(MuiPickersContext.Provider, {
    value: utils,
    children: children
  });
};

var checkUtils = function checkUtils(utils) {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
  }
};
function useUtils() {
  var utils = useContext(MuiPickersContext);
  checkUtils(utils);
  return utils;
}

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/** Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var DIALOG_WIDTH = 310;
var DIALOG_WIDTH_WIDER = 325;
var VIEW_HEIGHT = 305;

var useStyles$F = makeStyles$1(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var children = _ref.children;
  var classes = useStyles$F();
  return createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  });
};

var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onClear = _ref.onClear,
      onSetToday = _ref.onSetToday,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      clearable = _ref.clearable,
      showTodayButton = _ref.showTodayButton,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      other = _objectWithoutProperties$1(_ref, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);

  return createElement(Dialog, _extends$4({
    role: "dialog",
    onClose: onDismiss,
    classes: {
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }
  }, other), createElement(DialogContent, {
    children: children,
    className: classes.dialog
  }), createElement(DialogActions, {
    classes: {
      root: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
    }
  }, clearable && createElement(Button$2, {
    color: "primary",
    onClick: onClear
  }, clearLabel), showTodayButton && createElement(Button$2, {
    color: "primary",
    onClick: onSetToday
  }, todayLabel), cancelLabel && createElement(Button$2, {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), okLabel && createElement(Button$2, {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';
var styles$1f = createStyles({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
});
var ModalDialog$1 = withStyles$2(styles$1f, {
  name: 'MuiPickersModal'
})(ModalDialog);

var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
function runKeyHandler(e, keyHandlers) {
  var handler = keyHandlers[e.key];

  if (handler) {
    handler(); // if event was handled prevent other side effects (e.g. page scroll)

    e.preventDefault();
  }
}
function useKeyDown(active, keyHandlers) {
  var keyHandlersRef = useRef(keyHandlers);
  keyHandlersRef.current = keyHandlers;
  useIsomorphicEffect(function () {
    if (active) {
      var handleKeyDown = function handleKeyDown(event) {
        runKeyHandler(event, keyHandlersRef.current);
      };

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [active]);
}

var ModalWrapper = function ModalWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      InputComponent = _ref.InputComponent,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      other = _objectWithoutProperties$1(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);

  useKeyDown(open, {
    Enter: onAccept
  });
  return createElement(Fragment, null, createElement(InputComponent, _extends$4({}, other, DateInputProps)), createElement(ModalDialog$1, _extends$4({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children
  }, DialogProps)));
};
ModalWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};

var InlineWrapper = function InlineWrapper(_ref) {
  var open = _ref.open,
      wider = _ref.wider,
      children = _ref.children,
      PopoverProps = _ref.PopoverProps,
      onClear = _ref.onClear,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      onAccept = _ref.onAccept,
      showTabs = _ref.showTabs,
      DateInputProps = _ref.DateInputProps,
      InputComponent = _ref.InputComponent,
      other = _objectWithoutProperties$1(_ref, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]);

  var ref = useRef();
  useKeyDown(open, {
    Enter: onAccept
  });
  return createElement(Fragment, null, createElement(InputComponent, _extends$4({}, other, DateInputProps, {
    inputRef: ref
  })), createElement(Popover, _extends$4({
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    children: children
  }, PopoverProps)));
};

function getWrapperFromVariant(variant) {
  switch (variant) {
    case 'inline':
      return InlineWrapper;

    case 'static':
      return StaticWrapper;

    default:
      return ModalWrapper;
  }
}
var VariantContext = createContext(null);
var Wrapper = function Wrapper(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties$1(_ref, ["variant"]);

  var Component = getWrapperFromVariant(variant);
  return createElement(VariantContext.Provider, {
    value: variant || 'dialog'
  }, createElement(Component, props));
};

var Rifm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Rifm, _React$Component);

  function Rifm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._state = null;
    _this._del = false;

    _this._handleChange = function (evt) {


      var stateValue = _this.state.value;
      var value = evt.target.value;
      var input = evt.target;
      var op = value.length > stateValue.length;
      var del = _this._del;

      var noOp = stateValue === _this.props.format(value);

      _this.setState({
        value: value,
        local: true
      }, function () {
        var selectionStart = input.selectionStart;
        var refuse = _this.props.refuse || /[^\d]+/g;
        var before = value.substr(0, selectionStart).replace(refuse, '');
        _this._state = {
          input: input,
          before: before,
          op: op,
          di: del && noOp,
          del: del
        };

        if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
          var start = -1;

          for (var i = 0; i !== before.length; ++i) {
            start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
          }

          var c = value.substr(start + 1).replace(refuse, '')[0];
          start = value.indexOf(c, start + 1);
          value = "" + value.substr(0, start) + value.substr(start + 1);
        }

        var fv = _this.props.format(value);

        if (stateValue === fv) {
          _this.setState({
            value: value
          });
        } else {
          _this.props.onChange(fv);
        }
      });
    };

    _this._hKD = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = true;
      }
    };

    _this._hKU = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = false;
      }
    };

    _this.state = {
      value: props.value,
      local: true
    };
    return _this;
  }

  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      value: state.local ? state.value : props.value,
      local: false
    };
  };

  var _proto = Rifm.prototype;

  _proto.render = function render() {
    var _handleChange = this._handleChange,
        value = this.state.value,
        children = this.props.children;
    return children({
      value: value,
      onChange: _handleChange
    });
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this._hKD);
    document.removeEventListener('keyup', this._hKU);
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this._hKD);
    document.addEventListener('keyup', this._hKU);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _state = this._state;

    if (_state) {
      var value = this.state.value;
      var start = -1;

      for (var i = 0; i !== _state.before.length; ++i) {
        start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
      } // format usually looks better without this


      if (this.props.replace && (_state.op || _state.del && !_state.di)) {
        while (value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1])) {
          start += 1;
        }
      }

      _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
    }

    this._state = null;
  };

  return Rifm;
}(Component);

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var useStyles$G = makeStyles$1(function (theme) {
  return {
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '0 2px',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    daySelected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersDay'
});
var Day = function Day(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      current = _ref.current,
      selected = _ref.selected,
      other = _objectWithoutProperties$1(_ref, ["children", "disabled", "hidden", "current", "selected"]);

  var classes = useStyles$G();
  var className = clsx(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
  return createElement(IconButton$2, _extends$4({
    className: className,
    tabIndex: hidden || disabled ? -1 : 0
  }, other), createElement(Typography$2, {
    variant: "body2",
    color: "inherit"
  }, children));
};
Day.displayName = 'Day';
Day.defaultProps = {
  disabled: false,
  hidden: false,
  current: false,
  selected: false
};

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var hasClass_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
});

unwrapExports(hasClass_1$1);

var addClass_1$1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = addClass;

var _hasClass = interopRequireDefault(hasClass_1$1);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];
});

var addOneClass = unwrapExports(addClass_1$1);

function replaceClassName$1(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass$1 = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName$1(element.className, className);else element.setAttribute('class', replaceClassName$1(element.className && element.className.baseVal || '', className));
};

var config$1 = {
  disabled: false
};

var TransitionGroupContext$1 = React__default.createContext(null);

var UNMOUNTED$1 = 'unmounted';
var EXITED$1 = 'exited';
var ENTERING$1 = 'entering';
var ENTERED$1 = 'entered';
var EXITING$1 = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED$1;
        _this.appearStatus = ENTERING$1;
      } else {
        initialStatus = ENTERED$1;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED$1;
      } else {
        initialStatus = EXITED$1;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED$1) {
      return {
        status: EXITED$1
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING$1 && status !== ENTERED$1) {
          nextStatus = ENTERING$1;
        }
      } else {
        if (status === ENTERING$1 || status === ENTERED$1) {
          nextStatus = EXITING$1;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = ReactDOM__default.findDOMNode(this);

      if (nextStatus === ENTERING$1) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED$1) {
      this.setState({
        status: UNMOUNTED$1
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config$1.disabled) {
      this.safeSetState({
        status: ENTERED$1
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING$1
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED$1
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || config$1.disabled) {
      this.safeSetState({
        status: EXITED$1
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING$1
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED$1
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED$1) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return React__default.createElement(TransitionGroupContext$1.Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = React__default.Children.only(children);
    return (// allows for nested Transitions
      React__default.createElement(TransitionGroupContext$1.Provider, {
        value: null
      }, React__default.cloneElement(child, childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition$1.contextType = TransitionGroupContext$1;
Transition$1.propTypes =  {};

function noop$1() {}

Transition$1.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition$1.UNMOUNTED = 0;
Transition$1.EXITED = 1;
Transition$1.ENTERING = 2;
Transition$1.ENTERED = 3;
Transition$1.EXITING = 4;

var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addOneClass(node, c);
  });
};

var removeClass$2 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (node, appearing) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    if (type === 'appear' && phase === 'done') {
      className += " " + this.getClassNames('enter').doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    this.appliedClasses[type][phase] = className;

    _addClass(node, className);
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$2(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$2(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$2(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return React__default.createElement(Transition$1, _extends$4({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  {};

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping$1(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings$1(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp$1(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping$1(props, onExited) {
  return getChildMapping$1(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp$1(child, 'appear', props),
      enter: getProp$1(child, 'enter', props),
      exit: getProp$1(child, 'exit', props)
    });
  });
}
function getNextChildMapping$1(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping$1(nextProps.children);
  var children = mergeChildMappings$1(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp$1(child, 'exit', nextProps),
        enter: getProp$1(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp$1(child, 'exit', nextProps),
        enter: getProp$1(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values$1 = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$1(_assertThisInitialized$1(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping$1(nextProps, handleExited) : getNextChildMapping$1(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping$1(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$4({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values$1(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return React__default.createElement(TransitionGroupContext$1.Provider, {
        value: contextValue
      }, children);
    }

    return React__default.createElement(TransitionGroupContext$1.Provider, {
      value: contextValue
    }, React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup$1.propTypes =  {};
TransitionGroup$1.defaultProps = defaultProps$1;

var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
      utils = _ref.utils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = date;
  var backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  } // fallback to today if no enabled days


  return utils.date();
};
var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
};
var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.yearFormat;
  }

  if (isYearAndMonthViews(views)) {
    return utils.yearMonthFormat;
  }

  return utils.dateFormat;
};

var DayWrapper = function DayWrapper(_ref) {
  var children = _ref.children,
      value = _ref.value,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      dayInCurrentMonth = _ref.dayInCurrentMonth,
      other = _objectWithoutProperties$1(_ref, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]);

  var handleClick = useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return createElement("div", _extends$4({
    role: "presentation",
    onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
    onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
  }, other), children);
};

var animationDuration = 350;
var useStyles$H = makeStyles$1(function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: animationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)'
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)'
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-200%)',
      transition: slideTransition
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(200%)',
      transition: slideTransition
    }
  };
}, {
  name: 'MuiPickersSlideTransition'
});

var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
      transKey = _ref.transKey,
      slideDirection = _ref.slideDirection,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var classes = useStyles$H();
  var transitionClasses = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    // @ts-ignore
    enter: classes['slideEnter-' + slideDirection],
    // @ts-ignore
    exitActive: classes['slideExitActiveLeft-' + slideDirection]
  };
  return createElement(TransitionGroup$1, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, createElement(CSSTransition, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey + slideDirection,
    timeout: animationDuration,
    classNames: transitionClasses,
    children: children
  }));
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return React__default.createElement(SvgIcon$2, props, React__default.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return React__default.createElement(SvgIcon$2, props, React__default.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var useStyles$1$1 = makeStyles$1(function (theme) {
  return {
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1)
    },
    transitionContainer: {
      width: '100%',
      overflow: 'hidden',
      height: 23
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: '0 2px',
      textAlign: 'center',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersCalendarHeader'
});
var CalendarHeader = function CalendarHeader(_ref) {
  var currentMonth = _ref.currentMonth,
      onMonthChange = _ref.onMonthChange,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      disablePrevMonth = _ref.disablePrevMonth,
      disableNextMonth = _ref.disableNextMonth,
      slideDirection = _ref.slideDirection;
  var utils = useUtils();
  var classes = useStyles$1$1();
  var theme = useTheme$2();
  var rtl = theme.direction === 'rtl';

  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };

  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };

  return createElement("div", null, createElement("div", {
    className: classes.switchHeader
  }, createElement(IconButton$2, _extends$4({}, leftArrowButtonProps, {
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth,
    className: classes.iconButton
  }), rtl ? rightArrowIcon : leftArrowIcon), createElement(SlideTransition, {
    slideDirection: slideDirection,
    transKey: currentMonth.toString(),
    className: classes.transitionContainer
  }, createElement(Typography$2, {
    align: "center",
    variant: "body1"
  }, utils.getCalendarHeaderText(currentMonth))), createElement(IconButton$2, _extends$4({}, rightArrowButtonProps, {
    disabled: disableNextMonth,
    onClick: selectNextMonth,
    className: classes.iconButton
  }), rtl ? leftArrowIcon : rightArrowIcon)), createElement("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, index) {
    return createElement(Typography$2, {
      key: index // eslint-disable-line react/no-array-index-key
      ,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })));
};
CalendarHeader.displayName = 'CalendarHeader';
CalendarHeader.defaultProps = {
  leftArrowIcon: createElement(ArrowLeftIcon, null),
  rightArrowIcon: createElement(ArrowRightIcon, null),
  disablePrevMonth: false,
  disableNextMonth: false
};

var withUtils = function withUtils() {
  return function (Component) {
    var WithUtils = function WithUtils(props) {
      var utils = useUtils();
      return createElement(Component, _extends$4({
        utils: utils
      }, props));
    };

    WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
    return WithUtils;
  };
};

var KeyDownListener = function KeyDownListener(_ref) {
  var onKeyDown = _ref.onKeyDown;
  useEffect(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
  return null;
};

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      slideDirection: 'left',
      currentMonth: _this.props.utils.startOfMonth(_this.props.date),
      loadingQueue: 0
    };

    _this.pushToLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue + 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.popFromLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue;
      loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.handleChangeMonth = function (newMonth, slideDirection) {
      _this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });

      if (_this.props.onMonthChange) {
        var returnVal = _this.props.onMonthChange(newMonth);

        if (returnVal) {
          _this.pushToLoadingQueue();

          returnVal.then(function () {
            _this.popFromLoadingQueue();
          });
        }
      }
    };

    _this.validateMinMaxDate = function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          utils = _this$props.utils,
          disableFuture = _this$props.disableFuture,
          disablePast = _this$props.disablePast;
      var now = utils.date();
      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
    };

    _this.shouldDisablePrevMonth = function () {
      var _this$props2 = _this.props,
          utils = _this$props2.utils,
          disablePast = _this$props2.disablePast,
          minDate = _this$props2.minDate;
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
      return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableNextMonth = function () {
      var _this$props3 = _this.props,
          utils = _this$props3.utils,
          disableFuture = _this$props3.disableFuture,
          maxDate = _this$props3.maxDate;
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
      return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableDate = function (day) {
      var shouldDisableDate = _this.props.shouldDisableDate;
      return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
    };

    _this.handleDaySelect = function (day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props4 = _this.props,
          date = _this$props4.date,
          utils = _this$props4.utils;

      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
    };

    _this.moveToDay = function (day) {
      var utils = _this.props.utils;

      if (day && !_this.shouldDisableDate(day)) {
        if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) {
          _this.handleChangeMonth(utils.startOfMonth(day), 'left');
        }

        _this.handleDaySelect(day, false);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props5 = _this.props,
          theme = _this$props5.theme,
          date = _this$props5.date,
          utils = _this$props5.utils;
      runKeyHandler(event, {
        ArrowUp: function ArrowUp() {
          return _this.moveToDay(utils.addDays(date, -7));
        },
        ArrowDown: function ArrowDown() {
          return _this.moveToDay(utils.addDays(date, 7));
        },
        ArrowLeft: function ArrowLeft() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
        },
        ArrowRight: function ArrowRight() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
        }
      });
    };

    _this.renderWeeks = function () {
      var _this$props6 = _this.props,
          utils = _this$props6.utils,
          classes = _this$props6.classes;
      var weeks = utils.getWeekArray(_this.state.currentMonth);
      return weeks.map(function (week) {
        return createElement("div", {
          key: "week-".concat(week[0].toString()),
          className: classes.week
        }, _this.renderDays(week));
      });
    };

    _this.renderDays = function (week) {
      var _this$props7 = _this.props,
          date = _this$props7.date,
          renderDay = _this$props7.renderDay,
          utils = _this$props7.utils;
      var now = utils.date();
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
      return week.map(function (day) {
        var disabled = _this.shouldDisableDate(day);

        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var dayComponent = createElement(Day, {
          disabled: disabled,
          current: utils.isSameDay(day, now),
          hidden: !isDayInCurrentMonth,
          selected: utils.isSameDay(selectedDate, day)
        }, utils.getDayText(day));

        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
        }

        return createElement(DayWrapper, {
          value: day,
          key: day.toString(),
          disabled: disabled,
          dayInCurrentMonth: isDayInCurrentMonth,
          onSelect: _this.handleDaySelect
        }, dayComponent);
      });
    };

    return _this;
  }

  _createClass$1(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          date = _this$props8.date,
          minDate = _this$props8.minDate,
          maxDate = _this$props8.maxDate,
          utils = _this$props8.utils,
          disablePast = _this$props8.disablePast,
          disableFuture = _this$props8.disableFuture;

      if (this.shouldDisableDate(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          date: date,
          utils: utils,
          minDate: utils.date(minDate),
          maxDate: utils.date(maxDate),
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: this.shouldDisableDate
        });
        this.handleDaySelect(closestEnabledDate, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentMonth = _this$state.currentMonth,
          slideDirection = _this$state.slideDirection;
      var _this$props9 = this.props,
          classes = _this$props9.classes,
          allowKeyboardControl = _this$props9.allowKeyboardControl,
          leftArrowButtonProps = _this$props9.leftArrowButtonProps,
          leftArrowIcon = _this$props9.leftArrowIcon,
          rightArrowButtonProps = _this$props9.rightArrowButtonProps,
          rightArrowIcon = _this$props9.rightArrowIcon,
          loadingIndicator = _this$props9.loadingIndicator;
      var loadingElement = loadingIndicator ? loadingIndicator : createElement(CircularProgress$2, null);
      return createElement(Fragment, null, allowKeyboardControl && this.context !== 'static' && createElement(KeyDownListener, {
        onKeyDown: this.handleKeyDown
      }), createElement(CalendarHeader, {
        currentMonth: currentMonth,
        slideDirection: slideDirection,
        onMonthChange: this.handleChangeMonth,
        leftArrowIcon: leftArrowIcon,
        leftArrowButtonProps: leftArrowButtonProps,
        rightArrowIcon: rightArrowIcon,
        rightArrowButtonProps: rightArrowButtonProps,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), createElement(SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
      }, createElement(Fragment, null, this.state.loadingQueue > 0 && createElement("div", {
        className: classes.progressContainer
      }, loadingElement) || createElement("div", null, this.renderWeeks()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var utils = nextProps.utils,
          nextDate = nextProps.date;

      if (!utils.isEqual(nextDate, state.lastDate)) {
        var nextMonth = utils.getMonth(nextDate);
        var lastDate = state.lastDate || nextDate;
        var lastMonth = utils.getMonth(lastDate);
        return {
          lastDate: nextDate,
          currentMonth: nextProps.utils.startOfMonth(nextDate),
          // prettier-ignore
          slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(Component);
Calendar.contextType = VariantContext;
Calendar.defaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  disablePast: false,
  disableFuture: false,
  allowKeyboardControl: true
};
var styles$1g = function styles(theme) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: theme.spacing(1.5)
    },
    progressContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    week: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};
var Calendar$1 = withStyles$2(styles$1g, {
  name: 'MuiPickersCalendar',
  withTheme: true
})(withUtils()(Calendar));

var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

var ClockType$1 = ClockType;

var ClockPointer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClockPointer, _React$Component);

  function ClockPointer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          isInner = _this$props.isInner,
          type = _this$props.type;
      var max = type === ClockType$1.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockType$1.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  _createClass$1(ClockPointer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          hasSelected = _this$props2.hasSelected;
      return createElement("div", {
        style: this.getAngleStyle(),
        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
      }, createElement("div", {
        className: clsx(classes.thumb, hasSelected && classes.noPoint)
      }));
    }
  }]);

  return ClockPointer;
}(Component);

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var styles$1h = function styles(theme) {
  return createStyles({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid ".concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};
var ClockPointer$1 = withStyles$2(styles$1h, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours$1 = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};
var getMeridiem = function getMeridiem(date, utils) {
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  if (ampm) {
    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
      return utils.setHours(time, hours);
    }
  }

  return time;
};

var Clock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Clock, _React$Component);

  function Clock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockType$1.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  _createClass$1(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours$1(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm;
      var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
      return createElement("div", {
        className: classes.container
      }, createElement("div", {
        className: classes.clock
      }, createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: classes.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), createElement("div", {
        className: classes.pin
      }), createElement(ClockPointer$1, {
        type: type,
        value: value,
        isInner: isPointerInner,
        hasSelected: this.hasSelected()
      }), children));
    }
  }]);

  return Clock;
}(Component);
Clock.defaultProps = {
  ampm: false,
  minutesStep: 1
};
var styles$1$1 = function styles(theme) {
  return createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none'
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  });
};
var Clock$1 = withStyles$2(styles$1$1, {
  name: 'MuiPickersClock'
})(Clock);

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var useStyles$I = makeStyles$1(function (theme) {
  var size = theme.spacing(4);
  return {
    clockNumber: {
      width: size,
      height: 32,
      userSelect: 'none',
      position: 'absolute',
      left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
    },
    clockNumberSelected: {
      color: theme.palette.primary.contrastText
    }
  };
}, {
  name: 'MuiPickersClockNumber'
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      isInner = _ref.isInner;
  var classes = useStyles$I();
  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected);
  var transformStyle = useMemo(function () {
    var position = positions[index];
    return {
      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
    };
  }, [index]);
  return createElement(Typography$2, {
    component: "span",
    className: className,
    variant: isInner ? 'body2' : 'body1',
    style: transformStyle,
    children: label
  });
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      utils = _ref.utils,
      date = _ref.date;
  var currentHours = utils.getHours(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: utils.formatNumber(label),
      selected: isSelected(hour),
      isInner: !ampm && (hour === 0 || hour > 12)
    };
    hourNumbers.push(createElement(ClockNumber, _extends$4({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      utils = _ref2.utils;
  var f = utils.formatNumber;
  return [createElement(ClockNumber, {
    label: f('00'),
    selected: value === 0,
    index: 12,
    key: 12
  }), createElement(ClockNumber, {
    label: f('05'),
    selected: value === 5,
    index: 1,
    key: 1
  }), createElement(ClockNumber, {
    label: f('10'),
    selected: value === 10,
    index: 2,
    key: 2
  }), createElement(ClockNumber, {
    label: f('15'),
    selected: value === 15,
    index: 3,
    key: 3
  }), createElement(ClockNumber, {
    label: f('20'),
    selected: value === 20,
    index: 4,
    key: 4
  }), createElement(ClockNumber, {
    label: f('25'),
    selected: value === 25,
    index: 5,
    key: 5
  }), createElement(ClockNumber, {
    label: f('30'),
    selected: value === 30,
    index: 6,
    key: 6
  }), createElement(ClockNumber, {
    label: f('35'),
    selected: value === 35,
    index: 7,
    key: 7
  }), createElement(ClockNumber, {
    label: f('40'),
    selected: value === 40,
    index: 8,
    key: 8
  }), createElement(ClockNumber, {
    label: f('45'),
    selected: value === 45,
    index: 9,
    key: 9
  }), createElement(ClockNumber, {
    label: f('50'),
    selected: value === 50,
    index: 10,
    key: 10
  }), createElement(ClockNumber, {
    label: f('55'),
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var ClockView = function ClockView(_ref) {
  var type = _ref.type,
      onHourChange = _ref.onHourChange,
      onMinutesChange = _ref.onMinutesChange,
      onSecondsChange = _ref.onSecondsChange,
      ampm = _ref.ampm,
      date = _ref.date,
      minutesStep = _ref.minutesStep;
  var utils = useUtils();
  var viewProps = useMemo(function () {
    switch (type) {
      case ClockType$1.HOURS:
        return {
          value: utils.getHours(date),
          children: getHourNumbers({
            date: date,
            utils: utils,
            ampm: Boolean(ampm)
          }),
          onChange: function onChange(value, isFinish) {
            var currentMeridiem = getMeridiem(date, utils);
            var updatedTimeWithMeridiem = convertToMeridiem(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
            onHourChange(updatedTimeWithMeridiem, isFinish);
          }
        };

      case ClockType$1.MINUTES:
        var minutesValue = utils.getMinutes(date);
        return {
          value: minutesValue,
          children: getMinutesNumbers({
            value: minutesValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setMinutes(date, value);
            onMinutesChange(updatedTime, isFinish);
          }
        };

      case ClockType$1.SECONDS:
        var secondsValue = utils.getSeconds(date);
        return {
          value: secondsValue,
          children: getMinutesNumbers({
            value: secondsValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setSeconds(date, value);
            onSecondsChange(updatedTime, isFinish);
          }
        };

      default:
        throw new Error('You must provide the type for TimePickerView');
    }
  }, [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type, utils]);
  return createElement(Clock$1, _extends$4({
    type: type,
    ampm: ampm,
    minutesStep: minutesStep
  }, viewProps));
};
ClockView.displayName = 'TimePickerView';
ClockView.defaultProps = {
  ampm: true,
  minutesStep: 1
};
var ClockView$1 = memo(ClockView);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var date = oneOfType([object, string, number, instanceOf(Date)]);
var datePickerView = oneOf(['year', 'month', 'day']);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */

var timePickerDefaultProps = {
  ampm: true,
  invalidDateMessage: 'Invalid Time Format'
};
var datePickerDefaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
  allowKeyboardControl: true
};
var dateTimePickerDefaultProps = _objectSpread({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
  showTabs: true
});

function useViews(views, openTo, onChange) {
  var _React$useState = useState(openTo && arrayIncludes(views, openTo) ? openTo : views[0]),
      _React$useState2 = _slicedToArray$1(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var handleChangeAndOpenNext = useCallback(function (date, isFinish) {
    var nextViewToOpen = views[views.indexOf(openView) + 1];

    if (isFinish && nextViewToOpen) {
      // do not close picker if needs to show next view
      onChange(date, false);
      setOpenView(nextViewToOpen);
      return;
    }

    onChange(date, Boolean(isFinish));
  }, [onChange, openView, views]);
  return {
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    openView: openView,
    setOpenView: setOpenView
  };
}

var useStyles$J = makeStyles$1(function (theme) {
  return {
    root: {
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    yearSelected: {
      margin: '10px 0',
      fontWeight: theme.typography.fontWeightMedium
    },
    yearDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersYear'
});
var Year = function Year(_ref) {
  var onSelect = _ref.onSelect,
      forwardedRef = _ref.forwardedRef,
      value = _ref.value,
      selected = _ref.selected,
      disabled = _ref.disabled,
      children = _ref.children,
      other = _objectWithoutProperties$1(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]);

  var classes = useStyles$J();
  var handleClick = useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return createElement(Typography$2, _extends$4({
    role: "button",
    component: "div",
    tabIndex: disabled ? -1 : 0,
    onClick: handleClick,
    onKeyPress: handleClick,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children,
    ref: forwardedRef,
    className: clsx(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
  }, other));
};
Year.displayName = 'Year';
var Year$1 = forwardRef(function (props, ref) {
  return createElement(Year, _extends$4({}, props, {
    forwardedRef: ref
  }));
});

var useStyles$1$2 = makeStyles$1({
  container: {
    height: 300,
    overflowY: 'auto'
  }
}, {
  name: 'MuiPickersYearSelection'
});
var YearSelection = function YearSelection(_ref) {
  var date = _ref.date,
      onChange = _ref.onChange,
      onYearChange = _ref.onYearChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      animateYearScrolling = _ref.animateYearScrolling;
  var utils = useUtils();
  var classes = useStyles$1$2();
  var currentVariant = useContext(VariantContext);
  var selectedYearRef = useRef(null);
  useEffect(function () {
    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      try {
        selectedYearRef.current.scrollIntoView({
          block: currentVariant === 'static' ? 'nearest' : 'center',
          behavior: animateYearScrolling ? 'smooth' : 'auto'
        });
      } catch (e) {
        // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
        selectedYearRef.current.scrollIntoView();
      }
    }
  }, []); // eslint-disable-line

  var currentYear = utils.getYear(date);
  var onYearSelect = useCallback(function (year) {
    var newDate = utils.setYear(date, year);

    if (onYearChange) {
      onYearChange(newDate);
    }

    onChange(newDate, true);
  }, [date, onChange, onYearChange, utils]);
  return createElement("div", {
    className: classes.container
  }, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return createElement(Year$1, {
      key: utils.getYearText(year),
      selected: selected,
      value: yearNumber,
      onSelect: onYearSelect,
      ref: selected ? selectedYearRef : undefined,
      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
    }, utils.getYearText(year));
  }));
};

var useStyles$2$1 = makeStyles$1(function (theme) {
  return {
    root: {
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      height: 75,
      transition: theme.transitions.create('font-size', {
        duration: '100ms'
      }),
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersMonth'
});
var Month = function Month(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties$1(_ref, ["selected", "onSelect", "disabled", "value", "children"]);

  var classes = useStyles$2$1();
  var handleSelection = useCallback(function () {
    onSelect(value);
  }, [onSelect, value]);
  return createElement(Typography$2, _extends$4({
    role: "button",
    component: "div",
    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyPress: handleSelection,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children
  }, other));
};
Month.displayName = 'Month';

var useStyles$3$1 = makeStyles$1({
  container: {
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch'
  }
}, {
  name: 'MuiPickersMonthSelection'
});
var MonthSelection = function MonthSelection(_ref) {
  var disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      date = _ref.date,
      onMonthChange = _ref.onMonthChange,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$3$1();
  var currentMonth = utils.getMonth(date);

  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  var onMonthSelect = useCallback(function (month) {
    var newDate = utils.setMonth(date, month);
    onChange(newDate, true);

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  }, [date, onChange, onMonthChange, utils]);
  return createElement("div", {
    className: classes.container
  }, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'MMM');
    return createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};

var getOrientation = function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
};

function useIsLandscape(customOrientation) {
  var _React$useState = useState(getOrientation()),
      _React$useState2 = _slicedToArray$1(_React$useState, 2),
      orientation = _React$useState2[0],
      setOrientation = _React$useState2[1];

  var eventHandler = useCallback(function () {
    return setOrientation(getOrientation());
  }, []);
  useIsomorphicEffect(function () {
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      return window.removeEventListener('orientationchange', eventHandler);
    };
  }, [eventHandler]);
  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var viewsMap = {
  year: YearSelection,
  month: MonthSelection,
  date: Calendar$1,
  hours: ClockView,
  minutes: ClockView,
  seconds: ClockView
};
var useStyles$4$1 = makeStyles$1({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerLandscape: {
    flexDirection: 'row'
  },
  pickerView: {
    overflowX: 'hidden',
    minHeight: VIEW_HEIGHT,
    minWidth: DIALOG_WIDTH,
    maxWidth: DIALOG_WIDTH_WIDER,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  pickerViewLandscape: {
    padding: '0 8px'
  }
}, {
  name: 'MuiPickersBasePicker'
});
var Picker = function Picker(_ref) {
  var date = _ref.date,
      views = _ref.views,
      disableToolbar = _ref.disableToolbar,
      onChange = _ref.onChange,
      openTo = _ref.openTo,
      unparsedMinDate = _ref.minDate,
      unparsedMaxDate = _ref.maxDate,
      ToolbarComponent = _ref.ToolbarComponent,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties$1(_ref, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]);

  var utils = useUtils();
  var classes = useStyles$4$1();
  var isLandscape = useIsLandscape(orientation);

  var _useViews = useViews(views, openTo, onChange),
      openView = _useViews.openView,
      setOpenView = _useViews.setOpenView,
      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;

  var minDate = useMemo(function () {
    return utils.date(unparsedMinDate);
  }, [unparsedMinDate, utils]);
  var maxDate = useMemo(function () {
    return utils.date(unparsedMaxDate);
  }, [unparsedMaxDate, utils]);
  return createElement("div", {
    className: clsx(classes.container, isLandscape && classes.containerLandscape)
  }, !disableToolbar && createElement(ToolbarComponent, _extends$4({}, rest, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: onChange,
    setOpenView: setOpenView,
    openView: openView
  })), createElement("div", {
    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
  }, openView === 'year' && createElement(YearSelection, _extends$4({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'month' && createElement(MonthSelection, _extends$4({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'date' && createElement(Calendar$1, _extends$4({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && createElement(ClockView, _extends$4({}, rest, {
    date: date,
    type: openView,
    onHourChange: handleChangeAndOpenNext,
    onMinutesChange: handleChangeAndOpenNext,
    onSecondsChange: handleChangeAndOpenNext
  }))));
};
Picker.defaultProps = _objectSpread$1({}, datePickerDefaultProps, {
  views: Object.keys(viewsMap)
});

var useStyles$K = makeStyles$1(function (theme) {
  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
  return {
    toolbarTxt: {
      color: fade$1(textColor, 0.54)
    },
    toolbarBtnSelected: {
      color: textColor
    }
  };
}, {
  name: 'MuiPickersToolbarText'
});

var ToolbarText = function ToolbarText(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties$1(_ref, ["selected", "label", "className"]);

  var classes = useStyles$K();
  return createElement(Typography$2, _extends$4({
    children: label,
    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
  }, other));
};

var ToolbarButton = function ToolbarButton(_ref) {
  var classes = _ref.classes,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      label = _ref.label,
      selected = _ref.selected,
      variant = _ref.variant,
      align = _ref.align,
      typographyClassName = _ref.typographyClassName,
      other = _objectWithoutProperties$1(_ref, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);

  return createElement(Button$2, _extends$4({
    variant: "text",
    className: clsx(classes.toolbarBtn, className)
  }, other), createElement(ToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    label: label,
    selected: selected
  }));
};
ToolbarButton.defaultProps = {
  className: ''
};
var styles$1i = createStyles({
  toolbarBtn: {
    padding: 0,
    minWidth: '16px',
    textTransform: 'none'
  }
});
var ToolbarButton$1 = withStyles$2(styles$1i, {
  name: 'MuiPickersToolbarButton'
})(ToolbarButton);

var useStyles$1$3 = makeStyles$1(function (theme) {
  return {
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: 100,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
    },
    toolbarLandscape: {
      height: 'auto',
      maxWidth: 150,
      padding: 8,
      justifyContent: 'flex-start'
    }
  };
}, {
  name: 'MuiPickersToolbar'
});

var PickerToolbar = function PickerToolbar(_ref) {
  var children = _ref.children,
      isLandscape = _ref.isLandscape,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties$1(_ref, ["children", "isLandscape", "className"]);

  var classes = useStyles$1$3();
  return createElement(Toolbar, _extends$4({
    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
  }, other), children);
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties$1(_ref, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]);

  var PureDateInputProps = useMemo(function () {
    return _objectSpread$2({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  return createElement(TextFieldComponent, _extends$4({
    error: Boolean(validationError),
    helperText: validationError
  }, other, {
    // do not overridable
    onClick: onOpen,
    value: inputValue,
    variant: inputVariant,
    InputProps: PureDateInputProps,
    onKeyDown: function onKeyDown(e) {
      // space
      if (e.keyCode === 32) {
        e.stopPropagation();
        onOpen();
      }
    }
  }));
};
PureDateInput.displayName = 'PureDateInput';

var KeyboardIcon = function KeyboardIcon(props) {
  return React__default.createElement(SvgIcon$2, props, React__default.createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
  var invalidLabel = _ref.invalidLabel,
      emptyLabel = _ref.emptyLabel,
      labelFunc = _ref.labelFunc;
  var date = utils.date(value);

  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }

  if (isEmpty) {
    return emptyLabel || '';
  }

  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};

var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.endOfDay(date);
};

var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.startOfDay(date);
};

var validate = function validate(value, utils, _ref2) {
  var maxDate = _ref2.maxDate,
      minDate = _ref2.minDate,
      disablePast = _ref2.disablePast,
      disableFuture = _ref2.disableFuture,
      maxDateMessage = _ref2.maxDateMessage,
      minDateMessage = _ref2.minDateMessage,
      invalidDateMessage = _ref2.invalidDateMessage,
      strictCompareDates = _ref2.strictCompareDates;
  var parsedValue = utils.date(value); // if null - do not show error

  if (value === null) {
    return '';
  }

  if (!utils.isValid(value)) {
    return invalidDateMessage;
  }

  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
    return maxDateMessage;
  }

  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
    return maxDateMessage;
  }

  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
    return minDateMessage;
  }

  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
    return minDateMessage;
  }

  return '';
};
function pick12hOr24hFormat(userFormat) {
  var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var formats = arguments.length > 2 ? arguments[2] : undefined;

  if (userFormat) {
    return userFormat;
  }

  return ampm ? formats['12h'] : formats['24h'];
}
function makeMaskFromFormat(format, numberMaskChar) {
  return format.replace(/[a-z]/gi, numberMaskChar);
}
var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
  return function (value) {
    var result = '';
    var parsed = value.replace(refuse, '');

    if (parsed === '') {
      return parsed;
    }

    var i = 0;
    var n = 0;

    while (i < mask.length) {
      var maskChar = mask[i];

      if (maskChar === numberMaskChar && n < parsed.length) {
        var parsedChar = parsed[n];
        result += parsedChar;
        n += 1;
      } else {
        result += maskChar;
      }

      i += 1;
    }

    return result;
  };
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var KeyboardDateInput = function KeyboardDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      KeyboardButtonProps = _ref.KeyboardButtonProps,
      InputAdornmentProps = _ref.InputAdornmentProps,
      onOpen = _ref.openPicker,
      onChange = _ref.onChange,
      InputProps = _ref.InputProps,
      mask = _ref.mask,
      _ref$maskChar = _ref.maskChar,
      maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar,
      _ref$refuse = _ref.refuse,
      refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse,
      format = _ref.format,
      keyboardIcon = _ref.keyboardIcon,
      disabled = _ref.disabled,
      rifmFormatter = _ref.rifmFormatter,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties$1(_ref, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]);

  var inputMask = mask || makeMaskFromFormat(format, maskChar); // prettier-ignore

  var formatter = useMemo(function () {
    return maskedDateFormatter(inputMask, maskChar, refuse);
  }, [inputMask, maskChar, refuse]);
  var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';

  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === inputMask ? null : text;
    onChange(finalString);
  };

  return createElement(Rifm, {
    key: inputMask,
    value: inputValue,
    onChange: handleChange,
    refuse: refuse,
    format: rifmFormatter || formatter
  }, function (_ref2) {
    var onChange = _ref2.onChange,
        value = _ref2.value;
    return createElement(TextFieldComponent, _extends$4({
      disabled: disabled,
      error: Boolean(validationError),
      helperText: validationError
    }, other, {
      value: value,
      onChange: onChange,
      variant: inputVariant,
      InputProps: _objectSpread$1$1({}, InputProps, _defineProperty$1({}, "".concat(position, "Adornment"), createElement(InputAdornment, _extends$4({
        position: position
      }, InputAdornmentProps), createElement(IconButton$2, _extends$4({
        disabled: disabled
      }, KeyboardButtonProps, {
        onClick: onOpen
      }), keyboardIcon))))
    }));
  });
};
KeyboardDateInput.defaultProps = {
  keyboardIcon: createElement(KeyboardIcon, null)
};

function useOpenState(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;
  var setIsOpenState = null;

  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    var _useState = useState(false);

    var _useState2 = _slicedToArray$1(_useState, 2);

    open = _useState2[0];
    setIsOpenState = _useState2[1];
  } // prettier-ignore


  var setIsOpen = useCallback(function (newIsOpen) {
    setIsOpenState && setIsOpenState(newIsOpen);
    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [onOpen, onClose, setIsOpenState]);
  return {
    isOpen: open,
    setIsOpen: setIsOpen
  };
}

var useValueToDate = function useValueToDate(utils, _ref) {
  var value = _ref.value,
      initialFocusedDate = _ref.initialFocusedDate;
  var nowRef = useRef(utils.date());
  var date = utils.date(value || initialFocusedDate || nowRef.current);
  return date && utils.isValid(date) ? date : nowRef.current;
};

function useDateValues(props, options) {
  var utils = useUtils();
  var date = useValueToDate(utils, props);
  var format = props.format || options.getDefaultFormat();
  return {
    date: date,
    format: format
  };
}

function usePickerState(props, options) {
  var autoOk = props.autoOk,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onAccept = props.onAccept,
      _onChange = props.onChange,
      onError = props.onError,
      value = props.value,
      variant = props.variant;
  var utils = useUtils();

  var _useOpenState = useOpenState(props),
      isOpen = _useOpenState.isOpen,
      setIsOpen = _useOpenState.setIsOpen;

  var _useDateValues = useDateValues(props, options),
      date = _useDateValues.date,
      format = _useDateValues.format;

  var _useState = useState(date),
      _useState2 = _slicedToArray$1(_useState, 2),
      pickerDate = _useState2[0],
      setPickerDate = _useState2[1];

  useEffect(function () {
    // if value was changed in closed state - treat it as accepted
    if (!isOpen && !utils.isEqual(pickerDate, date)) {
      setPickerDate(date);
    }
  }, [date, isOpen, pickerDate, utils]);
  var acceptDate = useCallback(function (acceptedDate) {
    _onChange(acceptedDate);

    if (onAccept) {
      onAccept(acceptedDate);
    }

    setIsOpen(false);
  }, [onAccept, _onChange, setIsOpen]);
  var wrapperProps = useMemo(function () {
    return {
      format: format,
      open: isOpen,
      onClear: function onClear() {
        return acceptDate(null);
      },
      onAccept: function onAccept() {
        return acceptDate(pickerDate);
      },
      onSetToday: function onSetToday() {
        return setPickerDate(utils.date());
      },
      onDismiss: function onDismiss() {
        setIsOpen(false);
      }
    };
  }, [acceptDate, format, isOpen, pickerDate, setIsOpen, utils]);
  var pickerProps = useMemo(function () {
    return {
      date: pickerDate,
      onChange: function onChange(newDate) {
        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setPickerDate(newDate);

        if (isFinish && autoOk) {
          acceptDate(newDate);
          return;
        } // simulate autoOk, but do not close the modal


        if (variant === 'inline' || variant === 'static') {
          _onChange(newDate);

          onAccept && onAccept(newDate);
        }
      }
    };
  }, [acceptDate, autoOk, onAccept, _onChange, pickerDate, variant]);
  var validationError = validate(value, utils, props);
  useEffect(function () {
    if (onError) {
      onError(validationError, value);
    }
  }, [onError, validationError, value]);
  var inputValue = getDisplayDate(date, format, utils, value === null, props);
  var inputProps = useMemo(function () {
    return {
      inputValue: inputValue,
      validationError: validationError,
      openPicker: function openPicker() {
        return !readOnly && !disabled && setIsOpen(true);
      }
    };
  }, [disabled, inputValue, readOnly, setIsOpen, validationError]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  useDebugValue(pickerState);
  return pickerState;
}

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseInputString(value, utils, format) {
  try {
    return utils.parse(value, format);
  } catch (_unused) {
    return null;
  }
}

function useKeyboardPickerState(props, options) {
  var _props$format = props.format,
      format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
      inputValue = props.inputValue,
      _onChange = props.onChange,
      value = props.value;
  var utils = useUtils();
  var displayDate = getDisplayDate(value, format, utils, value === null, props);

  var _useState = useState(displayDate),
      _useState2 = _slicedToArray$1(_useState, 2),
      innerInputValue = _useState2[0],
      setInnerInputValue = _useState2[1];

  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
  useEffect(function () {
    if (value === null || utils.isValid(value)) {
      setInnerInputValue(displayDate);
    }
  }, [displayDate, setInnerInputValue, utils, value]);
  var handleKeyboardChange = useCallback(function (date) {
    _onChange(date, date === null ? null : utils.format(date, format));
  }, [format, _onChange, utils]);

  var _usePickerState = usePickerState( // Extend props interface
  _objectSpread$2$1({}, props, {
    value: dateValue,
    onChange: handleKeyboardChange
  }), options),
      innerInputProps = _usePickerState.inputProps,
      wrapperProps = _usePickerState.wrapperProps,
      pickerProps = _usePickerState.pickerProps;

  var inputProps = useMemo(function () {
    return _objectSpread$2$1({}, innerInputProps, {
      // reuse validation and open/close logic
      format: wrapperProps.format,
      inputValue: inputValue || innerInputValue,
      onChange: function onChange(value) {
        setInnerInputValue(value || '');
        var date = value === null ? null : utils.parse(value, wrapperProps.format);

        _onChange(date, value);
      }
    });
  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
  return {
    inputProps: inputProps,
    wrapperProps: wrapperProps,
    pickerProps: pickerProps
  };
}

function makePickerWithState(_ref) {
  var Input = _ref.Input,
      useState = _ref.useState,
      useOptions = _ref.useOptions,
      getCustomProps = _ref.getCustomProps,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;

  function PickerWithState(props) {
    var allowKeyboardControl = props.allowKeyboardControl,
        ampm = props.ampm,
        animateYearScrolling = props.animateYearScrolling,
        autoOk = props.autoOk,
        dateRangeIcon = props.dateRangeIcon,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        disableToolbar = props.disableToolbar,
        emptyLabel = props.emptyLabel,
        format = props.format,
        forwardedRef = props.forwardedRef,
        hideTabs = props.hideTabs,
        initialFocusedDate = props.initialFocusedDate,
        invalidDateMessage = props.invalidDateMessage,
        invalidLabel = props.invalidLabel,
        labelFunc = props.labelFunc,
        leftArrowButtonProps = props.leftArrowButtonProps,
        leftArrowIcon = props.leftArrowIcon,
        loadingIndicator = props.loadingIndicator,
        maxDate = props.maxDate,
        maxDateMessage = props.maxDateMessage,
        minDate = props.minDate,
        minDateMessage = props.minDateMessage,
        minutesStep = props.minutesStep,
        onAccept = props.onAccept,
        onChange = props.onChange,
        onClose = props.onClose,
        onMonthChange = props.onMonthChange,
        onOpen = props.onOpen,
        onYearChange = props.onYearChange,
        openTo = props.openTo,
        orientation = props.orientation,
        renderDay = props.renderDay,
        rightArrowButtonProps = props.rightArrowButtonProps,
        rightArrowIcon = props.rightArrowIcon,
        shouldDisableDate = props.shouldDisableDate,
        strictCompareDates = props.strictCompareDates,
        timeIcon = props.timeIcon,
        _props$ToolbarCompone = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone,
        value = props.value,
        variant = props.variant,
        views = props.views,
        other = _objectWithoutProperties$1(props, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]);

    var injectedProps = getCustomProps ? getCustomProps(props) : {};
    var options = useOptions(props);

    var _useState = useState(props, options),
        pickerProps = _useState.pickerProps,
        inputProps = _useState.inputProps,
        wrapperProps = _useState.wrapperProps;

    return createElement(Wrapper, _extends$4({
      variant: variant,
      InputComponent: Input,
      DateInputProps: inputProps
    }, injectedProps, wrapperProps, other), createElement(Picker, _extends$4({}, pickerProps, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      disableToolbar: disableToolbar,
      hideTabs: hideTabs,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowIcon: leftArrowIcon,
      loadingIndicator: loadingIndicator,
      maxDate: maxDate,
      minDate: minDate,
      minutesStep: minutesStep,
      onMonthChange: onMonthChange,
      onYearChange: onYearChange,
      openTo: openTo,
      orientation: orientation,
      renderDay: renderDay,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      strictCompareDates: strictCompareDates,
      timeIcon: timeIcon,
      ToolbarComponent: ToolbarComponent,
      views: views
    })));
  }

  return PickerWithState;
}

var useStyles$L = makeStyles$1({
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      setOpenView = _ref.setOpenView,
      isLandscape = _ref.isLandscape,
      openView = _ref.openView;
  var utils = useUtils();
  var classes = useStyles$L();
  var isYearOnly = useMemo(function () {
    return isYearOnlyView(views);
  }, [views]);
  var isYearAndMonth = useMemo(function () {
    return isYearAndMonthViews(views);
  }, [views]);
  return createElement(PickerToolbar, {
    isLandscape: isLandscape,
    className: clsx(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
  }, createElement(ToolbarButton$1, {
    variant: isYearOnly ? 'h3' : 'subtitle1',
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  }), !isYearOnly && !isYearAndMonth && createElement(ToolbarButton$1, {
    variant: "h4",
    selected: openView === 'date',
    onClick: function onClick() {
      return setOpenView('date');
    },
    align: isLandscape ? 'left' : 'center',
    label: utils.getDatePickerHeaderText(date),
    className: clsx(isLandscape && classes.dateLandscape)
  }), isYearAndMonth && createElement(ToolbarButton$1, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month',
    label: utils.getMonthText(date)
  }));
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps$2 = _objectSpread$3({}, datePickerDefaultProps, {
  openTo: 'date',
  views: ['year', 'date']
});

function useOptions(props) {
  var utils = useUtils();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return getFormatByViews(props.views, utils);
    }
  };
}

var DatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: PureDateInput,
  useState: usePickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
var KeyboardDatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: KeyboardDateInput,
  useState: useKeyboardPickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
DatePicker.defaultProps = defaultProps$2;
KeyboardDatePicker.defaultProps = defaultProps$2;

var useStyles$M = makeStyles$1({
  toolbarLandscape: {
    flexWrap: 'wrap'
  },
  toolbarAmpmLeftPadding: {
    paddingLeft: 50
  },
  separator: {
    margin: '0 4px 0 2px',
    cursor: 'default'
  },
  hourMinuteLabel: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  hourMinuteLabelAmpmLandscape: {
    marginTop: 'auto'
  },
  hourMinuteLabelReverse: {
    flexDirection: 'row-reverse'
  },
  ampmSelection: {
    marginLeft: 20,
    marginRight: -20,
    display: 'flex',
    flexDirection: 'column'
  },
  ampmLandscape: {
    margin: '4px 0 auto',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexBasis: '100%'
  },
  ampmSelectionWithSeconds: {
    marginLeft: 15,
    marginRight: 10
  },
  ampmLabel: {
    fontSize: 18
  }
}, {
  name: 'MuiPickersTimePickerToolbar'
});
function useMeridiemMode(date, ampm, onChange) {
  var utils = useUtils();
  var meridiemMode = getMeridiem(date, utils);
  var handleMeridiemChange = useCallback(function (mode) {
    var timeWithMeridiem = convertToMeridiem(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, false);
  }, [ampm, date, onChange, utils]);
  return {
    meridiemMode: meridiemMode,
    handleMeridiemChange: handleMeridiemChange
  };
}

var TimeIcon = function TimeIcon(props) {
  return React__default.createElement(SvgIcon$2, props, React__default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), React__default.createElement("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  }));
};

var DateRangeIcon = function DateRangeIcon(props) {
  return React__default.createElement(SvgIcon$2, props, React__default.createElement("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
  }), React__default.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var viewToTabIndex = function viewToTabIndex(openView) {
  if (openView === 'date' || openView === 'year') {
    return 'date';
  }

  return 'time';
};

var tabIndexToView = function tabIndexToView(tab) {
  if (tab === 'date') {
    return 'date';
  }

  return 'hours';
};

var useStyles$N = makeStyles$1(function (theme) {
  // prettier-ignore
  var tabsBackground = theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"];
  return {
    tabs: {
      color: theme.palette.getContrastText(tabsBackground),
      backgroundColor: tabsBackground
    }
  };
}, {
  name: 'MuiPickerDTTabs'
});
var DateTimePickerTabs = function DateTimePickerTabs(_ref) {
  var view = _ref.view,
      onChange = _ref.onChange,
      dateRangeIcon = _ref.dateRangeIcon,
      timeIcon = _ref.timeIcon;
  var classes = useStyles$N();
  var theme = useTheme$2();
  var indicatorColor = theme.palette.type === 'light' ? 'secondary' : 'primary';

  var handleChange = function handleChange(e, value) {
    if (value !== viewToTabIndex(view)) {
      onChange(tabIndexToView(value));
    }
  };

  return createElement(Paper, null, createElement(Tabs, {
    variant: "fullWidth",
    value: viewToTabIndex(view),
    onChange: handleChange,
    className: classes.tabs,
    indicatorColor: indicatorColor
  }, createElement(Tab, {
    value: "date",
    icon: createElement(Fragment, null, dateRangeIcon)
  }), createElement(Tab, {
    value: "time",
    icon: createElement(Fragment, null, timeIcon)
  })));
};
DateTimePickerTabs.defaultProps = {
  dateRangeIcon: createElement(DateRangeIcon, null),
  timeIcon: createElement(TimeIcon, null)
};

var useStyles$1$4 = makeStyles$1(function (_) {
  return {
    toolbar: {
      paddingLeft: 16,
      paddingRight: 16,
      justifyContent: 'space-around'
    },
    separator: {
      margin: '0 4px 0 2px',
      cursor: 'default'
    }
  };
}, {
  name: 'MuiPickerDTToolbar'
});
var DateTimePickerToolbar = function DateTimePickerToolbar(_ref) {
  var date = _ref.date,
      openView = _ref.openView,
      setOpenView = _ref.setOpenView,
      ampm = _ref.ampm,
      hideTabs = _ref.hideTabs,
      dateRangeIcon = _ref.dateRangeIcon,
      timeIcon = _ref.timeIcon,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$1$4();
  var showTabs = !hideTabs && typeof window !== 'undefined' && window.innerHeight > 667;

  var _useMeridiemMode = useMeridiemMode(date, ampm, onChange),
      meridiemMode = _useMeridiemMode.meridiemMode,
      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;

  var theme = useTheme$2();
  var rtl = theme.direction === 'rtl';
  return createElement(Fragment, null, createElement(PickerToolbar, {
    isLandscape: false,
    className: classes.toolbar
  }, createElement(Grid, {
    container: true,
    justify: "center",
    wrap: "nowrap"
  }, createElement(Grid, {
    item: true,
    container: true,
    xs: 5,
    justify: "flex-start",
    direction: "column"
  }, createElement("div", null, createElement(ToolbarButton$1, {
    variant: "subtitle1",
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  })), createElement("div", null, createElement(ToolbarButton$1, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('date');
    },
    selected: openView === 'date',
    label: utils.getDateTimePickerHeaderText(date)
  }))), createElement(Grid, {
    item: true,
    container: true,
    xs: 6,
    justify: "center",
    alignItems: "flex-end",
    direction: rtl ? 'row-reverse' : 'row'
  }, createElement(ToolbarButton$1, {
    variant: "h3",
    onClick: function onClick() {
      return setOpenView('hours');
    },
    selected: openView === 'hours',
    label: utils.getHourText(date, ampm)
  }), createElement(ToolbarText, {
    variant: "h3",
    label: ":",
    className: classes.separator
  }), createElement(ToolbarButton$1, {
    variant: "h3",
    onClick: function onClick() {
      return setOpenView('minutes');
    },
    selected: openView === 'minutes',
    label: utils.getMinuteText(date)
  })), ampm && createElement(Grid, {
    item: true,
    container: true,
    xs: 1,
    direction: "column",
    justify: "flex-end"
  }, createElement(ToolbarButton$1, {
    variant: "subtitle1",
    selected: meridiemMode === 'am',
    label: utils.getMeridiemText('am'),
    onClick: function onClick() {
      return handleMeridiemChange('am');
    }
  }), createElement(ToolbarButton$1, {
    variant: "subtitle1",
    selected: meridiemMode === 'pm',
    label: utils.getMeridiemText('pm'),
    onClick: function onClick() {
      return handleMeridiemChange('pm');
    }
  })))), showTabs && createElement(DateTimePickerTabs, {
    dateRangeIcon: dateRangeIcon,
    timeIcon: timeIcon,
    view: openView,
    onChange: setOpenView
  }));
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps$3 = _objectSpread$4({}, dateTimePickerDefaultProps, {
  wider: true,
  orientation: 'portrait',
  openTo: 'date',
  views: ['year', 'date', 'hours', 'minutes']
});

function useOptions$1(props) {
  var utils = useUtils();

  if (props.orientation !== 'portrait') {
    throw new Error('We are not supporting custom orientation for DateTimePicker yet :(');
  }

  return {
    getDefaultFormat: function getDefaultFormat() {
      return pick12hOr24hFormat(props.format, props.ampm, {
        '12h': utils.dateTime12hFormat,
        '24h': utils.dateTime24hFormat
      });
    }
  };
}

var DateTimePicker$2 = makePickerWithState({
  useOptions: useOptions$1,
  Input: PureDateInput,
  useState: usePickerState,
  DefaultToolbarComponent: DateTimePickerToolbar
});
var KeyboardDateTimePicker = makePickerWithState({
  useOptions: useOptions$1,
  Input: KeyboardDateInput,
  useState: useKeyboardPickerState,
  DefaultToolbarComponent: DateTimePickerToolbar,
  getCustomProps: function getCustomProps(props) {
    return {
      refuse: props.ampm ? /[^\dap]+/gi : /[^\d]+/gi
    };
  }
});
DateTimePicker$2.defaultProps = defaultProps$3;
KeyboardDateTimePicker.defaultProps = defaultProps$3;

function DateTime({
  enableTimeOption,
  value,
  onChange,
  name,
  dateFormat,
  required,
  label,
  instruction,
  error
}) {
  const TimePicker = enableTimeOption ? DateTimePicker$2 : DatePicker;
  const handleChange = React__default.useCallback(date => onChange({ name, value: date }), [name, onChange]);

  const styles = useStyles$E({});

  return React__default.createElement(
    MuiPickersUtilsProvider,
    { utils: DateFnsUtils },
    React__default.createElement(TimePicker, {
      error: error.length > 0,
      instruction: instruction,
      label: label,
      inputVariant: 'outlined',
      value: value,
      required: required,
      fullWidth: true,
      format: dateFormat,
      onChange: handleChange,
      helperText: error || instruction,
      className: styles.formItem,
      name: name
    })
  );
}

DateTime.displayName = 'DateTime';
DateTime.propTypes = {
  enableTimeOption: bool,
  required: bool,
  error: string,
  value: oneOfType([instanceOf(Date), number, string]),
  onChange: func,
  dateFormat: string,
  name: string,
  label: string,
  instruction: string
};

DateTime.defaultProps = {
  onChange: () => {},
  error: ''
};

function Radio({
  label,
  required,
  name,
  onChange,
  instruction,
  value,
  items,
  error
}) {
  const handleChange = React__default.useCallback(e => onChange({ name, value: e.target.value }), [name, onChange, value]);

  const styles = useStyles$E({});

  return React__default.createElement(
    FormControl,
    {
      error: error.length > 0,
      fullWidth: true,
      className: styles.formItem
    },
    React__default.createElement(
      Box,
      {
        component: 'fieldset',
        className: styles.box
      },
      label && React__default.createElement(
        Typography$2,
        { component: 'legend', variant: 'caption' },
        label + `${required ? '*' : ''}`
      ),
      React__default.createElement(
        RadioGroup$1,
        {
          name: name,
          value: value,
          onChange: handleChange
        },
        items.map(item => React__default.createElement(FormControlLabel, {
          key: item.id,
          value: item.value,
          control: React__default.createElement(Radio$1, { color: 'primary' }),
          label: item.value }))
      )
    ),
    (error || instruction) && React__default.createElement(
      FormHelperText,
      { variant: 'outlined' },
      error || instruction
    )
  );
}

Radio.displayName = 'Radio';
Radio.propTypes = {
  label: string,
  name: string,
  value: string,
  items: arrayOf(shape$1({
    id: string,
    value: string
  })),
  instruction: string,
  error: string,
  required: bool,
  onChange: func
};

Radio.defaultProps = {
  onChange: () => {},
  items: [],
  error: ''
};

var itemPropType = arrayOf(shape$1({
  id: oneOfType([string, number]),
  value: oneOfType([string, number])
}));

function Select$1({
  label,
  required,
  name,
  onChange,
  value,
  items,
  error,
  instruction
}) {
  const handleChange = React__default.useCallback(e => onChange({ name, value: e.target.value }), [onChange, name]);

  const styles = useStyles$E({});

  return React__default.createElement(
    TextField$1,
    {
      error: error.length > 0,
      label: label,
      variant: 'outlined',
      select: true,
      fullWidth: true,
      required: required,
      helperText: error || instruction,
      value: value,
      onChange: handleChange,
      className: styles.formItem,
      name: name
    },
    items.map(({ id, value }) => React__default.createElement(
      MenuItem,
      { key: id, value: value },
      value
    ))
  );
}

Select$1.displayName = 'Select';
Select$1.propTypes = {
  items: itemPropType,
  onChange: func,
  label: string,
  name: string,
  required: bool,
  value: string,
  error: string,
  instruction: string
};

Select$1.defaultProps = {
  items: [],
  onChange: () => {},
  error: '',
  value: ''
};

function Switch$1({
  label,
  required,
  name,
  onChange,
  instruction,
  value,
  error
}) {
  const handleChange = React__default.useCallback(e => onChange({ name, value: e.target.checked }), [name, onChange]);

  const styles = useStyles$E({});

  return React__default.createElement(
    FormControl,
    {
      fullWidth: true,
      error: error.length > 0,
      className: styles.formItem,
      required: required
    },
    React__default.createElement(FormControlLabel, {
      control: React__default.createElement(LibSwitch, {
        checked: value,
        onChange: handleChange,
        color: 'primary',
        name: name
      }),
      label: label
    }),
    (error || instruction) && React__default.createElement(
      FormHelperText,
      { variant: 'outlined' },
      error || instruction
    )
  );
}

Switch$1.displayName = 'Switch';
Switch$1.propTypes = {
  label: string,
  name: string,
  instruction: string,
  error: string,
  value: bool,
  required: bool,
  onChange: func
};

Switch$1.defaultProps = {
  onChange: () => {},
  error: ''
};

function TextInput({ label, required, name, onChange, instruction, value, error }) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name, value: e.target.value });
  }, [name, onChange]);

  const styles = useStyles$E({});

  return React__default.createElement(TextField$1, {
    fullWidth: true,
    label: label,
    required: required,
    error: error.length > 0,
    helperText: error || instruction,
    variant: 'outlined',
    value: value,
    onChange: handleChange,
    className: styles.formItem,
    name: name
  });
}

TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  label: string,
  required: bool,
  name: string,
  onChange: func,
  instruction: string,
  value: string,
  error: string
};

TextInput.defaultProps = {
  label: 'Text Input',
  name: `textInput-${Date.now()}`,
  onChange: () => {},
  value: '',
  error: ''
};

function Paragraph({
  label,
  required,
  name,
  onChange,
  instruction,
  value,
  error
}) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name, value: e.target.value });
  }, [name, onChange]);

  const styles = useStyles$E({});

  return React__default.createElement(TextField$1, {
    fullWidth: true,
    label: label || name,
    required: required,
    error: error.length > 0,
    helperText: error || instruction,
    variant: 'outlined',
    value: value,
    onChange: handleChange,
    multiline: true,
    rows: 4,
    className: styles.formItem,
    name: name
  });
}

Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  label: string,
  required: bool,
  name: string,
  onChange: func,
  instruction: string,
  value: string,
  error: string
};

Paragraph.defaultProps = {
  label: 'Paragraph',
  name: `paragraph-${Date.now()}`,
  onChange: () => {},
  value: '',
  error: ''
};

function createSvgIcon$2(path, displayName) {
  var Component = memo(forwardRef(function (props, ref) {
    return createElement(SvgIcon$2, _extends$1({
      ref: ref
    }, props), path);
  }));

  Component.muiName = SvgIcon$2.muiName;
  return Component;
}

/**
 * @ignore - internal component.
 */

var Star = createSvgIcon$2(createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}));

function clamp$2(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

function getDecimalPrecision(num) {
  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToPrecision(value, precision) {
  if (value == null) {
    return value;
  }

  var nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}

var styles$1j = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      position: 'relative',
      fontSize: theme.typography.pxToRem(24),
      color: '#ffb400',
      cursor: 'pointer',
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '&$focusVisible $iconActive': {
        outline: '1px solid #999'
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      fontSize: theme.typography.pxToRem(30)
    },

    /* Styles applied to the root element if `readOnly={true}`. */
    readOnly: {
      pointerEvents: 'none'
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Visually hide an element. */
    visuallyhidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      color: '#000',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },

    /* Styles applied to the pristine label. */
    pristine: {
      'input:focus + &': {
        top: 0,
        bottom: 0,
        position: 'absolute',
        outline: '1px solid #999',
        width: '100%'
      }
    },

    /* Styles applied to the label elements. */
    label: {
      cursor: 'inherit'
    },

    /* Styles applied to the icon wrapping elements. */
    icon: {
      display: 'flex',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      // Fix mouseLeave issue.
      // https://github.com/facebook/react/issues/4492
      pointerEvents: 'none'
    },

    /* Styles applied to the icon wrapping elements when empty. */
    iconEmpty: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the icon wrapping elements when filled. */
    iconFilled: {},

    /* Styles applied to the icon wrapping elements when hover. */
    iconHover: {},

    /* Styles applied to the icon wrapping elements when focus. */
    iconFocus: {},

    /* Styles applied to the icon wrapping elements when active. */
    iconActive: {
      transform: 'scale(1.2)'
    },

    /* Styles applied to the icon wrapping elements when decimals are necessary. */
    decimal: {
      position: 'relative'
    }
  };
};

function IconContainer(props) {
  var value = props.value,
      other = _objectWithoutProperties(props, ["value"]);

  return createElement("span", other);
}
var defaultIcon$1 = createElement(Star, {
  fontSize: "inherit"
});

function defaultLabelText(value) {
  return "".concat(value, " Star").concat(value !== 1 ? 's' : '');
}

var Rating = forwardRef(function Rating(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? null : _props$defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      emptyIcon = props.emptyIcon,
      _props$emptyLabelText = props.emptyLabelText,
      emptyLabelText = _props$emptyLabelText === void 0 ? 'Empty' : _props$emptyLabelText,
      _props$getLabelText = props.getLabelText,
      getLabelText = _props$getLabelText === void 0 ? defaultLabelText : _props$getLabelText,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon$1 : _props$icon,
      _props$IconContainerC = props.IconContainerComponent,
      IconContainerComponent = _props$IconContainerC === void 0 ? IconContainer : _props$IconContainerC,
      _props$max = props.max,
      max = _props$max === void 0 ? 5 : _props$max,
      nameProp = props.name,
      onChange = props.onChange,
      onChangeActive = props.onChangeActive,
      onMouseLeave = props.onMouseLeave,
      onMouseMove = props.onMouseMove,
      _props$precision = props.precision,
      precision = _props$precision === void 0 ? 1 : _props$precision,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      valueProp = props.value,
      other = _objectWithoutProperties(props, ["classes", "className", "defaultValue", "disabled", "emptyIcon", "emptyLabelText", "getLabelText", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"]);

  var _React$useState = useState(),
      defaultName = _React$useState[0],
      setDefaultName = _React$useState[1];

  var name = nameProp || defaultName;
  useEffect(function () {
    // Fallback to this default id when possible.
    // Use the random value for client-side rendering only.
    // We can't use it server-side.
    setDefaultName("mui-rating-".concat(Math.round(Math.random() * 1e5)));
  }, []);

  var _React$useRef = useRef(valueProp !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState2 = useState(defaultValue),
      valueState = _React$useState2[0],
      setValueState = _React$useState2[1];

  var valueDerived = isControlled ? valueProp : valueState;

  var valueRounded = roundValueToPrecision(valueDerived, precision);
  var theme = useTheme$2();

  var _React$useState3 = useState({
    hover: -1,
    focus: -1
  }),
      _React$useState3$ = _React$useState3[0],
      hover = _React$useState3$.hover,
      focus = _React$useState3$.focus,
      setState = _React$useState3[1];

  var value = valueRounded;

  if (hover !== -1) {
    value = hover;
  }

  if (focus !== -1) {
    value = focus;
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState4 = useState(false),
      focusVisible = _React$useState4[0],
      setFocusVisible = _React$useState4[1];

  var rootRef = useRef();
  var handleFocusRef = useForkRef(focusVisibleRef, rootRef);
  var handleRef = useForkRef(handleFocusRef, ref);

  var handleMouseMove = function handleMouseMove(event) {
    if (onMouseMove) {
      onMouseMove(event);
    }

    var rootNode = rootRef.current;

    var _rootNode$getBounding = rootNode.getBoundingClientRect(),
        right = _rootNode$getBounding.right,
        left = _rootNode$getBounding.left;

    var _rootNode$firstChild$ = rootNode.firstChild.getBoundingClientRect(),
        width = _rootNode$firstChild$.width;

    var percent;

    if (theme.direction === 'rtl') {
      percent = (right - event.clientX) / (width * max);
    } else {
      percent = (event.clientX - left) / (width * max);
    }

    var newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = clamp$2(newHover, precision, max);
    setState(function (prev) {
      return prev.hover === newHover && prev.focus === newHover ? prev : {
        hover: newHover,
        focus: newHover
      };
    });
    setFocusVisible(false);

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    var newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleChange = function handleChange(event) {
    var newValue = parseFloat(event.target.value);

    if (!isControlled) {
      setValueState(newValue);
    }

    if (onChange) {
      onChange(event, newValue);
    }
  };

  var handleClear = function handleClear(event) {
    // Ignore keyboard events
    // https://github.com/facebook/react/issues/7407
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }

    setState({
      hover: -1,
      focus: -1
    });

    if (!isControlled) {
      setValueState(null);
    }

    if (onChange && parseFloat(event.target.value) === valueRounded) {
      onChange(event, null);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    var newFocus = parseFloat(event.target.value);
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (hover !== -1) {
      return;
    }

    if (focusVisible !== false) {
      setFocusVisible(false);
      onBlurVisible();
    }

    var newFocus = -1;
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var item = function item(state, labelProps) {
    var id = "".concat(name, "-").concat(String(state.value).replace('.', '-'));
    var container = createElement(IconContainerComponent, {
      value: state.value,
      className: clsx(classes.icon, state.filled ? classes.iconFilled : classes.iconEmpty, state.hover && classes.iconHover, state.focus && classes.iconFocus, state.active && classes.iconActive)
    }, emptyIcon && !state.filled ? emptyIcon : icon);

    if (readOnly) {
      return createElement("span", _extends$1({
        key: state.value
      }, labelProps), container);
    }

    return createElement(Fragment, {
      key: state.value
    }, createElement("label", _extends$1({
      className: classes.label,
      htmlFor: id
    }, labelProps), container, createElement("span", {
      className: classes.visuallyhidden
    }, getLabelText(state.value))), createElement("input", {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onClick: handleClear,
      disabled: disabled,
      value: state.value,
      id: id,
      type: "radio",
      name: name,
      checked: state.checked,
      className: classes.visuallyhidden
    }));
  };

  return createElement("span", _extends$1({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: clsx(classes.root, className, size !== 'medium' && classes["size".concat(capitalize(size))], disabled && classes.disabled, focusVisible && classes.focusVisible, readOnly && classes.readOnly),
    role: readOnly ? 'img' : null,
    "aria-label": readOnly ? getLabelText(value) : null
  }, other), Array.from(new Array(max)).map(function (_, index) {
    var itemValue = index + 1;

    if (precision < 1) {
      var items = Array.from(new Array(1 / precision));
      return createElement("span", {
        key: itemValue,
        className: clsx(classes.decimal, itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1) && classes.iconActive)
      }, items.map(function ($, indexDecimal) {
        var itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
        return item({
          value: itemDecimalValue,
          filled: itemDecimalValue <= value,
          hover: itemDecimalValue <= hover,
          focus: itemDecimalValue <= focus,
          checked: itemDecimalValue === valueRounded
        }, {
          style: items.length - 1 === indexDecimal ? {} : {
            width: itemDecimalValue === value ? "".concat((indexDecimal + 1) * precision * 100, "%") : '0%',
            overflow: 'hidden',
            zIndex: 1,
            position: 'absolute'
          }
        });
      }));
    }

    return item({
      value: itemValue,
      active: itemValue === value && (hover !== -1 || focus !== -1),
      filled: itemValue <= value,
      hover: itemValue <= hover,
      focus: itemValue <= focus,
      checked: itemValue === valueRounded
    });
  }), !readOnly && !disabled && valueRounded == null && createElement(Fragment, null, createElement("input", {
    value: "",
    id: "".concat(name, "-empty"),
    type: "radio",
    name: name,
    defaultChecked: true,
    className: classes.visuallyhidden
  }), createElement("label", {
    className: classes.pristine,
    htmlFor: "".concat(name, "-empty")
  }, createElement("span", {
    className: classes.visuallyhidden
  }, emptyLabelText))));
});
var Rating$1 = withStyles$2(styles$1j, {
  name: 'MuiRating'
})(Rating);

function RatingNumber({
  label,
  required,
  name,
  onChange,
  instruction,
  min,
  max,
  value,
  error
}) {

  const handleChange = React__default.useCallback((_, newValue) => {
    onChange({ name, value: newValue });
  }, [value, onChange]);

  const styles = useStyles$E({});

  return React__default.createElement(
    FormControl,
    {
      error: error.length > 0,
      className: styles.formItem,
      fullWidth: true
    },
    React__default.createElement(
      Box,
      { mb: 3, borderColor: 'transparent', className: styles.ratingBox },
      label && React__default.createElement(
        Typography$2,
        { component: 'legend' },
        label + `${required ? '*' : ''}`
      ),
      React__default.createElement(Rating$1, {
        name: name,
        value: value,
        min: min,
        max: max,
        onChange: handleChange
      })
    ),
    (error || instruction) && React__default.createElement(
      FormHelperText,
      { variant: 'outlined' },
      error || instruction
    )
  );
}

RatingNumber.displayName = 'RatingNumber';
RatingNumber.propTypes = {
  instruction: string,
  error: string,
  min: number,
  max: number,
  value: number,
  required: bool,
  label: string,
  name: string,
  onChange: func
};

RatingNumber.defaultProps = {
  min: 0,
  max: 5,
  error: '',
  value: 0,
  onChange: () => {}
};

function TextInput$1({ label, required, name, onChange, instruction, value, error }) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name, value: e.target.value });
  }, [name, onChange]);
  const styles = useStyles$E({});

  return React__default.createElement(TextField$1, {
    fullWidth: true,
    label: label,
    required: required,
    error: error.length > 0,
    helperText: error || instruction,
    variant: 'outlined',
    value: value,
    onChange: handleChange,
    className: styles.formItem,
    type: 'number',
    name: name
  });
}

TextInput$1.displayName = 'TextInput';
TextInput$1.propTypes = {
  label: string,
  required: bool,
  name: string,
  onChange: func,
  instruction: string,
  value: number,
  error: string
};

TextInput$1.defaultProps = {
  label: 'InputNumber',
  name: `number-${Date.now()}`,
  onChange: () => {},
  value: 0,
  error: ''
};

const form = 'form';

function useSortable(index, type, dropRef, addBlock, swapBlock) {
  const [{ isDragging }, drag, preview] = useDrag({
    item: {
      index,
      type
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const [{ isHovered }, drop] = useDrop({
    accept: type,
    hover: (item, monitor) => {
      if (!dropRef.current) {
        return;
      }

      if (isNaN(item.index)) {
        addBlock(index, item.id);
        item.index = index;
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      swapBlock(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    collect: monitor => {
      return {
        isHovered: monitor.getItem() && index === monitor.getItem().index && monitor.getItem().isBlock
      };
    },
    drop: (_, monitor) => {
      return { index: monitor.getItem().index };
    }
  });

  return [{
    isHovered,
    isDragging
  }, drag, preview, drop];
}

function PreviewWrapper({
  selected,
  children,
  index,
  addBlock,
  swapBlock,
  selectBlock,
  removeBlock
}) {
  const dropRef = React__default.createRef();

  const [{ isDragging, isHovered }, drag, preview, drop] = useSortable(index, form, dropRef, addBlock, swapBlock);

  const styles = useStyles$E({});

  const handleSelect = React__default.useCallback(() => selectBlock(index), [index, selectBlock]);
  const handleRemove = React__default.useCallback(() => removeBlock(index), [index, selectBlock]);

  return drop(preview(React__default.createElement(
    'div',
    {
      ref: dropRef,
      className: cx$1(styles.previewContainer, {
        [styles.previewContainerSelected]: selected
      }),
      style: isDragging || isHovered ? { opacity: 0, height: 60 } : {}
    },
    React__default.createElement(
      'div',
      { className: styles.previewContent },
      children
    ),
    React__default.createElement(
      'div',
      { className: styles.previewAction },
      React__default.createElement(
        'div',
        { ref: drag },
        React__default.createElement(
          IconButton$2,
          null,
          React__default.createElement(DragHandle, null)
        )
      ),
      React__default.createElement(
        IconButton$2,
        { onClick: handleSelect },
        React__default.createElement(EditIcon, null)
      ),
      React__default.createElement(
        IconButton$2,
        { onClick: handleRemove },
        React__default.createElement(DeleteIcon, null)
      )
    )
  )));
}

PreviewWrapper.propTypes = {
  selected: bool,
  children: node,
  index: number,
  addBlock: func,
  swapBlock: func,
  selectBlock: func,
  removeBlock: func
};

var formItems = {
  checkBox: Checkboxes,
  paragraph: Paragraph,
  textInput: TextInput,
  dateTime: DateTime,
  rating: RatingNumber,
  radio: Radio,
  select: Select$1,
  switch: Switch$1,
  number: TextInput$1
};

function Form({ formDefinition, onChange, value, errors }) {
  const handleChange = React__default.useCallback(({ name, value: itemValue }) => {
    onChange(Object.assign({}, value, { [name]: itemValue }));
  }, [value, onChange]);

  return React__default.createElement(
    'div',
    null,
    formDefinition.map(formItem => {
      const FormItem = formItems[formItem.type];
      FormItem.displayName = 'FormItem';
      return React__default.createElement(FormItem, _extends({
        key: formItem.name
      }, formItem, {
        value: value[formItem.name],
        onChange: handleChange,
        error: errors[formItem.name]
      }));
    })
  );
}

Form.displayName = 'Form';
Form.propTypes = {
  formDefinition: arrayOf(shape$1({ name: string })),
  onChange: func,
  value: objectOf(any),
  errors: objectOf(string)
};

Form.defaultProps = {
  errors: {}
};

var useStyles$O = makeStyles$1(_ => createStyles({
  blockContainer: {
    'height': '80px',
    'width': '100px',
    'border': '1px solid #DADCDF',
    'border-radius': '4px',
    'background-color': '#FFF',
    'color': '#5C636B',
    'font-size': '12px',
    'display': 'flex',
    'flex-flow': 'column',
    'justify-items': 'center',
    'text-align': 'center',
    'justify-content': 'center',
    'cursor': 'pointer',
    'margin': '8px',
    'align-items': 'center',

    '& > p': {
      'margin': 0
    }
  },
  dragPreviewContainer: {
    'padding-left': '16px',
    'height': '60px',
    'width': '200px',
    'border': '1px solid #5C636B',
    'border-radius': '4px',
    'color': '#5C636B',
    'display': 'flex',
    'justify-items': 'center',
    'align-items': 'center'
  },
  blockText: {
    'margin-top': '8px'
  },
  previewText: {
    'margin-left': '8px'
  }
}));

const blockTypes = [{
  type: 'textInput',
  label: 'Input Text',
  icon: React__default.createElement(Title, null)
}, {
  type: 'paragraph',
  label: 'Paragraph',
  icon: React__default.createElement(Notes, null)
}, {
  type: 'radio',
  label: 'Radio',
  icon: React__default.createElement(RadioButtonChecked, null)
}, {
  type: 'checkBox',
  label: 'Checkbox',
  icon: React__default.createElement(CheckBoxOutlined, null)
}, {
  type: 'dateTime',
  label: 'Date Time',
  icon: React__default.createElement(CalendarToday, null)
}, {
  type: 'rating',
  label: 'Rating',
  icon: React__default.createElement(StarBorderOutlined, null)
}, {
  type: 'select',
  label: 'Select',
  icon: React__default.createElement(MenuIcon, null)
}, {
  type: 'switch',
  label: 'Switch',
  icon: React__default.createElement(EditAttributesIcon, null)
}, {
  type: 'number',
  label: 'Number',
  icon: React__default.createElement(ExposurePlus1, null)
}];

const blockMaps = blockTypes.reduce((blocks, { type, label, icon }) => _extends({}, blocks, {
  [type]: {
    label,
    icon
  }
}), {});

function BlockPreview({ type }) {
  const styles = useStyles$O({});
  return React__default.createElement(
    'div',
    { className: styles.dragPreviewContainer },
    blockMaps[type].icon,
    React__default.createElement(
      Typography$2,
      { className: styles.previewText },
      blockMaps[type].label
    )
  );
}

BlockPreview.displayName = 'BlockPreview';
BlockPreview.propTypes = {
  type: string
};

function Block({ type, label, icon, onCancel, onClick }) {
  const styles = useStyles$O({});
  const [{ opacity }, drag, preview] = useDrag({
    item: {
      id: type,
      type: form,
      isBlock: true
    },
    collect: monitor => ({
      opacity: monitor.isDragging() ? 0.5 : 1
    }),
    end: (item, monitor) => {
      if (!monitor.didDrop() && !isNaN(item.index)) {
        onCancel(item.index);
      }
    }
  });

  React__default.useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  const onBlockClick = React__default.useCallback(() => {
    onClick(type);
  }, [type, onClick]);

  return React__default.createElement(
    'div',
    {
      ref: drag,
      style: { opacity },
      className: styles.blockContainer,
      onClick: onBlockClick
    },
    icon,
    React__default.createElement(
      Typography$2,
      {
        variant: 'caption',
        className: styles.blockText
      },
      label
    )
  );
}

Block.displayName = 'Block';
Block.propTypes = {
  type: string,
  label: string,
  icon: node,
  onCancel: func,
  onClick: func
};

Block.defaultProps = {
  onCancel: _noop,
  onClick: _noop,
  label: 'TextInput',
  icon: React__default.createElement(Title, null)
};

var useStyles$P = makeStyles$1(_ => createStyles({
  layer: {
    'position': 'fixed',
    'pointer-events': 'none',
    'z-index': '100',
    'left': '0',
    'top': '0',
    'width': '100%',
    'height': '100%'
  }
}));

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }
  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform
  };
}
const CustomDragLayer = () => {
  const {
    itemType,
    isDragging,
    item,
    initialOffset,
    currentOffset
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }));

  const styles = useStyles$P({});

  function renderItem() {
    switch (itemType) {
      case form:
        if (item.isBlock) {
          return React__default.createElement(BlockPreview, { type: item.id });
        }
        return null;
      default:
        return null;
    }
  }
  if (!isDragging) {
    return null;
  }

  return React__default.createElement(
    'div',
    { className: styles.layer },
    React__default.createElement(
      'div',
      {
        style: getItemStyles(initialOffset, currentOffset)
      },
      renderItem()
    )
  );
};
CustomDragLayer.displayName = 'CustomDragLayer';

const typeConfiguration = {
  textInput: ['name', 'label', 'instruction', 'required'],
  paragraph: ['name', 'label', 'instruction', 'required'],
  radio: ['name', 'label', 'items', 'instruction', 'required'],
  checkBox: ['name', 'label', 'items', 'instruction', 'required'],
  dateTime: ['name', 'label', 'dateFormat', 'instruction', 'required', 'enableTimeOption'],
  rating: ['name', 'label', 'min', 'max', 'instruction', 'required'],
  select: ['name', 'label', 'items', 'instruction', 'required'],
  switch: ['name', 'label', 'instruction', 'required'],
  number: ['name', 'label', 'min', 'max', 'instruction', 'required']
};

const initData = {
  name: '',
  label: '',
  instruction: '',
  required: false,
  items: [{ value: 'option 1', id: new Date().getTime().toString() }],
  dateFormat: 'dd-MM-yyyy',
  enableTimeOption: false,
  min: 0,
  max: 5
};

const dateFormats$2 = ['dd-MM-yyyy', 'MM-dd-yyyy', 'yyyy-MM-dd'];

const dateTimeFormats$1 = ['dd-MM-yyyy HH:MM', 'MM-dd-yyyy HH:MM', 'yyyy-MM-dd HH:MM'];

const type = 'dateFormat';

function getFormatValue(value, enableTimeOption) {
  if (enableTimeOption && dateFormats$2.includes(value)) {
    return dateTimeFormats$1[dateFormats$2.indexOf(value)];
  }
  if (!enableTimeOption && dateTimeFormats$1.includes(value)) {
    return dateFormats$2[dateTimeFormats$1.indexOf(value)];
  }
  return value;
}

function DateFormat({
  value,
  onChange,
  className,
  enableTimeOption
}) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name: type, value: e.target.value });
  }, [onChange]);

  React__default.useEffect(() => {
    handleChange({
      target: {
        value: getFormatValue(value, enableTimeOption)
      }
    });
  }, [enableTimeOption, value]);

  const formats = enableTimeOption ? dateTimeFormats$1 : dateFormats$2;
  return React__default.createElement(
    TextField$1,
    {
      label: 'Date format',
      variant: 'outlined',
      select: true,
      fullWidth: true,
      value: value,
      helperText: 'Select your date format',
      onChange: handleChange,
      className: className
    },
    formats.map(format => React__default.createElement(
      MenuItem,
      { key: format, value: format },
      format
    ))
  );
}

DateFormat.displayName = 'DateFormat';
DateFormat.propTypes = {
  value: string,
  onChange: func,
  className: string,
  enableTimeOption: bool
};

DateFormat.defaultProps = {
  onChange: _noop
};

const type$1 = "enableTimeOption";

function EnableTimeOption({ value, onChange, className }) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name: type$1, value: e.target.checked });
  }, [value, onChange]);
  return React__default.createElement(FormControlLabel, {
    className: className,
    control: React__default.createElement(Checkbox$3, {
      color: 'primary',
      checked: value,
      onChange: handleChange
    }),
    label: 'Enable time option'
  });
}

EnableTimeOption.displayName = 'EnableTimeOption';
EnableTimeOption.propTypes = {
  value: bool,
  onChange: func,
  className: string
};

EnableTimeOption.defaultProps = {
  onChange: _noop,
  value: false
};

const add = (index, block, item) => {
  return [...block.slice(0, index), item, ...block.slice(index)];
};

const remove = (index, block) => {
  return block.filter((_, blockIndex) => blockIndex !== index);
};

const swap = ({ from, to }, block) => {
  return block.map((blockItem, blockIndex) => {
    if (blockIndex === from) {
      return block[to];
    }
    if (blockIndex === to) {
      return block[from];
    }
    return blockItem;
  });
};

const update = (index, block, item) => {
  return block.map((blockItem, blockIndex) => {
    if (blockIndex === index) {
      return _extends({}, block[index], item);
    }
    return blockItem;
  });
};

const select = (index, block) => {
  return block.map((blockItem, blockIndex) => {
    if (index !== blockIndex) {
      return _extends({}, blockItem, {
        selected: false
      });
    }
    return _extends({}, blockItem, {
      selected: !blockItem.selected
    });
  });
};

var useStyles$Q = makeStyles$1(_ => createStyles({
  configurationItem: {
    'margin-top': '8px !important'
  },
  itemContainer: {
    'display': 'flex',
    'align-items': 'center',
    'margin-top': '8px'
  },
  listItemsContainer: {
    'margin-top': '16px'
  },
  previewIcon: {
    'cursor': 'pointer',
    'opacity': '0.7',
    'margin': '0 8px'
  }
}));

const type$2 = "items";

function ListItems({ value, onChange, className }) {
  const swapBlock = React__default.useCallback((from, to) => {
    onChange({
      name: type$2,
      value: swap({ from, to }, value)
    });
  }, [value, onChange]);

  const addBlock = React__default.useCallback(index => {
    onChange({
      name: type$2,
      value: add(index + 1, value, {
        value: `option-${new Date().getTime()}`,
        id: new Date().getTime().toString()
      })
    });
  }, [value, onChange]);

  const removeBlock = React__default.useCallback(index => {
    if (value.length > 1) {
      onChange({
        name: type$2,
        value: remove(index, value)
      });
    }
  }, [value, onChange]);

  const updateBlock = React__default.useCallback((index, newValue) => {
    onChange({
      name: type$2,
      value: update(index, value, { value: newValue })
    });
  }, [value, onChange]);

  return React__default.createElement(
    'div',
    { className: className },
    React__default.createElement(
      'label',
      null,
      'Field Items'
    ),
    React__default.createElement(
      'div',
      null,
      value.map((block, index) => React__default.createElement(Item, {
        key: block.id,
        block: block,
        index: index,
        swapBlock: swapBlock,
        addBlock: addBlock,
        removeBlock: removeBlock,
        updateBlock: updateBlock
      }))
    )
  );
}

ListItems.displayName = 'ListItems';
ListItems.propTypes = {
  value: arrayOf(shape$1({
    id: string
  })),
  onChange: func,
  className: string
};

ListItems.defaultProps = {
  onChange: _noop,
  value: []
};

const Item = function Item({
  block,
  index,
  swapBlock,
  addBlock,
  removeBlock,
  updateBlock
}) {
  const dropRef = React__default.createRef();
  const styles = useStyles$Q({});

  const [{ isDragging }, drag, preview, drop] = useSortable(index, type$2, dropRef, addBlock, swapBlock);

  const handleChange = React__default.useCallback(e => updateBlock(index, e.target.value), [index, updateBlock]);

  const handleAdd = React__default.useCallback(() => addBlock(index), [index, addBlock]);
  const handleRemove = React__default.useCallback(() => removeBlock(index), [index, removeBlock]);

  return drop(preview(React__default.createElement(
    'div',
    {
      ref: dropRef,
      className: styles.itemContainer,
      style: isDragging ? { opacity: 0 } : {}
    },
    React__default.createElement(TextField$1, {
      label: `Option-${index + 1}`,
      variant: 'outlined',
      value: block.value,
      onChange: handleChange,
      fullWidth: true
    }),
    React__default.createElement(
      'div',
      { ref: drag },
      React__default.createElement(DragHandleOutlined, { className: styles.previewIcon })
    ),
    React__default.createElement(AddCircleOutline, {
      onClick: handleAdd,
      className: styles.previewIcon
    }),
    React__default.createElement(DeleteOutlined, {
      onClick: handleRemove,
      className: styles.previewIcon
    })
  )));
};

Item.propTypes = {
  block: shape$1({
    value: string
  }),
  index: number,
  swapBlock: func,
  addBlock: func,
  removeBlock: func
};

function createTextInput({
  type = 'text',
  itemType,
  label
}) {
  function TextInputComponent({ value, onChange, className }) {
    const handleChange = React__default.useCallback(e => onChange({ name: itemType, value: e.target.value }), [onChange]);
    return React__default.createElement(TextField$1, {
      label: label,
      variant: 'outlined',
      fullWidth: true,
      value: value,
      type: type,
      onChange: handleChange,
      className: className
    });
  }

  TextInputComponent.propTypes = {
    value: oneOfType([string, number]),
    onChange: func,
    className: string
  };

  TextInputComponent.defaultProps = {
    onChange: _noop,
    value: ''
  };
  return TextInputComponent;
}

const type$3 = "required";

function Required({ value, onChange, className }) {
  const handleChange = React__default.useCallback(e => {
    onChange({ name: type$3, value: e.target.checked });
  }, [onChange]);

  return React__default.createElement(FormControlLabel, {
    className: className,
    control: React__default.createElement(Checkbox$3, {
      color: 'primary',
      checked: value,
      onChange: handleChange
    }),
    label: 'Required'
  });
}

Required.displayName = 'Required';
Required.propTypes = {
  value: bool,
  onChange: func,
  className: string
};

Required.defaultProps = {
  onChange: _noop,
  value: false
};

var configurationComponents = {
  name: createTextInput({ itemType: 'name', label: 'Field Name' }),
  label: createTextInput({ itemType: 'label', label: 'Field Label' }),
  instruction: createTextInput({ itemType: 'instruction', label: 'Field Instruction' }),
  required: Required,
  items: ListItems,
  min: createTextInput({ itemType: 'min', label: 'Min Value', type: 'number' }),
  max: createTextInput({ itemType: 'max', label: 'Max Value', type: 'number' }),
  dateFormat: DateFormat,
  enableTimeOption: EnableTimeOption
};

function Configuration(_ref) {
  let { type, onChange } = _ref,
      data = objectWithoutProperties(_ref, ['type', 'onChange']);

  const styles = useStyles$Q({});
  return React__default.createElement(
    'div',
    null,
    typeConfiguration[type].map(configurationType => {
      const ConfigurationComponent = configurationComponents[configurationType];
      ConfigurationComponent.displayName = 'FormConfigurationItem';
      return React__default.createElement(ConfigurationComponent, _extends({
        key: configurationType,
        value: data[configurationType],
        onChange: onChange,
        className: styles.configurationItem
      }, data));
    })
  );
}

Configuration.displayName = 'Configuration';
Configuration.propTypes = {
  type: string,
  onChange: func
};

Configuration.defaultProps = {
  onChange: _noop
};

// errorChain function which get all data and configuration from form
// it return a function which can get a function or an array of functions which
// recieve data and settings and return error text.
// error validation can be chained mean we can compose many validate functions
function errorChain({ data, settings }) {
  return function getError(funcs) {
    if (_isFunction(funcs)) {
      return funcs({ data, settings });
    }
    if (_isArray(funcs)) {
      for (let i = 0; i < funcs.length; i++) {
        const error = funcs[i]({ data, settings });
        if (!_isEmpty(error)) {
          return error; // Return first error
        }
      }
    }
  };
}

function validateEmail({ data, settings }) {
  const { name } = settings;
  const re = /.+@.+\..+/;

  return re.test(String(data[name]).toLowerCase()) ? '' : 'Please enter a valid email address';
}

function validateEmpty({ data, settings }) {
  const { name, required } = settings;
  if (!required) {
    return;
  }
  return _isEmpty(data[name]) ? `${name.toUpperCase()} is required` : '';
}

function validateRange({ data, settings }) {
  const { name, min, max } = settings;
  if (_isNumber(min) && _isNumber(max) && (data[name] < min || data[name] > max)) {
    return `${name} must be between ${min} and ${max}`;
  }
  if (_isNumber(min) && data[name] < min) {
    return `Minimum required ${name} is ${min}`;
  }
  if (_isNumber(max) && data[name] > max) {
    return `Maximum ${name} can be ${max}`;
  }
  return '';
}

var helpers = /*#__PURE__*/Object.freeze({
  errorChain: errorChain,
  validateEmail: validateEmail,
  validateEmpty: validateEmpty,
  validateRange: validateRange
});

function ratingSchema(block) {
  return {
    name: block.name,
    schema: {
      minimum: block.min,
      maximum: block.max,
      type: 'integer'
    }
  };
}

function stringSchema(block) {
  return {
    name: block.name,
    schema: {
      type: 'string'
    }
  };
}

function enumSchema(block) {
  return {
    name: block.name,
    schema: {
      type: 'string',
      enum: block.items.reduce((currentEnums, { value }) => [...currentEnums, value], [])
    }
  };
}

function arraySchema(block) {
  return {
    name: block.name,
    schema: {
      type: 'array',
      items: {
        type: 'string',
        enum: block.items.reduce((currentEnums, { value }) => [...currentEnums, value], [])
      }
    }
  };
}

function booleanSchema(block) {
  return {
    name: block.name,
    schema: {
      type: 'boolean'
    }
  };
}

const mapSchema = {
  rating: ratingSchema,
  textInput: stringSchema,
  radio: enumSchema,
  dateTime: stringSchema,
  geoPoint: stringSchema,
  ip: stringSchema,
  paragraph: stringSchema,
  checkBox: arraySchema,
  switch: booleanSchema,
  select: enumSchema,
  number: ratingSchema
};

const formDefaultValue = {
  rating: 0,
  textInput: '',
  radio: '',
  dateTime: new Date(),
  switch: false,
  checkBox: [],
  ip: '',
  geoPoint: '',
  select: '',
  paragraph: '',
  number: 0
};

function generateSchema(formDefinition) {
  return {
    type: 'object',
    required: formDefinition.reduce((requiredFields, { name, required }) => {
      if (required) {
        return [...requiredFields, name];
      }
      return requiredFields;
    }, []),
    properties: formDefinition.reduce((currentForm, block) => {
      const { name, schema } = mapSchema[block.type](block);
      return _extends({}, currentForm, {
        [name]: schema
      });
    }, {})
  };
}

function generateState(formDefinition = [], initialState = {}) {
  const emptyState = formDefinition.reduce((currentForm, { name, type }) => _extends({}, currentForm, {
    [name]: formDefaultValue[type],
    error: {}
  }), {});

  return Object.assign({}, emptyState, initialState);
}

function validateForm(formDefinition = [], value = {}, validate = {}) {
  return formDefinition.reduce((formError, form) => _extends({}, formError, {
    [form.name]: errorChain({ data: value, settings: form })(validate[form.name])
  }), {});
}

var utils = /*#__PURE__*/Object.freeze({
  ratingSchema: ratingSchema,
  stringSchema: stringSchema,
  enumSchema: enumSchema,
  arraySchema: arraySchema,
  booleanSchema: booleanSchema,
  formDefaultValue: formDefaultValue,
  generateSchema: generateSchema,
  generateState: generateState,
  validateForm: validateForm
});

function PreviewDialog({ form, handleClose }) {
  const [formState, setFormState] = React__default.useState(generateState(form));

  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      Dialog,
      {
        open: true,
        onClose: handleClose,
        "aria-labelledby": "form-dialog-title",
        maxWidth: "md",
        fullWidth: true
      },
      React__default.createElement(
        DialogTitle,
        { id: "form-dialog-title" },
        "Form builder Preview"
      ),
      React__default.createElement(
        DialogContent,
        { dividers: true },
        React__default.createElement(Form, {
          formDefinition: form,
          value: formState,
          onChange: setFormState
        })
      ),
      React__default.createElement(
        DialogActions,
        { className: "dialog-footer" },
        React__default.createElement(
          Button$2,
          { onClick: handleClose },
          "Cancel"
        ),
        React__default.createElement(
          Button$2,
          { onClick: handleClose, color: "primary", variant: "contained" },
          "Submit"
        )
      )
    )
  );
}

PreviewDialog.displayName = "PreviewDialog";
PreviewDialog.propTypes = {
  form: arrayOf(shape$1({
    name: string
  })),
  handleClose: func
};

var useStyles$R = makeStyles$1(_ => createStyles({
  formBuilder: {
    'display': 'flex',
    'max-width': '1200px',
    'margin': 'auto',
    'height': '100%'
  },
  formBlocks: {
    'max-width': '350px',
    'flex-basis': '50%'
  },
  formBlocksTitle: {
    'margin-left': '8px !important',
    'margin-bottom': '12px !important'
  },
  blocksWrapper: {
    'display': 'flex',
    'flex-flow': 'row',
    'flex-wrap': 'wrap'
  },
  blocksPreview: {
    'flex-basis': '70%',
    'max-height': '100%',
    'overflow-y': 'auto',
    'overflow': '-moz-scrollbars-none',

    '&::-webkit-scrollbar': {
      'width': '0 !important'
    }
  },
  configurationContainer: {
    'padding-left': '10px',
    'width': '400px'
  },
  formConfigurationTitle: {
    'margin-bottom': '12px !important'
  }
}));

function formEqual({ form }, { form: nextForm }) {
  return _isEqual(form, nextForm);
}

function FormBuilderComponent({
  form: form$1,
  addBlock,
  swapBlock,
  updateBlock,
  removeBlock,
  selectBlock,
  classes,
  helpLink
}) {

  const styles = useStyles$R({});

  const [isPreview, setIsPreview] = React__default.useState(false);

  const [, drop] = useDrop({
    accept: form,
    drop: item => {
      if (isNaN(item.index) && form$1.length === 0) {
        addBlock(0, item.id);
        item.index = 0;
      }
    }
  });

  const onUpdateForm = React__default.useCallback(({ name, value }) => {
    const updateIndex = form$1.findIndex(formItem => formItem.selected);
    updateBlock(updateIndex, { [name]: value });
  }, [updateBlock, form$1]);

  const handleClickPreview = React__default.useCallback(() => {
    setIsPreview(x => !x);
  }, []);

  const onBlockClick = React__default.useCallback(type => {
    addBlock(form$1.length, type);
  }, [addBlock, form$1]);

  const configurationOpen = form$1.filter(formItem => formItem.selected);
  const settingOpen = configurationOpen.length > 0;

  return React__default.createElement(
    'div',
    { className: cx$1(styles.formBuilder, classes.container) },
    React__default.createElement(
      'div',
      { className: cx$1(styles.formBlocks) },
      React__default.createElement(
        Typography$2,
        { className: cx$1(styles.formBlocksTitle) },
        'Blocks'
      ),
      React__default.createElement(
        'div',
        { className: styles.blocksWrapper },
        blockTypes.map(block => React__default.createElement(Block, _extends({
          key: block.type
        }, block, {
          onCancel: removeBlock,
          onClick: onBlockClick
        })))
      ),
      React__default.createElement('hr', null),
      React__default.createElement(
        Button$2,
        {
          variant: 'contained',
          color: 'secondary',
          onClick: handleClickPreview
        },
        'Preview'
      ),
      isPreview && React__default.createElement(PreviewDialog, {
        form: form$1,
        handleClose: handleClickPreview
      })
    ),
    React__default.createElement(
      'div',
      { className: cx$1(styles.blocksPreview, classes.previewContainer) },
      form$1.length > 0 && React__default.createElement(
        Typography$2,
        { className: cx$1(styles.formPreviewTitle) },
        'Form preview'
      ),
      React__default.createElement(
        'div',
        { ref: drop, className: classes.previewContent },
        form$1.map((block, index) => {
          const BlockItem = formItems[block.type];
          return React__default.createElement(
            PreviewWrapper,
            {
              index: index,
              key: block.name,
              selected: block.selected,
              addBlock: addBlock,
              swapBlock: swapBlock,
              updateBlock: updateBlock,
              removeBlock: removeBlock,
              selectBlock: selectBlock
            },
            React__default.createElement(BlockItem, _extends({}, block, { name: `preview-${block.name}` }))
          );
        }),
        form$1.length > 0 && React__default.createElement(
          'pre',
          null,
          JSON.stringify(generateSchema(form$1), null, 2)
        ),
        form$1.length === 0 && React__default.createElement(
          NullState,
          {
            titleText: 'Begin by selecting block to your right'
          },
          React__default.createElement(
            Link,
            { href: helpLink, target: '_blank' },
            'Need help? Click here to watch a turtorial'
          )
        )
      )
    ),
    React__default.createElement(
      'div',
      { className: styles.configurationContainer },
      settingOpen && React__default.createElement(
        Typography$2,
        { className: styles.formConfigurationTitle },
        `${configurationOpen[0].name} settings`
      ),
      settingOpen && React__default.createElement(Configuration, _extends({
        onChange: onUpdateForm
      }, configurationOpen[0]))
    )
  );
}

FormBuilderComponent.displayName = 'FormBuilderComponent';
const formPropType = arrayOf(shape$1({
  type: string,
  name: string
}));

FormBuilderComponent.propTypes = {
  form: formPropType,
  addBlock: func,
  swapBlock: func,
  removeBlock: func,
  selectBlock: func,
  updateBlock: func,
  classes: objectOf(string),
  helpLink: string
};

FormBuilderComponent.defaultProps = {
  addBlock: _noop,
  swapBlock: _noop,
  removeBlock: _noop,
  selectBlock: _noop,
  updateBlock: _noop,
  form: [],
  classes: {},
  helpLink: 'https://help.veritone.com/en/'
};

const FormBuilderComponentMemo = React__default.memo(FormBuilderComponent, formEqual);

function FormBuilder(_ref) {
  let { form, onChange } = _ref,
      remainProps = objectWithoutProperties(_ref, ['form', 'onChange']);

  const addBlock = React__default.useCallback((index, type) => {
    const name = `${type}-${new Date().getTime()}`;
    const item = typeConfiguration[type].slice(1).reduce((data, type) => _extends({}, data, {
      [type]: initData[type]
    }), { type, name });
    onChange(add(index, form, item));
  }, [onChange, form]);

  const removeBlock = React__default.useCallback(index => {
    onChange(remove(index, form));
  }, [onChange, form]);

  const updateBlock = React__default.useCallback((index, item) => {
    onChange(update(index, form, item));
  }, [onChange, form]);

  const swapBlock = React__default.useCallback((from, to) => {
    onChange(swap({ from, to }, form));
  }, [onChange, form]);

  const selectBlock = React__default.useCallback(index => {
    onChange(select(index, form));
  }, [onChange, form]);

  return React__default.createElement(
    DndProvider,
    { backend: HTML },
    React__default.createElement(CustomDragLayer, null),
    React__default.createElement(FormBuilderComponentMemo, _extends({
      form: form,
      addBlock: addBlock,
      removeBlock: removeBlock,
      updateBlock: updateBlock,
      swapBlock: swapBlock,
      selectBlock: selectBlock
    }, remainProps))
  );
}

FormBuilder.displayName = 'FormBuilder';
FormBuilder.propTypes = {
  onChange: func,
  form: formPropType,
  classes: objectOf(string)
};

FormBuilder.defaultProps = {
  onChange: _noop,
  form: [],
  classes: {}
};

export { index as AppBar, AppContainer, AppFooter, AppSwitcher$1 as AppSwitcher, Avatar, Overlay as BoundingPolyOverlay, BreadCrums as Breadcrumbs, Chip$1 as Chip, Column, CreateFolder, index$e as DataPicker, DelayedProgress, DeleteFolder, DiscoverySideBarContainer as DiscoverySideBar, DiscoverySideBarContainerPure as DiscoverySideBarPure, EditFolder, EntitySearchTemplate, index$9 as ExpandableInputField, index$3 as FilePicker, index$4 as FileProgressDialog, NullState$2 as FolderNullState, FolderTree, Form, FormBuilder, index$1 as FullScreenDialog, index$8 as GeoPicker, HorizontalScroll, Interval, LOADING, index$d as Lightbox, NullState$1 as LoadingState, Lozenge, MediaPlayerComponent$1 as MediaPlayer, MenuColumn, index$c as ModalHeader, NavigationSideBarContainer as NavigationSideBar, Notifier$1 as Notifier, OAuthLoginButton, OverlayPositioningProvider$1 as OverlayPositioningProvider, PaginatedTable, ProfileMenu$1 as ProfileMenu, index$5 as ProgressDialog, RaisedTextField, RestartMediaButton, SearchBar, Searchbox as SearchBox, SearchPill$1 as SearchPill, SelectionButton, SimpleSearchBar, SimpleSearchBarBase, SimpleSearchBarController, SimpleText, index$b as StatusPill, SubAppbar, Table, index$2 as TopBar, VeritoneSDKThemeProvider, VideoSource, appBarHeight, appFooterHeightShort, appFooterHeightTall, defaultAppBarZIndex, defaultIntervals, defaultVSDKTheme, sectionsShape$1 as discoverySidebarSectionsShape, index$6 as formComponents, helpers as formHelpers, utils as formUtils, sectionsShape as navigationSidebarSectionsShape, topBarHeight, withVeritoneSDKThemeProvider };



//////////////////
// WEBPACK FOOTER
// ./~/veritone-react-common/dist/bundle-es.js
// module id = EDL6
// module chunks = 22